{
  "settings": {
    "max_custom_activities_pro": 5,
    "default_enabled_activities": [
      "standard_forecast",
      "hiking",
      "photography",
      "stargazing",
      "winter_sports",
      "water_sports",
      "advanced"
    ]
  },
  "layerCatalog": {
    "climate_data": {
      "id": "climate_data",
      "label": "Historical Climatology (30-year)",
      "product": "climate",
      "icon": "\ud83d\udcca",
      "category": "extended_climate",
      "is_tool_mode": true,
      "description": "30-year climatological normals & microclimate elevation profiles",
      "category_label": "Extended Climate & Outlooks",
      "long_description": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
      "score_description": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
      "source_models": [
        "PRISM 30-Year Normals (800m CONUS)",
        "ERA5 / WorldClim Global Climatology",
        "NOAA NCEI 1991-2020 Climate Normals"
      ],
      "output_models": [
        "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
        "Point Microclimate Elevation Profiles"
      ],
      "toast_title": "Historical Climatology (30-Year Normals)",
      "toast_subtitle": "1991\u20132020 CLIMATE BASELINE",
      "toast_description": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips.",
      "longDescription": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
      "scoreDescription": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
      "categoryLabel": "Extended Climate & Outlooks",
      "sourceModels": [
        "PRISM 30-Year Normals (800m CONUS)",
        "ERA5 / WorldClim Global Climatology",
        "NOAA NCEI 1991-2020 Climate Normals"
      ],
      "outputModels": [
        "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
        "Point Microclimate Elevation Profiles"
      ],
      "toastTitle": "Historical Climatology (30-Year Normals)",
      "toastSubtitle": "1991\u20132020 CLIMATE BASELINE",
      "toastDescription": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips."
    },
    "recent_climate": {
      "id": "recent_climate",
      "label": "Recent Climate Data",
      "product": "recent_climate",
      "icon": "\ud83d\uddd3\ufe0f",
      "category": "extended_climate",
      "is_tool_mode": true,
      "description": "Monthly & Year-to-Date observed temperature, precipitation, snowfall, and departures from 1991-2020 normals (2021-present)",
      "long_description": "Recent Climate Data is an interactive multi-year observed climate almanac (2021-present) tracking monthly and Year-to-Date (or Annual) temperature, precipitation, snowfall, and departures from 1991-2020 climatological normals.\n\nPowered by a seamless hybrid stitch of high-resolution NOAA NCEI nClimGrid-Daily (~4.6 km across CONUS) and NOAA PSL/CPC Global Unified Daily observations (0.5 deg across Alaska, Canada, and global land), paired with NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS). Hover anywhere over the map for instant telemetry showing High/Low, Mean Temp, Temp Departure, Total Precip, Normal Precip, % of Normal, Snowfall, and Elevation.",
      "score_description": "\u2022 7 Selectable Layers: Average High, Average Low, Mean Temp, Temp Departure (\u00b1\u00b0F), Total Precip, Precip Departure (\u00b1in & % of normal), and Snowfall (CONUS).\n\u2022 Time Modes: Clickable Jan-Dec monthly views plus Year-to-Date (active year) or Full Annual Summary (completed years 2021-2025+).\n\u2022 Daily Incremental Updates: Automatically refreshes the active calendar month and YTD totals daily as new NOAA observations publish.",
      "category_label": "Extended Climate & Outlooks",
      "source_models": [
        "NOAA NCEI nClimGrid-Daily (~4.6 km CONUS)",
        "NOAA PSL/CPC Global Unified Daily (0.5\u00b0 Global)",
        "NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS)"
      ],
      "output_models": [
        "Monthly & YTD Temperature, Precip, Snow & Departure Rasters (.pmtiles)"
      ],
      "toast_title": "Recent Climate Almanac (2021\u2013Present)",
      "toast_subtitle": "OBSERVED MONTHLY & YTD DEPARTURES",
      "toast_description": "Compare actual monthly and year-to-date temperatures, rainfall, and snowfall from 2021 to the present against 30-year climatological normals.",
      "longDescription": "Recent Climate Data is an interactive multi-year observed climate almanac (2021-present) tracking monthly and Year-to-Date (or Annual) temperature, precipitation, snowfall, and departures from 1991-2020 climatological normals.\n\nPowered by a seamless hybrid stitch of high-resolution NOAA NCEI nClimGrid-Daily (~4.6 km across CONUS) and NOAA PSL/CPC Global Unified Daily observations (0.5 deg across Alaska, Canada, and global land), paired with NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS). Hover anywhere over the map for instant telemetry showing High/Low, Mean Temp, Temp Departure, Total Precip, Normal Precip, % of Normal, Snowfall, and Elevation.",
      "scoreDescription": "\u2022 7 Selectable Layers: Average High, Average Low, Mean Temp, Temp Departure (\u00b1\u00b0F), Total Precip, Precip Departure (\u00b1in & % of normal), and Snowfall (CONUS).\n\u2022 Time Modes: Clickable Jan-Dec monthly views plus Year-to-Date (active year) or Full Annual Summary (completed years 2021-2025+).\n\u2022 Daily Incremental Updates: Automatically refreshes the active calendar month and YTD totals daily as new NOAA observations publish.",
      "categoryLabel": "Extended Climate & Outlooks",
      "sourceModels": [
        "NOAA NCEI nClimGrid-Daily (~4.6 km CONUS)",
        "NOAA PSL/CPC Global Unified Daily (0.5\u00b0 Global)",
        "NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS)"
      ],
      "outputModels": [
        "Monthly & YTD Temperature, Precip, Snow & Departure Rasters (.pmtiles)"
      ],
      "toastTitle": "Recent Climate Almanac (2021\u2013Present)",
      "toastSubtitle": "OBSERVED MONTHLY & YTD DEPARTURES",
      "toastDescription": "Compare actual monthly and year-to-date temperatures, rainfall, and snowfall from 2021 to the present against 30-year climatological normals."
    },
    "drought_usdm": {
      "id": "drought_usdm",
      "label": "U.S. Drought Monitor",
      "product": "drought",
      "icon": "\ud83c\udfdc\ufe0f",
      "category": "extended_climate",
      "description": "Authoritative weekly U.S. Drought Monitor classification (D0 Abnormally Dry to D4 Exceptional Drought)",
      "category_label": "Extended Climate & Outlooks",
      "long_description": "Authoritative weekly U.S. Drought Monitor classifications (D0 Abnormally Dry to D4 Exceptional Drought) from NDMC/USDA/NOAA, coupled with NOAA Climate Prediction Center (CPC) Monthly and Seasonal drought tendency outlooks.",
      "score_description": "\u2022 D0 (Abnormally Dry - Yellow): Going into drought or recovering from drought; short-term dryness slowing planting or growth.\n\u2022 D1 (Moderate Drought - Tan): Some damage to crops and pastures; streams, reservoirs, or wells low.\n\u2022 D2 (Severe Drought - Orange): Crop or pasture losses likely; water shortages common and water restrictions imposed.\n\u2022 D3 (Extreme Drought - Red): Major crop/pasture losses and widespread water shortages or restrictions.\n\u2022 D4 (Exceptional Drought - Dark Brown/Maroon): Exceptional and widespread crop/pasture losses; emergencies in water supply and wildfire fuel aridity.",
      "source_models": [
        "National Drought Mitigation Center (NDMC / UNL)",
        "NOAA National Integrated Drought Information System (NIDIS)",
        "USDA World Agricultural Outlook Board",
        "NOAA Climate Prediction Center (CPC)"
      ],
      "output_models": [
        "Vector Classifications & Tendency Polygons GeoJSON"
      ],
      "toast_title": "U.S. Drought Monitor & Outlook",
      "toast_subtitle": "WEEKLY NDMC / NOAA CLASSIFICATION",
      "toast_description": "Maps official weekly U.S. Drought Monitor intensity tiers (D0 Abnormally Dry to D4 Exceptional Drought) and seasonal drought tendency outlooks.",
      "longDescription": "Authoritative weekly U.S. Drought Monitor classifications (D0 Abnormally Dry to D4 Exceptional Drought) from NDMC/USDA/NOAA, coupled with NOAA Climate Prediction Center (CPC) Monthly and Seasonal drought tendency outlooks.",
      "scoreDescription": "\u2022 D0 (Abnormally Dry - Yellow): Going into drought or recovering from drought; short-term dryness slowing planting or growth.\n\u2022 D1 (Moderate Drought - Tan): Some damage to crops and pastures; streams, reservoirs, or wells low.\n\u2022 D2 (Severe Drought - Orange): Crop or pasture losses likely; water shortages common and water restrictions imposed.\n\u2022 D3 (Extreme Drought - Red): Major crop/pasture losses and widespread water shortages or restrictions.\n\u2022 D4 (Exceptional Drought - Dark Brown/Maroon): Exceptional and widespread crop/pasture losses; emergencies in water supply and wildfire fuel aridity.",
      "categoryLabel": "Extended Climate & Outlooks",
      "sourceModels": [
        "National Drought Mitigation Center (NDMC / UNL)",
        "NOAA National Integrated Drought Information System (NIDIS)",
        "USDA World Agricultural Outlook Board",
        "NOAA Climate Prediction Center (CPC)"
      ],
      "outputModels": [
        "Vector Classifications & Tendency Polygons GeoJSON"
      ],
      "toastTitle": "U.S. Drought Monitor & Outlook",
      "toastSubtitle": "WEEKLY NDMC / NOAA CLASSIFICATION",
      "toastDescription": "Maps official weekly U.S. Drought Monitor intensity tiers (D0 Abnormally Dry to D4 Exceptional Drought) and seasonal drought tendency outlooks."
    },
    "cpc_outlook": {
      "id": "cpc_outlook",
      "label": "Extended Outlooks (Climate Prediction Center)",
      "product": "cpc_outlooks",
      "icon": "\ud83d\udcc8",
      "category": "extended_climate",
      "description": "NOAA Climate Prediction Center 6-10 Day, 8-14 Day, and Monthly temperature and precipitation probability outlooks",
      "category_label": "Extended Climate & Outlooks",
      "long_description": "Authoritative NOAA Climate Prediction Center (CPC) probabilistic outlooks for temperature and precipitation anomalies covering 6-10 Day, 8-14 Day (Week 2), and Monthly planning horizons.",
      "score_description": "\u2022 Warm / Above-Normal Temperature (Orange to Red): Elevated probability (33% to 90%+) of temperatures averaging above the 30-year seasonal normal.\n\u2022 Cool / Below-Normal Temperature (Light Blue to Deep Blue): Elevated probability of temperatures averaging below the 30-year seasonal normal.\n\u2022 Wet / Above-Normal Precipitation (Teal to Emerald Green): Elevated probability of cumulative precipitation exceeding seasonal norms.\n\u2022 Dry / Below-Normal Precipitation (Tan to Brown): Elevated probability of drier-than-normal conditions.\n\u2022 Near Normal / Equal Chances (Gray/Clear): Climatological probabilities apply with no dominant anomaly signal.",
      "source_models": [
        "NOAA Climate Prediction Center (CPC)",
        "Global Ensemble Forecast System (GEFS)",
        "ECMWF Integrated Forecasting System Ensemble (EPS)",
        "Canadian Meteorological Centre Ensemble (CMCE)"
      ],
      "output_models": [
        "CPC Anomaly Probability Contours GeoJSON"
      ],
      "toast_title": "CPC Extended Temperature & Precip Outlooks",
      "toast_subtitle": "6\u201310 DAY, 8\u201314 DAY & MONTHLY OUTLOOKS",
      "toast_description": "Shows NOAA Climate Prediction Center probabilistic outlooks for above- or below-normal temperatures and precipitation 1 to 4 weeks ahead.",
      "longDescription": "Authoritative NOAA Climate Prediction Center (CPC) probabilistic outlooks for temperature and precipitation anomalies covering 6-10 Day, 8-14 Day (Week 2), and Monthly planning horizons.",
      "scoreDescription": "\u2022 Warm / Above-Normal Temperature (Orange to Red): Elevated probability (33% to 90%+) of temperatures averaging above the 30-year seasonal normal.\n\u2022 Cool / Below-Normal Temperature (Light Blue to Deep Blue): Elevated probability of temperatures averaging below the 30-year seasonal normal.\n\u2022 Wet / Above-Normal Precipitation (Teal to Emerald Green): Elevated probability of cumulative precipitation exceeding seasonal norms.\n\u2022 Dry / Below-Normal Precipitation (Tan to Brown): Elevated probability of drier-than-normal conditions.\n\u2022 Near Normal / Equal Chances (Gray/Clear): Climatological probabilities apply with no dominant anomaly signal.",
      "categoryLabel": "Extended Climate & Outlooks",
      "sourceModels": [
        "NOAA Climate Prediction Center (CPC)",
        "Global Ensemble Forecast System (GEFS)",
        "ECMWF Integrated Forecasting System Ensemble (EPS)",
        "Canadian Meteorological Centre Ensemble (CMCE)"
      ],
      "outputModels": [
        "CPC Anomaly Probability Contours GeoJSON"
      ],
      "toastTitle": "CPC Extended Temperature & Precip Outlooks",
      "toastSubtitle": "6\u201310 DAY, 8\u201314 DAY & MONTHLY OUTLOOKS",
      "toastDescription": "Shows NOAA Climate Prediction Center probabilistic outlooks for above- or below-normal temperatures and precipitation 1 to 4 weeks ahead."
    },
    "tropical_cyclones": {
      "id": "tropical_cyclones",
      "label": "Tropical Cyclones & Hazards",
      "product": "tropical",
      "icon": "\ud83c\udf00",
      "category": "extended_climate",
      "description": "NOAA National Hurricane Center (NHC) active tropical cyclone forecast tracks, cones of uncertainty, wind radii swaths, coastal warnings, and GTWO disturbance outlooks",
      "category_label": "Extended Climate & Outlooks",
      "long_description": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
      "score_description": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
      "source_models": [
        "NOAA National Hurricane Center (NHC)",
        "Central Pacific Hurricane Center (CPHC)",
        "Automated Tropical Cyclone Forecasting (ATCF) System"
      ],
      "output_models": [
        "NHC Active Tropical Advisory GIS GeoJSON"
      ],
      "toast_title": "Tropical Cyclones & NHC Outlooks",
      "toast_subtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
      "toast_description": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities.",
      "longDescription": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
      "scoreDescription": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
      "categoryLabel": "Extended Climate & Outlooks",
      "sourceModels": [
        "NOAA National Hurricane Center (NHC)",
        "Central Pacific Hurricane Center (CPHC)",
        "Automated Tropical Cyclone Forecasting (ATCF) System"
      ],
      "outputModels": [
        "NHC Active Tropical Advisory GIS GeoJSON"
      ],
      "toastTitle": "Tropical Cyclones & NHC Outlooks",
      "toastSubtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
      "toastDescription": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities."
    },
    "golden_hour": {
      "id": "golden_hour",
      "label": "Sunrise & Sunset",
      "product": "sunrise",
      "model": "gw_v2_blend_50",
      "icon": "\ud83c\udf05",
      "category": "sky_solar",
      "description": "Sunrise and Sunset color/quality probability forecast",
      "category_label": "Forecast Quality Scoring",
      "long_description": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
      "score_description": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf"
      ],
      "output_models": [
        "gw_v2_blend_50",
        "gw_v2_hrrr",
        "gw_v2_rrfs",
        "gw_v2_rdps",
        "gw_v2_gfs",
        "gw_v2_ecmwf",
        "gw_nowcast"
      ],
      "toast_title": "Sunrise & Sunset 10-Day Forecast",
      "toast_subtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
      "toast_description": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
      "nowcast_toast_title": "SkySkout Sunset & Sunrise NowCast",
      "nowcast_toast_subtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
      "nowcast_toast_description": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions.",
      "longDescription": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
      "scoreDescription": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
      "categoryLabel": "Forecast Quality Scoring",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf"
      ],
      "outputModels": [
        "gw_v2_blend_50",
        "gw_v2_hrrr",
        "gw_v2_rrfs",
        "gw_v2_rdps",
        "gw_v2_gfs",
        "gw_v2_ecmwf",
        "gw_nowcast"
      ],
      "toastTitle": "Sunrise & Sunset 10-Day Forecast",
      "toastSubtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
      "toastDescription": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
      "nowcastToastTitle": "SkySkout Sunset & Sunrise NowCast",
      "nowcastToastSubtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
      "nowcastToastDescription": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions."
    },
    "alpenglow_forecast": {
      "id": "alpenglow_forecast",
      "label": "Golden Hour / Alpenglow",
      "product": "alpenglow",
      "model": "gw_v2_blend_50",
      "icon": "\ud83c\udfd4\ufe0f\ud83c\udf05",
      "category": "sky_solar",
      "description": "High-elevation alpine illumination quality/probability score",
      "basemap_override": {
        "mode": "dark"
      },
      "category_label": "Forecast Quality Scoring",
      "long_description": "Dual-mode alpine alpenglow (topographic prominence & solar aspect hillshading) and landscape golden hour forecast.",
      "score_description": "\u2022 80-100 (Vivid/Burn): Unobstructed low-angle solar beam illuminating prominent peaks or landscapes with intense warm golden and crimson light.\n\u2022 60-79 (Above Average): Strong direct golden hour illumination with favorable atmospheric clarity and minimal horizon blockage.\n\u2022 40-59 (Average/Clear): Clean standard golden hour light on exposed terrain slopes and ridges.\n\u2022 31-39 (Below Average): Filtered or partially attenuated low-angle sunlight due to cloud bands or haze.\n\u2022 21-30 (Muted): Weak, diffused twilight illumination with heavy cloud filtering along the solar path.\n\u2022 0-20 (Poor/Occluded): Direct solar beam blocked by terrain shadow, dense low cloud decks, or precipitation.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf"
      ],
      "output_models": [
        "gw_v2_blend_50",
        "gw_v2_hrrr",
        "gw_v2_rrfs",
        "gw_v2_rdps",
        "gw_v2_gfs",
        "gw_v2_ecmwf",
        "gw_nowcast"
      ],
      "toast_title": "Golden Hour & Alpenglow 10-Day Forecast",
      "toast_subtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
      "toast_description": "Models low-angle direct solar beam transmission and topographic mountain peak illumination up to 10 days out using multi-model NWP cloud and moisture forecasts.",
      "nowcast_toast_title": "Golden Hour & Alpenglow Live NowCast",
      "nowcast_toast_subtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
      "nowcast_toast_description": "Uses live GOES satellite imagery and radar optical flow (T+2h/4h/6h) to score low-angle golden hour light transmission and peak alpenglow for the next upcoming twilight event.",
      "basemapOverride": {
        "mode": "dark"
      },
      "longDescription": "Dual-mode alpine alpenglow (topographic prominence & solar aspect hillshading) and landscape golden hour forecast.",
      "scoreDescription": "\u2022 80-100 (Vivid/Burn): Unobstructed low-angle solar beam illuminating prominent peaks or landscapes with intense warm golden and crimson light.\n\u2022 60-79 (Above Average): Strong direct golden hour illumination with favorable atmospheric clarity and minimal horizon blockage.\n\u2022 40-59 (Average/Clear): Clean standard golden hour light on exposed terrain slopes and ridges.\n\u2022 31-39 (Below Average): Filtered or partially attenuated low-angle sunlight due to cloud bands or haze.\n\u2022 21-30 (Muted): Weak, diffused twilight illumination with heavy cloud filtering along the solar path.\n\u2022 0-20 (Poor/Occluded): Direct solar beam blocked by terrain shadow, dense low cloud decks, or precipitation.",
      "categoryLabel": "Forecast Quality Scoring",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf"
      ],
      "outputModels": [
        "gw_v2_blend_50",
        "gw_v2_hrrr",
        "gw_v2_rrfs",
        "gw_v2_rdps",
        "gw_v2_gfs",
        "gw_v2_ecmwf",
        "gw_nowcast"
      ],
      "toastTitle": "Golden Hour & Alpenglow 10-Day Forecast",
      "toastSubtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
      "toastDescription": "Models low-angle direct solar beam transmission and topographic mountain peak illumination up to 10 days out using multi-model NWP cloud and moisture forecasts.",
      "nowcastToastTitle": "Golden Hour & Alpenglow Live NowCast",
      "nowcastToastSubtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
      "nowcastToastDescription": "Uses live GOES satellite imagery and radar optical flow (T+2h/4h/6h) to score low-angle golden hour light transmission and peak alpenglow for the next upcoming twilight event."
    },
    "darkskies_bortle": {
      "id": "darkskies_bortle",
      "label": "Dark Sky Forecast",
      "product": "darkskies",
      "model": "blend",
      "icon": "\u2728",
      "category": "sky_solar",
      "description": "Hourly forecast of clear sky conditions incorporating Bortle score, numerous atmospheric conditions, lunar phase/position, and more.",
      "basemap_override": {
        "mode": "dark",
        "terrain_3d": false
      },
      "category_label": "Forecast Quality Scoring",
      "long_description": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
      "score_description": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "World Atlas Light Pollution"
      ],
      "output_models": [
        "blend",
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf"
      ],
      "toast_title": "Dark Skies Stargazing Forecast",
      "toast_subtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
      "toast_description": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score.",
      "basemapOverride": {
        "mode": "dark",
        "terrain3d": false
      },
      "longDescription": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
      "scoreDescription": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
      "categoryLabel": "Forecast Quality Scoring",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "World Atlas Light Pollution"
      ],
      "outputModels": [
        "blend",
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf"
      ],
      "toastTitle": "Dark Skies Stargazing Forecast",
      "toastSubtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
      "toastDescription": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score."
    },
    "solar_lunar_tools": {
      "id": "solar_lunar_tools",
      "label": "Solar & Lunar Visualization Tools",
      "product": "solar_lunar",
      "icon": "\ud83c\udf17",
      "category": "sky_solar",
      "is_tool_mode": true,
      "description": "Solar and Lunar visualizations, calendar and AR tools.",
      "category_label": "Astronomical & Ephemeris",
      "long_description": "Astronomical ephemeris calculator and visualization tools predicting solar azimuth, golden hour, blue hour, moon phases, illumination percentage, and galactic core alignment.",
      "score_description": "\u2022 Solar Azimuth & Elevation: Real-time and forecasted sunrise, sunset, golden hour, and blue hour ray lines.\n\u2022 Lunar Ephemeris: Moonrise, moonset, phase percentage, and altitude/azimuth trajectories.\n\u2022 Galactic Core Visibility: Milky Way core elevation, azimuth window, and dark-sky overlap.",
      "source_models": [
        "Astronomical Ephemeris Algorithms (SunCalc & MoonCalc)"
      ],
      "output_models": [
        "Interactive ephemeris trajectories, galactic core tracking, and illumination curves"
      ],
      "toast_title": "Solar & Lunar Ephemeris Tools",
      "toast_subtitle": "SUN, MOON & MILKY WAY ALIGNMENT",
      "toast_description": "Visualizes exact sun and moon azimuth bearings, elevation angles, twilight windows, and Milky Way galactic core alignment for any map location.",
      "longDescription": "Astronomical ephemeris calculator and visualization tools predicting solar azimuth, golden hour, blue hour, moon phases, illumination percentage, and galactic core alignment.",
      "scoreDescription": "\u2022 Solar Azimuth & Elevation: Real-time and forecasted sunrise, sunset, golden hour, and blue hour ray lines.\n\u2022 Lunar Ephemeris: Moonrise, moonset, phase percentage, and altitude/azimuth trajectories.\n\u2022 Galactic Core Visibility: Milky Way core elevation, azimuth window, and dark-sky overlap.",
      "categoryLabel": "Astronomical & Ephemeris",
      "sourceModels": [
        "Astronomical Ephemeris Algorithms (SunCalc & MoonCalc)"
      ],
      "outputModels": [
        "Interactive ephemeris trajectories, galactic core tracking, and illumination curves"
      ],
      "toastTitle": "Solar & Lunar Ephemeris Tools",
      "toastSubtitle": "SUN, MOON & MILKY WAY ALIGNMENT",
      "toastDescription": "Visualizes exact sun and moon azimuth bearings, elevation angles, twilight windows, and Milky Way galactic core alignment for any map location."
    },
    "aurora_viewline": {
      "id": "aurora_viewline",
      "label": "Aurora Borealis",
      "product": "aurora",
      "icon": "\ud83c\udf0c",
      "category": "sky_solar",
      "description": "Auroral oval extent & Northern Lights visibility horizon forecast.",
      "category_label": "Space Weather & Astronomical",
      "long_description": "Auroral oval Extent & Kp Index Northern Lights visibility forecast.",
      "score_description": "\u2022 Overhead Auroral Oval (Green to Red Probability): Direct geomagnetic storm auroral precipitation probability.\n\u2022 Southern Viewline Horizon: The southernmost latitude where the Northern Lights can be seen low on the northern horizon under clear, dark skies.\n\u2022 Kp 0\u20133 (Quiet): Confined to far northern polar latitudes.\n\u2022 Kp 4\u20135 (Active to G1 Minor Storm): Visible across Canada and northern tier US states.\n\u2022 Kp 6\u20139 (G2 Moderate to G5 Extreme Storm): Mid-latitude aurora borealis expansion.",
      "source_models": [
        "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index (Kp) Forecast"
      ],
      "output_models": [
        "aurora_YYYY-MM-DD.pmtiles",
        "aurora_viewline_YYYY-MM-DD.json",
        "noaa_kp_forecast.json"
      ],
      "toast_title": "Aurora Borealis Viewline & Kp Forecast",
      "toast_subtitle": "NOAA SWPC GEOMAGNETIC STORM OUTLOOK",
      "toast_description": "Maps the southern aurora visibility horizon and geomagnetic Kp-index probabilities driven by real-time solar wind telemetry.",
      "longDescription": "Auroral oval Extent & Kp Index Northern Lights visibility forecast.",
      "scoreDescription": "\u2022 Overhead Auroral Oval (Green to Red Probability): Direct geomagnetic storm auroral precipitation probability.\n\u2022 Southern Viewline Horizon: The southernmost latitude where the Northern Lights can be seen low on the northern horizon under clear, dark skies.\n\u2022 Kp 0\u20133 (Quiet): Confined to far northern polar latitudes.\n\u2022 Kp 4\u20135 (Active to G1 Minor Storm): Visible across Canada and northern tier US states.\n\u2022 Kp 6\u20139 (G2 Moderate to G5 Extreme Storm): Mid-latitude aurora borealis expansion.",
      "categoryLabel": "Space Weather & Astronomical",
      "sourceModels": [
        "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index (Kp) Forecast"
      ],
      "outputModels": [
        "aurora_YYYY-MM-DD.pmtiles",
        "aurora_viewline_YYYY-MM-DD.json",
        "noaa_kp_forecast.json"
      ],
      "toastTitle": "Aurora Borealis Viewline & Kp Forecast",
      "toastSubtitle": "NOAA SWPC GEOMAGNETIC STORM OUTLOOK",
      "toastDescription": "Maps the southern aurora visibility horizon and geomagnetic Kp-index probabilities driven by real-time solar wind telemetry."
    },
    "kp_index": {
      "id": "kp_index",
      "label": "KP-Index Forecast",
      "product": "kp_index",
      "icon": "\ud83d\udcca",
      "category": "sky_solar",
      "description": "NOAA SWPC 3-day Planetary K-index (Kp) geomagnetic storm forecast.",
      "category_label": "Space Weather & Astronomical",
      "long_description": "Planetary K-index (Kp) geomagnetic storm intensity forecast and 3-day space weather outlook from NOAA SWPC, quantifying solar wind disturbance of Earth\u2019s magnetosphere in 3-hour intervals.",
      "score_description": "\u2022 Kp 0\u20133 (Quiet / Unsettled - Green): Calm magnetosphere; aurora limited to far northern latitudes.\n\u2022 Kp 4 (Active - Yellow): Auroral oval brightens and expands across northern Canada and Alaska.\n\u2022 Kp 5 (G1 Minor Storm - Amber): Northern Lights visible along the US\u2013Canada border.\n\u2022 Kp 6\u20137 (G2\u2013G3 Moderate/Strong Storm - Orange/Red): Widespread mid-latitude photographic and visual aurora.\n\u2022 Kp 8\u20139 (G4\u2013G5 Severe/Extreme Storm - Magenta): Historic geomagnetic storm visible deep into mid-to-low latitudes.",
      "source_models": [
        "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index Forecast"
      ],
      "output_models": [
        "noaa_kp_forecast.json",
        "aurora_viewline_YYYY-MM-DD.json"
      ],
      "toast_title": "Planetary Kp-Index Forecast",
      "toast_subtitle": "3-DAY GEOMAGNETIC STORM TIMELINE",
      "toast_description": "Tracks 3-hour Planetary Kp-index geomagnetic storm levels (Kp 0\u20139) from NOAA SWPC to time peak Northern Lights substorms.",
      "longDescription": "Planetary K-index (Kp) geomagnetic storm intensity forecast and 3-day space weather outlook from NOAA SWPC, quantifying solar wind disturbance of Earth\u2019s magnetosphere in 3-hour intervals.",
      "scoreDescription": "\u2022 Kp 0\u20133 (Quiet / Unsettled - Green): Calm magnetosphere; aurora limited to far northern latitudes.\n\u2022 Kp 4 (Active - Yellow): Auroral oval brightens and expands across northern Canada and Alaska.\n\u2022 Kp 5 (G1 Minor Storm - Amber): Northern Lights visible along the US\u2013Canada border.\n\u2022 Kp 6\u20137 (G2\u2013G3 Moderate/Strong Storm - Orange/Red): Widespread mid-latitude photographic and visual aurora.\n\u2022 Kp 8\u20139 (G4\u2013G5 Severe/Extreme Storm - Magenta): Historic geomagnetic storm visible deep into mid-to-low latitudes.",
      "categoryLabel": "Space Weather & Astronomical",
      "sourceModels": [
        "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index Forecast"
      ],
      "outputModels": [
        "noaa_kp_forecast.json",
        "aurora_viewline_YYYY-MM-DD.json"
      ],
      "toastTitle": "Planetary Kp-Index Forecast",
      "toastSubtitle": "3-DAY GEOMAGNETIC STORM TIMELINE",
      "toastDescription": "Tracks 3-hour Planetary Kp-index geomagnetic storm levels (Kp 0\u20139) from NOAA SWPC to time peak Northern Lights substorms."
    },
    "optics_dew_risk": {
      "id": "optics_dew_risk",
      "label": "Optics Fogging Potential",
      "product": "optics_dew_risk",
      "icon": "\ud83d\udcf7",
      "category": "temperature",
      "description": "Likelihood of optics (Camera lenses and Telescopes) fogging.",
      "category_label": "Specialized Forecast Index",
      "long_description": "Dew point depression & lens/telescope fogging risk index. Indicates where fogging on lenses is likely for telescope and camera users.",
      "score_description": "\u2022 Low Risk (0\u201325%): Large spread between air temperature and dew point or sufficient breeze to prevent radiative surface cooling.\n\u2022 Moderate Risk (25\u201360%): Narrowing dewpoint depression under clear skies; lens hoods recommended for long timelapses.\n\u2022 High / Severe Condensation Risk (60\u2013100%): Exposed glass and metal surfaces cool below the ambient dew point via clear-sky infrared radiation; active dew heaters required.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "output_models": [
        "blend & hrrr .pmtiles"
      ],
      "toast_title": "Camera & Telescope Optics Dew Risk",
      "toast_subtitle": "RADIATIVE COOLING CONDENSATION HAZARD",
      "toast_description": "Predicts the likelihood of condensation forming on exposed camera lenses and telescope optics based on dewpoint depression, wind speed, and clear-sky radiative cooling.",
      "longDescription": "Dew point depression & lens/telescope fogging risk index. Indicates where fogging on lenses is likely for telescope and camera users.",
      "scoreDescription": "\u2022 Low Risk (0\u201325%): Large spread between air temperature and dew point or sufficient breeze to prevent radiative surface cooling.\n\u2022 Moderate Risk (25\u201360%): Narrowing dewpoint depression under clear skies; lens hoods recommended for long timelapses.\n\u2022 High / Severe Condensation Risk (60\u2013100%): Exposed glass and metal surfaces cool below the ambient dew point via clear-sky infrared radiation; active dew heaters required.",
      "categoryLabel": "Specialized Forecast Index",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "outputModels": [
        "blend & hrrr .pmtiles"
      ],
      "toastTitle": "Camera & Telescope Optics Dew Risk",
      "toastSubtitle": "RADIATIVE COOLING CONDENSATION HAZARD",
      "toastDescription": "Predicts the likelihood of condensation forming on exposed camera lenses and telescope optics based on dewpoint depression, wind speed, and clear-sky radiative cooling."
    },
    "seeing": {
      "id": "seeing",
      "label": "Astronomical Seeing",
      "product": "seeing",
      "model": "rdps",
      "icon": "\ud83d\udd2d",
      "category": "sky_solar",
      "description": "Atmospheric optical stability and wavefront steadiness modeling turbulent optical distortion across night hours (0-100 score).",
      "category_label": "Specialized Forecast Index",
      "long_description": "Atmospheric optical stability predicting wavefront steadiness, jet stream shear, boundary layer turbulence, and telescope resolution.",
      "score_description": "\u2022 80\u2013100 (Excellent / Sub-Arcsecond Stability): Calm upper-level winds and minimal thermal gradients; crisp planetary detail and pinpoint stars.\n\u2022 60\u201379 (Good Seeing): Slight atmospheric shimmer; well-suited for deep-sky imaging and medium-to-high magnification.\n\u2022 40\u201359 (Average / Moderate Turbulence): Noticeable star twinkling (scintillation) and softening of fine lunar/planetary features.\n\u2022 0\u201339 (Poor / Turbulent Jet Stream Shear): Strong vertical wind shear or boundary-layer mixing causing rapid wavefront distortion.",
      "source_models": [
        "rdps",
        "hrrr",
        "rrfs",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "output_models": [
        "rdps & hrrr .pmtiles"
      ],
      "toast_title": "Astronomical Seeing & Jet Stream Stability",
      "toast_subtitle": "OPTICAL TURBULENCE & THERMAL SHEAR",
      "toast_description": "Evaluates atmospheric optical stability for planetary imaging and high-magnification stargazing based on vertical wind shear and thermal gradients.",
      "longDescription": "Atmospheric optical stability predicting wavefront steadiness, jet stream shear, boundary layer turbulence, and telescope resolution.",
      "scoreDescription": "\u2022 80\u2013100 (Excellent / Sub-Arcsecond Stability): Calm upper-level winds and minimal thermal gradients; crisp planetary detail and pinpoint stars.\n\u2022 60\u201379 (Good Seeing): Slight atmospheric shimmer; well-suited for deep-sky imaging and medium-to-high magnification.\n\u2022 40\u201359 (Average / Moderate Turbulence): Noticeable star twinkling (scintillation) and softening of fine lunar/planetary features.\n\u2022 0\u201339 (Poor / Turbulent Jet Stream Shear): Strong vertical wind shear or boundary-layer mixing causing rapid wavefront distortion.",
      "categoryLabel": "Specialized Forecast Index",
      "sourceModels": [
        "rdps",
        "hrrr",
        "rrfs",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "outputModels": [
        "rdps & hrrr .pmtiles"
      ],
      "toastTitle": "Astronomical Seeing & Jet Stream Stability",
      "toastSubtitle": "OPTICAL TURBULENCE & THERMAL SHEAR",
      "toastDescription": "Evaluates atmospheric optical stability for planetary imaging and high-magnification stargazing based on vertical wind shear and thermal gradients."
    },
    "foliage": {
      "id": "foliage",
      "label": "Fall Foliage Forecast",
      "product": "foliage",
      "icon": "\ud83c\udf41",
      "category": "phenology",
      "description": "Daily refreshed forecast for fall foliage timing and intensity.",
      "category_label": "Seasonal Phenology",
      "long_description": "The Fall Foliage forecast provides a comprehensive set of visual tools to help autumn travelers, hikers, and photographers plan their trips:\n\n\u2022 PEAK DATE - Displays a continental map of the projected calendar date when peak autumn color first arrives at each location. Colors transition chronologically from early September 15 peaks (green), through yellow, gold, orange, red, and brown, to mid-November (grey). Toggle between Full Landscape and Treed Regions Only, or click any location to see its exact projected peak date.\n\n\u2022 DETAILED TIMING / CALENDAR - Shows an interactive calendar providing an at-a-glance seasonal color progression for any selected location, alongside daily continental maps showing color evolution from green canopy to peak foliage. Toggle between Full Landscape and Treed Regions Only to inspect regional forests.\n\n\u2022 VIBRANCY THIS SEASON - Displays anticipated differences in peak color brilliance and saturation compared to an average season. Evaluates cool crisp nights (which trap anthocyanin red pigments), bright sunny days (which power sugar production), summer drought scorch, and wind penalties.\n\n\u2022 CANOPY COVER - Displays satellite-measured tree canopy density (USGS NLCD & NALCMS) to show where broadleaf deciduous and mixed hardwood forests are concentrated across North America.\n\n\u2022 TREE SPECIES - Maps native forest distributions for key autumn tree families, including Scarlet Red Maples, Canary Gold Aspens & Birches, Bronze Oaks & Beeches, and Golden Larches/Tamaracks.\n\n\u2022 HEAT ANOMALY - Shows summer mean temperature departures compared to 30-year climate normals. Excessive summer heat stress damages leaf chlorophyll and can cause early scorching or dull browning.\n\n\u2022 MOISTURE - Shows summer root-zone soil moisture anomalies compared to normal (from NOAA CPC). Soil moisture plays a critical role in tree health: severe drought causes premature leaf drop and muted colors, whereas healthy summer moisture supports vibrant displays.\n\nHow the Forecast Works & Data Timeline:\nOur biophysical phenology model continuously integrates seasonal growing conditions, real-time weather observations, and short-term numerical forecasts:\n\u2022 Antecedent Inputs: Summer soil moisture and heat stress define baseline tree vitality and drought resilience.\n\u2022 Observed Weather: Ground-truth daily minimum temperatures from NOAA URMA lock in chilling accumulation through September and October.\n\u2022 5-to-7 Day Forecasts: Short-term weather predictions from NOAA NDFD drive active chilling and color onset. Note that forecasts 5 to 7 days out are dynamic and subject to update as weather systems shift.\n\u2022 Long-Range Horizon: Dates beyond the short-term forecast window are guided by 30-year PRISM climatological normals for long-range trip planning.",
      "score_description": "\u2022 Above Normal / Enhanced Vibrancy: Plentiful sunny afternoons, crisp above-freezing nights (34\u00b0F to 45\u00b0F), and calm winds promote intense anthocyanin pigment production, rich saturation, and extended peak retention with minimal early leaf drop.\n\u2022 Average / Typical Vibrancy: Expected baseline autumn coloration aligned with 30-year historical climate norms for the region and species mix.\n\u2022 Below Normal / Reduced Vibrancy: Unseasonably warm nights (preventing sugar trapping), severe summer drought scorch, persistent cloudy rain, or premature killing freezes produce muted, dull, or brown-tinted foliage.",
      "source_models": [
        "NOAA URMA (Observed Daily Tmin)",
        "NOAA NDFD (5-7 Day Weather Forecast)",
        "PRISM (30-Yr Daily Climatology Normals)",
        "NOAA CPC (Soil Moisture Anomalies)",
        "NASA Daymet (Solar Irradiance Normals)",
        "USGS NLCD & Tree Species Atlas"
      ],
      "output_models": [
        "Peak Color Arrival by Date (foliage_peak_date.pmtiles)",
        "Peak Color Arrival - Treed Only (foliage_peak_date_treed.pmtiles)",
        "Daily Color Progression (foliage_{date}.pmtiles)",
        "Seasonal Vibrancy Departure (foliage_vibrancy.pmtiles)",
        "Deciduous Tree Canopy Density (foliage_canopy.pmtiles)",
        "Native Tree Species Distribution (foliage_species.pmtiles)",
        "Summer Temperature Anomaly (foliage_summer_temp_anomaly.pmtiles)",
        "Summer Soil Moisture Anomaly (foliage_soil_moisture_anomaly.pmtiles)"
      ],
      "toast_title": "Fall Foliage Timing & Vibrancy Forecast",
      "toast_subtitle": "BIOPHYSICAL AUTUMN PHENOLOGY MODEL",
      "toast_description": "Tracks projected peak autumn foliage dates, daily color progression, tree species habitats, and seasonal color vibrancy across North America.",
      "longDescription": "The Fall Foliage forecast provides a comprehensive set of visual tools to help autumn travelers, hikers, and photographers plan their trips:\n\n\u2022 PEAK DATE - Displays a continental map of the projected calendar date when peak autumn color first arrives at each location. Colors transition chronologically from early September 15 peaks (green), through yellow, gold, orange, red, and brown, to mid-November (grey). Toggle between Full Landscape and Treed Regions Only, or click any location to see its exact projected peak date.\n\n\u2022 DETAILED TIMING / CALENDAR - Shows an interactive calendar providing an at-a-glance seasonal color progression for any selected location, alongside daily continental maps showing color evolution from green canopy to peak foliage. Toggle between Full Landscape and Treed Regions Only to inspect regional forests.\n\n\u2022 VIBRANCY THIS SEASON - Displays anticipated differences in peak color brilliance and saturation compared to an average season. Evaluates cool crisp nights (which trap anthocyanin red pigments), bright sunny days (which power sugar production), summer drought scorch, and wind penalties.\n\n\u2022 CANOPY COVER - Displays satellite-measured tree canopy density (USGS NLCD & NALCMS) to show where broadleaf deciduous and mixed hardwood forests are concentrated across North America.\n\n\u2022 TREE SPECIES - Maps native forest distributions for key autumn tree families, including Scarlet Red Maples, Canary Gold Aspens & Birches, Bronze Oaks & Beeches, and Golden Larches/Tamaracks.\n\n\u2022 HEAT ANOMALY - Shows summer mean temperature departures compared to 30-year climate normals. Excessive summer heat stress damages leaf chlorophyll and can cause early scorching or dull browning.\n\n\u2022 MOISTURE - Shows summer root-zone soil moisture anomalies compared to normal (from NOAA CPC). Soil moisture plays a critical role in tree health: severe drought causes premature leaf drop and muted colors, whereas healthy summer moisture supports vibrant displays.\n\nHow the Forecast Works & Data Timeline:\nOur biophysical phenology model continuously integrates seasonal growing conditions, real-time weather observations, and short-term numerical forecasts:\n\u2022 Antecedent Inputs: Summer soil moisture and heat stress define baseline tree vitality and drought resilience.\n\u2022 Observed Weather: Ground-truth daily minimum temperatures from NOAA URMA lock in chilling accumulation through September and October.\n\u2022 5-to-7 Day Forecasts: Short-term weather predictions from NOAA NDFD drive active chilling and color onset. Note that forecasts 5 to 7 days out are dynamic and subject to update as weather systems shift.\n\u2022 Long-Range Horizon: Dates beyond the short-term forecast window are guided by 30-year PRISM climatological normals for long-range trip planning.",
      "scoreDescription": "\u2022 Above Normal / Enhanced Vibrancy: Plentiful sunny afternoons, crisp above-freezing nights (34\u00b0F to 45\u00b0F), and calm winds promote intense anthocyanin pigment production, rich saturation, and extended peak retention with minimal early leaf drop.\n\u2022 Average / Typical Vibrancy: Expected baseline autumn coloration aligned with 30-year historical climate norms for the region and species mix.\n\u2022 Below Normal / Reduced Vibrancy: Unseasonably warm nights (preventing sugar trapping), severe summer drought scorch, persistent cloudy rain, or premature killing freezes produce muted, dull, or brown-tinted foliage.",
      "categoryLabel": "Seasonal Phenology",
      "sourceModels": [
        "NOAA URMA (Observed Daily Tmin)",
        "NOAA NDFD (5-7 Day Weather Forecast)",
        "PRISM (30-Yr Daily Climatology Normals)",
        "NOAA CPC (Soil Moisture Anomalies)",
        "NASA Daymet (Solar Irradiance Normals)",
        "USGS NLCD & Tree Species Atlas"
      ],
      "outputModels": [
        "Peak Color Arrival by Date (foliage_peak_date.pmtiles)",
        "Peak Color Arrival - Treed Only (foliage_peak_date_treed.pmtiles)",
        "Daily Color Progression (foliage_{date}.pmtiles)",
        "Seasonal Vibrancy Departure (foliage_vibrancy.pmtiles)",
        "Deciduous Tree Canopy Density (foliage_canopy.pmtiles)",
        "Native Tree Species Distribution (foliage_species.pmtiles)",
        "Summer Temperature Anomaly (foliage_summer_temp_anomaly.pmtiles)",
        "Summer Soil Moisture Anomaly (foliage_soil_moisture_anomaly.pmtiles)"
      ],
      "toastTitle": "Fall Foliage Timing & Vibrancy Forecast",
      "toastSubtitle": "BIOPHYSICAL AUTUMN PHENOLOGY MODEL",
      "toastDescription": "Tracks projected peak autumn foliage dates, daily color progression, tree species habitats, and seasonal color vibrancy across North America."
    },
    "mushrooms": {
      "id": "mushrooms",
      "label": "Wild Mushroom Foraging",
      "product": "mushrooms",
      "icon": "\ud83c\udf44",
      "category": "phenology",
      "description": "Active fruiting flushes and 7-day outlook updated daily.",
      "category_label": "Seasonal Phenology",
      "long_description": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
      "score_description": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
      "source_models": [
        "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
        "NOAA NBM / HRRR Soil & Surface Temperature",
        "USGS NLCD & Forest Host Species Habitat Maps"
      ],
      "output_models": [
        "Species-Specific Fruiting Probability Tiles (.pmtiles)",
        "7-Day Foraging Flush Outlook"
      ],
      "toast_title": "Wild Mushroom Foraging Forecast",
      "toast_subtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
      "toast_description": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats.",
      "longDescription": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
      "scoreDescription": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
      "categoryLabel": "Seasonal Phenology",
      "sourceModels": [
        "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
        "NOAA NBM / HRRR Soil & Surface Temperature",
        "USGS NLCD & Forest Host Species Habitat Maps"
      ],
      "outputModels": [
        "Species-Specific Fruiting Probability Tiles (.pmtiles)",
        "7-Day Foraging Flush Outlook"
      ],
      "toastTitle": "Wild Mushroom Foraging Forecast",
      "toastSubtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
      "toastDescription": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats."
    },
    "alpine_wildflowers": {
      "id": "alpine_wildflowers",
      "label": "Wildflowers (Mountain/Alpine)",
      "product": "alpine_wildflowers",
      "icon": "\ud83c\udf38",
      "category": "phenology",
      "description": "Peak bloom timing & intensity",
      "category_label": "Seasonal & Phenology",
      "long_description": "Predicts bloom onset, peak floral concurrency, bloom duration, and display intensity (Mountain Bloom Intensity Index, MBII) for alpine and subalpine herbaceous perennials.\n\nDriven by winter snowpack insulation, dynamic snowmelt biofix (SWE <= 0), and post-melt growing degree days (GDD) with elevation lapse-rate corrections.\n\nIncludes multi-species coverage (Arrowleaf Balsamroot, Subalpine Lupine, Indian Paintbrush, Avalanche Lily), dual domain support (North America 2.5km and Global Alpine 13km), and interactive summer calendar and multi-species concurrency curves.",
      "score_description": "\u2022 Snowbound / Pre-Melt (Icy Cyan): Terrain still insulated under winter snowpack.\n\u2022 Emerging / Vegetative (Fresh Green): Post-melt vegetative green-up and bud initiation.\n\u2022 Early Bloom (Lime Yellow): Initial floral bud opening (15-30% open).\n\u2022 Peak Concurrency (Magenta / Rose): Broadfield meadow bloom display (60-100% open).\n\u2022 Past Peak (Amber / Orange): Seed maturation and petal drop.\n\u2022 MBII Intensity (Gold to Hot Pink): Mountain Bloom Intensity factoring floral synchrony, insulation, frost risk, and snowmelt sub-irrigation.",
      "source_models": [
        "nbm",
        "icon13",
        "gdps"
      ],
      "output_models": [
        "Alpine Wildflowers (.pmtiles)"
      ],
      "toast_title": "Alpine & Mountain Wildflowers Forecast",
      "toast_subtitle": "SNOWMELT BIOFIX & GDD PHENOLOGY",
      "toast_description": "Predicts alpine meadow bloom timing, peak multi-species concurrency, and Mountain Bloom Intensity (MBII) following winter snowmelt.",
      "longDescription": "Predicts bloom onset, peak floral concurrency, bloom duration, and display intensity (Mountain Bloom Intensity Index, MBII) for alpine and subalpine herbaceous perennials.\n\nDriven by winter snowpack insulation, dynamic snowmelt biofix (SWE <= 0), and post-melt growing degree days (GDD) with elevation lapse-rate corrections.\n\nIncludes multi-species coverage (Arrowleaf Balsamroot, Subalpine Lupine, Indian Paintbrush, Avalanche Lily), dual domain support (North America 2.5km and Global Alpine 13km), and interactive summer calendar and multi-species concurrency curves.",
      "scoreDescription": "\u2022 Snowbound / Pre-Melt (Icy Cyan): Terrain still insulated under winter snowpack.\n\u2022 Emerging / Vegetative (Fresh Green): Post-melt vegetative green-up and bud initiation.\n\u2022 Early Bloom (Lime Yellow): Initial floral bud opening (15-30% open).\n\u2022 Peak Concurrency (Magenta / Rose): Broadfield meadow bloom display (60-100% open).\n\u2022 Past Peak (Amber / Orange): Seed maturation and petal drop.\n\u2022 MBII Intensity (Gold to Hot Pink): Mountain Bloom Intensity factoring floral synchrony, insulation, frost risk, and snowmelt sub-irrigation.",
      "categoryLabel": "Seasonal & Phenology",
      "sourceModels": [
        "nbm",
        "icon13",
        "gdps"
      ],
      "outputModels": [
        "Alpine Wildflowers (.pmtiles)"
      ],
      "toastTitle": "Alpine & Mountain Wildflowers Forecast",
      "toastSubtitle": "SNOWMELT BIOFIX & GDD PHENOLOGY",
      "toastDescription": "Predicts alpine meadow bloom timing, peak multi-species concurrency, and Mountain Bloom Intensity (MBII) following winter snowmelt."
    },
    "desert_wildflowers": {
      "id": "desert_wildflowers",
      "label": "Desert Superbloom & Annuals",
      "product": "desert_wildflowers",
      "icon": "\ud83c\udfdc\ufe0f",
      "category": "phenology",
      "description": "Spring Desert wildflower timing and outlook updated daily.",
      "category_label": "Seasonal & Phenology",
      "long_description": "Predicts episodic germination probability, storm cadence viability, seasonal precipitation anomalies, and flowering intensity (Bloom Intensity Index, BII) across arid basins and alluvial fans.\n\nModels the 4-phase environmental cascade: autumn seed-leaching storm trigger (>= 20mm), mid-winter storm spacing (<= 18 days), spring thermal maturation, and desert heat scorch resistance.",
      "score_description": "\u2022 Germination / Rosette (Meadow Green): Early basal leaves emerging following soaking rainfall.\n\u2022 Early Blooms (Lime Yellow): Initial desert wash and alluvial fan flowering.\n\u2022 Peak Floral Carpet (Vibrant Rose / Crimson): Peak carpet concurrency across desert valley floors.\n\u2022 Past Peak (Warm Gold): Seed setting and rapid thermal desiccation.\n\u2022 BII Score (0-100): Desert Bloom Intensity measuring superbloom probability and display density.",
      "source_models": [
        "nbm",
        "icon13"
      ],
      "output_models": [
        "Desert Superbloom (.pmtiles)"
      ],
      "toast_title": "Desert Superbloom & Annuals Outlook",
      "toast_subtitle": "ARID GERMINATION & BLOOM INTENSITY",
      "toast_description": "Tracks winter rain germination triggers, storm cadence survival, and spring superbloom intensity across desert basins and washes.",
      "longDescription": "Predicts episodic germination probability, storm cadence viability, seasonal precipitation anomalies, and flowering intensity (Bloom Intensity Index, BII) across arid basins and alluvial fans.\n\nModels the 4-phase environmental cascade: autumn seed-leaching storm trigger (>= 20mm), mid-winter storm spacing (<= 18 days), spring thermal maturation, and desert heat scorch resistance.",
      "scoreDescription": "\u2022 Germination / Rosette (Meadow Green): Early basal leaves emerging following soaking rainfall.\n\u2022 Early Blooms (Lime Yellow): Initial desert wash and alluvial fan flowering.\n\u2022 Peak Floral Carpet (Vibrant Rose / Crimson): Peak carpet concurrency across desert valley floors.\n\u2022 Past Peak (Warm Gold): Seed setting and rapid thermal desiccation.\n\u2022 BII Score (0-100): Desert Bloom Intensity measuring superbloom probability and display density.",
      "categoryLabel": "Seasonal & Phenology",
      "sourceModels": [
        "nbm",
        "icon13"
      ],
      "outputModels": [
        "Desert Superbloom (.pmtiles)"
      ],
      "toastTitle": "Desert Superbloom & Annuals Outlook",
      "toastSubtitle": "ARID GERMINATION & BLOOM INTENSITY",
      "toastDescription": "Tracks winter rain germination triggers, storm cadence survival, and spring superbloom intensity across desert basins and washes."
    },
    "wild_berries": {
      "id": "wild_berries",
      "label": "Wild Berry Ripening & Foraging",
      "product": "wild_berries",
      "icon": "\ud83e\uded0",
      "category": "phenology",
      "description": "Ripening waves, harvest windows & berry quality updated daily.",
      "category_label": "Seasonal & Phenology",
      "long_description": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
      "score_description": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
      "source_models": [
        "nbm",
        "icon13",
        "gdps"
      ],
      "output_models": [
        "Wild Berries (.pmtiles)"
      ],
      "toast_title": "Wild Berry Ripening & Foraging",
      "toast_subtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
      "toast_description": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality.",
      "longDescription": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
      "scoreDescription": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
      "categoryLabel": "Seasonal & Phenology",
      "sourceModels": [
        "nbm",
        "icon13",
        "gdps"
      ],
      "outputModels": [
        "Wild Berries (.pmtiles)"
      ],
      "toastTitle": "Wild Berry Ripening & Foraging",
      "toastSubtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
      "toastDescription": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality."
    },
    "snow_depth": {
      "id": "snow_depth",
      "label": "Snow Depth & SNOTEL",
      "product": "snow_depth",
      "icon": "\u2744\ufe0f",
      "category": "hydrology",
      "description": "Observed snowpack depth & SNOTEL telemetry",
      "category_label": "Hydrology & Mountain Weather",
      "long_description": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
      "score_description": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
      "source_models": [
        "NOAA SNODAS 1km Snow Analysis",
        "USDA NRCS SNOTEL Telemetry",
        "ECCC & BC Snow Pillow Network"
      ],
      "output_models": [
        "Continuous mountain snowpack gradient",
        "Live SNOTEL observation stations"
      ],
      "toast_title": "Snow Depth & Live SNOTEL Stations",
      "toast_subtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
      "toast_description": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements.",
      "longDescription": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
      "scoreDescription": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
      "categoryLabel": "Hydrology & Mountain Weather",
      "sourceModels": [
        "NOAA SNODAS 1km Snow Analysis",
        "USDA NRCS SNOTEL Telemetry",
        "ECCC & BC Snow Pillow Network"
      ],
      "outputModels": [
        "Continuous mountain snowpack gradient",
        "Live SNOTEL observation stations"
      ],
      "toastTitle": "Snow Depth & Live SNOTEL Stations",
      "toastSubtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
      "toastDescription": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements."
    },
    "fire_restrictions": {
      "id": "fire_restrictions",
      "label": "Fire Restrictions (USFS/BLM/NPS)",
      "product": "fire_restrictions",
      "icon": "\ud83d\udd25\ud83d\udeab",
      "category": "air_quality_fires",
      "description": "Camp Fire restrictions.",
      "long_description": "Provides data from land management agencies around what fire restrictions, if any, are currently in place.\n\nAggregates active campfire bans, Stage 1 and Stage 2 fire restrictions, industrial fire precaution levels, and area closures across US Forest Service (USFS), Bureau of Land Management (BLM), National Park Service (NPS), BIA, USFWS, and state forestry jurisdictions.",
      "category_label": "Public Lands & Wildfire Safety",
      "score_description": "\u2022 Stage 1 Fire Restrictions (Yellow/Amber): Campfires restricted to developed agency-approved fire rings; smoking and spark-emitting equipment restricted.\n\u2022 Stage 2 Fire Restrictions (Orange/Red): All wood and charcoal campfires prohibited (including developed campgrounds); pressurized liquid/gas stoves with shutoff valves typically permitted.\n\u2022 Stage 3 / Area Closure (Magenta/Dark Red): Extreme fire danger closure or complete prohibition of all ignition sources.",
      "source_models": [
        "NIFC / Interagency Fire Restrictions Feeds (USFS, BLM, NPS, BIA, State)"
      ],
      "output_models": [
        "Jurisdictional Fire Restriction Polygons & Order Summaries GeoJSON"
      ],
      "toast_title": "Public Land Fire Restrictions",
      "toast_subtitle": "USFS, BLM, NPS & STATE CAMPFIRE ORDERS",
      "toast_description": "Maps active Stage 1 and Stage 2 campfire bans and agency fire restriction orders across federal and state public lands.",
      "longDescription": "Provides data from land management agencies around what fire restrictions, if any, are currently in place.\n\nAggregates active campfire bans, Stage 1 and Stage 2 fire restrictions, industrial fire precaution levels, and area closures across US Forest Service (USFS), Bureau of Land Management (BLM), National Park Service (NPS), BIA, USFWS, and state forestry jurisdictions.",
      "scoreDescription": "\u2022 Stage 1 Fire Restrictions (Yellow/Amber): Campfires restricted to developed agency-approved fire rings; smoking and spark-emitting equipment restricted.\n\u2022 Stage 2 Fire Restrictions (Orange/Red): All wood and charcoal campfires prohibited (including developed campgrounds); pressurized liquid/gas stoves with shutoff valves typically permitted.\n\u2022 Stage 3 / Area Closure (Magenta/Dark Red): Extreme fire danger closure or complete prohibition of all ignition sources.",
      "categoryLabel": "Public Lands & Wildfire Safety",
      "sourceModels": [
        "NIFC / Interagency Fire Restrictions Feeds (USFS, BLM, NPS, BIA, State)"
      ],
      "outputModels": [
        "Jurisdictional Fire Restriction Polygons & Order Summaries GeoJSON"
      ],
      "toastTitle": "Public Land Fire Restrictions",
      "toastSubtitle": "USFS, BLM, NPS & STATE CAMPFIRE ORDERS",
      "toastDescription": "Maps active Stage 1 and Stage 2 campfire bans and agency fire restriction orders across federal and state public lands."
    },
    "avalanche_danger": {
      "id": "avalanche_danger",
      "label": "Avalanche Danger (USFS NAC)",
      "product": "avalanche",
      "icon": "\ud83c\udfd4\ufe0f\u26a0\ufe0f",
      "category": "hydrology",
      "description": "Live avalanche danger ratings & official bulletins",
      "basemap_override": {
        "theme": "usgs-topo"
      },
      "category_label": "Backcountry & Alpine Safety",
      "long_description": "Official daily backcountry avalanche danger ratings, avalanche problem types, elevation rose diagrams, and forecaster bulletins aggregated from the USFS National Avalanche Center (NAC) and regional avalanche centers across North America.",
      "score_description": "\u2022 1 - Low (Green): Generally safe avalanche conditions; watch for unstable snow on isolated terrain features.\n\u2022 2 - Moderate (Yellow): Heightened avalanche conditions on specific terrain features; evaluate snow and terrain carefully.\n\u2022 3 - Considerable (Orange): Dangerous avalanche conditions; careful snowpack evaluation, conservative decision-making, and cautious route-finding essential.\n\u2022 4 - High (Red): Very dangerous avalanche conditions; travel in avalanche terrain not recommended.\n\u2022 5 - Extreme (Black/Maroon): Avoid all avalanche terrain; natural and human-triggered avalanches certain.",
      "source_models": [
        "USFS National Avalanche Center (NAC) API",
        "Regional Backcountry Avalanche Forecast Centers"
      ],
      "output_models": [
        "Interactive Avalanche Forecast Zone Polygons & Official Bulletins"
      ],
      "toast_title": "Backcountry Avalanche Danger (NAC)",
      "toast_subtitle": "OFFICIAL NORTH AMERICAN AVALANCHE RATINGS",
      "toast_description": "Displays live official avalanche danger ratings (1-Low to 5-Extreme) and backcountry forecast bulletins by mountain zone.",
      "basemapOverride": {
        "theme": "usgs-topo"
      },
      "longDescription": "Official daily backcountry avalanche danger ratings, avalanche problem types, elevation rose diagrams, and forecaster bulletins aggregated from the USFS National Avalanche Center (NAC) and regional avalanche centers across North America.",
      "scoreDescription": "\u2022 1 - Low (Green): Generally safe avalanche conditions; watch for unstable snow on isolated terrain features.\n\u2022 2 - Moderate (Yellow): Heightened avalanche conditions on specific terrain features; evaluate snow and terrain carefully.\n\u2022 3 - Considerable (Orange): Dangerous avalanche conditions; careful snowpack evaluation, conservative decision-making, and cautious route-finding essential.\n\u2022 4 - High (Red): Very dangerous avalanche conditions; travel in avalanche terrain not recommended.\n\u2022 5 - Extreme (Black/Maroon): Avoid all avalanche terrain; natural and human-triggered avalanches certain.",
      "categoryLabel": "Backcountry & Alpine Safety",
      "sourceModels": [
        "USFS National Avalanche Center (NAC) API",
        "Regional Backcountry Avalanche Forecast Centers"
      ],
      "outputModels": [
        "Interactive Avalanche Forecast Zone Polygons & Official Bulletins"
      ],
      "toastTitle": "Backcountry Avalanche Danger (NAC)",
      "toastSubtitle": "OFFICIAL NORTH AMERICAN AVALANCHE RATINGS",
      "toastDescription": "Displays live official avalanche danger ratings (1-Low to 5-Extreme) and backcountry forecast bulletins by mountain zone."
    },
    "wildfires": {
      "id": "wildfires",
      "label": "Wildfire Perimeters & Info",
      "product": "wildfires",
      "icon": "\ud83d\udd25",
      "category": "air_quality_fires",
      "description": "Active US (NIFC) and Canadian (CWFIS) wildfire perimeters & incident info.",
      "category_label": "Environmental & Air Quality",
      "long_description": "Displays active wildfire perimeters across the United States (NIFC) and Canada (CWFIS), alongside near-real-time satellite thermal anomaly hotspots detected by NASA VIIRS instruments (375m resolution). Includes acreage, containment progress, and incident reporting.",
      "score_description": "\u2022 Active Fire Perimeters (Red/Orange Polygons): Official mapped incident burn boundaries from NIFC WFIGS and Canadian CWFIS with acreage and % containment.\n\u2022 VIIRS Thermal Hotspots (Glowing Dots): Satellite-detected 375m infrared heat signatures indicating active fire fronts and flare-ups.",
      "source_models": [
        "NIFC WFIGS (National Interagency Fire Center)",
        "CWFIS (Canadian Wildland Fire Information System)",
        "NASA FIRMS VIIRS (375m Active Fire Detections)"
      ],
      "output_models": [
        "Vector Perimeters & Point Hotspots GeoJSON"
      ],
      "toast_title": "Active Wildfire Perimeters & Incidents",
      "toast_subtitle": "NIFC, CWFIS & NASA VIIRS DETECTIONS",
      "toast_description": "Maps active US and Canadian wildfire burn perimeters, containment percentages, incident details, and satellite thermal hotspots.",
      "longDescription": "Displays active wildfire perimeters across the United States (NIFC) and Canada (CWFIS), alongside near-real-time satellite thermal anomaly hotspots detected by NASA VIIRS instruments (375m resolution). Includes acreage, containment progress, and incident reporting.",
      "scoreDescription": "\u2022 Active Fire Perimeters (Red/Orange Polygons): Official mapped incident burn boundaries from NIFC WFIGS and Canadian CWFIS with acreage and % containment.\n\u2022 VIIRS Thermal Hotspots (Glowing Dots): Satellite-detected 375m infrared heat signatures indicating active fire fronts and flare-ups.",
      "categoryLabel": "Environmental & Air Quality",
      "sourceModels": [
        "NIFC WFIGS (National Interagency Fire Center)",
        "CWFIS (Canadian Wildland Fire Information System)",
        "NASA FIRMS VIIRS (375m Active Fire Detections)"
      ],
      "outputModels": [
        "Vector Perimeters & Point Hotspots GeoJSON"
      ],
      "toastTitle": "Active Wildfire Perimeters & Incidents",
      "toastSubtitle": "NIFC, CWFIS & NASA VIIRS DETECTIONS",
      "toastDescription": "Maps active US and Canadian wildfire burn perimeters, containment percentages, incident details, and satellite thermal hotspots."
    },
    "wildfire_hotspots": {
      "id": "wildfire_hotspots",
      "label": "Satellite Hotspots",
      "product": "wildfires",
      "model": "firms_hotspots",
      "icon": "\ud83d\udce1",
      "category": "air_quality_fires",
      "description": "Hot spots detected by satellite.",
      "category_label": "Environmental & Air Quality",
      "long_description": "Near-real-time satellite thermal anomaly hotspots detected by NASA/NOAA Suomi-NPP and NOAA-20/21 VIIRS (375m) and MODIS (1km) instruments, highlighting active wildfire fronts, spot fires, and radiative heat intensity (FRP).",
      "score_description": "\u2022 Recent Detections (<6h - Bright Red/Yellow): Fresh satellite overpass thermal detections indicating active flaming fronts.\n\u2022 6\u201324h Detections (Orange): Active burning detected within the past day.\n\u2022 Fire Radiative Power (FRP): Measured in Megawatts (MW), indicating thermal intensity of the sub-pixel heat source.",
      "source_models": [
        "NASA FIRMS VIIRS (375m Active Fire Detections)",
        "NOAA NESDIS HMS Fire & Smoke Product"
      ],
      "output_models": [
        "Satellite Thermal Anomaly Hotspots GeoJSON"
      ],
      "toast_title": "Satellite Wildfire Thermal Hotspots",
      "toast_subtitle": "375M NASA VIIRS INFRARED DETECTIONS",
      "toast_description": "Pinpoints near-real-time 375-meter satellite infrared heat detections to track active wildfire expansion before perimeters are mapped.",
      "longDescription": "Near-real-time satellite thermal anomaly hotspots detected by NASA/NOAA Suomi-NPP and NOAA-20/21 VIIRS (375m) and MODIS (1km) instruments, highlighting active wildfire fronts, spot fires, and radiative heat intensity (FRP).",
      "scoreDescription": "\u2022 Recent Detections (<6h - Bright Red/Yellow): Fresh satellite overpass thermal detections indicating active flaming fronts.\n\u2022 6\u201324h Detections (Orange): Active burning detected within the past day.\n\u2022 Fire Radiative Power (FRP): Measured in Megawatts (MW), indicating thermal intensity of the sub-pixel heat source.",
      "categoryLabel": "Environmental & Air Quality",
      "sourceModels": [
        "NASA FIRMS VIIRS (375m Active Fire Detections)",
        "NOAA NESDIS HMS Fire & Smoke Product"
      ],
      "outputModels": [
        "Satellite Thermal Anomaly Hotspots GeoJSON"
      ],
      "toastTitle": "Satellite Wildfire Thermal Hotspots",
      "toastSubtitle": "375M NASA VIIRS INFRARED DETECTIONS",
      "toastDescription": "Pinpoints near-real-time 375-meter satellite infrared heat detections to track active wildfire expansion before perimeters are mapped."
    },
    "aqi_index": {
      "id": "aqi_index",
      "label": "AQI Forecast",
      "product": "aqi",
      "icon": "\ud83e\udec1",
      "category": "air_quality_fires",
      "description": "Air quality forecast.",
      "category_label": "Environmental & Air Quality",
      "long_description": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
      "score_description": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
      "source_models": [
        "gefs",
        "raqdps",
        "hrrr",
        "rrfs",
        "AirNow / EPA Station Telemetry"
      ],
      "output_models": [
        "AQI scale .pmtiles per model",
        "Real-time observation markers"
      ],
      "toast_title": "Air Quality Index (AQI) Forecast",
      "toast_subtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
      "toast_description": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone.",
      "longDescription": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
      "scoreDescription": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
      "categoryLabel": "Environmental & Air Quality",
      "sourceModels": [
        "gefs",
        "raqdps",
        "hrrr",
        "rrfs",
        "AirNow / EPA Station Telemetry"
      ],
      "outputModels": [
        "AQI scale .pmtiles per model",
        "Real-time observation markers"
      ],
      "toastTitle": "Air Quality Index (AQI) Forecast",
      "toastSubtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
      "toastDescription": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone."
    },
    "aqi_stations": {
      "id": "aqi_stations",
      "label": "AQI Station Data",
      "product": "live_weather",
      "model": "aqi_stations",
      "icon": "\ud83e\udec1",
      "category": "air_quality_fires",
      "description": "Near real time AQI station data.",
      "category_label": "Environmental & Air Quality",
      "long_description": "Near-real-time hourly Air Quality Index (AQI) and PM2.5/Ozone pollutant observations from official US EPA AirNow, USFS permanent and temporary smoke monitors, and Canadian AQHI monitoring stations.",
      "score_description": "\u2022 0\u201350 (Good - Green): Clean breathable air.\n\u2022 51\u2013100 (Moderate - Yellow): Slight particulate or ozone elevation.\n\u2022 101\u2013150 (USG - Orange): Unhealthy for sensitive groups.\n\u2022 151\u2013200 (Unhealthy - Red): Widespread smoke or pollution impact.\n\u2022 201+ (Very Unhealthy / Hazardous - Purple/Maroon): Severe smoke plume impact at surface sensors.",
      "source_models": [
        "US EPA AirNow Real-Time Telemetry",
        "USFS AirFire Smoke Monitors",
        "ECCC Canadian AQHI Network"
      ],
      "output_models": [
        "Real-time AQI observation station markers & telemetry"
      ],
      "toast_title": "Live Air Quality Monitoring Stations",
      "toast_subtitle": "REAL-TIME EPA AIRNOW & SMOKE SENSORS",
      "toast_description": "Displays live hourly AQI readings from ground-level EPA AirNow and USFS air quality monitoring stations.",
      "longDescription": "Near-real-time hourly Air Quality Index (AQI) and PM2.5/Ozone pollutant observations from official US EPA AirNow, USFS permanent and temporary smoke monitors, and Canadian AQHI monitoring stations.",
      "scoreDescription": "\u2022 0\u201350 (Good - Green): Clean breathable air.\n\u2022 51\u2013100 (Moderate - Yellow): Slight particulate or ozone elevation.\n\u2022 101\u2013150 (USG - Orange): Unhealthy for sensitive groups.\n\u2022 151\u2013200 (Unhealthy - Red): Widespread smoke or pollution impact.\n\u2022 201+ (Very Unhealthy / Hazardous - Purple/Maroon): Severe smoke plume impact at surface sensors.",
      "categoryLabel": "Environmental & Air Quality",
      "sourceModels": [
        "US EPA AirNow Real-Time Telemetry",
        "USFS AirFire Smoke Monitors",
        "ECCC Canadian AQHI Network"
      ],
      "outputModels": [
        "Real-time AQI observation station markers & telemetry"
      ],
      "toastTitle": "Live Air Quality Monitoring Stations",
      "toastSubtitle": "REAL-TIME EPA AIRNOW & SMOKE SENSORS",
      "toastDescription": "Displays live hourly AQI readings from ground-level EPA AirNow and USFS air quality monitoring stations."
    },
    "smoke_forecast": {
      "id": "smoke_forecast",
      "label": "Wildfire Smoke",
      "product": "smoke",
      "icon": "\ud83c\udf2b\ufe0f",
      "category": "air_quality_fires",
      "description": "Wildfire smoke forecasts for North America.",
      "category_label": "Environmental & Air Quality",
      "long_description": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
      "score_description": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
      "source_models": [
        "raqdps (Canadian AQ)",
        "rrfs (Smoke)",
        "hrrr (3km Smoke)"
      ],
      "output_models": [
        "Smoke density .pmtiles per model (Surface & Column levels)"
      ],
      "toast_title": "Wildfire Smoke & Vertically Integrated PM2.5",
      "toast_subtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
      "toast_description": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation.",
      "longDescription": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
      "scoreDescription": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
      "categoryLabel": "Environmental & Air Quality",
      "sourceModels": [
        "raqdps (Canadian AQ)",
        "rrfs (Smoke)",
        "hrrr (3km Smoke)"
      ],
      "outputModels": [
        "Smoke density .pmtiles per model (Surface & Column levels)"
      ],
      "toastTitle": "Wildfire Smoke & Vertically Integrated PM2.5",
      "toastSubtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
      "toastDescription": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation."
    },
    "dust_forecast": {
      "id": "dust_forecast",
      "label": "Global Dust",
      "product": "dust",
      "model": "gefs_dust",
      "icon": "\ud83c\udfdc\ufe0f",
      "category": "air_quality_fires",
      "description": "Global desert dust PM2.5 particulate concentration forecast from NOAA GEFS Aerosols.",
      "category_label": "Environmental & Air Quality",
      "long_description": "Global desert dust PM2.5/PM10 aerosol dispersion and surface concentration forecast from NOAA GEFS Aerosols.",
      "score_description": "\u2022 Light Dust Haze (5\u201325 \u00b5g/m\u00b3): Subtle atmospheric scattering and warm twilight tinting.\n\u2022 Moderate Dust Plume (25\u201375 \u00b5g/m\u00b3): Noticeable horizon haze, reduced mountain visibility, and elevated particulate levels.\n\u2022 Dense Dust Storm (75\u2013250+ \u00b5g/m\u00b3): Severe visibility reduction and unhealthy breathable dust concentrations.",
      "source_models": [
        "gefs_dust (Global 0.25\u00b0 GEFS-Aerosols)"
      ],
      "output_models": [
        "Global dust PM2.5 concentration .pmtiles"
      ],
      "toast_title": "Global Desert Dust & Aerosol Forecast",
      "toast_subtitle": "NOAA GEFS-AEROSOLS DUST DISPERSION",
      "toast_description": "Forecasts windblown desert dust plumes and fine mineral particulate concentrations from the NOAA Global Ensemble Aerosol model.",
      "longDescription": "Global desert dust PM2.5/PM10 aerosol dispersion and surface concentration forecast from NOAA GEFS Aerosols.",
      "scoreDescription": "\u2022 Light Dust Haze (5\u201325 \u00b5g/m\u00b3): Subtle atmospheric scattering and warm twilight tinting.\n\u2022 Moderate Dust Plume (25\u201375 \u00b5g/m\u00b3): Noticeable horizon haze, reduced mountain visibility, and elevated particulate levels.\n\u2022 Dense Dust Storm (75\u2013250+ \u00b5g/m\u00b3): Severe visibility reduction and unhealthy breathable dust concentrations.",
      "categoryLabel": "Environmental & Air Quality",
      "sourceModels": [
        "gefs_dust (Global 0.25\u00b0 GEFS-Aerosols)"
      ],
      "outputModels": [
        "Global dust PM2.5 concentration .pmtiles"
      ],
      "toastTitle": "Global Desert Dust & Aerosol Forecast",
      "toastSubtitle": "NOAA GEFS-AEROSOLS DUST DISPERSION",
      "toastDescription": "Forecasts windblown desert dust plumes and fine mineral particulate concentrations from the NOAA Global Ensemble Aerosol model."
    },
    "precip_radar": {
      "id": "precip_radar",
      "label": "Doppler Radar",
      "product": "live_weather",
      "model": "mrms",
      "icon": "\ud83d\udce1",
      "category": "precipitation",
      "description": "Near real time doppler radar",
      "basemap_override": {
        "terrain_3d": false
      },
      "category_label": "Real-Time Observation",
      "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
      "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
      "source_models": [
        "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
      ],
      "output_models": [
        "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
      ],
      "toast_title": "Live NOAA MRMS Doppler Radar",
      "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
      "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
      "basemapOverride": {
        "terrain3d": false
      },
      "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
      "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
      "categoryLabel": "Real-Time Observation",
      "sourceModels": [
        "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
      ],
      "outputModels": [
        "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
      ],
      "toastTitle": "Live NOAA MRMS Doppler Radar",
      "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
      "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
    },
    "precip_forecast": {
      "id": "precip_forecast",
      "label": "Precipitation Forecast",
      "product": "precip",
      "icon": "\ud83c\udf27\ufe0f",
      "category": "precipitation",
      "description": "Hourly and daily rain and snow forecasts.",
      "category_label": "Core Meteorological",
      "long_description": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
      "score_description": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
      "source_models": [
        "nbm",
        "rdps",
        "ecmwf",
        "gfs",
        "hrrr",
        "icon13",
        "blend",
        "MRMS (Obs)"
      ],
      "output_models": [
        "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
      ],
      "toast_title": "Precipitation Rate, Probability & Snow",
      "toast_subtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
      "toast_description": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models.",
      "longDescription": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
      "scoreDescription": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "nbm",
        "rdps",
        "ecmwf",
        "gfs",
        "hrrr",
        "icon13",
        "blend",
        "MRMS (Obs)"
      ],
      "outputModels": [
        "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
      ],
      "toastTitle": "Precipitation Rate, Probability & Snow",
      "toastSubtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
      "toastDescription": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models."
    },
    "lightning_live": {
      "id": "lightning_live",
      "label": "Lightning Activity (Observed)",
      "product": "live_weather",
      "model": "mrms_lightning",
      "icon": "\u26a1",
      "category": "precipitation",
      "description": "Rolling 8-hour 5-minute lightning strikes scaled by flash density and age (yellow to gray).",
      "long_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
      "category_label": "Real-Time Observation",
      "score_description": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
      "source_models": [
        "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
      ],
      "output_models": [
        "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
      ],
      "toast_title": "Live Lightning Strikes (8-Hour Trail)",
      "toast_subtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
      "toast_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.",
      "longDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
      "scoreDescription": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
      "categoryLabel": "Real-Time Observation",
      "sourceModels": [
        "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
      ],
      "outputModels": [
        "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
      ],
      "toastTitle": "Live Lightning Strikes (8-Hour Trail)",
      "toastSubtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
      "toastDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes."
    },
    "thunderstorm": {
      "id": "thunderstorm",
      "label": "Thunderstorm Probability",
      "product": "thunderstorm",
      "model": "blend",
      "icon": "\u26a1",
      "category": "precipitation",
      "description": "Thunderstorm probability (0-100%) combining atmospheric instability (CAPE), cap strength (CIN), and convective triggers.",
      "category_label": "Core Meteorological",
      "long_description": "Convective storm lightning probability & flash density forecast. Shows area where conditions will be favorable for lightning.",
      "score_description": "\u2022 Slight / Isolated Risk (10\u201330% - Cool Teal/Green): Weak convective instability; isolated rumbles or brief mountain afternoon showers possible.\n\u2022 Moderate Thunderstorm Risk (35\u201365% - Yellow to Orange): Elevated CAPE and lifting; scattered thunderstorms and cloud-to-ground lightning likely.\n\u2022 High / Severe Convective Risk (70\u2013100% - Red to Magenta): Strong atmospheric instability and updraft helicity; widespread thunderstorms and frequent lightning.",
      "source_models": [
        "hrrr",
        "rrfs",
        "ecmwf",
        "gfs",
        "MRMS NLDN (Obs)"
      ],
      "output_models": [
        "Lightning risk .pmtiles per model",
        "Real-time MRMS flash density"
      ],
      "toast_title": "Lightning & Convective Hazard",
      "toast_subtitle": "CONVECTIVE CAPE & FLASH DENSITY POTENTIAL",
      "toast_description": "Quantifies thunderstorm instability and lightning strike hazard using convective available potential energy (CAPE) and updraft helicity.",
      "longDescription": "Convective storm lightning probability & flash density forecast. Shows area where conditions will be favorable for lightning.",
      "scoreDescription": "\u2022 Slight / Isolated Risk (10\u201330% - Cool Teal/Green): Weak convective instability; isolated rumbles or brief mountain afternoon showers possible.\n\u2022 Moderate Thunderstorm Risk (35\u201365% - Yellow to Orange): Elevated CAPE and lifting; scattered thunderstorms and cloud-to-ground lightning likely.\n\u2022 High / Severe Convective Risk (70\u2013100% - Red to Magenta): Strong atmospheric instability and updraft helicity; widespread thunderstorms and frequent lightning.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "ecmwf",
        "gfs",
        "MRMS NLDN (Obs)"
      ],
      "outputModels": [
        "Lightning risk .pmtiles per model",
        "Real-time MRMS flash density"
      ],
      "toastTitle": "Lightning & Convective Hazard",
      "toastSubtitle": "CONVECTIVE CAPE & FLASH DENSITY POTENTIAL",
      "toastDescription": "Quantifies thunderstorm instability and lightning strike hazard using convective available potential energy (CAPE) and updraft helicity."
    },
    "precip_accum": {
      "id": "precip_accum",
      "label": "Precipitation Accumulation (Past 1-7 Days)",
      "product": "precip_accum",
      "model": "cmorph2",
      "sources": [
        "cmorph2",
        "ecmwf",
        "mrms"
      ],
      "icon": "\ud83c\udf27\ufe0f",
      "category": "precipitation",
      "description": "Global observed and NWP precipitation accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
      "category_label": "Real-Time & Multi-Model Accumulation",
      "long_description": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
      "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
      "source_models": [
        "NOAA CMORPH2 Global Satellite QPE",
        "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
        "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
      ],
      "output_models": [
        "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
      ],
      "toast_title": "Observed Precipitation Accumulation (1\u20137 Days)",
      "toast_subtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
      "toast_description": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation.",
      "longDescription": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
      "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
      "categoryLabel": "Real-Time & Multi-Model Accumulation",
      "sourceModels": [
        "NOAA CMORPH2 Global Satellite QPE",
        "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
        "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
      ],
      "outputModels": [
        "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
      ],
      "toastTitle": "Observed Precipitation Accumulation (1\u20137 Days)",
      "toastSubtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
      "toastDescription": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation."
    },
    "snow_accum": {
      "id": "snow_accum",
      "label": "Snowfall Accumulation (Past 1-7 Days)",
      "product": "snow_accum",
      "model": "cmorph2",
      "sources": [
        "cmorph2",
        "ecmwf",
        "mrms"
      ],
      "icon": "\ud83c\udf28\ufe0f",
      "category": "precipitation",
      "description": "Global observed and NWP snowfall accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
      "long_description": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
      "category_label": "Real-Time & Multi-Model Accumulation",
      "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
      "source_models": [
        "NOAA MRMS Snowfall Accumulation Product",
        "NOAA CMORPH2 Global Satellite Snow Estimation",
        "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
      ],
      "output_models": [
        "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
      ],
      "toast_title": "Observed Snowfall Accumulation (1\u20137 Days)",
      "toast_subtitle": "RECENT FRESH POWDER & STORM TOTALS",
      "toast_description": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows.",
      "longDescription": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
      "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
      "categoryLabel": "Real-Time & Multi-Model Accumulation",
      "sourceModels": [
        "NOAA MRMS Snowfall Accumulation Product",
        "NOAA CMORPH2 Global Satellite Snow Estimation",
        "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
      ],
      "outputModels": [
        "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
      ],
      "toastTitle": "Observed Snowfall Accumulation (1\u20137 Days)",
      "toastSubtitle": "RECENT FRESH POWDER & STORM TOTALS",
      "toastDescription": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows."
    },
    "clouds": {
      "id": "clouds",
      "label": "Cloud Forecast",
      "product": "clouds",
      "icon": "\u2601\ufe0f",
      "category": "clouds_wind",
      "description": "Cloud forecasts.",
      "long_description": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
      "category_label": "Core Meteorological",
      "score_description": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
      "source_models": [
        "ecmwf",
        "gfs",
        "hrrr",
        "rdps",
        "rrfs",
        "icon13"
      ],
      "output_models": [
        "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
      ],
      "toast_title": "Cloud Cover Forecast",
      "toast_subtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
      "toast_description": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures.",
      "longDescription": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
      "scoreDescription": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "ecmwf",
        "gfs",
        "hrrr",
        "rdps",
        "rrfs",
        "icon13"
      ],
      "outputModels": [
        "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
      ],
      "toastTitle": "Cloud Cover Forecast",
      "toastSubtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
      "toastDescription": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures."
    },
    "lenticular_clouds": {
      "id": "lenticular_clouds",
      "label": "Lenticular Cloud Probability",
      "product": "lenticular",
      "model": "ensemble",
      "icon": "\ud83d\udef8",
      "category": "clouds_wind",
      "description": "Identifies favorable conditions for lenticular cloud formation indicating turbulent conditions near mountain peaks.",
      "long_description": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
      "category_label": "Forecast Quality Scoring",
      "score_description": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
      "source_models": [
        "ecmwf",
        "rrfs",
        "rdps",
        "gdps"
      ],
      "output_models": [
        "ecmwf",
        "rrfs",
        "rdps",
        "gdps"
      ],
      "toast_title": "Lenticular Wave Cloud Forecast",
      "toast_subtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
      "toast_description": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks.",
      "longDescription": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
      "scoreDescription": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
      "categoryLabel": "Forecast Quality Scoring",
      "sourceModels": [
        "ecmwf",
        "rrfs",
        "rdps",
        "gdps"
      ],
      "outputModels": [
        "ecmwf",
        "rrfs",
        "rdps",
        "gdps"
      ],
      "toastTitle": "Lenticular Wave Cloud Forecast",
      "toastSubtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
      "toastDescription": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks."
    },
    "valley_fog": {
      "id": "valley_fog",
      "label": "Surface Fog",
      "product": "valley_fog",
      "model": "hrrr",
      "icon": "\ud83c\udf2b\ufe0f",
      "category": "clouds_wind",
      "description": "Ground level radiation fog.",
      "category_label": "Core Meteorological",
      "long_description": "Radiation & inversion valley fog formation risk. Forecasts likelihood of low lying fog development.",
      "score_description": "\u2022 20\u201340% (Patchy Mist / Shallow Ground Fog): Localized fog forming in low meadows, river bottoms, and marshlands near dawn.\n\u2022 45\u201370% (Moderate Valley Fog): Cohesive radiation or advection fog bank pooling in sheltered valleys.\n\u2022 75\u2013100% (Dense Radiation / Inversion Fog): High probability of thick boundary-layer fog filling valley floors under a stable nocturnal inversion.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "nbm",
        "gdps"
      ],
      "output_models": [
        "Fog probability .pmtiles per model"
      ],
      "toast_title": "Valley Fog & Radiation Fog Probability",
      "toast_subtitle": "TERRAIN-TRAPPED BOUNDARY LAYER FOG",
      "toast_description": "Identifies nocturnal temperature inversions, boundary-layer saturation, and topographic cold-air drainage to forecast low-lying valley fog and sea-of-clouds events.",
      "longDescription": "Radiation & inversion valley fog formation risk. Forecasts likelihood of low lying fog development.",
      "scoreDescription": "\u2022 20\u201340% (Patchy Mist / Shallow Ground Fog): Localized fog forming in low meadows, river bottoms, and marshlands near dawn.\n\u2022 45\u201370% (Moderate Valley Fog): Cohesive radiation or advection fog bank pooling in sheltered valleys.\n\u2022 75\u2013100% (Dense Radiation / Inversion Fog): High probability of thick boundary-layer fog filling valley floors under a stable nocturnal inversion.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "nbm",
        "gdps"
      ],
      "outputModels": [
        "Fog probability .pmtiles per model"
      ],
      "toastTitle": "Valley Fog & Radiation Fog Probability",
      "toastSubtitle": "TERRAIN-TRAPPED BOUNDARY LAYER FOG",
      "toastDescription": "Identifies nocturnal temperature inversions, boundary-layer saturation, and topographic cold-air drainage to forecast low-lying valley fog and sea-of-clouds events."
    },
    "cloud_inversion": {
      "id": "cloud_inversion",
      "label": "Valley Clouds / Sea of Clouds",
      "product": "cloud_inversion",
      "model": "nbm",
      "icon": "\ud83c\udfd4\ufe0f",
      "category": "clouds_wind",
      "description": "Reveals low cloud decks/deep fog below mountainous terrain.",
      "long_description": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
      "score_description": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
      "category_label": "Core Meteorological",
      "source_models": [
        "nbm"
      ],
      "output_models": [
        "Cloud Inversion / Sea of Clouds (.pmtiles)"
      ],
      "toast_title": "Sea of Clouds (Cloud Inversion)",
      "toast_subtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
      "toast_description": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas.",
      "longDescription": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
      "scoreDescription": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "nbm"
      ],
      "outputModels": [
        "Cloud Inversion / Sea of Clouds (.pmtiles)"
      ],
      "toastTitle": "Sea of Clouds (Cloud Inversion)",
      "toastSubtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
      "toastDescription": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas."
    },
    "cloud_base": {
      "id": "cloud_base",
      "label": "Cloud Base Elevation",
      "product": "cloud_base",
      "model": "nbm",
      "icon": "\u2601\ufe0f",
      "category": "clouds_wind",
      "description": "Cloud base elevation (MSL) critical for climbing, hiking, and photography",
      "long_description": "Cloud Base Elevation maps the absolute Mean Sea Level (MSL) altitude of the lowest cloud deck across the landscape.\n\nKnowing the exact cloud base altitude is critical for backcountry hikers, mountaineers, climbers, and landscape photographers. It indicates the exact elevation where trails enter fog, rain, and whiteout conditions, and reveals when summits, ridgelines, and alpine passes are clear of cloud cover.\n\nThe layer uses high-resolution National Blend of Models (NOAA NBM) aviation ceiling and lowest cloud base fields combined with high-resolution digital elevation modeling. Clear skies with absent or high cirrus clouds are rendered transparent so the underlying terrain remains visible, while active cloud decks are rendered with a continuous elevation gradient from sea level up to 16,000 ft MSL.",
      "score_description": "\u2022 Purple/Violet (0 - 3,000 ft MSL): Very low cloud base or sea-level marine stratus and coastal fog.\n\u2022 Blue to Cyan (3,000 - 6,000 ft MSL): Low-to-mid mountain cloud deck covering foothills and lower trailheads.\n\u2022 Teal to Emerald Green (6,000 - 9,000 ft MSL): Subalpine cloud ceiling; peaks above 9,000 ft extend above the clouds.\n\u2022 Yellow to Amber (9,000 - 12,000 ft MSL): High-altitude mountain cloud deck; alpine terrain below 9,000 ft remains in clear air.\n\u2022 Orange to Red/Magenta (12,000 - 16,000+ ft MSL): High cloud bases; only the highest continental summits are obscured.\n\u2022 Transparent: Clear skies (no low cloud deck or ceiling detected).",
      "category_label": "Core Meteorological",
      "source_models": [
        "nbm"
      ],
      "output_models": [
        "Cloud Base Elevation (.pmtiles)"
      ],
      "toast_title": "Cloud Base Altitude (MSL)",
      "toast_subtitle": "LOWEST CLOUD CEILING ELEVATION",
      "toast_description": "Maps the Mean Sea Level (MSL) elevation of the lowest cloud ceiling so hikers and photographers know whether summits are clear or in the clouds.",
      "longDescription": "Cloud Base Elevation maps the absolute Mean Sea Level (MSL) altitude of the lowest cloud deck across the landscape.\n\nKnowing the exact cloud base altitude is critical for backcountry hikers, mountaineers, climbers, and landscape photographers. It indicates the exact elevation where trails enter fog, rain, and whiteout conditions, and reveals when summits, ridgelines, and alpine passes are clear of cloud cover.\n\nThe layer uses high-resolution National Blend of Models (NOAA NBM) aviation ceiling and lowest cloud base fields combined with high-resolution digital elevation modeling. Clear skies with absent or high cirrus clouds are rendered transparent so the underlying terrain remains visible, while active cloud decks are rendered with a continuous elevation gradient from sea level up to 16,000 ft MSL.",
      "scoreDescription": "\u2022 Purple/Violet (0 - 3,000 ft MSL): Very low cloud base or sea-level marine stratus and coastal fog.\n\u2022 Blue to Cyan (3,000 - 6,000 ft MSL): Low-to-mid mountain cloud deck covering foothills and lower trailheads.\n\u2022 Teal to Emerald Green (6,000 - 9,000 ft MSL): Subalpine cloud ceiling; peaks above 9,000 ft extend above the clouds.\n\u2022 Yellow to Amber (9,000 - 12,000 ft MSL): High-altitude mountain cloud deck; alpine terrain below 9,000 ft remains in clear air.\n\u2022 Orange to Red/Magenta (12,000 - 16,000+ ft MSL): High cloud bases; only the highest continental summits are obscured.\n\u2022 Transparent: Clear skies (no low cloud deck or ceiling detected).",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "nbm"
      ],
      "outputModels": [
        "Cloud Base Elevation (.pmtiles)"
      ],
      "toastTitle": "Cloud Base Altitude (MSL)",
      "toastSubtitle": "LOWEST CLOUD CEILING ELEVATION",
      "toastDescription": "Maps the Mean Sea Level (MSL) elevation of the lowest cloud ceiling so hikers and photographers know whether summits are clear or in the clouds."
    },
    "mountain_visibility": {
      "id": "mountain_visibility",
      "label": "Mountain Visibility",
      "product": "mountain_visibility",
      "model": "nbm",
      "icon": "\ud83c\udf2b\ufe0f",
      "category": "clouds_wind",
      "description": "Terrain based visibility forecast indicating mountainous areas with no or limited visibility.",
      "long_description": "Mountain Visibility identifies the exact vertical zone where mountain slopes, passes, and ridgelines are submerged within active cloud decks, enveloped in dense fog, rain, or whiteout conditions.\n\nUsing high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with National Blend of Models (NBM) cloud base and cloud top boundary surfaces, this layer maps the physical 3D cloud deck sandwich against real terrain:\n\u2022 Below Cloud Base: Valleys and lowlands under the cloud deck remain 100% transparent in clear air beneath the ceiling.\n\u2022 In-Cloud Deck: Mountain terrain between cloud base and cloud top is rendered in an atmospheric slate-blue cloud shroud.\n\u2022 Above Cloud Tops: Mountain summits and high alpine ridges piercing above the cloud deck remain 100% transparent in clear sunshine.\n\nThis gives backcountry hikers, mountaineers, trail runners, and alpine photographers immediate clarity on whether a trail enters the clouds, where whiteout conditions begin, and which mountain peaks rise into clear sky above.",
      "score_description": "\u2022 Slate-Blue Shroud: Terrain submerged inside the cloud deck (Cloud Base <= Elevation <= Cloud Top), indicating fog, cloud obscuration, or whiteout.\n\u2022 Transparent Valleys: Terrain below the cloud base with clear air and open ground-level visibility underneath the ceiling.\n\u2022 Transparent Summits: High alpine peaks and ridges extending above the cloud top into clear blue sky and sunshine.\n\u2022 Shoreline Feathering: Smooth 50-meter elevation transition along lower and upper cloud boundaries.",
      "category_label": "Core Meteorological",
      "source_models": [
        "nbm"
      ],
      "output_models": [
        "Mountain Visibility (.pmtiles)"
      ],
      "toast_title": "Mountain Cloud Shroud & Whiteout Zones",
      "toast_subtitle": "3D TERRAIN CLOUD INTERSECTION",
      "toast_description": "Map plots areas where there is no visibility based on elevation in grey.  Areas shrouded in grey on the map indicates low or no visibility at the given elevation.",
      "longDescription": "Mountain Visibility identifies the exact vertical zone where mountain slopes, passes, and ridgelines are submerged within active cloud decks, enveloped in dense fog, rain, or whiteout conditions.\n\nUsing high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with National Blend of Models (NBM) cloud base and cloud top boundary surfaces, this layer maps the physical 3D cloud deck sandwich against real terrain:\n\u2022 Below Cloud Base: Valleys and lowlands under the cloud deck remain 100% transparent in clear air beneath the ceiling.\n\u2022 In-Cloud Deck: Mountain terrain between cloud base and cloud top is rendered in an atmospheric slate-blue cloud shroud.\n\u2022 Above Cloud Tops: Mountain summits and high alpine ridges piercing above the cloud deck remain 100% transparent in clear sunshine.\n\nThis gives backcountry hikers, mountaineers, trail runners, and alpine photographers immediate clarity on whether a trail enters the clouds, where whiteout conditions begin, and which mountain peaks rise into clear sky above.",
      "scoreDescription": "\u2022 Slate-Blue Shroud: Terrain submerged inside the cloud deck (Cloud Base <= Elevation <= Cloud Top), indicating fog, cloud obscuration, or whiteout.\n\u2022 Transparent Valleys: Terrain below the cloud base with clear air and open ground-level visibility underneath the ceiling.\n\u2022 Transparent Summits: High alpine peaks and ridges extending above the cloud top into clear blue sky and sunshine.\n\u2022 Shoreline Feathering: Smooth 50-meter elevation transition along lower and upper cloud boundaries.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "nbm"
      ],
      "outputModels": [
        "Mountain Visibility (.pmtiles)"
      ],
      "toastTitle": "Mountain Cloud Shroud & Whiteout Zones",
      "toastSubtitle": "3D TERRAIN CLOUD INTERSECTION",
      "toastDescription": "Map plots areas where there is no visibility based on elevation in grey.  Areas shrouded in grey on the map indicates low or no visibility at the given elevation."
    },
    "satellite_imagery": {
      "id": "satellite_imagery",
      "label": "Satellite Imagery (Vis & IR)",
      "product": "live_weather",
      "model": "goes",
      "icon": "\ud83d\udef0\ufe0f",
      "category": "clouds_wind",
      "description": "High-frequency visible and infrared geostationary satellite cloud loops.",
      "category_label": "Real-Time Observation",
      "long_description": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
      "score_description": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
      "source_models": [
        "NOAA GOES-East (GOES-16/19)",
        "NOAA GOES-West (GOES-18)",
        "JMA Himawari-9",
        "EUMETSAT Meteosat-9/10"
      ],
      "output_models": [
        "Georeferenced visual & infrared tile loops"
      ],
      "toast_title": "Live Geostationary Satellite Imagery",
      "toast_subtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
      "toast_description": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems.",
      "longDescription": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
      "scoreDescription": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
      "categoryLabel": "Real-Time Observation",
      "sourceModels": [
        "NOAA GOES-East (GOES-16/19)",
        "NOAA GOES-West (GOES-18)",
        "JMA Himawari-9",
        "EUMETSAT Meteosat-9/10"
      ],
      "outputModels": [
        "Georeferenced visual & infrared tile loops"
      ],
      "toastTitle": "Live Geostationary Satellite Imagery",
      "toastSubtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
      "toastDescription": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems."
    },
    "winds_surface_current": {
      "id": "winds_surface_current",
      "label": "Surface Winds (Current)",
      "product": "live_weather",
      "model": "rtma_winds",
      "icon": "\ud83d\udca8",
      "category": "clouds_wind",
      "description": "Current and recently observed surface winds.",
      "category_label": "Real-Time Observation",
      "long_description": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
      "score_description": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
      "source_models": [
        "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
      ],
      "output_models": [
        "Real-time wind vector streamlines and velocity tiles"
      ],
      "toast_title": "Current Surface Winds (Live RTMA)",
      "toast_subtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
      "toast_description": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines.",
      "longDescription": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
      "scoreDescription": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
      "categoryLabel": "Real-Time Observation",
      "sourceModels": [
        "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
      ],
      "outputModels": [
        "Real-time wind vector streamlines and velocity tiles"
      ],
      "toastTitle": "Current Surface Winds (Live RTMA)",
      "toastSubtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
      "toastDescription": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines."
    },
    "winds_surface": {
      "id": "winds_surface",
      "label": "Surface Winds Forecast",
      "product": "winds",
      "model": "blend",
      "icon": "\ud83d\udca8",
      "category": "clouds_wind",
      "description": "Forecasted Surface Winds (10m)",
      "category_label": "Core Meteorological",
      "long_description": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
      "score_description": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
      "source_models": [
        "hrrr",
        "rrfs",
        "gfs",
        "rdps",
        "ecmwf",
        "icon13",
        "RTMA (Obs)"
      ],
      "output_models": [
        "Vector directional JSON (wind_grid.json)",
        "Magnitude .pmtiles per model"
      ],
      "toast_title": "Surface Winds & Gusts",
      "toast_subtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
      "toast_description": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models.",
      "longDescription": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
      "scoreDescription": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "gfs",
        "rdps",
        "ecmwf",
        "icon13",
        "RTMA (Obs)"
      ],
      "outputModels": [
        "Vector directional JSON (wind_grid.json)",
        "Magnitude .pmtiles per model"
      ],
      "toastTitle": "Surface Winds & Gusts",
      "toastSubtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
      "toastDescription": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models."
    },
    "aviation_turbulence": {
      "id": "aviation_turbulence",
      "label": "Aviation Turbulence (EDR)",
      "product": "turbulence",
      "model": "gfs",
      "icon": "\u2708\ufe0f",
      "category": "clouds_wind",
      "description": "Upper-air clear-air and mountain-wave turbulence risk (EDR & NOAA GTG).",
      "category_label": "Upper-Air & Aviation",
      "long_description": "Upper-air clear-air turbulence (CAT) and mountain-wave turbulence forecast expressed in Eddy Dissipation Rate (EDR, m\u00b2/\u00b3 s\u207b\u00b9) across selectable flight levels (FL100 to FL420).",
      "score_description": "\u2022 Smooth (<0.15 EDR - Transparent): Calm laminar upper-level airflow.\n\u2022 Light Turbulence (0.15\u20130.25 EDR - Teal/Cyan): Slight erratic bumpiness.\n\u2022 Moderate Turbulence (0.25\u20130.45 EDR - Yellow/Amber): Definite strain against seatbelts; unsecured objects dislodged.\n\u2022 Severe / Extreme Turbulence (>0.45 EDR - Red/Magenta): Abrupt altitude changes and strong mountain-wave or jet-shear rotors.",
      "source_models": [
        "NOAA GFS / GTG Upper-Air Eddy Dissipation Rate (EDR)"
      ],
      "output_models": [
        "Multi-Flight-Level Turbulence EDR Rasters (.pmtiles)"
      ],
      "toast_title": "Aviation & Mountain-Wave Turbulence (EDR)",
      "toast_subtitle": "UPPER-AIR EDDY DISSIPATION RATE",
      "toast_description": "Maps clear-air and mountain-wave turbulence intensity (EDR) across selectable altitudes from 10,000 to 42,000 ft MSL.",
      "longDescription": "Upper-air clear-air turbulence (CAT) and mountain-wave turbulence forecast expressed in Eddy Dissipation Rate (EDR, m\u00b2/\u00b3 s\u207b\u00b9) across selectable flight levels (FL100 to FL420).",
      "scoreDescription": "\u2022 Smooth (<0.15 EDR - Transparent): Calm laminar upper-level airflow.\n\u2022 Light Turbulence (0.15\u20130.25 EDR - Teal/Cyan): Slight erratic bumpiness.\n\u2022 Moderate Turbulence (0.25\u20130.45 EDR - Yellow/Amber): Definite strain against seatbelts; unsecured objects dislodged.\n\u2022 Severe / Extreme Turbulence (>0.45 EDR - Red/Magenta): Abrupt altitude changes and strong mountain-wave or jet-shear rotors.",
      "categoryLabel": "Upper-Air & Aviation",
      "sourceModels": [
        "NOAA GFS / GTG Upper-Air Eddy Dissipation Rate (EDR)"
      ],
      "outputModels": [
        "Multi-Flight-Level Turbulence EDR Rasters (.pmtiles)"
      ],
      "toastTitle": "Aviation & Mountain-Wave Turbulence (EDR)",
      "toastSubtitle": "UPPER-AIR EDDY DISSIPATION RATE",
      "toastDescription": "Maps clear-air and mountain-wave turbulence intensity (EDR) across selectable altitudes from 10,000 to 42,000 ft MSL."
    },
    "jet_stream": {
      "id": "jet_stream",
      "label": "Jet Stream & Winds Aloft (250 hPa)",
      "product": "jet_stream",
      "model": "gfs",
      "icon": "\ud83c\udf00\ud83d\udca8",
      "category": "clouds_wind",
      "description": "250 hPa wind speed isotachs and animated upper-atmosphere wind stream vectors.",
      "category_label": "Upper-Air & Aviation",
      "long_description": "250 hPa (~34,000 ft / 10.5 km MSL) upper-tropospheric jet stream wind speed isotachs and animated wind particle streamlines, driving synoptic storm tracks, cirrus canopies, and astronomical seeing.",
      "score_description": "\u2022 Sub-Jet Flow (<60 kt): Weak upper-level winds favorable for calm astronomical seeing.\n\u2022 Moderate Jet Streak (60\u2013110 kt - Cyan to Green/Yellow): Active upper-tropospheric flow and high cirrus transport.\n\u2022 Intense Jet Core (110\u2013180+ kt - Orange/Red/Magenta): Powerful upper-level jet streak driving rapid cyclogenesis and vertical wind shear.",
      "source_models": [
        "gfs",
        "ecmwf",
        "hrrr"
      ],
      "output_models": [
        "250 hPa Isotach Rasters (.pmtiles) & Upper-Level Wind Vectors"
      ],
      "toast_title": "Jet Stream & Winds Aloft (250 hPa)",
      "toast_subtitle": "34,000 FT UPPER-AIR WIND STREAKS",
      "toast_description": "Visualizes 250 hPa jet stream wind speeds and animated upper-atmosphere streamlines driving storm tracks and high cloud movement.",
      "longDescription": "250 hPa (~34,000 ft / 10.5 km MSL) upper-tropospheric jet stream wind speed isotachs and animated wind particle streamlines, driving synoptic storm tracks, cirrus canopies, and astronomical seeing.",
      "scoreDescription": "\u2022 Sub-Jet Flow (<60 kt): Weak upper-level winds favorable for calm astronomical seeing.\n\u2022 Moderate Jet Streak (60\u2013110 kt - Cyan to Green/Yellow): Active upper-tropospheric flow and high cirrus transport.\n\u2022 Intense Jet Core (110\u2013180+ kt - Orange/Red/Magenta): Powerful upper-level jet streak driving rapid cyclogenesis and vertical wind shear.",
      "categoryLabel": "Upper-Air & Aviation",
      "sourceModels": [
        "gfs",
        "ecmwf",
        "hrrr"
      ],
      "outputModels": [
        "250 hPa Isotach Rasters (.pmtiles) & Upper-Level Wind Vectors"
      ],
      "toastTitle": "Jet Stream & Winds Aloft (250 hPa)",
      "toastSubtitle": "34,000 FT UPPER-AIR WIND STREAKS",
      "toastDescription": "Visualizes 250 hPa jet stream wind speeds and animated upper-atmosphere streamlines driving storm tracks and high cloud movement."
    },
    "hrtemp_current": {
      "id": "hrtemp_current",
      "label": "Current Temperature (RTMA)",
      "product": "hrtemp_current",
      "model": "rtma",
      "icon": "\ud83c\udf21\ufe0f",
      "category": "temperature",
      "description": "Real-time NOAA RTMA 2.5km surface temperature observations.",
      "category_label": "Real-Time Observation",
      "long_description": "Real-time surface temperature observations derived from NOAA Real-Time Mesoscale Analysis (RTMA 2.5km).",
      "score_description": "\u2022 High-Resolution 2.5km Grid: Blends surface weather station observations with topographic elevation modeling to map current temperatures across peaks and valleys.\n\u2022 Isotherm Contours: Optional 5\u00b0F contour lines highlighting sharp thermal fronts and freezing boundaries.",
      "source_models": [
        "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
      ],
      "output_models": [
        "Real-time 2.5km surface temperature .pmtiles"
      ],
      "toast_title": "Current Surface Temperature (Live RTMA)",
      "toast_subtitle": "2.5KM TERRAIN-ANALYZED OBSERVATIONS",
      "toast_description": "Maps current real-time 2-meter air temperatures at 2.5km resolution using NOAA Real-Time Mesoscale Analysis.",
      "longDescription": "Real-time surface temperature observations derived from NOAA Real-Time Mesoscale Analysis (RTMA 2.5km).",
      "scoreDescription": "\u2022 High-Resolution 2.5km Grid: Blends surface weather station observations with topographic elevation modeling to map current temperatures across peaks and valleys.\n\u2022 Isotherm Contours: Optional 5\u00b0F contour lines highlighting sharp thermal fronts and freezing boundaries.",
      "categoryLabel": "Real-Time Observation",
      "sourceModels": [
        "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
      ],
      "outputModels": [
        "Real-time 2.5km surface temperature .pmtiles"
      ],
      "toastTitle": "Current Surface Temperature (Live RTMA)",
      "toastSubtitle": "2.5KM TERRAIN-ANALYZED OBSERVATIONS",
      "toastDescription": "Maps current real-time 2-meter air temperatures at 2.5km resolution using NOAA Real-Time Mesoscale Analysis."
    },
    "wx_stations": {
      "id": "wx_stations",
      "label": "Weather Station Observations",
      "product": "wx_stations",
      "model": "metar",
      "icon": "\ud83d\udce1",
      "category": "temperature",
      "description": "Real-time 5-min NOAA METAR/ASOS surface weather station observations & 14-day history charts.",
      "category_label": "Surface Weather Observations",
      "long_description": "Real-time surface weather observations (5-minute cadence) from ~7,300+ global NOAA Aviation Weather Center (METAR / ASOS / AWOS) and backcountry US Interagency RAWS mountain/wilderness weather stations with interactive Today, 7-Day, and 14-Day telemetry charts.",
      "score_description": "\u2022 Selectable Telemetry Badges: Switch station badges between Temperature, Wind Speed, Wind Gusts, Dew Point, Relative Humidity, Pressure, and Visibility.\n\u2022 Historical Trend Charts: Click any station to inspect 24-Hour, 7-Day, and 14-Day observed temperature, wind, and precipitation history.",
      "source_models": [
        "NOAA Aviation Weather Center (AWC) METAR / ASOS / AWOS Feed",
        "NIFC Interagency Remote Automatic Weather Stations (PublicView_RAWS)",
        "NOAA HADS / NWS & Iowa Environmental Mesonet Historical Archives"
      ],
      "output_models": [
        "Progressive-zoom WebGL station markers & readout badges",
        "Interactive 24H / 7-Day / 14-Day surface observation trend charts"
      ],
      "toast_title": "Live Weather Stations (METAR & RAWS)",
      "toast_subtitle": "REAL-TIME 5-MIN SURFACE TELEMETRY",
      "toast_description": "Displays live observations from 7,300+ airport METAR and backcountry mountain RAWS weather stations with 14-day historical charts.",
      "longDescription": "Real-time surface weather observations (5-minute cadence) from ~7,300+ global NOAA Aviation Weather Center (METAR / ASOS / AWOS) and backcountry US Interagency RAWS mountain/wilderness weather stations with interactive Today, 7-Day, and 14-Day telemetry charts.",
      "scoreDescription": "\u2022 Selectable Telemetry Badges: Switch station badges between Temperature, Wind Speed, Wind Gusts, Dew Point, Relative Humidity, Pressure, and Visibility.\n\u2022 Historical Trend Charts: Click any station to inspect 24-Hour, 7-Day, and 14-Day observed temperature, wind, and precipitation history.",
      "categoryLabel": "Surface Weather Observations",
      "sourceModels": [
        "NOAA Aviation Weather Center (AWC) METAR / ASOS / AWOS Feed",
        "NIFC Interagency Remote Automatic Weather Stations (PublicView_RAWS)",
        "NOAA HADS / NWS & Iowa Environmental Mesonet Historical Archives"
      ],
      "outputModels": [
        "Progressive-zoom WebGL station markers & readout badges",
        "Interactive 24H / 7-Day / 14-Day surface observation trend charts"
      ],
      "toastTitle": "Live Weather Stations (METAR & RAWS)",
      "toastSubtitle": "REAL-TIME 5-MIN SURFACE TELEMETRY",
      "toastDescription": "Displays live observations from 7,300+ airport METAR and backcountry mountain RAWS weather stations with 14-day historical charts."
    },
    "hrtemp": {
      "id": "hrtemp",
      "label": "Temperature Forecast",
      "product": "hrtemp",
      "model": "nbm",
      "icon": "\ud83c\udf21\ufe0f",
      "category": "temperature",
      "description": "2M Surface temperature forecast with high-resolution topographic corrections.",
      "category_label": "Core Meteorological",
      "long_description": "2M Surface temperature forecast with high-resolution topographic corrections.",
      "score_description": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13",
        "RTMA (Obs)"
      ],
      "output_models": [
        "Surface temperature .pmtiles per model"
      ],
      "toast_title": "Terrain-Corrected Surface Temperature",
      "toast_subtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
      "toast_description": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures.",
      "longDescription": "2M Surface temperature forecast with high-resolution topographic corrections.",
      "scoreDescription": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13",
        "RTMA (Obs)"
      ],
      "outputModels": [
        "Surface temperature .pmtiles per model"
      ],
      "toastTitle": "Terrain-Corrected Surface Temperature",
      "toastSubtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
      "toastDescription": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures."
    },
    "sun_intensity_forecast": {
      "id": "sun_intensity_forecast",
      "label": "Solar Intensity Forecast",
      "product": "sun_intensity",
      "icon": "\u2600\ufe0f",
      "category": "temperature",
      "description": "Surface downwelling solar irradiance forecast (W/m\u00b2) across numerical weather models.",
      "category_label": "Core Meteorological",
      "long_description": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
      "score_description": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
      "source_models": [
        "rrfs",
        "rdps",
        "gfs",
        "gdps",
        "icon13"
      ],
      "output_models": [
        "Solar Intensity .pmtiles per model"
      ],
      "toast_title": "Solar Intensity & Surface Irradiance",
      "toast_subtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
      "toast_description": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation.",
      "longDescription": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
      "scoreDescription": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "rrfs",
        "rdps",
        "gfs",
        "gdps",
        "icon13"
      ],
      "outputModels": [
        "Solar Intensity .pmtiles per model"
      ],
      "toastTitle": "Solar Intensity & Surface Irradiance",
      "toastSubtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
      "toastDescription": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation."
    },
    "freezing_level": {
      "id": "freezing_level",
      "label": "Freezing Level",
      "product": "freezing_level",
      "model": "hrrr",
      "icon": "\ud83e\uddca",
      "category": "temperature",
      "description": "Freezing level forecast.",
      "category_label": "Core Meteorological",
      "long_description": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
      "score_description": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "output_models": [
        "Altitude (Meters MSL) .pmtiles per model"
      ],
      "toast_title": "Freezing Level Altitude (0\u00b0C Isotherm)",
      "toast_subtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
      "toast_description": "Displays the forecasted elevation where air temperature reaches freezing.",
      "longDescription": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
      "scoreDescription": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "outputModels": [
        "Altitude (Meters MSL) .pmtiles per model"
      ],
      "toastTitle": "Freezing Level Altitude (0\u00b0C Isotherm)",
      "toastSubtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
      "toastDescription": "Displays the forecasted elevation where air temperature reaches freezing."
    },
    "relative_humidity": {
      "id": "relative_humidity",
      "label": "Relative Humidity",
      "product": "relative_humidity",
      "icon": "\ud83d\udca7",
      "category": "temperature",
      "description": "Relative Humidity forecast.",
      "category_label": "Core Meteorological",
      "long_description": "2m Surface Relative Humidity percentage.",
      "score_description": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "output_models": [
        "Surface RH .pmtiles per model"
      ],
      "toast_title": "Surface Relative Humidity (RH%)",
      "toast_subtitle": "2-METER ATMOSPHERIC SATURATION",
      "toast_description": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions.",
      "longDescription": "2m Surface Relative Humidity percentage.",
      "scoreDescription": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "outputModels": [
        "Surface RH .pmtiles per model"
      ],
      "toastTitle": "Surface Relative Humidity (RH%)",
      "toastSubtitle": "2-METER ATMOSPHERIC SATURATION",
      "toastDescription": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions."
    },
    "dewpoint": {
      "id": "dewpoint",
      "label": "Dew Point",
      "product": "dewpoint",
      "icon": "\ud83c\udf2b\ufe0f",
      "category": "temperature",
      "description": "2m Surface Dew Point forecast.",
      "category_label": "Core Meteorological",
      "long_description": "2m Surface Dew Point temperature and atmospheric moisture comfort levels.",
      "score_description": "\u2022 <30\u00b0F (Crisp / Arid): Very dry continental or alpine air mass.\n\u2022 35\u201355\u00b0F (Comfortable): Pleasant outdoor humidity levels.\n\u2022 60\u201369\u00b0F (Muggy / Humid): Noticeable low-level moisture and fuel for convective storms.\n\u2022 70\u00b0F+ (Oppressive / Tropical): High latent heat and oppressive humidity.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "gdps",
        "icon13",
        "nbm"
      ],
      "output_models": [
        "Surface Dew Point .pmtiles per model"
      ],
      "toast_title": "Surface Dew Point Temperature",
      "toast_subtitle": "ABSOLUTE MOISTURE & HUMIDITY COMFORT",
      "toast_description": "Maps 2-meter dew point temperatures to measure absolute atmospheric moisture, mugginess, and overnight condensation thresholds.",
      "longDescription": "2m Surface Dew Point temperature and atmospheric moisture comfort levels.",
      "scoreDescription": "\u2022 <30\u00b0F (Crisp / Arid): Very dry continental or alpine air mass.\n\u2022 35\u201355\u00b0F (Comfortable): Pleasant outdoor humidity levels.\n\u2022 60\u201369\u00b0F (Muggy / Humid): Noticeable low-level moisture and fuel for convective storms.\n\u2022 70\u00b0F+ (Oppressive / Tropical): High latent heat and oppressive humidity.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "gdps",
        "icon13",
        "nbm"
      ],
      "outputModels": [
        "Surface Dew Point .pmtiles per model"
      ],
      "toastTitle": "Surface Dew Point Temperature",
      "toastSubtitle": "ABSOLUTE MOISTURE & HUMIDITY COMFORT",
      "toastDescription": "Maps 2-meter dew point temperatures to measure absolute atmospheric moisture, mugginess, and overnight condensation thresholds."
    },
    "windchill": {
      "id": "windchill",
      "label": "Wind Chill Index",
      "product": "windchill",
      "icon": "\ud83e\udd76",
      "category": "temperature",
      "description": "Wind chill forecast.",
      "category_label": "Core Meteorological",
      "long_description": "Apparent temperature / wind chill index.",
      "score_description": "\u2022 32\u00b0F to 15\u00b0F (Chilly - Light Blue): Dress in warm windproof layers.\n\u2022 15\u00b0F to -15\u00b0F (Bitter Cold - Deep Blue/Violet): Frostbite risk on exposed skin within 30 minutes under strong winds.\n\u2022 Below -20\u00b0F (Extreme Cold Hazard - Magenta/Purple): Life-threatening wind chill; frostbite can occur on exposed skin in under 10\u201315 minutes.",
      "source_models": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "output_models": [
        "Wind chill .pmtiles per model"
      ],
      "toast_title": "Wind Chill & Apparent Temperature",
      "toast_subtitle": "FEELS-LIKE COLD EXPOSURE INDEX",
      "toast_description": "Combines air temperature and 10-meter wind speed to calculate feels-like wind chill temperatures and alpine frostbite risk.",
      "longDescription": "Apparent temperature / wind chill index.",
      "scoreDescription": "\u2022 32\u00b0F to 15\u00b0F (Chilly - Light Blue): Dress in warm windproof layers.\n\u2022 15\u00b0F to -15\u00b0F (Bitter Cold - Deep Blue/Violet): Frostbite risk on exposed skin within 30 minutes under strong winds.\n\u2022 Below -20\u00b0F (Extreme Cold Hazard - Magenta/Purple): Life-threatening wind chill; frostbite can occur on exposed skin in under 10\u201315 minutes.",
      "categoryLabel": "Core Meteorological",
      "sourceModels": [
        "hrrr",
        "rrfs",
        "rdps",
        "gfs",
        "ecmwf",
        "icon13"
      ],
      "outputModels": [
        "Wind chill .pmtiles per model"
      ],
      "toastTitle": "Wind Chill & Apparent Temperature",
      "toastSubtitle": "FEELS-LIKE COLD EXPOSURE INDEX",
      "toastDescription": "Combines air temperature and 10-meter wind speed to calculate feels-like wind chill temperatures and alpine frostbite risk."
    },
    "streamflow_gauges": {
      "id": "streamflow_gauges",
      "label": "Stream & Reservoir Flows",
      "product": "streamflow",
      "icon": "\ud83c\udf0a",
      "category": "hydrology",
      "description": "Stream and reservoir levels, flow rates, temperature.",
      "category_label": "Hydrology & Inland Waters",
      "long_description": "Real-time USGS river and stream telemetry monitoring flow discharge rates (cfs), gauge height, and water temperatures.",
      "score_description": "\u2022 Percentile Color Mode (% of Historical Normal): Colors gauges from extreme low flow (Red/Orange) through normal flow (Green) to high/flood flow (Blue/Purple).\n\u2022 Flow & Storage Mode: Displays absolute river discharge (cfs) and reservoir storage capacity.\n\u2022 Water Temperature Mode: Displays live river and lake water temperatures (\u00b0F/\u00b0C) for anglers and paddlers.",
      "source_models": [
        "USGS National Water Information System (NWIS) Telemetry"
      ],
      "output_models": [
        "Streamflow station telemetry markers",
        "Inland water temperature raster"
      ],
      "toast_title": "Live Streamflow, Reservoirs & Water Temp",
      "toast_subtitle": "REAL-TIME USGS NWIS HYDROLOGY GAUGES",
      "toast_description": "Monitors real-time river discharge (cfs), historical flow percentiles, reservoir levels, and water temperatures across thousands of gauges.",
      "longDescription": "Real-time USGS river and stream telemetry monitoring flow discharge rates (cfs), gauge height, and water temperatures.",
      "scoreDescription": "\u2022 Percentile Color Mode (% of Historical Normal): Colors gauges from extreme low flow (Red/Orange) through normal flow (Green) to high/flood flow (Blue/Purple).\n\u2022 Flow & Storage Mode: Displays absolute river discharge (cfs) and reservoir storage capacity.\n\u2022 Water Temperature Mode: Displays live river and lake water temperatures (\u00b0F/\u00b0C) for anglers and paddlers.",
      "categoryLabel": "Hydrology & Inland Waters",
      "sourceModels": [
        "USGS National Water Information System (NWIS) Telemetry"
      ],
      "outputModels": [
        "Streamflow station telemetry markers",
        "Inland water temperature raster"
      ],
      "toastTitle": "Live Streamflow, Reservoirs & Water Temp",
      "toastSubtitle": "REAL-TIME USGS NWIS HYDROLOGY GAUGES",
      "toastDescription": "Monitors real-time river discharge (cfs), historical flow percentiles, reservoir levels, and water temperatures across thousands of gauges."
    },
    "sst": {
      "id": "sst",
      "label": "Sea Surface Temperature",
      "product": "sst",
      "icon": "\ud83c\udf0a",
      "category": "hydrology",
      "description": "Observed sea surface temperature.",
      "category_label": "Marine & Oceanographic",
      "long_description": "High-resolution sea surface water temperatures coupled with NOAA NDBC real-time buoy observations.",
      "score_description": "\u2022 5km SST Raster: Daily satellite-blended ocean and Great Lakes surface water temperatures.\n\u2022 Live NDBC Marine Buoys: Click any offshore or coastal buoy to view real-time water temperature, wave height, dominant swell period, and marine winds.",
      "source_models": [
        "NOAA Coral Reef Watch (CRW) 5km SST",
        "NOAA NDBC Marine Buoy Stations"
      ],
      "output_models": [
        "SST temperature .pmtiles",
        "Live marine buoy observation telemetry"
      ],
      "toast_title": "Sea Surface Temperature & Marine Buoys",
      "toast_subtitle": "5KM SATELLITE SST & LIVE NDBC BUOYS",
      "toast_description": "Combines high-resolution satellite sea surface water temperatures with live coastal and offshore NOAA marine buoy telemetry.",
      "longDescription": "High-resolution sea surface water temperatures coupled with NOAA NDBC real-time buoy observations.",
      "scoreDescription": "\u2022 5km SST Raster: Daily satellite-blended ocean and Great Lakes surface water temperatures.\n\u2022 Live NDBC Marine Buoys: Click any offshore or coastal buoy to view real-time water temperature, wave height, dominant swell period, and marine winds.",
      "categoryLabel": "Marine & Oceanographic",
      "sourceModels": [
        "NOAA Coral Reef Watch (CRW) 5km SST",
        "NOAA NDBC Marine Buoy Stations"
      ],
      "outputModels": [
        "SST temperature .pmtiles",
        "Live marine buoy observation telemetry"
      ],
      "toastTitle": "Sea Surface Temperature & Marine Buoys",
      "toastSubtitle": "5KM SATELLITE SST & LIVE NDBC BUOYS",
      "toastDescription": "Combines high-resolution satellite sea surface water temperatures with live coastal and offshore NOAA marine buoy telemetry."
    }
  },
  "cannedPersonas": {
    "hiking": {
      "id": "hiking",
      "title": "Hiking / Mountaineering",
      "icon": "\ud83e\udd7e",
      "description": "Altitude hazards, extreme temps, radar, lightning & rain",
      "defaultBasemap": "terrain-mapterhorn",
      "basemapConfig": {
        "theme": "terrain-mapterhorn",
        "mode": "light",
        "terrain3d": true,
        "shading": "color_tint"
      },
      "isDefault": true,
      "isCustom": false,
      "forecastLayoutRef": "config/forecast_layouts/hiking.yaml",
      "forecastLayout": {
        "id": "hiking",
        "name": "Hiking & Climbing",
        "description": "Altitude hazards, mountain lapse rates, lightning timing, wind, and precipitation",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "widget_1791652625511_437",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "widget_1791656609430_2",
              "type": "daily-forecast-list",
              "title": "Daily Weather Forecast",
              "colSpan": 6,
              "options": {
                "period": "auto",
                "dataSource": "auto",
                "showRainChance": true,
                "showWind": true,
                "showTempBar": true,
                "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
              },
              "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
            },
            {
              "id": "widget_1791655092340_480",
              "type": "recent-weather-2x3",
              "title": "Recent Observations",
              "colSpan": 6,
              "options": {
                "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
              },
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            {
              "id": "widget_1791606537622_893",
              "type": "elevation-temp-card",
              "title": "Elevation Temperatures & Lapse Trend",
              "colSpan": 12,
              "options": {
                "showFreezingLine": true,
                "chartHeight": 160,
                "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
              },
              "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
            },
            {
              "id": "widget_1791606564694_787",
              "type": "cloud-ceiling-card",
              "title": "Clouds & Tops Elevation Trend",
              "colSpan": 12,
              "options": {
                "displayMode": "chart",
                "showFreezingLine": false,
                "showCloudCover": true,
                "chartHeight": 250,
                "topColor": "#93c5fd",
                "baseColor": "#0284c7",
                "fillColor": "#daf3fe",
                "fillOpacity": 22,
                "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
              },
              "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
            },
            {
              "id": "widget_1791606612397_565",
              "type": "meteogram-card",
              "title": "Precipitation Rate and Freezing LEvel",
              "colSpan": 12,
              "options": {
                "height": 200,
                "showNow": true,
                "horizonDays": "auto",
                "showMountainSilhouette": false,
                "declutterElevations": true,
                "showMinMaxLines": false,
                "minMaxSeriesKey": "auto",
                "series": [
                  {
                    "key": "freezing_level_ft",
                    "type": "line",
                    "yAxis": "left",
                    "color": "#38bdf8",
                    "tension": 0.3
                  },
                  {
                    "key": "precip_rate_in_h",
                    "type": "bar",
                    "yAxis": "right",
                    "color": "#3b82f6",
                    "tension": 0.3
                  }
                ],
                "description": "Hourly mountain hazard meteogram comparing the freezing level altitude (ft MSL, cyan curve on left axis) against hourly liquid-equivalent precipitation intensity (in/hr, blue bars on right axis). When the freezing level drops below your trail or summit elevation during active precipitation, expect rain to transition to snow, sleet, or verglas."
              },
              "description": "Hourly mountain hazard meteogram comparing the freezing level altitude (ft MSL, cyan curve on left axis) against hourly liquid-equivalent precipitation intensity (in/hr, blue bars on right axis). When the freezing level drops below your trail or summit elevation during active precipitation, expect rain to transition to snow, sleet, or verglas."
            },
            {
              "id": "widget_1791655030071_613",
              "type": "golden-window-card",
              "title": "Sunrise, Sunset and Golden Hour Outlooks",
              "colSpan": 12,
              "options": {
                "displayMode": "cards",
                "daysCount": "auto",
                "showLunarTimeline": true,
                "showScores": true,
                "showTimes": false,
                "showAlpenglow": false,
                "chartHeight": 140,
                "showGoldenHour": true,
                "layoutStyle": "web",
                "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
              },
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "w_appbar",
              "type": "app-bar",
              "title": "Mountain Location Bar",
              "col_span": 12,
              "options": {
                "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
              },
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            {
              "id": "w_horizon",
              "type": "horizon-selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "default": "5-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "widget_1791576661895_925",
              "type": "glance-2x2",
              "title": "Current Conditions",
              "col_span": 4,
              "options": {
                "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
              },
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            {
              "id": "widget_1791606446037_292",
              "type": "elevation-temp-card",
              "title": "Elevation Temperatures & Lapse Trend",
              "colSpan": 6,
              "options": {
                "showFreezingLine": true,
                "chartHeight": 160,
                "labelFontSize": 9,
                "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
              },
              "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
            },
            {
              "id": "widget_1791561906679_640",
              "type": "cloud-ceiling-card",
              "title": "Clouds & Tops Elevation Trend",
              "col_span": 6,
              "options": {
                "displayMode": "chart",
                "showFreezingLine": false,
                "showCloudCover": true,
                "chartHeight": 220,
                "baseColor": "#cfebea",
                "fillColor": "#d6e0e0",
                "labelFontSize": 9,
                "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
              },
              "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
            },
            {
              "id": "widget_1791574438751_161",
              "type": "meteogram-card",
              "title": "Thunderstorm and Precipitation Probability",
              "col_span": 12,
              "options": {
                "height": 180,
                "showNow": true,
                "horizonDays": "5",
                "showMountainSilhouette": false,
                "declutterElevations": true,
                "showMinMaxLines": false,
                "minMaxSeriesKey": "precip_rate_in_h",
                "series": [
                  {
                    "key": "precip_prob_pct",
                    "type": "line",
                    "yAxis": "left",
                    "color": "#3b82f6",
                    "tension": 0.3
                  },
                  {
                    "key": "thunderstorm_prob",
                    "type": "bar",
                    "yAxis": "left",
                    "color": "#eab308",
                    "tension": 0.3
                  },
                  {
                    "key": "precip_rate_in_h",
                    "label": "Precipitation Rate (in/hr)",
                    "type": "bar",
                    "yAxis": "right",
                    "color": "#38bdf8",
                    "tension": 0.3
                  }
                ],
                "labelFontSize": 9,
                "description": "Hourly alpine convective threat meteogram combining precipitation probability (%, blue curve), thunderstorm probability (%, gold bars), and hourly precipitation rate (in/hr, cyan bars on right axis). Ideal for timing early-morning summit pushes before afternoon convective storms build over exposed ridges."
              },
              "description": "Hourly alpine convective threat meteogram combining precipitation probability (%, blue curve), thunderstorm probability (%, gold bars), and hourly precipitation rate (in/hr, cyan bars on right axis). Ideal for timing early-morning summit pushes before afternoon convective storms build over exposed ridges."
            },
            {
              "id": "widget_1792980764902_513",
              "type": "recent-weather-2x3",
              "title": "Recent Rainfall",
              "colSpan": 6,
              "options": {
                "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
              },
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            {
              "id": "widget_1793035208082_674",
              "type": "sounding-card",
              "title": "Vertical Atmospheric Sounding",
              "colSpan": 6,
              "options": {
                "chartHeight": 280,
                "showInversions": true,
                "showFreezingLine": true,
                "showWindsAloft": true,
                "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
              },
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            {
              "id": "widget_1793034976723_41",
              "type": "wildfires-card",
              "title": "Nearby Wildfires",
              "colSpan": 6,
              "options": {
                "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
              },
              "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
            },
            {
              "id": "widget_1791574434399_102",
              "type": "bottom-nav",
              "title": "Navigation Bar",
              "col_span": 12,
              "options": {
                "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
              },
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "avalanche_danger",
          "label": "Avalanche Danger (USFS NAC)",
          "product": "avalanche",
          "icon": "\ud83c\udfd4\ufe0f\u26a0\ufe0f",
          "category": "hydrology",
          "description": "Live avalanche danger ratings & official bulletins",
          "basemap_override": {
            "theme": "usgs-topo"
          },
          "category_label": "Backcountry & Alpine Safety",
          "long_description": "Official daily backcountry avalanche danger ratings, avalanche problem types, elevation rose diagrams, and forecaster bulletins aggregated from the USFS National Avalanche Center (NAC) and regional avalanche centers across North America.",
          "score_description": "\u2022 1 - Low (Green): Generally safe avalanche conditions; watch for unstable snow on isolated terrain features.\n\u2022 2 - Moderate (Yellow): Heightened avalanche conditions on specific terrain features; evaluate snow and terrain carefully.\n\u2022 3 - Considerable (Orange): Dangerous avalanche conditions; careful snowpack evaluation, conservative decision-making, and cautious route-finding essential.\n\u2022 4 - High (Red): Very dangerous avalanche conditions; travel in avalanche terrain not recommended.\n\u2022 5 - Extreme (Black/Maroon): Avoid all avalanche terrain; natural and human-triggered avalanches certain.",
          "source_models": [
            "USFS National Avalanche Center (NAC) API",
            "Regional Backcountry Avalanche Forecast Centers"
          ],
          "output_models": [
            "Interactive Avalanche Forecast Zone Polygons & Official Bulletins"
          ],
          "toast_title": "Backcountry Avalanche Danger (NAC)",
          "toast_subtitle": "OFFICIAL NORTH AMERICAN AVALANCHE RATINGS",
          "toast_description": "Displays live official avalanche danger ratings (1-Low to 5-Extreme) and backcountry forecast bulletins by mountain zone.",
          "basemapOverride": {
            "theme": "usgs-topo"
          },
          "longDescription": "Official daily backcountry avalanche danger ratings, avalanche problem types, elevation rose diagrams, and forecaster bulletins aggregated from the USFS National Avalanche Center (NAC) and regional avalanche centers across North America.",
          "scoreDescription": "\u2022 1 - Low (Green): Generally safe avalanche conditions; watch for unstable snow on isolated terrain features.\n\u2022 2 - Moderate (Yellow): Heightened avalanche conditions on specific terrain features; evaluate snow and terrain carefully.\n\u2022 3 - Considerable (Orange): Dangerous avalanche conditions; careful snowpack evaluation, conservative decision-making, and cautious route-finding essential.\n\u2022 4 - High (Red): Very dangerous avalanche conditions; travel in avalanche terrain not recommended.\n\u2022 5 - Extreme (Black/Maroon): Avoid all avalanche terrain; natural and human-triggered avalanches certain.",
          "categoryLabel": "Backcountry & Alpine Safety",
          "sourceModels": [
            "USFS National Avalanche Center (NAC) API",
            "Regional Backcountry Avalanche Forecast Centers"
          ],
          "outputModels": [
            "Interactive Avalanche Forecast Zone Polygons & Official Bulletins"
          ],
          "toastTitle": "Backcountry Avalanche Danger (NAC)",
          "toastSubtitle": "OFFICIAL NORTH AMERICAN AVALANCHE RATINGS",
          "toastDescription": "Displays live official avalanche danger ratings (1-Low to 5-Extreme) and backcountry forecast bulletins by mountain zone."
        },
        {
          "id": "mountain_visibility",
          "label": "Mountain Visibility",
          "product": "mountain_visibility",
          "model": "nbm",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "clouds_wind",
          "description": "Terrain based visibility forecast indicating mountainous areas with no or limited visibility.",
          "long_description": "Mountain Visibility identifies the exact vertical zone where mountain slopes, passes, and ridgelines are submerged within active cloud decks, enveloped in dense fog, rain, or whiteout conditions.\n\nUsing high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with National Blend of Models (NBM) cloud base and cloud top boundary surfaces, this layer maps the physical 3D cloud deck sandwich against real terrain:\n\u2022 Below Cloud Base: Valleys and lowlands under the cloud deck remain 100% transparent in clear air beneath the ceiling.\n\u2022 In-Cloud Deck: Mountain terrain between cloud base and cloud top is rendered in an atmospheric slate-blue cloud shroud.\n\u2022 Above Cloud Tops: Mountain summits and high alpine ridges piercing above the cloud deck remain 100% transparent in clear sunshine.\n\nThis gives backcountry hikers, mountaineers, trail runners, and alpine photographers immediate clarity on whether a trail enters the clouds, where whiteout conditions begin, and which mountain peaks rise into clear sky above.",
          "score_description": "\u2022 Slate-Blue Shroud: Terrain submerged inside the cloud deck (Cloud Base <= Elevation <= Cloud Top), indicating fog, cloud obscuration, or whiteout.\n\u2022 Transparent Valleys: Terrain below the cloud base with clear air and open ground-level visibility underneath the ceiling.\n\u2022 Transparent Summits: High alpine peaks and ridges extending above the cloud top into clear blue sky and sunshine.\n\u2022 Shoreline Feathering: Smooth 50-meter elevation transition along lower and upper cloud boundaries.",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Mountain Visibility (.pmtiles)"
          ],
          "toast_title": "Mountain Cloud Shroud & Whiteout Zones",
          "toast_subtitle": "3D TERRAIN CLOUD INTERSECTION",
          "toast_description": "Map plots areas where there is no visibility based on elevation in grey.  Areas shrouded in grey on the map indicates low or no visibility at the given elevation.",
          "longDescription": "Mountain Visibility identifies the exact vertical zone where mountain slopes, passes, and ridgelines are submerged within active cloud decks, enveloped in dense fog, rain, or whiteout conditions.\n\nUsing high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with National Blend of Models (NBM) cloud base and cloud top boundary surfaces, this layer maps the physical 3D cloud deck sandwich against real terrain:\n\u2022 Below Cloud Base: Valleys and lowlands under the cloud deck remain 100% transparent in clear air beneath the ceiling.\n\u2022 In-Cloud Deck: Mountain terrain between cloud base and cloud top is rendered in an atmospheric slate-blue cloud shroud.\n\u2022 Above Cloud Tops: Mountain summits and high alpine ridges piercing above the cloud deck remain 100% transparent in clear sunshine.\n\nThis gives backcountry hikers, mountaineers, trail runners, and alpine photographers immediate clarity on whether a trail enters the clouds, where whiteout conditions begin, and which mountain peaks rise into clear sky above.",
          "scoreDescription": "\u2022 Slate-Blue Shroud: Terrain submerged inside the cloud deck (Cloud Base <= Elevation <= Cloud Top), indicating fog, cloud obscuration, or whiteout.\n\u2022 Transparent Valleys: Terrain below the cloud base with clear air and open ground-level visibility underneath the ceiling.\n\u2022 Transparent Summits: High alpine peaks and ridges extending above the cloud top into clear blue sky and sunshine.\n\u2022 Shoreline Feathering: Smooth 50-meter elevation transition along lower and upper cloud boundaries.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Mountain Visibility (.pmtiles)"
          ],
          "toastTitle": "Mountain Cloud Shroud & Whiteout Zones",
          "toastSubtitle": "3D TERRAIN CLOUD INTERSECTION",
          "toastDescription": "Map plots areas where there is no visibility based on elevation in grey.  Areas shrouded in grey on the map indicates low or no visibility at the given elevation."
        },
        {
          "id": "snow_depth",
          "label": "Snow Depth & SNOTEL",
          "product": "snow_depth",
          "icon": "\u2744\ufe0f",
          "category": "hydrology",
          "description": "Observed snowpack depth & SNOTEL telemetry",
          "category_label": "Hydrology & Mountain Weather",
          "long_description": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
          "score_description": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
          "source_models": [
            "NOAA SNODAS 1km Snow Analysis",
            "USDA NRCS SNOTEL Telemetry",
            "ECCC & BC Snow Pillow Network"
          ],
          "output_models": [
            "Continuous mountain snowpack gradient",
            "Live SNOTEL observation stations"
          ],
          "toast_title": "Snow Depth & Live SNOTEL Stations",
          "toast_subtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
          "toast_description": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements.",
          "longDescription": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
          "scoreDescription": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
          "categoryLabel": "Hydrology & Mountain Weather",
          "sourceModels": [
            "NOAA SNODAS 1km Snow Analysis",
            "USDA NRCS SNOTEL Telemetry",
            "ECCC & BC Snow Pillow Network"
          ],
          "outputModels": [
            "Continuous mountain snowpack gradient",
            "Live SNOTEL observation stations"
          ],
          "toastTitle": "Snow Depth & Live SNOTEL Stations",
          "toastSubtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
          "toastDescription": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements."
        },
        {
          "id": "wildfires",
          "label": "Wildfire Perimeters & Info",
          "product": "wildfires",
          "icon": "\ud83d\udd25",
          "category": "air_quality_fires",
          "description": "Active US (NIFC) and Canadian (CWFIS) wildfire perimeters & incident info.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Displays active wildfire perimeters across the United States (NIFC) and Canada (CWFIS), alongside near-real-time satellite thermal anomaly hotspots detected by NASA VIIRS instruments (375m resolution). Includes acreage, containment progress, and incident reporting.",
          "score_description": "\u2022 Active Fire Perimeters (Red/Orange Polygons): Official mapped incident burn boundaries from NIFC WFIGS and Canadian CWFIS with acreage and % containment.\n\u2022 VIIRS Thermal Hotspots (Glowing Dots): Satellite-detected 375m infrared heat signatures indicating active fire fronts and flare-ups.",
          "source_models": [
            "NIFC WFIGS (National Interagency Fire Center)",
            "CWFIS (Canadian Wildland Fire Information System)",
            "NASA FIRMS VIIRS (375m Active Fire Detections)"
          ],
          "output_models": [
            "Vector Perimeters & Point Hotspots GeoJSON"
          ],
          "toast_title": "Active Wildfire Perimeters & Incidents",
          "toast_subtitle": "NIFC, CWFIS & NASA VIIRS DETECTIONS",
          "toast_description": "Maps active US and Canadian wildfire burn perimeters, containment percentages, incident details, and satellite thermal hotspots.",
          "longDescription": "Displays active wildfire perimeters across the United States (NIFC) and Canada (CWFIS), alongside near-real-time satellite thermal anomaly hotspots detected by NASA VIIRS instruments (375m resolution). Includes acreage, containment progress, and incident reporting.",
          "scoreDescription": "\u2022 Active Fire Perimeters (Red/Orange Polygons): Official mapped incident burn boundaries from NIFC WFIGS and Canadian CWFIS with acreage and % containment.\n\u2022 VIIRS Thermal Hotspots (Glowing Dots): Satellite-detected 375m infrared heat signatures indicating active fire fronts and flare-ups.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "NIFC WFIGS (National Interagency Fire Center)",
            "CWFIS (Canadian Wildland Fire Information System)",
            "NASA FIRMS VIIRS (375m Active Fire Detections)"
          ],
          "outputModels": [
            "Vector Perimeters & Point Hotspots GeoJSON"
          ],
          "toastTitle": "Active Wildfire Perimeters & Incidents",
          "toastSubtitle": "NIFC, CWFIS & NASA VIIRS DETECTIONS",
          "toastDescription": "Maps active US and Canadian wildfire burn perimeters, containment percentages, incident details, and satellite thermal hotspots."
        },
        {
          "id": "fire_restrictions",
          "label": "Fire Restrictions (USFS/BLM/NPS)",
          "product": "fire_restrictions",
          "icon": "\ud83d\udd25\ud83d\udeab",
          "category": "air_quality_fires",
          "description": "Camp Fire restrictions.",
          "long_description": "Provides data from land management agencies around what fire restrictions, if any, are currently in place.\n\nAggregates active campfire bans, Stage 1 and Stage 2 fire restrictions, industrial fire precaution levels, and area closures across US Forest Service (USFS), Bureau of Land Management (BLM), National Park Service (NPS), BIA, USFWS, and state forestry jurisdictions.",
          "category_label": "Public Lands & Wildfire Safety",
          "score_description": "\u2022 Stage 1 Fire Restrictions (Yellow/Amber): Campfires restricted to developed agency-approved fire rings; smoking and spark-emitting equipment restricted.\n\u2022 Stage 2 Fire Restrictions (Orange/Red): All wood and charcoal campfires prohibited (including developed campgrounds); pressurized liquid/gas stoves with shutoff valves typically permitted.\n\u2022 Stage 3 / Area Closure (Magenta/Dark Red): Extreme fire danger closure or complete prohibition of all ignition sources.",
          "source_models": [
            "NIFC / Interagency Fire Restrictions Feeds (USFS, BLM, NPS, BIA, State)"
          ],
          "output_models": [
            "Jurisdictional Fire Restriction Polygons & Order Summaries GeoJSON"
          ],
          "toast_title": "Public Land Fire Restrictions",
          "toast_subtitle": "USFS, BLM, NPS & STATE CAMPFIRE ORDERS",
          "toast_description": "Maps active Stage 1 and Stage 2 campfire bans and agency fire restriction orders across federal and state public lands.",
          "longDescription": "Provides data from land management agencies around what fire restrictions, if any, are currently in place.\n\nAggregates active campfire bans, Stage 1 and Stage 2 fire restrictions, industrial fire precaution levels, and area closures across US Forest Service (USFS), Bureau of Land Management (BLM), National Park Service (NPS), BIA, USFWS, and state forestry jurisdictions.",
          "scoreDescription": "\u2022 Stage 1 Fire Restrictions (Yellow/Amber): Campfires restricted to developed agency-approved fire rings; smoking and spark-emitting equipment restricted.\n\u2022 Stage 2 Fire Restrictions (Orange/Red): All wood and charcoal campfires prohibited (including developed campgrounds); pressurized liquid/gas stoves with shutoff valves typically permitted.\n\u2022 Stage 3 / Area Closure (Magenta/Dark Red): Extreme fire danger closure or complete prohibition of all ignition sources.",
          "categoryLabel": "Public Lands & Wildfire Safety",
          "sourceModels": [
            "NIFC / Interagency Fire Restrictions Feeds (USFS, BLM, NPS, BIA, State)"
          ],
          "outputModels": [
            "Jurisdictional Fire Restriction Polygons & Order Summaries GeoJSON"
          ],
          "toastTitle": "Public Land Fire Restrictions",
          "toastSubtitle": "USFS, BLM, NPS & STATE CAMPFIRE ORDERS",
          "toastDescription": "Maps active Stage 1 and Stage 2 campfire bans and agency fire restriction orders across federal and state public lands."
        },
        {
          "id": "cloud_base",
          "label": "Cloud Base Elevation",
          "product": "cloud_base",
          "model": "nbm",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud base elevation (MSL) critical for climbing, hiking, and photography",
          "long_description": "Cloud Base Elevation maps the absolute Mean Sea Level (MSL) altitude of the lowest cloud deck across the landscape.\n\nKnowing the exact cloud base altitude is critical for backcountry hikers, mountaineers, climbers, and landscape photographers. It indicates the exact elevation where trails enter fog, rain, and whiteout conditions, and reveals when summits, ridgelines, and alpine passes are clear of cloud cover.\n\nThe layer uses high-resolution National Blend of Models (NOAA NBM) aviation ceiling and lowest cloud base fields combined with high-resolution digital elevation modeling. Clear skies with absent or high cirrus clouds are rendered transparent so the underlying terrain remains visible, while active cloud decks are rendered with a continuous elevation gradient from sea level up to 16,000 ft MSL.",
          "score_description": "\u2022 Purple/Violet (0 - 3,000 ft MSL): Very low cloud base or sea-level marine stratus and coastal fog.\n\u2022 Blue to Cyan (3,000 - 6,000 ft MSL): Low-to-mid mountain cloud deck covering foothills and lower trailheads.\n\u2022 Teal to Emerald Green (6,000 - 9,000 ft MSL): Subalpine cloud ceiling; peaks above 9,000 ft extend above the clouds.\n\u2022 Yellow to Amber (9,000 - 12,000 ft MSL): High-altitude mountain cloud deck; alpine terrain below 9,000 ft remains in clear air.\n\u2022 Orange to Red/Magenta (12,000 - 16,000+ ft MSL): High cloud bases; only the highest continental summits are obscured.\n\u2022 Transparent: Clear skies (no low cloud deck or ceiling detected).",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Cloud Base Elevation (.pmtiles)"
          ],
          "toast_title": "Cloud Base Altitude (MSL)",
          "toast_subtitle": "LOWEST CLOUD CEILING ELEVATION",
          "toast_description": "Maps the Mean Sea Level (MSL) elevation of the lowest cloud ceiling so hikers and photographers know whether summits are clear or in the clouds.",
          "longDescription": "Cloud Base Elevation maps the absolute Mean Sea Level (MSL) altitude of the lowest cloud deck across the landscape.\n\nKnowing the exact cloud base altitude is critical for backcountry hikers, mountaineers, climbers, and landscape photographers. It indicates the exact elevation where trails enter fog, rain, and whiteout conditions, and reveals when summits, ridgelines, and alpine passes are clear of cloud cover.\n\nThe layer uses high-resolution National Blend of Models (NOAA NBM) aviation ceiling and lowest cloud base fields combined with high-resolution digital elevation modeling. Clear skies with absent or high cirrus clouds are rendered transparent so the underlying terrain remains visible, while active cloud decks are rendered with a continuous elevation gradient from sea level up to 16,000 ft MSL.",
          "scoreDescription": "\u2022 Purple/Violet (0 - 3,000 ft MSL): Very low cloud base or sea-level marine stratus and coastal fog.\n\u2022 Blue to Cyan (3,000 - 6,000 ft MSL): Low-to-mid mountain cloud deck covering foothills and lower trailheads.\n\u2022 Teal to Emerald Green (6,000 - 9,000 ft MSL): Subalpine cloud ceiling; peaks above 9,000 ft extend above the clouds.\n\u2022 Yellow to Amber (9,000 - 12,000 ft MSL): High-altitude mountain cloud deck; alpine terrain below 9,000 ft remains in clear air.\n\u2022 Orange to Red/Magenta (12,000 - 16,000+ ft MSL): High cloud bases; only the highest continental summits are obscured.\n\u2022 Transparent: Clear skies (no low cloud deck or ceiling detected).",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Cloud Base Elevation (.pmtiles)"
          ],
          "toastTitle": "Cloud Base Altitude (MSL)",
          "toastSubtitle": "LOWEST CLOUD CEILING ELEVATION",
          "toastDescription": "Maps the Mean Sea Level (MSL) elevation of the lowest cloud ceiling so hikers and photographers know whether summits are clear or in the clouds."
        },
        {
          "id": "lenticular_clouds",
          "label": "Lenticular Cloud Probability",
          "product": "lenticular",
          "model": "ensemble",
          "icon": "\ud83d\udef8",
          "category": "clouds_wind",
          "description": "Identifies favorable conditions for lenticular cloud formation indicating turbulent conditions near mountain peaks.",
          "long_description": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
          "category_label": "Forecast Quality Scoring",
          "score_description": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
          "source_models": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "output_models": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "toast_title": "Lenticular Wave Cloud Forecast",
          "toast_subtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
          "toast_description": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks.",
          "longDescription": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
          "scoreDescription": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "outputModels": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "toastTitle": "Lenticular Wave Cloud Forecast",
          "toastSubtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
          "toastDescription": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks."
        },
        {
          "id": "smoke_forecast",
          "label": "Wildfire Smoke",
          "product": "smoke",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "air_quality_fires",
          "description": "Wildfire smoke forecasts for North America.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "score_description": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "source_models": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "output_models": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toast_title": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toast_subtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toast_description": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation.",
          "longDescription": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "scoreDescription": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "outputModels": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toastTitle": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toastSubtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toastDescription": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation."
        },
        {
          "id": "sun_intensity_forecast",
          "label": "Solar Intensity Forecast",
          "product": "sun_intensity",
          "icon": "\u2600\ufe0f",
          "category": "temperature",
          "description": "Surface downwelling solar irradiance forecast (W/m\u00b2) across numerical weather models.",
          "category_label": "Core Meteorological",
          "long_description": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "score_description": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "source_models": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "output_models": [
            "Solar Intensity .pmtiles per model"
          ],
          "toast_title": "Solar Intensity & Surface Irradiance",
          "toast_subtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toast_description": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation.",
          "longDescription": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "scoreDescription": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "outputModels": [
            "Solar Intensity .pmtiles per model"
          ],
          "toastTitle": "Solar Intensity & Surface Irradiance",
          "toastSubtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toastDescription": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation."
        }
      ],
      "secondaryLayers": [
        {
          "id": "precip_radar",
          "label": "Doppler Radar",
          "product": "live_weather",
          "model": "mrms",
          "icon": "\ud83d\udce1",
          "category": "precipitation",
          "description": "Near real time doppler radar",
          "basemap_override": {
            "terrain_3d": false
          },
          "category_label": "Real-Time Observation",
          "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "source_models": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "output_models": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toast_title": "Live NOAA MRMS Doppler Radar",
          "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
          "basemapOverride": {
            "terrain3d": false
          },
          "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "outputModels": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toastTitle": "Live NOAA MRMS Doppler Radar",
          "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
        },
        {
          "id": "lightning_live",
          "label": "Lightning Activity (Observed)",
          "product": "live_weather",
          "model": "mrms_lightning",
          "icon": "\u26a1",
          "category": "precipitation",
          "description": "Rolling 8-hour 5-minute lightning strikes scaled by flash density and age (yellow to gray).",
          "long_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "category_label": "Real-Time Observation",
          "score_description": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "source_models": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "output_models": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toast_title": "Live Lightning Strikes (8-Hour Trail)",
          "toast_subtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toast_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.",
          "longDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "scoreDescription": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "outputModels": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toastTitle": "Live Lightning Strikes (8-Hour Trail)",
          "toastSubtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toastDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes."
        },
        {
          "id": "precip_forecast",
          "label": "Precipitation Forecast",
          "product": "precip",
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Hourly and daily rain and snow forecasts.",
          "category_label": "Core Meteorological",
          "long_description": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "score_description": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "source_models": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "output_models": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toast_title": "Precipitation Rate, Probability & Snow",
          "toast_subtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toast_description": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models.",
          "longDescription": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "scoreDescription": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "outputModels": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toastTitle": "Precipitation Rate, Probability & Snow",
          "toastSubtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toastDescription": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models."
        },
        {
          "id": "precip_accum",
          "label": "Precipitation Accumulation (Past 1-7 Days)",
          "product": "precip_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP precipitation accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "long_description": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "source_models": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toast_title": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toast_subtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toast_description": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation.",
          "longDescription": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toastSubtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toastDescription": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation."
        },
        {
          "id": "snow_accum",
          "label": "Snowfall Accumulation (Past 1-7 Days)",
          "product": "snow_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf28\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP snowfall accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "long_description": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "source_models": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toast_title": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toast_subtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toast_description": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows.",
          "longDescription": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toastSubtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toastDescription": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows."
        },
        {
          "id": "clouds",
          "label": "Cloud Forecast",
          "product": "clouds",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud forecasts.",
          "long_description": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "category_label": "Core Meteorological",
          "score_description": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "source_models": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "output_models": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toast_title": "Cloud Cover Forecast",
          "toast_subtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toast_description": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures.",
          "longDescription": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "scoreDescription": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "outputModels": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toastTitle": "Cloud Cover Forecast",
          "toastSubtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toastDescription": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures."
        },
        {
          "id": "winds_surface_current",
          "label": "Surface Winds (Current)",
          "product": "live_weather",
          "model": "rtma_winds",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Current and recently observed surface winds.",
          "category_label": "Real-Time Observation",
          "long_description": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "score_description": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "source_models": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "output_models": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toast_title": "Current Surface Winds (Live RTMA)",
          "toast_subtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toast_description": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines.",
          "longDescription": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "scoreDescription": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "outputModels": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toastTitle": "Current Surface Winds (Live RTMA)",
          "toastSubtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toastDescription": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines."
        },
        {
          "id": "winds_surface",
          "label": "Surface Winds Forecast",
          "product": "winds",
          "model": "blend",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Forecasted Surface Winds (10m)",
          "category_label": "Core Meteorological",
          "long_description": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "score_description": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toast_title": "Surface Winds & Gusts",
          "toast_subtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toast_description": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models.",
          "longDescription": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "scoreDescription": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toastTitle": "Surface Winds & Gusts",
          "toastSubtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toastDescription": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models."
        },
        {
          "id": "hrtemp_current",
          "label": "Current Temperature (RTMA)",
          "product": "hrtemp_current",
          "model": "rtma",
          "icon": "\ud83c\udf21\ufe0f",
          "category": "temperature",
          "description": "Real-time NOAA RTMA 2.5km surface temperature observations.",
          "category_label": "Real-Time Observation",
          "long_description": "Real-time surface temperature observations derived from NOAA Real-Time Mesoscale Analysis (RTMA 2.5km).",
          "score_description": "\u2022 High-Resolution 2.5km Grid: Blends surface weather station observations with topographic elevation modeling to map current temperatures across peaks and valleys.\n\u2022 Isotherm Contours: Optional 5\u00b0F contour lines highlighting sharp thermal fronts and freezing boundaries.",
          "source_models": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "output_models": [
            "Real-time 2.5km surface temperature .pmtiles"
          ],
          "toast_title": "Current Surface Temperature (Live RTMA)",
          "toast_subtitle": "2.5KM TERRAIN-ANALYZED OBSERVATIONS",
          "toast_description": "Maps current real-time 2-meter air temperatures at 2.5km resolution using NOAA Real-Time Mesoscale Analysis.",
          "longDescription": "Real-time surface temperature observations derived from NOAA Real-Time Mesoscale Analysis (RTMA 2.5km).",
          "scoreDescription": "\u2022 High-Resolution 2.5km Grid: Blends surface weather station observations with topographic elevation modeling to map current temperatures across peaks and valleys.\n\u2022 Isotherm Contours: Optional 5\u00b0F contour lines highlighting sharp thermal fronts and freezing boundaries.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "outputModels": [
            "Real-time 2.5km surface temperature .pmtiles"
          ],
          "toastTitle": "Current Surface Temperature (Live RTMA)",
          "toastSubtitle": "2.5KM TERRAIN-ANALYZED OBSERVATIONS",
          "toastDescription": "Maps current real-time 2-meter air temperatures at 2.5km resolution using NOAA Real-Time Mesoscale Analysis."
        },
        {
          "id": "hrtemp",
          "label": "Temperature Forecast",
          "product": "hrtemp",
          "model": "nbm",
          "icon": "\ud83c\udf21\ufe0f",
          "category": "temperature",
          "description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "category_label": "Core Meteorological",
          "long_description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "score_description": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Surface temperature .pmtiles per model"
          ],
          "toast_title": "Terrain-Corrected Surface Temperature",
          "toast_subtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toast_description": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures.",
          "longDescription": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "scoreDescription": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Surface temperature .pmtiles per model"
          ],
          "toastTitle": "Terrain-Corrected Surface Temperature",
          "toastSubtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toastDescription": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures."
        },
        {
          "id": "freezing_level",
          "label": "Freezing Level",
          "product": "freezing_level",
          "model": "hrrr",
          "icon": "\ud83e\uddca",
          "category": "temperature",
          "description": "Freezing level forecast.",
          "category_label": "Core Meteorological",
          "long_description": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
          "score_description": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Altitude (Meters MSL) .pmtiles per model"
          ],
          "toast_title": "Freezing Level Altitude (0\u00b0C Isotherm)",
          "toast_subtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
          "toast_description": "Displays the forecasted elevation where air temperature reaches freezing.",
          "longDescription": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
          "scoreDescription": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Altitude (Meters MSL) .pmtiles per model"
          ],
          "toastTitle": "Freezing Level Altitude (0\u00b0C Isotherm)",
          "toastSubtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
          "toastDescription": "Displays the forecasted elevation where air temperature reaches freezing."
        },
        {
          "id": "sun_intensity_forecast",
          "label": "Solar Intensity Forecast",
          "product": "sun_intensity",
          "icon": "\u2600\ufe0f",
          "category": "temperature",
          "description": "Surface downwelling solar irradiance forecast (W/m\u00b2) across numerical weather models.",
          "category_label": "Core Meteorological",
          "long_description": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "score_description": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "source_models": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "output_models": [
            "Solar Intensity .pmtiles per model"
          ],
          "toast_title": "Solar Intensity & Surface Irradiance",
          "toast_subtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toast_description": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation.",
          "longDescription": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "scoreDescription": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "outputModels": [
            "Solar Intensity .pmtiles per model"
          ],
          "toastTitle": "Solar Intensity & Surface Irradiance",
          "toastSubtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toastDescription": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation."
        }
      ]
    },
    "photography": {
      "id": "photography",
      "title": "Photography",
      "icon": "\ud83d\udcf7",
      "description": "Golden Hour, Alpenglow, cloud layers, optics & reflection winds",
      "defaultBasemap": "road",
      "basemapConfig": {
        "theme": "road",
        "mode": "dark",
        "terrain3d": true,
        "shading": "color_tint"
      },
      "isDefault": true,
      "isCustom": false,
      "forecastLayoutRef": "config/forecast_layouts/photography.yaml",
      "forecastLayout": {
        "id": "photography",
        "name": "Outdoor Photography",
        "description": "Golden hour timing, alpenglow quality, optical condensation risk, cloud tiers, and clarity",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "widget_1791671255326_575",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "solar_alpenglow",
              "type": "solar_alpenglow_card",
              "title": "Sunrise, Sunset and Golden Hour Outlooks",
              "col_span": 6,
              "options": {
                "show_blue_hour": true,
                "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
              },
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            {
              "id": "widget_1791831610606_85",
              "type": "darkskies-card",
              "title": "Dark Skies Stargazing & Trend",
              "colSpan": 12,
              "options": {
                "showTrend": true,
                "showSolarLunarPhase": true,
                "showKpis": true,
                "chartHeight": 120,
                "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
              },
              "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
            },
            {
              "id": "widget_1791831619161_990",
              "type": "meteogram-card",
              "title": "Cloud Coverage",
              "colSpan": 12,
              "options": {
                "height": 200,
                "showNow": true,
                "horizonDays": "auto",
                "showMountainSilhouette": false,
                "declutterElevations": true,
                "showMinMaxLines": false,
                "minMaxSeriesKey": "auto",
                "series": [
                  {
                    "key": "cloud_cover_mid",
                    "type": "stacked_area",
                    "yAxis": "right",
                    "color": "#0284c7",
                    "tension": 0.3
                  },
                  {
                    "key": "cloud_cover_low",
                    "type": "stacked_area",
                    "yAxis": "right",
                    "color": "#a855f7",
                    "tension": 0.3
                  },
                  {
                    "key": "cloud_cover_high",
                    "type": "stacked_area",
                    "yAxis": "right",
                    "color": "#3b82f6",
                    "tension": 0.3
                  },
                  {
                    "key": "cloud_cover_total",
                    "type": "area",
                    "yAxis": "right",
                    "color": "#94a3b8",
                    "tension": 0.3
                  }
                ],
                "staticYAxis": true,
                "description": "Multi-tier hourly cloud fraction meteogram separating high-altitude cirrus (blue), mid-level altocumulus (cyan), low-level stratus (purple), and total sky cover (slate). For dramatic sunrise and sunset color, look for 30\u201370% high or mid clouds to catch sub-horizon light while low cloud cover remains minimal (<20%) so the horizon stays unobstructed."
              },
              "description": "Multi-tier hourly cloud fraction meteogram separating high-altitude cirrus (blue), mid-level altocumulus (cyan), low-level stratus (purple), and total sky cover (slate). For dramatic sunrise and sunset color, look for 30\u201370% high or mid clouds to catch sub-horizon light while low cloud cover remains minimal (<20%) so the horizon stays unobstructed."
            },
            {
              "id": "widget_1793384573308_147",
              "type": "solar-lunar-calendar",
              "title": "Solar & Lunar Calendar & Ephemeris",
              "colSpan": 12,
              "options": {
                "componentMode": "combined",
                "displayMode": "calendar",
                "daysToShow": 10,
                "showIllumination": true,
                "showMoonTimes": true,
                "showSunTimes": true,
                "showLunarTimeline": true,
                "showGoldenHour": true,
                "showBlueHour": true,
                "showMoonPhase": true,
                "description": "10-day astronomical ephemeris table and visual timeline detailing exact Sunrise, Sunset, Golden Hour, Blue Hour, Moonrise, Moonset, Lunar Phase, and % Lunar Illumination."
              },
              "description": "10-day astronomical ephemeris table and visual timeline detailing exact Sunrise, Sunset, Golden Hour, Blue Hour, Moonrise, Moonset, Lunar Phase, and % Lunar Illumination."
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "w_appbar",
              "type": "app-bar",
              "title": "Location Header",
              "col_span": 12,
              "options": {
                "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
              },
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            {
              "id": "w_horizon",
              "type": "horizon-selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "default": "3-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "w_golden_window",
              "type": "golden-window-card",
              "title": "Sunrise, Sunset and Golden Hour Outlooks",
              "col_span": 12,
              "options": {
                "showLunarTimeline": true,
                "showScores": true,
                "displayMode": "both",
                "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
              },
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            {
              "id": "w_ephemeris",
              "type": "solar-lunar-calendar",
              "title": "Solar & Lunar Calendar & Ephemeris",
              "col_span": 12,
              "options": {
                "componentMode": "combined",
                "displayMode": "calendar",
                "showTimeline": true,
                "showGoldenHour": true,
                "showMoonPhase": true,
                "showIllumination": true,
                "showMoonTimes": true,
                "showSunTimes": true,
                "description": "10-day astronomical ephemeris table and visual timeline detailing exact Sunrise, Sunset, Golden Hour, Blue Hour, Moonrise, Moonset, Lunar Phase, and % Lunar Illumination."
              },
              "description": "10-day astronomical ephemeris table and visual timeline detailing exact Sunrise, Sunset, Golden Hour, Blue Hour, Moonrise, Moonset, Lunar Phase, and % Lunar Illumination."
            },
            {
              "id": "widget_1793035233770_738",
              "type": "aurora-card",
              "title": "Aurora & Space Weather",
              "colSpan": 6,
              "options": {
                "showKpTrend": true,
                "kpChartScope": "all",
                "chartHeight": 130,
                "showProbabilities": true,
                "showMetrics": true,
                "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
              },
              "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
            },
            {
              "id": "w_bottom_nav",
              "type": "bottom-nav",
              "title": "Navigation Bar",
              "col_span": 12,
              "options": {
                "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
              },
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "golden_hour",
          "label": "Sunrise & Sunset",
          "product": "sunrise",
          "model": "gw_v2_blend_50",
          "icon": "\ud83c\udf05",
          "category": "sky_solar",
          "description": "Sunrise and Sunset color/quality probability forecast",
          "category_label": "Forecast Quality Scoring",
          "long_description": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
          "score_description": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "output_models": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toast_title": "Sunrise & Sunset 10-Day Forecast",
          "toast_subtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toast_description": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
          "nowcast_toast_title": "SkySkout Sunset & Sunrise NowCast",
          "nowcast_toast_subtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcast_toast_description": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions.",
          "longDescription": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
          "scoreDescription": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "outputModels": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toastTitle": "Sunrise & Sunset 10-Day Forecast",
          "toastSubtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toastDescription": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
          "nowcastToastTitle": "SkySkout Sunset & Sunrise NowCast",
          "nowcastToastSubtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcastToastDescription": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions."
        },
        {
          "id": "alpenglow_forecast",
          "label": "Golden Hour / Alpenglow",
          "product": "alpenglow",
          "model": "gw_v2_blend_50",
          "icon": "\ud83c\udfd4\ufe0f\ud83c\udf05",
          "category": "sky_solar",
          "description": "High-elevation alpine illumination quality/probability score",
          "basemap_override": {
            "mode": "dark"
          },
          "category_label": "Forecast Quality Scoring",
          "long_description": "Dual-mode alpine alpenglow (topographic prominence & solar aspect hillshading) and landscape golden hour forecast.",
          "score_description": "\u2022 80-100 (Vivid/Burn): Unobstructed low-angle solar beam illuminating prominent peaks or landscapes with intense warm golden and crimson light.\n\u2022 60-79 (Above Average): Strong direct golden hour illumination with favorable atmospheric clarity and minimal horizon blockage.\n\u2022 40-59 (Average/Clear): Clean standard golden hour light on exposed terrain slopes and ridges.\n\u2022 31-39 (Below Average): Filtered or partially attenuated low-angle sunlight due to cloud bands or haze.\n\u2022 21-30 (Muted): Weak, diffused twilight illumination with heavy cloud filtering along the solar path.\n\u2022 0-20 (Poor/Occluded): Direct solar beam blocked by terrain shadow, dense low cloud decks, or precipitation.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "output_models": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toast_title": "Golden Hour & Alpenglow 10-Day Forecast",
          "toast_subtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toast_description": "Models low-angle direct solar beam transmission and topographic mountain peak illumination up to 10 days out using multi-model NWP cloud and moisture forecasts.",
          "nowcast_toast_title": "Golden Hour & Alpenglow Live NowCast",
          "nowcast_toast_subtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcast_toast_description": "Uses live GOES satellite imagery and radar optical flow (T+2h/4h/6h) to score low-angle golden hour light transmission and peak alpenglow for the next upcoming twilight event.",
          "basemapOverride": {
            "mode": "dark"
          },
          "longDescription": "Dual-mode alpine alpenglow (topographic prominence & solar aspect hillshading) and landscape golden hour forecast.",
          "scoreDescription": "\u2022 80-100 (Vivid/Burn): Unobstructed low-angle solar beam illuminating prominent peaks or landscapes with intense warm golden and crimson light.\n\u2022 60-79 (Above Average): Strong direct golden hour illumination with favorable atmospheric clarity and minimal horizon blockage.\n\u2022 40-59 (Average/Clear): Clean standard golden hour light on exposed terrain slopes and ridges.\n\u2022 31-39 (Below Average): Filtered or partially attenuated low-angle sunlight due to cloud bands or haze.\n\u2022 21-30 (Muted): Weak, diffused twilight illumination with heavy cloud filtering along the solar path.\n\u2022 0-20 (Poor/Occluded): Direct solar beam blocked by terrain shadow, dense low cloud decks, or precipitation.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "outputModels": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toastTitle": "Golden Hour & Alpenglow 10-Day Forecast",
          "toastSubtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toastDescription": "Models low-angle direct solar beam transmission and topographic mountain peak illumination up to 10 days out using multi-model NWP cloud and moisture forecasts.",
          "nowcastToastTitle": "Golden Hour & Alpenglow Live NowCast",
          "nowcastToastSubtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcastToastDescription": "Uses live GOES satellite imagery and radar optical flow (T+2h/4h/6h) to score low-angle golden hour light transmission and peak alpenglow for the next upcoming twilight event."
        },
        {
          "id": "darkskies_bortle",
          "label": "Dark Sky Forecast",
          "product": "darkskies",
          "model": "blend",
          "icon": "\u2728",
          "category": "sky_solar",
          "description": "Hourly forecast of clear sky conditions incorporating Bortle score, numerous atmospheric conditions, lunar phase/position, and more.",
          "basemap_override": {
            "mode": "dark",
            "terrain_3d": false
          },
          "category_label": "Forecast Quality Scoring",
          "long_description": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
          "score_description": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "World Atlas Light Pollution"
          ],
          "output_models": [
            "blend",
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "toast_title": "Dark Skies Stargazing Forecast",
          "toast_subtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
          "toast_description": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score.",
          "basemapOverride": {
            "mode": "dark",
            "terrain3d": false
          },
          "longDescription": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
          "scoreDescription": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "World Atlas Light Pollution"
          ],
          "outputModels": [
            "blend",
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "toastTitle": "Dark Skies Stargazing Forecast",
          "toastSubtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
          "toastDescription": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score."
        },
        {
          "id": "aurora_viewline",
          "label": "Aurora Borealis",
          "product": "aurora",
          "icon": "\ud83c\udf0c",
          "category": "sky_solar",
          "description": "Auroral oval extent & Northern Lights visibility horizon forecast.",
          "category_label": "Space Weather & Astronomical",
          "long_description": "Auroral oval Extent & Kp Index Northern Lights visibility forecast.",
          "score_description": "\u2022 Overhead Auroral Oval (Green to Red Probability): Direct geomagnetic storm auroral precipitation probability.\n\u2022 Southern Viewline Horizon: The southernmost latitude where the Northern Lights can be seen low on the northern horizon under clear, dark skies.\n\u2022 Kp 0\u20133 (Quiet): Confined to far northern polar latitudes.\n\u2022 Kp 4\u20135 (Active to G1 Minor Storm): Visible across Canada and northern tier US states.\n\u2022 Kp 6\u20139 (G2 Moderate to G5 Extreme Storm): Mid-latitude aurora borealis expansion.",
          "source_models": [
            "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index (Kp) Forecast"
          ],
          "output_models": [
            "aurora_YYYY-MM-DD.pmtiles",
            "aurora_viewline_YYYY-MM-DD.json",
            "noaa_kp_forecast.json"
          ],
          "toast_title": "Aurora Borealis Viewline & Kp Forecast",
          "toast_subtitle": "NOAA SWPC GEOMAGNETIC STORM OUTLOOK",
          "toast_description": "Maps the southern aurora visibility horizon and geomagnetic Kp-index probabilities driven by real-time solar wind telemetry.",
          "longDescription": "Auroral oval Extent & Kp Index Northern Lights visibility forecast.",
          "scoreDescription": "\u2022 Overhead Auroral Oval (Green to Red Probability): Direct geomagnetic storm auroral precipitation probability.\n\u2022 Southern Viewline Horizon: The southernmost latitude where the Northern Lights can be seen low on the northern horizon under clear, dark skies.\n\u2022 Kp 0\u20133 (Quiet): Confined to far northern polar latitudes.\n\u2022 Kp 4\u20135 (Active to G1 Minor Storm): Visible across Canada and northern tier US states.\n\u2022 Kp 6\u20139 (G2 Moderate to G5 Extreme Storm): Mid-latitude aurora borealis expansion.",
          "categoryLabel": "Space Weather & Astronomical",
          "sourceModels": [
            "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index (Kp) Forecast"
          ],
          "outputModels": [
            "aurora_YYYY-MM-DD.pmtiles",
            "aurora_viewline_YYYY-MM-DD.json",
            "noaa_kp_forecast.json"
          ],
          "toastTitle": "Aurora Borealis Viewline & Kp Forecast",
          "toastSubtitle": "NOAA SWPC GEOMAGNETIC STORM OUTLOOK",
          "toastDescription": "Maps the southern aurora visibility horizon and geomagnetic Kp-index probabilities driven by real-time solar wind telemetry."
        },
        {
          "id": "optics_dew_risk",
          "label": "Optics Fogging Potential",
          "product": "optics_dew_risk",
          "icon": "\ud83d\udcf7",
          "category": "temperature",
          "description": "Likelihood of optics (Camera lenses and Telescopes) fogging.",
          "category_label": "Specialized Forecast Index",
          "long_description": "Dew point depression & lens/telescope fogging risk index. Indicates where fogging on lenses is likely for telescope and camera users.",
          "score_description": "\u2022 Low Risk (0\u201325%): Large spread between air temperature and dew point or sufficient breeze to prevent radiative surface cooling.\n\u2022 Moderate Risk (25\u201360%): Narrowing dewpoint depression under clear skies; lens hoods recommended for long timelapses.\n\u2022 High / Severe Condensation Risk (60\u2013100%): Exposed glass and metal surfaces cool below the ambient dew point via clear-sky infrared radiation; active dew heaters required.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "blend & hrrr .pmtiles"
          ],
          "toast_title": "Camera & Telescope Optics Dew Risk",
          "toast_subtitle": "RADIATIVE COOLING CONDENSATION HAZARD",
          "toast_description": "Predicts the likelihood of condensation forming on exposed camera lenses and telescope optics based on dewpoint depression, wind speed, and clear-sky radiative cooling.",
          "longDescription": "Dew point depression & lens/telescope fogging risk index. Indicates where fogging on lenses is likely for telescope and camera users.",
          "scoreDescription": "\u2022 Low Risk (0\u201325%): Large spread between air temperature and dew point or sufficient breeze to prevent radiative surface cooling.\n\u2022 Moderate Risk (25\u201360%): Narrowing dewpoint depression under clear skies; lens hoods recommended for long timelapses.\n\u2022 High / Severe Condensation Risk (60\u2013100%): Exposed glass and metal surfaces cool below the ambient dew point via clear-sky infrared radiation; active dew heaters required.",
          "categoryLabel": "Specialized Forecast Index",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "blend & hrrr .pmtiles"
          ],
          "toastTitle": "Camera & Telescope Optics Dew Risk",
          "toastSubtitle": "RADIATIVE COOLING CONDENSATION HAZARD",
          "toastDescription": "Predicts the likelihood of condensation forming on exposed camera lenses and telescope optics based on dewpoint depression, wind speed, and clear-sky radiative cooling."
        },
        {
          "id": "cloud_base",
          "label": "Cloud Base Elevation",
          "product": "cloud_base",
          "model": "nbm",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud base elevation (MSL) critical for climbing, hiking, and photography",
          "long_description": "Cloud Base Elevation maps the absolute Mean Sea Level (MSL) altitude of the lowest cloud deck across the landscape.\n\nKnowing the exact cloud base altitude is critical for backcountry hikers, mountaineers, climbers, and landscape photographers. It indicates the exact elevation where trails enter fog, rain, and whiteout conditions, and reveals when summits, ridgelines, and alpine passes are clear of cloud cover.\n\nThe layer uses high-resolution National Blend of Models (NOAA NBM) aviation ceiling and lowest cloud base fields combined with high-resolution digital elevation modeling. Clear skies with absent or high cirrus clouds are rendered transparent so the underlying terrain remains visible, while active cloud decks are rendered with a continuous elevation gradient from sea level up to 16,000 ft MSL.",
          "score_description": "\u2022 Purple/Violet (0 - 3,000 ft MSL): Very low cloud base or sea-level marine stratus and coastal fog.\n\u2022 Blue to Cyan (3,000 - 6,000 ft MSL): Low-to-mid mountain cloud deck covering foothills and lower trailheads.\n\u2022 Teal to Emerald Green (6,000 - 9,000 ft MSL): Subalpine cloud ceiling; peaks above 9,000 ft extend above the clouds.\n\u2022 Yellow to Amber (9,000 - 12,000 ft MSL): High-altitude mountain cloud deck; alpine terrain below 9,000 ft remains in clear air.\n\u2022 Orange to Red/Magenta (12,000 - 16,000+ ft MSL): High cloud bases; only the highest continental summits are obscured.\n\u2022 Transparent: Clear skies (no low cloud deck or ceiling detected).",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Cloud Base Elevation (.pmtiles)"
          ],
          "toast_title": "Cloud Base Altitude (MSL)",
          "toast_subtitle": "LOWEST CLOUD CEILING ELEVATION",
          "toast_description": "Maps the Mean Sea Level (MSL) elevation of the lowest cloud ceiling so hikers and photographers know whether summits are clear or in the clouds.",
          "longDescription": "Cloud Base Elevation maps the absolute Mean Sea Level (MSL) altitude of the lowest cloud deck across the landscape.\n\nKnowing the exact cloud base altitude is critical for backcountry hikers, mountaineers, climbers, and landscape photographers. It indicates the exact elevation where trails enter fog, rain, and whiteout conditions, and reveals when summits, ridgelines, and alpine passes are clear of cloud cover.\n\nThe layer uses high-resolution National Blend of Models (NOAA NBM) aviation ceiling and lowest cloud base fields combined with high-resolution digital elevation modeling. Clear skies with absent or high cirrus clouds are rendered transparent so the underlying terrain remains visible, while active cloud decks are rendered with a continuous elevation gradient from sea level up to 16,000 ft MSL.",
          "scoreDescription": "\u2022 Purple/Violet (0 - 3,000 ft MSL): Very low cloud base or sea-level marine stratus and coastal fog.\n\u2022 Blue to Cyan (3,000 - 6,000 ft MSL): Low-to-mid mountain cloud deck covering foothills and lower trailheads.\n\u2022 Teal to Emerald Green (6,000 - 9,000 ft MSL): Subalpine cloud ceiling; peaks above 9,000 ft extend above the clouds.\n\u2022 Yellow to Amber (9,000 - 12,000 ft MSL): High-altitude mountain cloud deck; alpine terrain below 9,000 ft remains in clear air.\n\u2022 Orange to Red/Magenta (12,000 - 16,000+ ft MSL): High cloud bases; only the highest continental summits are obscured.\n\u2022 Transparent: Clear skies (no low cloud deck or ceiling detected).",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Cloud Base Elevation (.pmtiles)"
          ],
          "toastTitle": "Cloud Base Altitude (MSL)",
          "toastSubtitle": "LOWEST CLOUD CEILING ELEVATION",
          "toastDescription": "Maps the Mean Sea Level (MSL) elevation of the lowest cloud ceiling so hikers and photographers know whether summits are clear or in the clouds."
        },
        {
          "id": "valley_fog",
          "label": "Surface Fog",
          "product": "valley_fog",
          "model": "hrrr",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "clouds_wind",
          "description": "Ground level radiation fog.",
          "category_label": "Core Meteorological",
          "long_description": "Radiation & inversion valley fog formation risk. Forecasts likelihood of low lying fog development.",
          "score_description": "\u2022 20\u201340% (Patchy Mist / Shallow Ground Fog): Localized fog forming in low meadows, river bottoms, and marshlands near dawn.\n\u2022 45\u201370% (Moderate Valley Fog): Cohesive radiation or advection fog bank pooling in sheltered valleys.\n\u2022 75\u2013100% (Dense Radiation / Inversion Fog): High probability of thick boundary-layer fog filling valley floors under a stable nocturnal inversion.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "nbm",
            "gdps"
          ],
          "output_models": [
            "Fog probability .pmtiles per model"
          ],
          "toast_title": "Valley Fog & Radiation Fog Probability",
          "toast_subtitle": "TERRAIN-TRAPPED BOUNDARY LAYER FOG",
          "toast_description": "Identifies nocturnal temperature inversions, boundary-layer saturation, and topographic cold-air drainage to forecast low-lying valley fog and sea-of-clouds events.",
          "longDescription": "Radiation & inversion valley fog formation risk. Forecasts likelihood of low lying fog development.",
          "scoreDescription": "\u2022 20\u201340% (Patchy Mist / Shallow Ground Fog): Localized fog forming in low meadows, river bottoms, and marshlands near dawn.\n\u2022 45\u201370% (Moderate Valley Fog): Cohesive radiation or advection fog bank pooling in sheltered valleys.\n\u2022 75\u2013100% (Dense Radiation / Inversion Fog): High probability of thick boundary-layer fog filling valley floors under a stable nocturnal inversion.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "nbm",
            "gdps"
          ],
          "outputModels": [
            "Fog probability .pmtiles per model"
          ],
          "toastTitle": "Valley Fog & Radiation Fog Probability",
          "toastSubtitle": "TERRAIN-TRAPPED BOUNDARY LAYER FOG",
          "toastDescription": "Identifies nocturnal temperature inversions, boundary-layer saturation, and topographic cold-air drainage to forecast low-lying valley fog and sea-of-clouds events."
        },
        {
          "id": "lenticular_clouds",
          "label": "Lenticular Cloud Probability",
          "product": "lenticular",
          "model": "ensemble",
          "icon": "\ud83d\udef8",
          "category": "clouds_wind",
          "description": "Identifies favorable conditions for lenticular cloud formation indicating turbulent conditions near mountain peaks.",
          "long_description": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
          "category_label": "Forecast Quality Scoring",
          "score_description": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
          "source_models": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "output_models": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "toast_title": "Lenticular Wave Cloud Forecast",
          "toast_subtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
          "toast_description": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks.",
          "longDescription": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
          "scoreDescription": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "outputModels": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "toastTitle": "Lenticular Wave Cloud Forecast",
          "toastSubtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
          "toastDescription": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks."
        },
        {
          "id": "cloud_inversion",
          "label": "Valley Clouds / Sea of Clouds",
          "product": "cloud_inversion",
          "model": "nbm",
          "icon": "\ud83c\udfd4\ufe0f",
          "category": "clouds_wind",
          "description": "Reveals low cloud decks/deep fog below mountainous terrain.",
          "long_description": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
          "score_description": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Cloud Inversion / Sea of Clouds (.pmtiles)"
          ],
          "toast_title": "Sea of Clouds (Cloud Inversion)",
          "toast_subtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
          "toast_description": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas.",
          "longDescription": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
          "scoreDescription": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Cloud Inversion / Sea of Clouds (.pmtiles)"
          ],
          "toastTitle": "Sea of Clouds (Cloud Inversion)",
          "toastSubtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
          "toastDescription": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas."
        },
        {
          "id": "mountain_visibility",
          "label": "Mountain Visibility",
          "product": "mountain_visibility",
          "model": "nbm",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "clouds_wind",
          "description": "Terrain based visibility forecast indicating mountainous areas with no or limited visibility.",
          "long_description": "Mountain Visibility identifies the exact vertical zone where mountain slopes, passes, and ridgelines are submerged within active cloud decks, enveloped in dense fog, rain, or whiteout conditions.\n\nUsing high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with National Blend of Models (NBM) cloud base and cloud top boundary surfaces, this layer maps the physical 3D cloud deck sandwich against real terrain:\n\u2022 Below Cloud Base: Valleys and lowlands under the cloud deck remain 100% transparent in clear air beneath the ceiling.\n\u2022 In-Cloud Deck: Mountain terrain between cloud base and cloud top is rendered in an atmospheric slate-blue cloud shroud.\n\u2022 Above Cloud Tops: Mountain summits and high alpine ridges piercing above the cloud deck remain 100% transparent in clear sunshine.\n\nThis gives backcountry hikers, mountaineers, trail runners, and alpine photographers immediate clarity on whether a trail enters the clouds, where whiteout conditions begin, and which mountain peaks rise into clear sky above.",
          "score_description": "\u2022 Slate-Blue Shroud: Terrain submerged inside the cloud deck (Cloud Base <= Elevation <= Cloud Top), indicating fog, cloud obscuration, or whiteout.\n\u2022 Transparent Valleys: Terrain below the cloud base with clear air and open ground-level visibility underneath the ceiling.\n\u2022 Transparent Summits: High alpine peaks and ridges extending above the cloud top into clear blue sky and sunshine.\n\u2022 Shoreline Feathering: Smooth 50-meter elevation transition along lower and upper cloud boundaries.",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Mountain Visibility (.pmtiles)"
          ],
          "toast_title": "Mountain Cloud Shroud & Whiteout Zones",
          "toast_subtitle": "3D TERRAIN CLOUD INTERSECTION",
          "toast_description": "Map plots areas where there is no visibility based on elevation in grey.  Areas shrouded in grey on the map indicates low or no visibility at the given elevation.",
          "longDescription": "Mountain Visibility identifies the exact vertical zone where mountain slopes, passes, and ridgelines are submerged within active cloud decks, enveloped in dense fog, rain, or whiteout conditions.\n\nUsing high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with National Blend of Models (NBM) cloud base and cloud top boundary surfaces, this layer maps the physical 3D cloud deck sandwich against real terrain:\n\u2022 Below Cloud Base: Valleys and lowlands under the cloud deck remain 100% transparent in clear air beneath the ceiling.\n\u2022 In-Cloud Deck: Mountain terrain between cloud base and cloud top is rendered in an atmospheric slate-blue cloud shroud.\n\u2022 Above Cloud Tops: Mountain summits and high alpine ridges piercing above the cloud deck remain 100% transparent in clear sunshine.\n\nThis gives backcountry hikers, mountaineers, trail runners, and alpine photographers immediate clarity on whether a trail enters the clouds, where whiteout conditions begin, and which mountain peaks rise into clear sky above.",
          "scoreDescription": "\u2022 Slate-Blue Shroud: Terrain submerged inside the cloud deck (Cloud Base <= Elevation <= Cloud Top), indicating fog, cloud obscuration, or whiteout.\n\u2022 Transparent Valleys: Terrain below the cloud base with clear air and open ground-level visibility underneath the ceiling.\n\u2022 Transparent Summits: High alpine peaks and ridges extending above the cloud top into clear blue sky and sunshine.\n\u2022 Shoreline Feathering: Smooth 50-meter elevation transition along lower and upper cloud boundaries.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Mountain Visibility (.pmtiles)"
          ],
          "toastTitle": "Mountain Cloud Shroud & Whiteout Zones",
          "toastSubtitle": "3D TERRAIN CLOUD INTERSECTION",
          "toastDescription": "Map plots areas where there is no visibility based on elevation in grey.  Areas shrouded in grey on the map indicates low or no visibility at the given elevation."
        },
        {
          "id": "smoke_forecast",
          "label": "Wildfire Smoke",
          "product": "smoke",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "air_quality_fires",
          "description": "Wildfire smoke forecasts for North America.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "score_description": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "source_models": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "output_models": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toast_title": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toast_subtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toast_description": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation.",
          "longDescription": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "scoreDescription": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "outputModels": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toastTitle": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toastSubtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toastDescription": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation."
        },
        {
          "id": "foliage",
          "label": "Fall Foliage Forecast",
          "product": "foliage",
          "icon": "\ud83c\udf41",
          "category": "phenology",
          "description": "Daily refreshed forecast for fall foliage timing and intensity.",
          "category_label": "Seasonal Phenology",
          "long_description": "The Fall Foliage forecast provides a comprehensive set of visual tools to help autumn travelers, hikers, and photographers plan their trips:\n\n\u2022 PEAK DATE - Displays a continental map of the projected calendar date when peak autumn color first arrives at each location. Colors transition chronologically from early September 15 peaks (green), through yellow, gold, orange, red, and brown, to mid-November (grey). Toggle between Full Landscape and Treed Regions Only, or click any location to see its exact projected peak date.\n\n\u2022 DETAILED TIMING / CALENDAR - Shows an interactive calendar providing an at-a-glance seasonal color progression for any selected location, alongside daily continental maps showing color evolution from green canopy to peak foliage. Toggle between Full Landscape and Treed Regions Only to inspect regional forests.\n\n\u2022 VIBRANCY THIS SEASON - Displays anticipated differences in peak color brilliance and saturation compared to an average season. Evaluates cool crisp nights (which trap anthocyanin red pigments), bright sunny days (which power sugar production), summer drought scorch, and wind penalties.\n\n\u2022 CANOPY COVER - Displays satellite-measured tree canopy density (USGS NLCD & NALCMS) to show where broadleaf deciduous and mixed hardwood forests are concentrated across North America.\n\n\u2022 TREE SPECIES - Maps native forest distributions for key autumn tree families, including Scarlet Red Maples, Canary Gold Aspens & Birches, Bronze Oaks & Beeches, and Golden Larches/Tamaracks.\n\n\u2022 HEAT ANOMALY - Shows summer mean temperature departures compared to 30-year climate normals. Excessive summer heat stress damages leaf chlorophyll and can cause early scorching or dull browning.\n\n\u2022 MOISTURE - Shows summer root-zone soil moisture anomalies compared to normal (from NOAA CPC). Soil moisture plays a critical role in tree health: severe drought causes premature leaf drop and muted colors, whereas healthy summer moisture supports vibrant displays.\n\nHow the Forecast Works & Data Timeline:\nOur biophysical phenology model continuously integrates seasonal growing conditions, real-time weather observations, and short-term numerical forecasts:\n\u2022 Antecedent Inputs: Summer soil moisture and heat stress define baseline tree vitality and drought resilience.\n\u2022 Observed Weather: Ground-truth daily minimum temperatures from NOAA URMA lock in chilling accumulation through September and October.\n\u2022 5-to-7 Day Forecasts: Short-term weather predictions from NOAA NDFD drive active chilling and color onset. Note that forecasts 5 to 7 days out are dynamic and subject to update as weather systems shift.\n\u2022 Long-Range Horizon: Dates beyond the short-term forecast window are guided by 30-year PRISM climatological normals for long-range trip planning.",
          "score_description": "\u2022 Above Normal / Enhanced Vibrancy: Plentiful sunny afternoons, crisp above-freezing nights (34\u00b0F to 45\u00b0F), and calm winds promote intense anthocyanin pigment production, rich saturation, and extended peak retention with minimal early leaf drop.\n\u2022 Average / Typical Vibrancy: Expected baseline autumn coloration aligned with 30-year historical climate norms for the region and species mix.\n\u2022 Below Normal / Reduced Vibrancy: Unseasonably warm nights (preventing sugar trapping), severe summer drought scorch, persistent cloudy rain, or premature killing freezes produce muted, dull, or brown-tinted foliage.",
          "source_models": [
            "NOAA URMA (Observed Daily Tmin)",
            "NOAA NDFD (5-7 Day Weather Forecast)",
            "PRISM (30-Yr Daily Climatology Normals)",
            "NOAA CPC (Soil Moisture Anomalies)",
            "NASA Daymet (Solar Irradiance Normals)",
            "USGS NLCD & Tree Species Atlas"
          ],
          "output_models": [
            "Peak Color Arrival by Date (foliage_peak_date.pmtiles)",
            "Peak Color Arrival - Treed Only (foliage_peak_date_treed.pmtiles)",
            "Daily Color Progression (foliage_{date}.pmtiles)",
            "Seasonal Vibrancy Departure (foliage_vibrancy.pmtiles)",
            "Deciduous Tree Canopy Density (foliage_canopy.pmtiles)",
            "Native Tree Species Distribution (foliage_species.pmtiles)",
            "Summer Temperature Anomaly (foliage_summer_temp_anomaly.pmtiles)",
            "Summer Soil Moisture Anomaly (foliage_soil_moisture_anomaly.pmtiles)"
          ],
          "toast_title": "Fall Foliage Timing & Vibrancy Forecast",
          "toast_subtitle": "BIOPHYSICAL AUTUMN PHENOLOGY MODEL",
          "toast_description": "Tracks projected peak autumn foliage dates, daily color progression, tree species habitats, and seasonal color vibrancy across North America.",
          "longDescription": "The Fall Foliage forecast provides a comprehensive set of visual tools to help autumn travelers, hikers, and photographers plan their trips:\n\n\u2022 PEAK DATE - Displays a continental map of the projected calendar date when peak autumn color first arrives at each location. Colors transition chronologically from early September 15 peaks (green), through yellow, gold, orange, red, and brown, to mid-November (grey). Toggle between Full Landscape and Treed Regions Only, or click any location to see its exact projected peak date.\n\n\u2022 DETAILED TIMING / CALENDAR - Shows an interactive calendar providing an at-a-glance seasonal color progression for any selected location, alongside daily continental maps showing color evolution from green canopy to peak foliage. Toggle between Full Landscape and Treed Regions Only to inspect regional forests.\n\n\u2022 VIBRANCY THIS SEASON - Displays anticipated differences in peak color brilliance and saturation compared to an average season. Evaluates cool crisp nights (which trap anthocyanin red pigments), bright sunny days (which power sugar production), summer drought scorch, and wind penalties.\n\n\u2022 CANOPY COVER - Displays satellite-measured tree canopy density (USGS NLCD & NALCMS) to show where broadleaf deciduous and mixed hardwood forests are concentrated across North America.\n\n\u2022 TREE SPECIES - Maps native forest distributions for key autumn tree families, including Scarlet Red Maples, Canary Gold Aspens & Birches, Bronze Oaks & Beeches, and Golden Larches/Tamaracks.\n\n\u2022 HEAT ANOMALY - Shows summer mean temperature departures compared to 30-year climate normals. Excessive summer heat stress damages leaf chlorophyll and can cause early scorching or dull browning.\n\n\u2022 MOISTURE - Shows summer root-zone soil moisture anomalies compared to normal (from NOAA CPC). Soil moisture plays a critical role in tree health: severe drought causes premature leaf drop and muted colors, whereas healthy summer moisture supports vibrant displays.\n\nHow the Forecast Works & Data Timeline:\nOur biophysical phenology model continuously integrates seasonal growing conditions, real-time weather observations, and short-term numerical forecasts:\n\u2022 Antecedent Inputs: Summer soil moisture and heat stress define baseline tree vitality and drought resilience.\n\u2022 Observed Weather: Ground-truth daily minimum temperatures from NOAA URMA lock in chilling accumulation through September and October.\n\u2022 5-to-7 Day Forecasts: Short-term weather predictions from NOAA NDFD drive active chilling and color onset. Note that forecasts 5 to 7 days out are dynamic and subject to update as weather systems shift.\n\u2022 Long-Range Horizon: Dates beyond the short-term forecast window are guided by 30-year PRISM climatological normals for long-range trip planning.",
          "scoreDescription": "\u2022 Above Normal / Enhanced Vibrancy: Plentiful sunny afternoons, crisp above-freezing nights (34\u00b0F to 45\u00b0F), and calm winds promote intense anthocyanin pigment production, rich saturation, and extended peak retention with minimal early leaf drop.\n\u2022 Average / Typical Vibrancy: Expected baseline autumn coloration aligned with 30-year historical climate norms for the region and species mix.\n\u2022 Below Normal / Reduced Vibrancy: Unseasonably warm nights (preventing sugar trapping), severe summer drought scorch, persistent cloudy rain, or premature killing freezes produce muted, dull, or brown-tinted foliage.",
          "categoryLabel": "Seasonal Phenology",
          "sourceModels": [
            "NOAA URMA (Observed Daily Tmin)",
            "NOAA NDFD (5-7 Day Weather Forecast)",
            "PRISM (30-Yr Daily Climatology Normals)",
            "NOAA CPC (Soil Moisture Anomalies)",
            "NASA Daymet (Solar Irradiance Normals)",
            "USGS NLCD & Tree Species Atlas"
          ],
          "outputModels": [
            "Peak Color Arrival by Date (foliage_peak_date.pmtiles)",
            "Peak Color Arrival - Treed Only (foliage_peak_date_treed.pmtiles)",
            "Daily Color Progression (foliage_{date}.pmtiles)",
            "Seasonal Vibrancy Departure (foliage_vibrancy.pmtiles)",
            "Deciduous Tree Canopy Density (foliage_canopy.pmtiles)",
            "Native Tree Species Distribution (foliage_species.pmtiles)",
            "Summer Temperature Anomaly (foliage_summer_temp_anomaly.pmtiles)",
            "Summer Soil Moisture Anomaly (foliage_soil_moisture_anomaly.pmtiles)"
          ],
          "toastTitle": "Fall Foliage Timing & Vibrancy Forecast",
          "toastSubtitle": "BIOPHYSICAL AUTUMN PHENOLOGY MODEL",
          "toastDescription": "Tracks projected peak autumn foliage dates, daily color progression, tree species habitats, and seasonal color vibrancy across North America."
        },
        {
          "id": "desert_wildflowers",
          "label": "Desert Superbloom & Annuals",
          "product": "desert_wildflowers",
          "icon": "\ud83c\udfdc\ufe0f",
          "category": "phenology",
          "description": "Spring Desert wildflower timing and outlook updated daily.",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts episodic germination probability, storm cadence viability, seasonal precipitation anomalies, and flowering intensity (Bloom Intensity Index, BII) across arid basins and alluvial fans.\n\nModels the 4-phase environmental cascade: autumn seed-leaching storm trigger (>= 20mm), mid-winter storm spacing (<= 18 days), spring thermal maturation, and desert heat scorch resistance.",
          "score_description": "\u2022 Germination / Rosette (Meadow Green): Early basal leaves emerging following soaking rainfall.\n\u2022 Early Blooms (Lime Yellow): Initial desert wash and alluvial fan flowering.\n\u2022 Peak Floral Carpet (Vibrant Rose / Crimson): Peak carpet concurrency across desert valley floors.\n\u2022 Past Peak (Warm Gold): Seed setting and rapid thermal desiccation.\n\u2022 BII Score (0-100): Desert Bloom Intensity measuring superbloom probability and display density.",
          "source_models": [
            "nbm",
            "icon13"
          ],
          "output_models": [
            "Desert Superbloom (.pmtiles)"
          ],
          "toast_title": "Desert Superbloom & Annuals Outlook",
          "toast_subtitle": "ARID GERMINATION & BLOOM INTENSITY",
          "toast_description": "Tracks winter rain germination triggers, storm cadence survival, and spring superbloom intensity across desert basins and washes.",
          "longDescription": "Predicts episodic germination probability, storm cadence viability, seasonal precipitation anomalies, and flowering intensity (Bloom Intensity Index, BII) across arid basins and alluvial fans.\n\nModels the 4-phase environmental cascade: autumn seed-leaching storm trigger (>= 20mm), mid-winter storm spacing (<= 18 days), spring thermal maturation, and desert heat scorch resistance.",
          "scoreDescription": "\u2022 Germination / Rosette (Meadow Green): Early basal leaves emerging following soaking rainfall.\n\u2022 Early Blooms (Lime Yellow): Initial desert wash and alluvial fan flowering.\n\u2022 Peak Floral Carpet (Vibrant Rose / Crimson): Peak carpet concurrency across desert valley floors.\n\u2022 Past Peak (Warm Gold): Seed setting and rapid thermal desiccation.\n\u2022 BII Score (0-100): Desert Bloom Intensity measuring superbloom probability and display density.",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13"
          ],
          "outputModels": [
            "Desert Superbloom (.pmtiles)"
          ],
          "toastTitle": "Desert Superbloom & Annuals Outlook",
          "toastSubtitle": "ARID GERMINATION & BLOOM INTENSITY",
          "toastDescription": "Tracks winter rain germination triggers, storm cadence survival, and spring superbloom intensity across desert basins and washes."
        },
        {
          "id": "alpine_wildflowers",
          "label": "Wildflowers (Mountain/Alpine)",
          "product": "alpine_wildflowers",
          "icon": "\ud83c\udf38",
          "category": "phenology",
          "description": "Peak bloom timing & intensity",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts bloom onset, peak floral concurrency, bloom duration, and display intensity (Mountain Bloom Intensity Index, MBII) for alpine and subalpine herbaceous perennials.\n\nDriven by winter snowpack insulation, dynamic snowmelt biofix (SWE <= 0), and post-melt growing degree days (GDD) with elevation lapse-rate corrections.\n\nIncludes multi-species coverage (Arrowleaf Balsamroot, Subalpine Lupine, Indian Paintbrush, Avalanche Lily), dual domain support (North America 2.5km and Global Alpine 13km), and interactive summer calendar and multi-species concurrency curves.",
          "score_description": "\u2022 Snowbound / Pre-Melt (Icy Cyan): Terrain still insulated under winter snowpack.\n\u2022 Emerging / Vegetative (Fresh Green): Post-melt vegetative green-up and bud initiation.\n\u2022 Early Bloom (Lime Yellow): Initial floral bud opening (15-30% open).\n\u2022 Peak Concurrency (Magenta / Rose): Broadfield meadow bloom display (60-100% open).\n\u2022 Past Peak (Amber / Orange): Seed maturation and petal drop.\n\u2022 MBII Intensity (Gold to Hot Pink): Mountain Bloom Intensity factoring floral synchrony, insulation, frost risk, and snowmelt sub-irrigation.",
          "source_models": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "output_models": [
            "Alpine Wildflowers (.pmtiles)"
          ],
          "toast_title": "Alpine & Mountain Wildflowers Forecast",
          "toast_subtitle": "SNOWMELT BIOFIX & GDD PHENOLOGY",
          "toast_description": "Predicts alpine meadow bloom timing, peak multi-species concurrency, and Mountain Bloom Intensity (MBII) following winter snowmelt.",
          "longDescription": "Predicts bloom onset, peak floral concurrency, bloom duration, and display intensity (Mountain Bloom Intensity Index, MBII) for alpine and subalpine herbaceous perennials.\n\nDriven by winter snowpack insulation, dynamic snowmelt biofix (SWE <= 0), and post-melt growing degree days (GDD) with elevation lapse-rate corrections.\n\nIncludes multi-species coverage (Arrowleaf Balsamroot, Subalpine Lupine, Indian Paintbrush, Avalanche Lily), dual domain support (North America 2.5km and Global Alpine 13km), and interactive summer calendar and multi-species concurrency curves.",
          "scoreDescription": "\u2022 Snowbound / Pre-Melt (Icy Cyan): Terrain still insulated under winter snowpack.\n\u2022 Emerging / Vegetative (Fresh Green): Post-melt vegetative green-up and bud initiation.\n\u2022 Early Bloom (Lime Yellow): Initial floral bud opening (15-30% open).\n\u2022 Peak Concurrency (Magenta / Rose): Broadfield meadow bloom display (60-100% open).\n\u2022 Past Peak (Amber / Orange): Seed maturation and petal drop.\n\u2022 MBII Intensity (Gold to Hot Pink): Mountain Bloom Intensity factoring floral synchrony, insulation, frost risk, and snowmelt sub-irrigation.",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "outputModels": [
            "Alpine Wildflowers (.pmtiles)"
          ],
          "toastTitle": "Alpine & Mountain Wildflowers Forecast",
          "toastSubtitle": "SNOWMELT BIOFIX & GDD PHENOLOGY",
          "toastDescription": "Predicts alpine meadow bloom timing, peak multi-species concurrency, and Mountain Bloom Intensity (MBII) following winter snowmelt."
        }
      ],
      "secondaryLayers": [
        {
          "id": "precip_radar",
          "label": "Doppler Radar",
          "product": "live_weather",
          "model": "mrms",
          "icon": "\ud83d\udce1",
          "category": "precipitation",
          "description": "Near real time doppler radar",
          "basemap_override": {
            "terrain_3d": false
          },
          "category_label": "Real-Time Observation",
          "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "source_models": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "output_models": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toast_title": "Live NOAA MRMS Doppler Radar",
          "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
          "basemapOverride": {
            "terrain3d": false
          },
          "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "outputModels": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toastTitle": "Live NOAA MRMS Doppler Radar",
          "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
        },
        {
          "id": "precip_forecast",
          "label": "Precipitation Forecast",
          "product": "precip",
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Hourly and daily rain and snow forecasts.",
          "category_label": "Core Meteorological",
          "long_description": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "score_description": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "source_models": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "output_models": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toast_title": "Precipitation Rate, Probability & Snow",
          "toast_subtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toast_description": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models.",
          "longDescription": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "scoreDescription": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "outputModels": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toastTitle": "Precipitation Rate, Probability & Snow",
          "toastSubtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toastDescription": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models."
        },
        {
          "id": "precip_accum",
          "label": "Precipitation Accumulation (Past 1-7 Days)",
          "product": "precip_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP precipitation accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "long_description": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "source_models": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toast_title": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toast_subtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toast_description": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation.",
          "longDescription": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toastSubtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toastDescription": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation."
        },
        {
          "id": "snow_accum",
          "label": "Snowfall Accumulation (Past 1-7 Days)",
          "product": "snow_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf28\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP snowfall accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "long_description": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "source_models": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toast_title": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toast_subtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toast_description": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows.",
          "longDescription": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toastSubtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toastDescription": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows."
        },
        {
          "id": "lightning_live",
          "label": "Lightning Activity (Observed)",
          "product": "live_weather",
          "model": "mrms_lightning",
          "icon": "\u26a1",
          "category": "precipitation",
          "description": "Rolling 8-hour 5-minute lightning strikes scaled by flash density and age (yellow to gray).",
          "long_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "category_label": "Real-Time Observation",
          "score_description": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "source_models": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "output_models": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toast_title": "Live Lightning Strikes (8-Hour Trail)",
          "toast_subtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toast_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.",
          "longDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "scoreDescription": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "outputModels": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toastTitle": "Live Lightning Strikes (8-Hour Trail)",
          "toastSubtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toastDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes."
        },
        {
          "id": "thunderstorm",
          "label": "Thunderstorm Probability",
          "product": "thunderstorm",
          "model": "blend",
          "icon": "\u26a1",
          "category": "precipitation",
          "description": "Thunderstorm probability (0-100%) combining atmospheric instability (CAPE), cap strength (CIN), and convective triggers.",
          "category_label": "Core Meteorological",
          "long_description": "Convective storm lightning probability & flash density forecast. Shows area where conditions will be favorable for lightning.",
          "score_description": "\u2022 Slight / Isolated Risk (10\u201330% - Cool Teal/Green): Weak convective instability; isolated rumbles or brief mountain afternoon showers possible.\n\u2022 Moderate Thunderstorm Risk (35\u201365% - Yellow to Orange): Elevated CAPE and lifting; scattered thunderstorms and cloud-to-ground lightning likely.\n\u2022 High / Severe Convective Risk (70\u2013100% - Red to Magenta): Strong atmospheric instability and updraft helicity; widespread thunderstorms and frequent lightning.",
          "source_models": [
            "hrrr",
            "rrfs",
            "ecmwf",
            "gfs",
            "MRMS NLDN (Obs)"
          ],
          "output_models": [
            "Lightning risk .pmtiles per model",
            "Real-time MRMS flash density"
          ],
          "toast_title": "Lightning & Convective Hazard",
          "toast_subtitle": "CONVECTIVE CAPE & FLASH DENSITY POTENTIAL",
          "toast_description": "Quantifies thunderstorm instability and lightning strike hazard using convective available potential energy (CAPE) and updraft helicity.",
          "longDescription": "Convective storm lightning probability & flash density forecast. Shows area where conditions will be favorable for lightning.",
          "scoreDescription": "\u2022 Slight / Isolated Risk (10\u201330% - Cool Teal/Green): Weak convective instability; isolated rumbles or brief mountain afternoon showers possible.\n\u2022 Moderate Thunderstorm Risk (35\u201365% - Yellow to Orange): Elevated CAPE and lifting; scattered thunderstorms and cloud-to-ground lightning likely.\n\u2022 High / Severe Convective Risk (70\u2013100% - Red to Magenta): Strong atmospheric instability and updraft helicity; widespread thunderstorms and frequent lightning.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "ecmwf",
            "gfs",
            "MRMS NLDN (Obs)"
          ],
          "outputModels": [
            "Lightning risk .pmtiles per model",
            "Real-time MRMS flash density"
          ],
          "toastTitle": "Lightning & Convective Hazard",
          "toastSubtitle": "CONVECTIVE CAPE & FLASH DENSITY POTENTIAL",
          "toastDescription": "Quantifies thunderstorm instability and lightning strike hazard using convective available potential energy (CAPE) and updraft helicity."
        },
        {
          "id": "clouds",
          "label": "Cloud Forecast",
          "product": "clouds",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud forecasts.",
          "long_description": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "category_label": "Core Meteorological",
          "score_description": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "source_models": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "output_models": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toast_title": "Cloud Cover Forecast",
          "toast_subtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toast_description": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures.",
          "longDescription": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "scoreDescription": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "outputModels": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toastTitle": "Cloud Cover Forecast",
          "toastSubtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toastDescription": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures."
        },
        {
          "id": "winds_surface_current",
          "label": "Surface Winds (Current)",
          "product": "live_weather",
          "model": "rtma_winds",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Current and recently observed surface winds.",
          "category_label": "Real-Time Observation",
          "long_description": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "score_description": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "source_models": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "output_models": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toast_title": "Current Surface Winds (Live RTMA)",
          "toast_subtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toast_description": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines.",
          "longDescription": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "scoreDescription": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "outputModels": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toastTitle": "Current Surface Winds (Live RTMA)",
          "toastSubtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toastDescription": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines."
        },
        {
          "id": "winds_surface",
          "label": "Surface Winds Forecast",
          "product": "winds",
          "model": "blend",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Forecasted Surface Winds (10m)",
          "category_label": "Core Meteorological",
          "long_description": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "score_description": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toast_title": "Surface Winds & Gusts",
          "toast_subtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toast_description": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models.",
          "longDescription": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "scoreDescription": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toastTitle": "Surface Winds & Gusts",
          "toastSubtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toastDescription": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models."
        },
        {
          "id": "aqi_stations",
          "label": "AQI Station Data",
          "product": "live_weather",
          "model": "aqi_stations",
          "icon": "\ud83e\udec1",
          "category": "air_quality_fires",
          "description": "Near real time AQI station data.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Near-real-time hourly Air Quality Index (AQI) and PM2.5/Ozone pollutant observations from official US EPA AirNow, USFS permanent and temporary smoke monitors, and Canadian AQHI monitoring stations.",
          "score_description": "\u2022 0\u201350 (Good - Green): Clean breathable air.\n\u2022 51\u2013100 (Moderate - Yellow): Slight particulate or ozone elevation.\n\u2022 101\u2013150 (USG - Orange): Unhealthy for sensitive groups.\n\u2022 151\u2013200 (Unhealthy - Red): Widespread smoke or pollution impact.\n\u2022 201+ (Very Unhealthy / Hazardous - Purple/Maroon): Severe smoke plume impact at surface sensors.",
          "source_models": [
            "US EPA AirNow Real-Time Telemetry",
            "USFS AirFire Smoke Monitors",
            "ECCC Canadian AQHI Network"
          ],
          "output_models": [
            "Real-time AQI observation station markers & telemetry"
          ],
          "toast_title": "Live Air Quality Monitoring Stations",
          "toast_subtitle": "REAL-TIME EPA AIRNOW & SMOKE SENSORS",
          "toast_description": "Displays live hourly AQI readings from ground-level EPA AirNow and USFS air quality monitoring stations.",
          "longDescription": "Near-real-time hourly Air Quality Index (AQI) and PM2.5/Ozone pollutant observations from official US EPA AirNow, USFS permanent and temporary smoke monitors, and Canadian AQHI monitoring stations.",
          "scoreDescription": "\u2022 0\u201350 (Good - Green): Clean breathable air.\n\u2022 51\u2013100 (Moderate - Yellow): Slight particulate or ozone elevation.\n\u2022 101\u2013150 (USG - Orange): Unhealthy for sensitive groups.\n\u2022 151\u2013200 (Unhealthy - Red): Widespread smoke or pollution impact.\n\u2022 201+ (Very Unhealthy / Hazardous - Purple/Maroon): Severe smoke plume impact at surface sensors.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "US EPA AirNow Real-Time Telemetry",
            "USFS AirFire Smoke Monitors",
            "ECCC Canadian AQHI Network"
          ],
          "outputModels": [
            "Real-time AQI observation station markers & telemetry"
          ],
          "toastTitle": "Live Air Quality Monitoring Stations",
          "toastSubtitle": "REAL-TIME EPA AIRNOW & SMOKE SENSORS",
          "toastDescription": "Displays live hourly AQI readings from ground-level EPA AirNow and USFS air quality monitoring stations."
        },
        {
          "id": "aqi_index",
          "label": "AQI Forecast",
          "product": "aqi",
          "icon": "\ud83e\udec1",
          "category": "air_quality_fires",
          "description": "Air quality forecast.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "score_description": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "source_models": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "output_models": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toast_title": "Air Quality Index (AQI) Forecast",
          "toast_subtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toast_description": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone.",
          "longDescription": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "scoreDescription": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "outputModels": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toastTitle": "Air Quality Index (AQI) Forecast",
          "toastSubtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toastDescription": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone."
        },
        {
          "id": "smoke_forecast",
          "label": "Wildfire Smoke",
          "product": "smoke",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "air_quality_fires",
          "description": "Wildfire smoke forecasts for North America.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "score_description": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "source_models": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "output_models": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toast_title": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toast_subtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toast_description": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation.",
          "longDescription": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "scoreDescription": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "outputModels": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toastTitle": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toastSubtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toastDescription": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation."
        },
        {
          "id": "climate_data",
          "label": "Historical Climatology (30-year)",
          "product": "climate",
          "icon": "\ud83d\udcca",
          "category": "extended_climate",
          "is_tool_mode": true,
          "description": "30-year climatological normals & microclimate elevation profiles",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "score_description": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "source_models": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "output_models": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toast_title": "Historical Climatology (30-Year Normals)",
          "toast_subtitle": "1991\u20132020 CLIMATE BASELINE",
          "toast_description": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips.",
          "longDescription": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "scoreDescription": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "outputModels": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toastTitle": "Historical Climatology (30-Year Normals)",
          "toastSubtitle": "1991\u20132020 CLIMATE BASELINE",
          "toastDescription": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips."
        }
      ]
    },
    "stargazing": {
      "id": "stargazing",
      "title": "Star Gazing",
      "icon": "\ud83c\udf0c",
      "description": "Dark sky light pollution, transparency, high cirrus & aurora",
      "defaultBasemap": "terrain-mapterhorn",
      "basemapConfig": {
        "theme": "terrain-mapterhorn",
        "mode": "dark",
        "terrain3d": false,
        "shading": "monochrome"
      },
      "isDefault": true,
      "isCustom": false,
      "forecastLayoutRef": "config/forecast_layouts/stargazing.yaml",
      "forecastLayout": {
        "id": "stargazing",
        "name": "Stargazing & Astronomy",
        "description": "Dark sky quality, lunar illumination, aurora oval forecast, optics dew risk, and atmospheric transparency",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "widget_1791671263127_680",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "widget_1791820176917_527",
              "type": "darkskies-card",
              "title": "Dark Skies Stargazing & Trend",
              "colSpan": 12,
              "options": {
                "showTrend": true,
                "showSolarLunarPhase": true,
                "showKpis": true,
                "chartHeight": 120,
                "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
              },
              "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
            },
            {
              "id": "widget_1791813712754_635",
              "type": "aurora-card",
              "title": "Aurora & Space Weather",
              "colSpan": 6,
              "options": {
                "showKpTrend": true,
                "kpChartScope": "all",
                "chartHeight": 130,
                "showProbabilities": true,
                "showMetrics": true,
                "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
              },
              "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
            },
            {
              "id": "widget_1791813723827_322",
              "type": "meteogram-card",
              "title": "Dark Skies vs Optical Dew Risk",
              "colSpan": 6,
              "options": {
                "height": 240,
                "showNow": true,
                "horizonDays": "auto",
                "showMountainSilhouette": false,
                "declutterElevations": true,
                "showMinMaxLines": false,
                "minMaxSeriesKey": "auto",
                "series": [
                  {
                    "key": "seeing_arcsec",
                    "type": "line",
                    "yAxis": "left",
                    "color": "#f97316",
                    "tension": 0.3
                  },
                  {
                    "key": "darkskies_score",
                    "type": "area",
                    "yAxis": "right",
                    "color": "#a855f7",
                    "tension": 0.3
                  },
                  {
                    "key": "optics_dew_risk_score",
                    "type": "line",
                    "yAxis": "right",
                    "color": "#fbbf24",
                    "tension": 0.3
                  }
                ],
                "staticYAxis": true,
                "description": "Astrophotography & deep-sky planning meteogram comparing the composite Dark Skies Score (purple shaded area), Astronomical Seeing FWHM in arcseconds (orange curve on left axis \u2014 lower arcsec means steadier air and sharper planetary/lunar detail), and Optics Dew Risk (0\u2013100 gold curve \u2014 activate lens/telescope dew heaters when risk exceeds 50)."
              },
              "description": "Astrophotography & deep-sky planning meteogram comparing the composite Dark Skies Score (purple shaded area), Astronomical Seeing FWHM in arcseconds (orange curve on left axis \u2014 lower arcsec means steadier air and sharper planetary/lunar detail), and Optics Dew Risk (0\u2013100 gold curve \u2014 activate lens/telescope dew heaters when risk exceeds 50)."
            },
            {
              "id": "darksky_calendar",
              "type": "darksky-calendar",
              "title": "Dark Sky & Ephemeris Calendar",
              "col_span": 12,
              "options": {
                "showDiurnalCurve": true,
                "showDarkScores": true,
                "showDarkHours": true,
                "showEphemerisDetails": true,
                "bortleOverride": "auto",
                "description": "Multi-night stargazing planning calendar showing each night's peak Dark Skies score, total cloud-free dark hours, astronomical twilight window, and lunar interference curve."
              },
              "description": "Multi-night stargazing planning calendar showing each night's peak Dark Skies score, total cloud-free dark hours, astronomical twilight window, and lunar interference curve."
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "w_appbar",
              "type": "app-bar",
              "title": "Location Header",
              "col_span": 12,
              "options": {
                "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
              },
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            {
              "id": "w_horizon",
              "type": "horizon-selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "default": "3-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "w_glance",
              "type": "glance-2x2",
              "title": "Current Conditions",
              "col_span": 4,
              "options": {
                "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
              },
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            {
              "id": "widget_1791819245399_381",
              "type": "darkskies-card",
              "title": "Dark Skies Stargazing & Trend",
              "colSpan": 12,
              "options": {
                "showTrend": true,
                "showSolarLunarPhase": true,
                "showKpis": true,
                "chartHeight": 120,
                "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
              },
              "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
            },
            {
              "id": "w_darksky_cal",
              "type": "darksky-calendar",
              "title": "Dark Sky & Ephemeris Calendar",
              "col_span": 12,
              "options": {
                "showDiurnalCurve": true,
                "showDarkScores": true,
                "showDarkHours": true,
                "showEphemerisDetails": true,
                "bortleOverride": "auto",
                "description": "Multi-night stargazing planning calendar showing each night's peak Dark Skies score, total cloud-free dark hours, astronomical twilight window, and lunar interference curve."
              },
              "description": "Multi-night stargazing planning calendar showing each night's peak Dark Skies score, total cloud-free dark hours, astronomical twilight window, and lunar interference curve."
            },
            {
              "id": "w_aurora",
              "type": "aurora-card",
              "title": "Aurora Borealis & Space Weather",
              "col_span": 12,
              "options": {
                "showKpTrend": true,
                "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
              },
              "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
            },
            {
              "id": "w_astro_meteo",
              "type": "meteogram-card",
              "title": "Dark Sky Score vs Cloud Cover & Dew Risk",
              "col_span": 12,
              "options": {
                "height": 380,
                "showNow": false,
                "horizonDays": "3",
                "series": [
                  {
                    "key": "darkskies_score",
                    "type": "line",
                    "yAxis": "left",
                    "color": "#a855f7"
                  },
                  {
                    "key": "cloud_cover_total",
                    "type": "area",
                    "yAxis": "right",
                    "color": "#94a3b8"
                  },
                  {
                    "key": "optics_dew_risk_score",
                    "type": "line",
                    "dashed": true,
                    "yAxis": "left",
                    "color": "#fbbf24"
                  }
                ],
                "declutterElevations": false,
                "staticYAxis": true,
                "description": "Night-sky observing meteogram overlaying the composite Dark Skies Score (purple line), Total Cloud Cover percentage (grey shaded area on right axis), and Optics Dew Risk index (gold dashed line). Target windows where Dark Skies Score peaks, cloud cover drops near 0%, and optical dew risk remains manageable."
              },
              "description": "Night-sky observing meteogram overlaying the composite Dark Skies Score (purple line), Total Cloud Cover percentage (grey shaded area on right axis), and Optics Dew Risk index (gold dashed line). Target windows where Dark Skies Score peaks, cloud cover drops near 0%, and optical dew risk remains manageable."
            },
            {
              "id": "w_bottom_nav",
              "type": "bottom-nav",
              "title": "Navigation Bar",
              "col_span": 12,
              "options": {
                "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
              },
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "darkskies_bortle",
          "label": "Dark Sky Forecast",
          "product": "darkskies",
          "model": "blend",
          "icon": "\u2728",
          "category": "sky_solar",
          "description": "Hourly forecast of clear sky conditions incorporating Bortle score, numerous atmospheric conditions, lunar phase/position, and more.",
          "basemap_override": {
            "mode": "dark",
            "terrain_3d": false
          },
          "category_label": "Forecast Quality Scoring",
          "long_description": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
          "score_description": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "World Atlas Light Pollution"
          ],
          "output_models": [
            "blend",
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "toast_title": "Dark Skies Stargazing Forecast",
          "toast_subtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
          "toast_description": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score.",
          "basemapOverride": {
            "mode": "dark",
            "terrain3d": false
          },
          "longDescription": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
          "scoreDescription": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "World Atlas Light Pollution"
          ],
          "outputModels": [
            "blend",
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "toastTitle": "Dark Skies Stargazing Forecast",
          "toastSubtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
          "toastDescription": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score."
        },
        {
          "id": "aurora_viewline",
          "label": "Aurora Borealis",
          "product": "aurora",
          "icon": "\ud83c\udf0c",
          "category": "sky_solar",
          "description": "Auroral oval extent & Northern Lights visibility horizon forecast.",
          "category_label": "Space Weather & Astronomical",
          "long_description": "Auroral oval Extent & Kp Index Northern Lights visibility forecast.",
          "score_description": "\u2022 Overhead Auroral Oval (Green to Red Probability): Direct geomagnetic storm auroral precipitation probability.\n\u2022 Southern Viewline Horizon: The southernmost latitude where the Northern Lights can be seen low on the northern horizon under clear, dark skies.\n\u2022 Kp 0\u20133 (Quiet): Confined to far northern polar latitudes.\n\u2022 Kp 4\u20135 (Active to G1 Minor Storm): Visible across Canada and northern tier US states.\n\u2022 Kp 6\u20139 (G2 Moderate to G5 Extreme Storm): Mid-latitude aurora borealis expansion.",
          "source_models": [
            "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index (Kp) Forecast"
          ],
          "output_models": [
            "aurora_YYYY-MM-DD.pmtiles",
            "aurora_viewline_YYYY-MM-DD.json",
            "noaa_kp_forecast.json"
          ],
          "toast_title": "Aurora Borealis Viewline & Kp Forecast",
          "toast_subtitle": "NOAA SWPC GEOMAGNETIC STORM OUTLOOK",
          "toast_description": "Maps the southern aurora visibility horizon and geomagnetic Kp-index probabilities driven by real-time solar wind telemetry.",
          "longDescription": "Auroral oval Extent & Kp Index Northern Lights visibility forecast.",
          "scoreDescription": "\u2022 Overhead Auroral Oval (Green to Red Probability): Direct geomagnetic storm auroral precipitation probability.\n\u2022 Southern Viewline Horizon: The southernmost latitude where the Northern Lights can be seen low on the northern horizon under clear, dark skies.\n\u2022 Kp 0\u20133 (Quiet): Confined to far northern polar latitudes.\n\u2022 Kp 4\u20135 (Active to G1 Minor Storm): Visible across Canada and northern tier US states.\n\u2022 Kp 6\u20139 (G2 Moderate to G5 Extreme Storm): Mid-latitude aurora borealis expansion.",
          "categoryLabel": "Space Weather & Astronomical",
          "sourceModels": [
            "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index (Kp) Forecast"
          ],
          "outputModels": [
            "aurora_YYYY-MM-DD.pmtiles",
            "aurora_viewline_YYYY-MM-DD.json",
            "noaa_kp_forecast.json"
          ],
          "toastTitle": "Aurora Borealis Viewline & Kp Forecast",
          "toastSubtitle": "NOAA SWPC GEOMAGNETIC STORM OUTLOOK",
          "toastDescription": "Maps the southern aurora visibility horizon and geomagnetic Kp-index probabilities driven by real-time solar wind telemetry."
        },
        {
          "id": "seeing",
          "label": "Astronomical Seeing",
          "product": "seeing",
          "model": "rdps",
          "icon": "\ud83d\udd2d",
          "category": "sky_solar",
          "description": "Atmospheric optical stability and wavefront steadiness modeling turbulent optical distortion across night hours (0-100 score).",
          "category_label": "Specialized Forecast Index",
          "long_description": "Atmospheric optical stability predicting wavefront steadiness, jet stream shear, boundary layer turbulence, and telescope resolution.",
          "score_description": "\u2022 80\u2013100 (Excellent / Sub-Arcsecond Stability): Calm upper-level winds and minimal thermal gradients; crisp planetary detail and pinpoint stars.\n\u2022 60\u201379 (Good Seeing): Slight atmospheric shimmer; well-suited for deep-sky imaging and medium-to-high magnification.\n\u2022 40\u201359 (Average / Moderate Turbulence): Noticeable star twinkling (scintillation) and softening of fine lunar/planetary features.\n\u2022 0\u201339 (Poor / Turbulent Jet Stream Shear): Strong vertical wind shear or boundary-layer mixing causing rapid wavefront distortion.",
          "source_models": [
            "rdps",
            "hrrr",
            "rrfs",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "rdps & hrrr .pmtiles"
          ],
          "toast_title": "Astronomical Seeing & Jet Stream Stability",
          "toast_subtitle": "OPTICAL TURBULENCE & THERMAL SHEAR",
          "toast_description": "Evaluates atmospheric optical stability for planetary imaging and high-magnification stargazing based on vertical wind shear and thermal gradients.",
          "longDescription": "Atmospheric optical stability predicting wavefront steadiness, jet stream shear, boundary layer turbulence, and telescope resolution.",
          "scoreDescription": "\u2022 80\u2013100 (Excellent / Sub-Arcsecond Stability): Calm upper-level winds and minimal thermal gradients; crisp planetary detail and pinpoint stars.\n\u2022 60\u201379 (Good Seeing): Slight atmospheric shimmer; well-suited for deep-sky imaging and medium-to-high magnification.\n\u2022 40\u201359 (Average / Moderate Turbulence): Noticeable star twinkling (scintillation) and softening of fine lunar/planetary features.\n\u2022 0\u201339 (Poor / Turbulent Jet Stream Shear): Strong vertical wind shear or boundary-layer mixing causing rapid wavefront distortion.",
          "categoryLabel": "Specialized Forecast Index",
          "sourceModels": [
            "rdps",
            "hrrr",
            "rrfs",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "rdps & hrrr .pmtiles"
          ],
          "toastTitle": "Astronomical Seeing & Jet Stream Stability",
          "toastSubtitle": "OPTICAL TURBULENCE & THERMAL SHEAR",
          "toastDescription": "Evaluates atmospheric optical stability for planetary imaging and high-magnification stargazing based on vertical wind shear and thermal gradients."
        },
        {
          "id": "optics_dew_risk",
          "label": "Optics Fogging Potential",
          "product": "optics_dew_risk",
          "icon": "\ud83d\udcf7",
          "category": "temperature",
          "description": "Likelihood of optics (Camera lenses and Telescopes) fogging.",
          "category_label": "Specialized Forecast Index",
          "long_description": "Dew point depression & lens/telescope fogging risk index. Indicates where fogging on lenses is likely for telescope and camera users.",
          "score_description": "\u2022 Low Risk (0\u201325%): Large spread between air temperature and dew point or sufficient breeze to prevent radiative surface cooling.\n\u2022 Moderate Risk (25\u201360%): Narrowing dewpoint depression under clear skies; lens hoods recommended for long timelapses.\n\u2022 High / Severe Condensation Risk (60\u2013100%): Exposed glass and metal surfaces cool below the ambient dew point via clear-sky infrared radiation; active dew heaters required.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "blend & hrrr .pmtiles"
          ],
          "toast_title": "Camera & Telescope Optics Dew Risk",
          "toast_subtitle": "RADIATIVE COOLING CONDENSATION HAZARD",
          "toast_description": "Predicts the likelihood of condensation forming on exposed camera lenses and telescope optics based on dewpoint depression, wind speed, and clear-sky radiative cooling.",
          "longDescription": "Dew point depression & lens/telescope fogging risk index. Indicates where fogging on lenses is likely for telescope and camera users.",
          "scoreDescription": "\u2022 Low Risk (0\u201325%): Large spread between air temperature and dew point or sufficient breeze to prevent radiative surface cooling.\n\u2022 Moderate Risk (25\u201360%): Narrowing dewpoint depression under clear skies; lens hoods recommended for long timelapses.\n\u2022 High / Severe Condensation Risk (60\u2013100%): Exposed glass and metal surfaces cool below the ambient dew point via clear-sky infrared radiation; active dew heaters required.",
          "categoryLabel": "Specialized Forecast Index",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "blend & hrrr .pmtiles"
          ],
          "toastTitle": "Camera & Telescope Optics Dew Risk",
          "toastSubtitle": "RADIATIVE COOLING CONDENSATION HAZARD",
          "toastDescription": "Predicts the likelihood of condensation forming on exposed camera lenses and telescope optics based on dewpoint depression, wind speed, and clear-sky radiative cooling."
        },
        {
          "id": "clouds",
          "label": "Cloud Forecast",
          "product": "clouds",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud forecasts.",
          "long_description": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "category_label": "Core Meteorological",
          "score_description": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "source_models": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "output_models": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toast_title": "Cloud Cover Forecast",
          "toast_subtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toast_description": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures.",
          "longDescription": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "scoreDescription": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "outputModels": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toastTitle": "Cloud Cover Forecast",
          "toastSubtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toastDescription": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures."
        },
        {
          "id": "cloud_inversion",
          "label": "Valley Clouds / Sea of Clouds",
          "product": "cloud_inversion",
          "model": "nbm",
          "icon": "\ud83c\udfd4\ufe0f",
          "category": "clouds_wind",
          "description": "Reveals low cloud decks/deep fog below mountainous terrain.",
          "long_description": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
          "score_description": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Cloud Inversion / Sea of Clouds (.pmtiles)"
          ],
          "toast_title": "Sea of Clouds (Cloud Inversion)",
          "toast_subtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
          "toast_description": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas.",
          "longDescription": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
          "scoreDescription": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Cloud Inversion / Sea of Clouds (.pmtiles)"
          ],
          "toastTitle": "Sea of Clouds (Cloud Inversion)",
          "toastSubtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
          "toastDescription": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas."
        },
        {
          "id": "valley_fog",
          "label": "Surface Fog",
          "product": "valley_fog",
          "model": "hrrr",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "clouds_wind",
          "description": "Ground level radiation fog.",
          "category_label": "Core Meteorological",
          "long_description": "Radiation & inversion valley fog formation risk. Forecasts likelihood of low lying fog development.",
          "score_description": "\u2022 20\u201340% (Patchy Mist / Shallow Ground Fog): Localized fog forming in low meadows, river bottoms, and marshlands near dawn.\n\u2022 45\u201370% (Moderate Valley Fog): Cohesive radiation or advection fog bank pooling in sheltered valleys.\n\u2022 75\u2013100% (Dense Radiation / Inversion Fog): High probability of thick boundary-layer fog filling valley floors under a stable nocturnal inversion.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "nbm",
            "gdps"
          ],
          "output_models": [
            "Fog probability .pmtiles per model"
          ],
          "toast_title": "Valley Fog & Radiation Fog Probability",
          "toast_subtitle": "TERRAIN-TRAPPED BOUNDARY LAYER FOG",
          "toast_description": "Identifies nocturnal temperature inversions, boundary-layer saturation, and topographic cold-air drainage to forecast low-lying valley fog and sea-of-clouds events.",
          "longDescription": "Radiation & inversion valley fog formation risk. Forecasts likelihood of low lying fog development.",
          "scoreDescription": "\u2022 20\u201340% (Patchy Mist / Shallow Ground Fog): Localized fog forming in low meadows, river bottoms, and marshlands near dawn.\n\u2022 45\u201370% (Moderate Valley Fog): Cohesive radiation or advection fog bank pooling in sheltered valleys.\n\u2022 75\u2013100% (Dense Radiation / Inversion Fog): High probability of thick boundary-layer fog filling valley floors under a stable nocturnal inversion.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "nbm",
            "gdps"
          ],
          "outputModels": [
            "Fog probability .pmtiles per model"
          ],
          "toastTitle": "Valley Fog & Radiation Fog Probability",
          "toastSubtitle": "TERRAIN-TRAPPED BOUNDARY LAYER FOG",
          "toastDescription": "Identifies nocturnal temperature inversions, boundary-layer saturation, and topographic cold-air drainage to forecast low-lying valley fog and sea-of-clouds events."
        },
        {
          "id": "dust_forecast",
          "label": "Global Dust",
          "product": "dust",
          "model": "gefs_dust",
          "icon": "\ud83c\udfdc\ufe0f",
          "category": "air_quality_fires",
          "description": "Global desert dust PM2.5 particulate concentration forecast from NOAA GEFS Aerosols.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Global desert dust PM2.5/PM10 aerosol dispersion and surface concentration forecast from NOAA GEFS Aerosols.",
          "score_description": "\u2022 Light Dust Haze (5\u201325 \u00b5g/m\u00b3): Subtle atmospheric scattering and warm twilight tinting.\n\u2022 Moderate Dust Plume (25\u201375 \u00b5g/m\u00b3): Noticeable horizon haze, reduced mountain visibility, and elevated particulate levels.\n\u2022 Dense Dust Storm (75\u2013250+ \u00b5g/m\u00b3): Severe visibility reduction and unhealthy breathable dust concentrations.",
          "source_models": [
            "gefs_dust (Global 0.25\u00b0 GEFS-Aerosols)"
          ],
          "output_models": [
            "Global dust PM2.5 concentration .pmtiles"
          ],
          "toast_title": "Global Desert Dust & Aerosol Forecast",
          "toast_subtitle": "NOAA GEFS-AEROSOLS DUST DISPERSION",
          "toast_description": "Forecasts windblown desert dust plumes and fine mineral particulate concentrations from the NOAA Global Ensemble Aerosol model.",
          "longDescription": "Global desert dust PM2.5/PM10 aerosol dispersion and surface concentration forecast from NOAA GEFS Aerosols.",
          "scoreDescription": "\u2022 Light Dust Haze (5\u201325 \u00b5g/m\u00b3): Subtle atmospheric scattering and warm twilight tinting.\n\u2022 Moderate Dust Plume (25\u201375 \u00b5g/m\u00b3): Noticeable horizon haze, reduced mountain visibility, and elevated particulate levels.\n\u2022 Dense Dust Storm (75\u2013250+ \u00b5g/m\u00b3): Severe visibility reduction and unhealthy breathable dust concentrations.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "gefs_dust (Global 0.25\u00b0 GEFS-Aerosols)"
          ],
          "outputModels": [
            "Global dust PM2.5 concentration .pmtiles"
          ],
          "toastTitle": "Global Desert Dust & Aerosol Forecast",
          "toastSubtitle": "NOAA GEFS-AEROSOLS DUST DISPERSION",
          "toastDescription": "Forecasts windblown desert dust plumes and fine mineral particulate concentrations from the NOAA Global Ensemble Aerosol model."
        }
      ],
      "secondaryLayers": [
        {
          "id": "precip_radar",
          "label": "Doppler Radar",
          "product": "live_weather",
          "model": "mrms",
          "icon": "\ud83d\udce1",
          "category": "precipitation",
          "description": "Near real time doppler radar",
          "basemap_override": {
            "terrain_3d": false
          },
          "category_label": "Real-Time Observation",
          "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "source_models": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "output_models": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toast_title": "Live NOAA MRMS Doppler Radar",
          "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
          "basemapOverride": {
            "terrain3d": false
          },
          "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "outputModels": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toastTitle": "Live NOAA MRMS Doppler Radar",
          "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
        },
        {
          "id": "precip_forecast",
          "label": "Precipitation Forecast",
          "product": "precip",
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Hourly and daily rain and snow forecasts.",
          "category_label": "Core Meteorological",
          "long_description": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "score_description": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "source_models": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "output_models": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toast_title": "Precipitation Rate, Probability & Snow",
          "toast_subtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toast_description": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models.",
          "longDescription": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "scoreDescription": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "outputModels": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toastTitle": "Precipitation Rate, Probability & Snow",
          "toastSubtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toastDescription": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models."
        },
        {
          "id": "relative_humidity",
          "label": "Relative Humidity",
          "product": "relative_humidity",
          "icon": "\ud83d\udca7",
          "category": "temperature",
          "description": "Relative Humidity forecast.",
          "category_label": "Core Meteorological",
          "long_description": "2m Surface Relative Humidity percentage.",
          "score_description": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Surface RH .pmtiles per model"
          ],
          "toast_title": "Surface Relative Humidity (RH%)",
          "toast_subtitle": "2-METER ATMOSPHERIC SATURATION",
          "toast_description": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions.",
          "longDescription": "2m Surface Relative Humidity percentage.",
          "scoreDescription": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Surface RH .pmtiles per model"
          ],
          "toastTitle": "Surface Relative Humidity (RH%)",
          "toastSubtitle": "2-METER ATMOSPHERIC SATURATION",
          "toastDescription": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions."
        },
        {
          "id": "climate_data",
          "label": "Historical Climatology (30-year)",
          "product": "climate",
          "icon": "\ud83d\udcca",
          "category": "extended_climate",
          "is_tool_mode": true,
          "description": "30-year climatological normals & microclimate elevation profiles",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "score_description": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "source_models": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "output_models": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toast_title": "Historical Climatology (30-Year Normals)",
          "toast_subtitle": "1991\u20132020 CLIMATE BASELINE",
          "toast_description": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips.",
          "longDescription": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "scoreDescription": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "outputModels": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toastTitle": "Historical Climatology (30-Year Normals)",
          "toastSubtitle": "1991\u20132020 CLIMATE BASELINE",
          "toastDescription": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips."
        },
        {
          "id": "aqi_index",
          "label": "AQI Forecast",
          "product": "aqi",
          "icon": "\ud83e\udec1",
          "category": "air_quality_fires",
          "description": "Air quality forecast.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "score_description": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "source_models": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "output_models": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toast_title": "Air Quality Index (AQI) Forecast",
          "toast_subtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toast_description": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone.",
          "longDescription": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "scoreDescription": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "outputModels": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toastTitle": "Air Quality Index (AQI) Forecast",
          "toastSubtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toastDescription": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone."
        },
        {
          "id": "smoke_forecast",
          "label": "Wildfire Smoke",
          "product": "smoke",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "air_quality_fires",
          "description": "Wildfire smoke forecasts for North America.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "score_description": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "source_models": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "output_models": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toast_title": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toast_subtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toast_description": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation.",
          "longDescription": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "scoreDescription": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "outputModels": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toastTitle": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toastSubtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toastDescription": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation."
        }
      ]
    },
    "winter_sports": {
      "id": "winter_sports",
      "title": "Winter Sports",
      "icon": "\u2744\ufe0f",
      "description": "Snow accumulation, freezing levels, wind chill & radar transition",
      "defaultBasemap": "terrain-mapterhorn",
      "basemapConfig": {
        "theme": "terrain-mapterhorn",
        "mode": "light",
        "terrain3d": true,
        "shading": "monochrome"
      },
      "isDefault": true,
      "isCustom": false,
      "forecastLayoutRef": "config/forecast_layouts/winter_sports.yaml",
      "forecastLayout": {
        "id": "winter_sports",
        "name": "Winter Sports",
        "description": "Freezing level, snowfall accumulation, mountain ridge winds, and temperature inversions",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "widget_1791671275142_901",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "widget_1793073747833_714",
              "type": "daily-snow-card",
              "title": "Daily Snowfall Forecast",
              "colSpan": 12,
              "options": {
                "period": "auto",
                "dataSource": "auto",
                "showProbability": true,
                "showSummaryBanner": true,
                "description": "Day-by-day snowfall accumulation forecast (inches/cm) and daily snow probability, highlighting total storm snowfall and the deepest powder day across the forecast horizon."
              },
              "description": "Day-by-day snowfall accumulation forecast (inches/cm) and daily snow probability, highlighting total storm snowfall and the deepest powder day across the forecast horizon."
            },
            {
              "id": "widget_1793073795807_264",
              "type": "meteogram-card",
              "title": "Multi-Product Meteogram",
              "colSpan": 12,
              "options": {
                "height": 200,
                "showNow": true,
                "staticYAxis": false,
                "horizonDays": "auto",
                "showMountainSilhouette": false,
                "declutterElevations": true,
                "showMinMaxLines": false,
                "minMaxSeriesKey": "auto",
                "series": [
                  {
                    "key": "cloud_cover_total",
                    "type": "area",
                    "yAxis": "right",
                    "color": "#94a3b8",
                    "tension": 0.3,
                    "label": "Total Cloud Cover (%)",
                    "model": "auto"
                  },
                  {
                    "key": "sun_intensity_wm2",
                    "type": "area",
                    "yAxis": "left",
                    "color": "#fbbf24",
                    "tension": 0.3,
                    "label": "Downwelling Solar Irradiance (W/m\u00b2)"
                  }
                ],
                "description": "Alpine solar radiation & flat-light meteogram comparing downwelling solar irradiance (W/m\u00b2, gold area on left axis) against total cloud cover (%, grey area on right axis). High solar irradiance under low cloud cover indicates bright visibility and potential south-aspect solar snow crusting, whereas 100% cloud cover with low irradiance warns of flat-light conditions."
              },
              "description": "Alpine solar radiation & flat-light meteogram comparing downwelling solar irradiance (W/m\u00b2, gold area on left axis) against total cloud cover (%, grey area on right axis). High solar irradiance under low cloud cover indicates bright visibility and potential south-aspect solar snow crusting, whereas 100% cloud cover with low irradiance warns of flat-light conditions."
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "w_appbar",
              "type": "app-bar",
              "title": "Mountain Location Header",
              "col_span": 12,
              "options": {
                "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
              },
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            {
              "id": "w_horizon",
              "type": "horizon-selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "default": "5-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "w_elevation_temps",
              "type": "elevation-temp-card",
              "title": "Mountain Temperatures & Lapse Rates",
              "col_span": 12,
              "options": {
                "showFreezingLine": true,
                "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
              },
              "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
            },
            {
              "id": "widget_1792980324958_278",
              "type": "daily-snow-card",
              "title": "Daily Snowfall Forecast",
              "colSpan": 12,
              "options": {
                "period": "auto",
                "dataSource": "auto",
                "showProbability": true,
                "showSummaryBanner": true,
                "description": "Day-by-day snowfall accumulation forecast (inches/cm) and daily snow probability, highlighting total storm snowfall and the deepest powder day across the forecast horizon."
              },
              "description": "Day-by-day snowfall accumulation forecast (inches/cm) and daily snow probability, highlighting total storm snowfall and the deepest powder day across the forecast horizon."
            },
            {
              "id": "w_snow",
              "type": "observed-snow-card",
              "title": "SNOTEL Snowpack & 24h New Snow",
              "col_span": 12,
              "options": {
                "expandedStations": {
                  "0": true
                },
                "description": "Live telemetry from the nearest high-elevation SNOTEL and snow-pillow stations showing total snow depth, Snow Water Equivalent (SWE), 24h/72h new snowfall, and multi-day snowpack trends."
              },
              "description": "Live telemetry from the nearest high-elevation SNOTEL and snow-pillow stations showing total snow depth, Snow Water Equivalent (SWE), 24h/72h new snowfall, and multi-day snowpack trends."
            },
            {
              "id": "w_cloud_ceiling",
              "type": "cloud-ceiling-card",
              "title": "Snow Level & Cloud Tops",
              "col_span": 12,
              "options": {
                "displayMode": "chart",
                "showFreezingLine": true,
                "showCloudCover": true,
                "chartHeight": 340,
                "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
              },
              "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
            },
            {
              "id": "w_winter_meteo",
              "type": "meteogram-card",
              "title": "Snow Accumulation vs Freezing Line & Ridge Winds",
              "col_span": 12,
              "options": {
                "height": 380,
                "showNow": true,
                "horizonDays": "5",
                "series": [
                  {
                    "key": "snow_rate_in_h",
                    "type": "bar",
                    "yAxis": "right",
                    "color": "#38bdf8"
                  },
                  {
                    "key": "freezing_level_ft",
                    "type": "line",
                    "yAxis": "left",
                    "color": "#3b82f6"
                  },
                  {
                    "key": "wind_gust_mph",
                    "type": "line",
                    "dashed": true,
                    "yAxis": "right",
                    "color": "#f43f5e"
                  }
                ],
                "description": "Backcountry & resort storm meteogram tracking hourly snowfall rate (in/hr, cyan bars), freezing level elevation (ft MSL, blue curve on left axis), and peak ridge wind gusts (mph, red dashed curve). Watch for high snowfall rates paired with strong gusts, which rapidly build reactive wind slabs on leeward alpine slopes."
              },
              "description": "Backcountry & resort storm meteogram tracking hourly snowfall rate (in/hr, cyan bars), freezing level elevation (ft MSL, blue curve on left axis), and peak ridge wind gusts (mph, red dashed curve). Watch for high snowfall rates paired with strong gusts, which rapidly build reactive wind slabs on leeward alpine slopes."
            },
            {
              "id": "w_bottom_nav",
              "type": "bottom-nav",
              "title": "Navigation Bar",
              "col_span": 12,
              "options": {
                "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
              },
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "avalanche_danger",
          "label": "Avalanche Danger (USFS NAC)",
          "product": "avalanche",
          "icon": "\ud83c\udfd4\ufe0f\u26a0\ufe0f",
          "category": "hydrology",
          "description": "Live avalanche danger ratings & official bulletins",
          "basemap_override": {
            "theme": "usgs-topo"
          },
          "category_label": "Backcountry & Alpine Safety",
          "long_description": "Official daily backcountry avalanche danger ratings, avalanche problem types, elevation rose diagrams, and forecaster bulletins aggregated from the USFS National Avalanche Center (NAC) and regional avalanche centers across North America.",
          "score_description": "\u2022 1 - Low (Green): Generally safe avalanche conditions; watch for unstable snow on isolated terrain features.\n\u2022 2 - Moderate (Yellow): Heightened avalanche conditions on specific terrain features; evaluate snow and terrain carefully.\n\u2022 3 - Considerable (Orange): Dangerous avalanche conditions; careful snowpack evaluation, conservative decision-making, and cautious route-finding essential.\n\u2022 4 - High (Red): Very dangerous avalanche conditions; travel in avalanche terrain not recommended.\n\u2022 5 - Extreme (Black/Maroon): Avoid all avalanche terrain; natural and human-triggered avalanches certain.",
          "source_models": [
            "USFS National Avalanche Center (NAC) API",
            "Regional Backcountry Avalanche Forecast Centers"
          ],
          "output_models": [
            "Interactive Avalanche Forecast Zone Polygons & Official Bulletins"
          ],
          "toast_title": "Backcountry Avalanche Danger (NAC)",
          "toast_subtitle": "OFFICIAL NORTH AMERICAN AVALANCHE RATINGS",
          "toast_description": "Displays live official avalanche danger ratings (1-Low to 5-Extreme) and backcountry forecast bulletins by mountain zone.",
          "basemapOverride": {
            "theme": "usgs-topo"
          },
          "longDescription": "Official daily backcountry avalanche danger ratings, avalanche problem types, elevation rose diagrams, and forecaster bulletins aggregated from the USFS National Avalanche Center (NAC) and regional avalanche centers across North America.",
          "scoreDescription": "\u2022 1 - Low (Green): Generally safe avalanche conditions; watch for unstable snow on isolated terrain features.\n\u2022 2 - Moderate (Yellow): Heightened avalanche conditions on specific terrain features; evaluate snow and terrain carefully.\n\u2022 3 - Considerable (Orange): Dangerous avalanche conditions; careful snowpack evaluation, conservative decision-making, and cautious route-finding essential.\n\u2022 4 - High (Red): Very dangerous avalanche conditions; travel in avalanche terrain not recommended.\n\u2022 5 - Extreme (Black/Maroon): Avoid all avalanche terrain; natural and human-triggered avalanches certain.",
          "categoryLabel": "Backcountry & Alpine Safety",
          "sourceModels": [
            "USFS National Avalanche Center (NAC) API",
            "Regional Backcountry Avalanche Forecast Centers"
          ],
          "outputModels": [
            "Interactive Avalanche Forecast Zone Polygons & Official Bulletins"
          ],
          "toastTitle": "Backcountry Avalanche Danger (NAC)",
          "toastSubtitle": "OFFICIAL NORTH AMERICAN AVALANCHE RATINGS",
          "toastDescription": "Displays live official avalanche danger ratings (1-Low to 5-Extreme) and backcountry forecast bulletins by mountain zone."
        },
        {
          "id": "snow_depth",
          "label": "Snow Depth & SNOTEL",
          "product": "snow_depth",
          "icon": "\u2744\ufe0f",
          "category": "hydrology",
          "description": "Observed snowpack depth & SNOTEL telemetry",
          "category_label": "Hydrology & Mountain Weather",
          "long_description": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
          "score_description": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
          "source_models": [
            "NOAA SNODAS 1km Snow Analysis",
            "USDA NRCS SNOTEL Telemetry",
            "ECCC & BC Snow Pillow Network"
          ],
          "output_models": [
            "Continuous mountain snowpack gradient",
            "Live SNOTEL observation stations"
          ],
          "toast_title": "Snow Depth & Live SNOTEL Stations",
          "toast_subtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
          "toast_description": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements.",
          "longDescription": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
          "scoreDescription": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
          "categoryLabel": "Hydrology & Mountain Weather",
          "sourceModels": [
            "NOAA SNODAS 1km Snow Analysis",
            "USDA NRCS SNOTEL Telemetry",
            "ECCC & BC Snow Pillow Network"
          ],
          "outputModels": [
            "Continuous mountain snowpack gradient",
            "Live SNOTEL observation stations"
          ],
          "toastTitle": "Snow Depth & Live SNOTEL Stations",
          "toastSubtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
          "toastDescription": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements."
        },
        {
          "id": "snow_accum",
          "label": "Snowfall Accumulation (Past 1-7 Days)",
          "product": "snow_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf28\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP snowfall accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "long_description": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "source_models": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toast_title": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toast_subtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toast_description": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows.",
          "longDescription": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toastSubtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toastDescription": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows."
        },
        {
          "id": "precip_accum",
          "label": "Precipitation Accumulation (Past 1-7 Days)",
          "product": "precip_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP precipitation accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "long_description": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "source_models": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toast_title": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toast_subtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toast_description": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation.",
          "longDescription": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toastSubtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toastDescription": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation."
        },
        {
          "id": "precip_forecast",
          "label": "Precipitation Forecast",
          "product": "precip",
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Hourly and daily rain and snow forecasts.",
          "category_label": "Core Meteorological",
          "long_description": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "score_description": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "source_models": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "output_models": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toast_title": "Precipitation Rate, Probability & Snow",
          "toast_subtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toast_description": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models.",
          "longDescription": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "scoreDescription": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "outputModels": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toastTitle": "Precipitation Rate, Probability & Snow",
          "toastSubtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toastDescription": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models."
        },
        {
          "id": "freezing_level",
          "label": "Freezing Level",
          "product": "freezing_level",
          "model": "hrrr",
          "icon": "\ud83e\uddca",
          "category": "temperature",
          "description": "Freezing level forecast.",
          "category_label": "Core Meteorological",
          "long_description": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
          "score_description": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Altitude (Meters MSL) .pmtiles per model"
          ],
          "toast_title": "Freezing Level Altitude (0\u00b0C Isotherm)",
          "toast_subtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
          "toast_description": "Displays the forecasted elevation where air temperature reaches freezing.",
          "longDescription": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
          "scoreDescription": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Altitude (Meters MSL) .pmtiles per model"
          ],
          "toastTitle": "Freezing Level Altitude (0\u00b0C Isotherm)",
          "toastSubtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
          "toastDescription": "Displays the forecasted elevation where air temperature reaches freezing."
        },
        {
          "id": "sun_intensity_forecast",
          "label": "Solar Intensity Forecast",
          "product": "sun_intensity",
          "icon": "\u2600\ufe0f",
          "category": "temperature",
          "description": "Surface downwelling solar irradiance forecast (W/m\u00b2) across numerical weather models.",
          "category_label": "Core Meteorological",
          "long_description": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "score_description": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "source_models": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "output_models": [
            "Solar Intensity .pmtiles per model"
          ],
          "toast_title": "Solar Intensity & Surface Irradiance",
          "toast_subtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toast_description": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation.",
          "longDescription": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "scoreDescription": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "outputModels": [
            "Solar Intensity .pmtiles per model"
          ],
          "toastTitle": "Solar Intensity & Surface Irradiance",
          "toastSubtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toastDescription": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation."
        }
      ],
      "secondaryLayers": [
        {
          "id": "precip_radar",
          "label": "Doppler Radar",
          "product": "live_weather",
          "model": "mrms",
          "icon": "\ud83d\udce1",
          "category": "precipitation",
          "description": "Near real time doppler radar",
          "basemap_override": {
            "terrain_3d": false
          },
          "category_label": "Real-Time Observation",
          "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "source_models": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "output_models": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toast_title": "Live NOAA MRMS Doppler Radar",
          "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
          "basemapOverride": {
            "terrain3d": false
          },
          "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "outputModels": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toastTitle": "Live NOAA MRMS Doppler Radar",
          "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
        },
        {
          "id": "satellite_imagery",
          "label": "Satellite Imagery (Vis & IR)",
          "product": "live_weather",
          "model": "goes",
          "icon": "\ud83d\udef0\ufe0f",
          "category": "clouds_wind",
          "description": "High-frequency visible and infrared geostationary satellite cloud loops.",
          "category_label": "Real-Time Observation",
          "long_description": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "score_description": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "source_models": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "output_models": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toast_title": "Live Geostationary Satellite Imagery",
          "toast_subtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toast_description": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems.",
          "longDescription": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "scoreDescription": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "outputModels": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toastTitle": "Live Geostationary Satellite Imagery",
          "toastSubtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toastDescription": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems."
        },
        {
          "id": "clouds",
          "label": "Cloud Forecast",
          "product": "clouds",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud forecasts.",
          "long_description": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "category_label": "Core Meteorological",
          "score_description": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "source_models": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "output_models": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toast_title": "Cloud Cover Forecast",
          "toast_subtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toast_description": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures.",
          "longDescription": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "scoreDescription": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "outputModels": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toastTitle": "Cloud Cover Forecast",
          "toastSubtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toastDescription": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures."
        },
        {
          "id": "winds_surface",
          "label": "Surface Winds Forecast",
          "product": "winds",
          "model": "blend",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Forecasted Surface Winds (10m)",
          "category_label": "Core Meteorological",
          "long_description": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "score_description": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toast_title": "Surface Winds & Gusts",
          "toast_subtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toast_description": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models.",
          "longDescription": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "scoreDescription": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toastTitle": "Surface Winds & Gusts",
          "toastSubtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toastDescription": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models."
        },
        {
          "id": "golden_hour",
          "label": "Sunrise & Sunset",
          "product": "sunrise",
          "model": "gw_v2_blend_50",
          "icon": "\ud83c\udf05",
          "category": "sky_solar",
          "description": "Sunrise and Sunset color/quality probability forecast",
          "category_label": "Forecast Quality Scoring",
          "long_description": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
          "score_description": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "output_models": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toast_title": "Sunrise & Sunset 10-Day Forecast",
          "toast_subtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toast_description": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
          "nowcast_toast_title": "SkySkout Sunset & Sunrise NowCast",
          "nowcast_toast_subtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcast_toast_description": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions.",
          "longDescription": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
          "scoreDescription": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "outputModels": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toastTitle": "Sunrise & Sunset 10-Day Forecast",
          "toastSubtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toastDescription": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
          "nowcastToastTitle": "SkySkout Sunset & Sunrise NowCast",
          "nowcastToastSubtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcastToastDescription": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions."
        },
        {
          "id": "climate_data",
          "label": "Historical Climatology (30-year)",
          "product": "climate",
          "icon": "\ud83d\udcca",
          "category": "extended_climate",
          "is_tool_mode": true,
          "description": "30-year climatological normals & microclimate elevation profiles",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "score_description": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "source_models": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "output_models": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toast_title": "Historical Climatology (30-Year Normals)",
          "toast_subtitle": "1991\u20132020 CLIMATE BASELINE",
          "toast_description": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips.",
          "longDescription": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "scoreDescription": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "outputModels": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toastTitle": "Historical Climatology (30-Year Normals)",
          "toastSubtitle": "1991\u20132020 CLIMATE BASELINE",
          "toastDescription": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips."
        }
      ]
    },
    "water_sports": {
      "id": "water_sports",
      "title": "Water Sports",
      "icon": "\ud83c\udf0a",
      "description": "Stream flow rates, surface winds/gusts, water temp & lightning",
      "defaultBasemap": "road",
      "basemapConfig": {
        "theme": "road",
        "mode": "light",
        "terrain3d": false,
        "shading": "color_tint"
      },
      "isDefault": true,
      "isCustom": false,
      "forecastLayoutRef": "config/forecast_layouts/water_sports.yaml",
      "forecastLayout": {
        "id": "water_sports",
        "name": "Water Sports",
        "description": "Surface wind vectors, gust progression, convective thunderstorms, and sun exposure",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "widget_1791671281638_187",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "wind_profile",
              "type": "wind_card",
              "title": "Surface Wind & Water Chop",
              "col_span": 6,
              "options": {
                "height": 180,
                "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
              },
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            {
              "id": "lightning_hazard",
              "type": "lightning_map_card",
              "title": "Lake Convective Storm & Lightning Timing",
              "col_span": 6,
              "options": {
                "show_diurnal_chart": true,
                "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
              },
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            {
              "id": "temp_precip_meteo",
              "type": "meteogram_card",
              "title": "Air Temperature & Precipitation",
              "col_span": 6,
              "options": {
                "height": 220,
                "description": "Hourly air temperature and precipitation trend over the selected water body, helping paddlers and boaters anticipate cold-front passages, squalls, and thermal comfort shifts."
              },
              "description": "Hourly air temperature and precipitation trend over the selected water body, helping paddlers and boaters anticipate cold-front passages, squalls, and thermal comfort shifts."
            },
            {
              "id": "sun_intensity",
              "type": "sun_intensity_card",
              "title": "Direct Solar Exposure & UV Index",
              "col_span": 6,
              "options": {
                "height": 120,
                "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
              },
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            {
              "id": "air_quality",
              "type": "air_quality_card",
              "title": "Air Quality & Smoke",
              "col_span": 6,
              "options": {
                "height": 180,
                "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
              },
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "w_appbar",
              "type": "app-bar",
              "title": "River & Lake Location Header",
              "col_span": 12,
              "options": {
                "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
              },
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            {
              "id": "w_horizon",
              "type": "horizon-selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "default": "3-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "w_glance",
              "type": "glance-2x2",
              "title": "Current Conditions",
              "col_span": 4,
              "options": {
                "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
              },
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            {
              "id": "w_recent_weather",
              "type": "recent-weather-2x3",
              "title": "Recent Rainfall",
              "col_span": 12,
              "options": {
                "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
              },
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            {
              "id": "widget_1792980395767_168",
              "type": "daily-precip-card",
              "title": "Daily Precipitation Forecast",
              "colSpan": 12,
              "options": {
                "period": "auto",
                "dataSource": "auto",
                "showProbability": true,
                "showSummaryBanner": true,
                "description": "Day-by-day liquid precipitation accumulation forecast (inches/mm) and daily probability of measurable rain, including a storm-total summary banner and peak wettest day highlight."
              },
              "description": "Day-by-day liquid precipitation accumulation forecast (inches/mm) and daily probability of measurable rain, including a storm-total summary banner and peak wettest day highlight."
            },
            {
              "id": "w_water_meteo",
              "type": "meteogram-card",
              "title": "Rain Rate vs Surface Winds & Gusts",
              "col_span": 12,
              "options": {
                "height": 380,
                "showNow": true,
                "horizonDays": "3",
                "series": [
                  {
                    "key": "precip_rate_in_h",
                    "type": "bar",
                    "yAxis": "right",
                    "color": "#38bdf8"
                  },
                  {
                    "key": "wind_speed_mph",
                    "type": "line",
                    "yAxis": "left",
                    "color": "#10b981"
                  },
                  {
                    "key": "wind_gust_mph",
                    "type": "line",
                    "dashed": true,
                    "yAxis": "left",
                    "color": "#f43f5e"
                  }
                ],
                "description": "On-water wind & squall meteogram plotting sustained 10-meter surface wind speed (mph, green curve), peak wind gusts (mph, red dashed curve), and hourly rainfall rate (in/hr, cyan bars on right axis). Critical for identifying afternoon thermal wind ramps and sudden convective gust fronts on open lakes, reservoirs, and bays."
              },
              "description": "On-water wind & squall meteogram plotting sustained 10-meter surface wind speed (mph, green curve), peak wind gusts (mph, red dashed curve), and hourly rainfall rate (in/hr, cyan bars on right axis). Critical for identifying afternoon thermal wind ramps and sudden convective gust fronts on open lakes, reservoirs, and bays."
            },
            {
              "id": "w_bottom_nav",
              "type": "bottom-nav",
              "title": "Navigation Bar",
              "col_span": 12,
              "options": {
                "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
              },
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "winds_surface_current",
          "label": "Surface Winds (Current)",
          "product": "live_weather",
          "model": "rtma_winds",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Current and recently observed surface winds.",
          "category_label": "Real-Time Observation",
          "long_description": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "score_description": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "source_models": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "output_models": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toast_title": "Current Surface Winds (Live RTMA)",
          "toast_subtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toast_description": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines.",
          "longDescription": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "scoreDescription": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "outputModels": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toastTitle": "Current Surface Winds (Live RTMA)",
          "toastSubtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toastDescription": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines."
        },
        {
          "id": "streamflow_gauges",
          "label": "Stream & Reservoir Flows",
          "product": "streamflow",
          "icon": "\ud83c\udf0a",
          "category": "hydrology",
          "description": "Stream and reservoir levels, flow rates, temperature.",
          "category_label": "Hydrology & Inland Waters",
          "long_description": "Real-time USGS river and stream telemetry monitoring flow discharge rates (cfs), gauge height, and water temperatures.",
          "score_description": "\u2022 Percentile Color Mode (% of Historical Normal): Colors gauges from extreme low flow (Red/Orange) through normal flow (Green) to high/flood flow (Blue/Purple).\n\u2022 Flow & Storage Mode: Displays absolute river discharge (cfs) and reservoir storage capacity.\n\u2022 Water Temperature Mode: Displays live river and lake water temperatures (\u00b0F/\u00b0C) for anglers and paddlers.",
          "source_models": [
            "USGS National Water Information System (NWIS) Telemetry"
          ],
          "output_models": [
            "Streamflow station telemetry markers",
            "Inland water temperature raster"
          ],
          "toast_title": "Live Streamflow, Reservoirs & Water Temp",
          "toast_subtitle": "REAL-TIME USGS NWIS HYDROLOGY GAUGES",
          "toast_description": "Monitors real-time river discharge (cfs), historical flow percentiles, reservoir levels, and water temperatures across thousands of gauges.",
          "longDescription": "Real-time USGS river and stream telemetry monitoring flow discharge rates (cfs), gauge height, and water temperatures.",
          "scoreDescription": "\u2022 Percentile Color Mode (% of Historical Normal): Colors gauges from extreme low flow (Red/Orange) through normal flow (Green) to high/flood flow (Blue/Purple).\n\u2022 Flow & Storage Mode: Displays absolute river discharge (cfs) and reservoir storage capacity.\n\u2022 Water Temperature Mode: Displays live river and lake water temperatures (\u00b0F/\u00b0C) for anglers and paddlers.",
          "categoryLabel": "Hydrology & Inland Waters",
          "sourceModels": [
            "USGS National Water Information System (NWIS) Telemetry"
          ],
          "outputModels": [
            "Streamflow station telemetry markers",
            "Inland water temperature raster"
          ],
          "toastTitle": "Live Streamflow, Reservoirs & Water Temp",
          "toastSubtitle": "REAL-TIME USGS NWIS HYDROLOGY GAUGES",
          "toastDescription": "Monitors real-time river discharge (cfs), historical flow percentiles, reservoir levels, and water temperatures across thousands of gauges."
        },
        {
          "id": "sst",
          "label": "Sea Surface Temperature",
          "product": "sst",
          "icon": "\ud83c\udf0a",
          "category": "hydrology",
          "description": "Observed sea surface temperature.",
          "category_label": "Marine & Oceanographic",
          "long_description": "High-resolution sea surface water temperatures coupled with NOAA NDBC real-time buoy observations.",
          "score_description": "\u2022 5km SST Raster: Daily satellite-blended ocean and Great Lakes surface water temperatures.\n\u2022 Live NDBC Marine Buoys: Click any offshore or coastal buoy to view real-time water temperature, wave height, dominant swell period, and marine winds.",
          "source_models": [
            "NOAA Coral Reef Watch (CRW) 5km SST",
            "NOAA NDBC Marine Buoy Stations"
          ],
          "output_models": [
            "SST temperature .pmtiles",
            "Live marine buoy observation telemetry"
          ],
          "toast_title": "Sea Surface Temperature & Marine Buoys",
          "toast_subtitle": "5KM SATELLITE SST & LIVE NDBC BUOYS",
          "toast_description": "Combines high-resolution satellite sea surface water temperatures with live coastal and offshore NOAA marine buoy telemetry.",
          "longDescription": "High-resolution sea surface water temperatures coupled with NOAA NDBC real-time buoy observations.",
          "scoreDescription": "\u2022 5km SST Raster: Daily satellite-blended ocean and Great Lakes surface water temperatures.\n\u2022 Live NDBC Marine Buoys: Click any offshore or coastal buoy to view real-time water temperature, wave height, dominant swell period, and marine winds.",
          "categoryLabel": "Marine & Oceanographic",
          "sourceModels": [
            "NOAA Coral Reef Watch (CRW) 5km SST",
            "NOAA NDBC Marine Buoy Stations"
          ],
          "outputModels": [
            "SST temperature .pmtiles",
            "Live marine buoy observation telemetry"
          ],
          "toastTitle": "Sea Surface Temperature & Marine Buoys",
          "toastSubtitle": "5KM SATELLITE SST & LIVE NDBC BUOYS",
          "toastDescription": "Combines high-resolution satellite sea surface water temperatures with live coastal and offshore NOAA marine buoy telemetry."
        },
        {
          "id": "precip_accum",
          "label": "Precipitation Accumulation (Past 1-7 Days)",
          "product": "precip_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP precipitation accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "long_description": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "source_models": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toast_title": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toast_subtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toast_description": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation.",
          "longDescription": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toastSubtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toastDescription": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation."
        },
        {
          "id": "snow_accum",
          "label": "Snowfall Accumulation (Past 1-7 Days)",
          "product": "snow_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf28\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP snowfall accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "long_description": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "source_models": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toast_title": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toast_subtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toast_description": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows.",
          "longDescription": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toastSubtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toastDescription": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows."
        },
        {
          "id": "tropical_cyclones",
          "label": "Tropical Cyclones & Hazards",
          "product": "tropical",
          "icon": "\ud83c\udf00",
          "category": "extended_climate",
          "description": "NOAA National Hurricane Center (NHC) active tropical cyclone forecast tracks, cones of uncertainty, wind radii swaths, coastal warnings, and GTWO disturbance outlooks",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
          "score_description": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
          "source_models": [
            "NOAA National Hurricane Center (NHC)",
            "Central Pacific Hurricane Center (CPHC)",
            "Automated Tropical Cyclone Forecasting (ATCF) System"
          ],
          "output_models": [
            "NHC Active Tropical Advisory GIS GeoJSON"
          ],
          "toast_title": "Tropical Cyclones & NHC Outlooks",
          "toast_subtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
          "toast_description": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities.",
          "longDescription": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
          "scoreDescription": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "NOAA National Hurricane Center (NHC)",
            "Central Pacific Hurricane Center (CPHC)",
            "Automated Tropical Cyclone Forecasting (ATCF) System"
          ],
          "outputModels": [
            "NHC Active Tropical Advisory GIS GeoJSON"
          ],
          "toastTitle": "Tropical Cyclones & NHC Outlooks",
          "toastSubtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
          "toastDescription": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities."
        }
      ],
      "secondaryLayers": [
        {
          "id": "precip_radar",
          "label": "Doppler Radar",
          "product": "live_weather",
          "model": "mrms",
          "icon": "\ud83d\udce1",
          "category": "precipitation",
          "description": "Near real time doppler radar",
          "basemap_override": {
            "terrain_3d": false
          },
          "category_label": "Real-Time Observation",
          "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "source_models": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "output_models": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toast_title": "Live NOAA MRMS Doppler Radar",
          "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
          "basemapOverride": {
            "terrain3d": false
          },
          "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "outputModels": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toastTitle": "Live NOAA MRMS Doppler Radar",
          "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
        },
        {
          "id": "precip_accum",
          "label": "Precipitation Accumulation (Past 1-7 Days)",
          "product": "precip_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP precipitation accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "long_description": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "source_models": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toast_title": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toast_subtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toast_description": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation.",
          "longDescription": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toastSubtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toastDescription": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation."
        },
        {
          "id": "snow_accum",
          "label": "Snowfall Accumulation (Past 1-7 Days)",
          "product": "snow_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf28\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP snowfall accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "long_description": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "source_models": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toast_title": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toast_subtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toast_description": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows.",
          "longDescription": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toastSubtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toastDescription": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows."
        },
        {
          "id": "satellite_imagery",
          "label": "Satellite Imagery (Vis & IR)",
          "product": "live_weather",
          "model": "goes",
          "icon": "\ud83d\udef0\ufe0f",
          "category": "clouds_wind",
          "description": "High-frequency visible and infrared geostationary satellite cloud loops.",
          "category_label": "Real-Time Observation",
          "long_description": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "score_description": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "source_models": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "output_models": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toast_title": "Live Geostationary Satellite Imagery",
          "toast_subtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toast_description": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems.",
          "longDescription": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "scoreDescription": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "outputModels": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toastTitle": "Live Geostationary Satellite Imagery",
          "toastSubtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toastDescription": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems."
        },
        {
          "id": "hrtemp",
          "label": "Temperature Forecast",
          "product": "hrtemp",
          "model": "nbm",
          "icon": "\ud83c\udf21\ufe0f",
          "category": "temperature",
          "description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "category_label": "Core Meteorological",
          "long_description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "score_description": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Surface temperature .pmtiles per model"
          ],
          "toast_title": "Terrain-Corrected Surface Temperature",
          "toast_subtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toast_description": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures.",
          "longDescription": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "scoreDescription": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Surface temperature .pmtiles per model"
          ],
          "toastTitle": "Terrain-Corrected Surface Temperature",
          "toastSubtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toastDescription": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures."
        },
        {
          "id": "sun_intensity_forecast",
          "label": "Solar Intensity Forecast",
          "product": "sun_intensity",
          "icon": "\u2600\ufe0f",
          "category": "temperature",
          "description": "Surface downwelling solar irradiance forecast (W/m\u00b2) across numerical weather models.",
          "category_label": "Core Meteorological",
          "long_description": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "score_description": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "source_models": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "output_models": [
            "Solar Intensity .pmtiles per model"
          ],
          "toast_title": "Solar Intensity & Surface Irradiance",
          "toast_subtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toast_description": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation.",
          "longDescription": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "scoreDescription": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "outputModels": [
            "Solar Intensity .pmtiles per model"
          ],
          "toastTitle": "Solar Intensity & Surface Irradiance",
          "toastSubtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toastDescription": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation."
        },
        {
          "id": "aqi_index",
          "label": "AQI Forecast",
          "product": "aqi",
          "icon": "\ud83e\udec1",
          "category": "air_quality_fires",
          "description": "Air quality forecast.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "score_description": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "source_models": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "output_models": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toast_title": "Air Quality Index (AQI) Forecast",
          "toast_subtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toast_description": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone.",
          "longDescription": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "scoreDescription": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "outputModels": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toastTitle": "Air Quality Index (AQI) Forecast",
          "toastSubtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toastDescription": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone."
        },
        {
          "id": "wildfire_hotspots",
          "label": "Satellite Hotspots",
          "product": "wildfires",
          "model": "firms_hotspots",
          "icon": "\ud83d\udce1",
          "category": "air_quality_fires",
          "description": "Hot spots detected by satellite.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Near-real-time satellite thermal anomaly hotspots detected by NASA/NOAA Suomi-NPP and NOAA-20/21 VIIRS (375m) and MODIS (1km) instruments, highlighting active wildfire fronts, spot fires, and radiative heat intensity (FRP).",
          "score_description": "\u2022 Recent Detections (<6h - Bright Red/Yellow): Fresh satellite overpass thermal detections indicating active flaming fronts.\n\u2022 6\u201324h Detections (Orange): Active burning detected within the past day.\n\u2022 Fire Radiative Power (FRP): Measured in Megawatts (MW), indicating thermal intensity of the sub-pixel heat source.",
          "source_models": [
            "NASA FIRMS VIIRS (375m Active Fire Detections)",
            "NOAA NESDIS HMS Fire & Smoke Product"
          ],
          "output_models": [
            "Satellite Thermal Anomaly Hotspots GeoJSON"
          ],
          "toast_title": "Satellite Wildfire Thermal Hotspots",
          "toast_subtitle": "375M NASA VIIRS INFRARED DETECTIONS",
          "toast_description": "Pinpoints near-real-time 375-meter satellite infrared heat detections to track active wildfire expansion before perimeters are mapped.",
          "longDescription": "Near-real-time satellite thermal anomaly hotspots detected by NASA/NOAA Suomi-NPP and NOAA-20/21 VIIRS (375m) and MODIS (1km) instruments, highlighting active wildfire fronts, spot fires, and radiative heat intensity (FRP).",
          "scoreDescription": "\u2022 Recent Detections (<6h - Bright Red/Yellow): Fresh satellite overpass thermal detections indicating active flaming fronts.\n\u2022 6\u201324h Detections (Orange): Active burning detected within the past day.\n\u2022 Fire Radiative Power (FRP): Measured in Megawatts (MW), indicating thermal intensity of the sub-pixel heat source.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "NASA FIRMS VIIRS (375m Active Fire Detections)",
            "NOAA NESDIS HMS Fire & Smoke Product"
          ],
          "outputModels": [
            "Satellite Thermal Anomaly Hotspots GeoJSON"
          ],
          "toastTitle": "Satellite Wildfire Thermal Hotspots",
          "toastSubtitle": "375M NASA VIIRS INFRARED DETECTIONS",
          "toastDescription": "Pinpoints near-real-time 375-meter satellite infrared heat detections to track active wildfire expansion before perimeters are mapped."
        }
      ]
    },
    "advanced": {
      "id": "advanced",
      "title": "All Map Layers",
      "icon": "\u26a1",
      "description": "Classic weather grids, proprietary scoring models & raw telemetry",
      "defaultBasemap": "terrain-mapterhorn",
      "basemapConfig": {
        "theme": "terrain-mapterhorn",
        "mode": "light",
        "terrain3d": false,
        "shading": "color_tint"
      },
      "isDefault": true,
      "isCustom": false,
      "forecastLayoutRef": "config/forecast_layouts/advanced.yaml",
      "forecastLayout": {
        "id": "advanced",
        "name": "Advanced Meteorology",
        "description": "Atmospheric lapse rates, thermal inversions, Skew-T soundings, diurnal lightning hazard, and multi-model consensus",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "sounding_inversion",
              "type": "sounding_card",
              "title": "Thermodynamic Sounding & Inversion Profile",
              "col_span": 6,
              "options": {
                "interactive": true,
                "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
              },
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            {
              "id": "temp_precip_meteo",
              "type": "meteogram_card",
              "title": "Mesoanalysis Temperature & Precipitation Rate",
              "col_span": 6,
              "options": {
                "height": 230,
                "description": "High-resolution mesoanalysis meteogram tracking hourly surface temperature, dew point depression, and precipitation rate across the active forecast horizon."
              },
              "description": "High-resolution mesoanalysis meteogram tracking hourly surface temperature, dew point depression, and precipitation rate across the active forecast horizon."
            },
            {
              "id": "lightning_hazard",
              "type": "lightning_map_card",
              "title": "Diurnal Convective Initiation & Strike Timing",
              "col_span": 6,
              "options": {
                "show_diurnal_chart": true,
                "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
              },
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            {
              "id": "wind_profile",
              "type": "wind_card",
              "title": "Boundary Layer Wind Vectors",
              "col_span": 6,
              "options": {
                "height": 180,
                "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
              },
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            {
              "id": "air_quality",
              "type": "air_quality_card",
              "title": "Boundary Layer Smoke & Aerosol Optical Depth",
              "col_span": 6,
              "options": {
                "height": 180,
                "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
              },
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            {
              "id": "darkskies_aurora",
              "type": "darkskies_aurora_card",
              "title": "Atmospheric Optical Transparency & Night Sky",
              "col_span": 6,
              "options": {
                "show_kp_chart": true,
                "show_aurora_map": true,
                "description": "Night-sky transparency and stargazing outlook combining the composite Dark Skies score with planetary geomagnetic Kp-index trends and aurora visibility potential."
              },
              "description": "Night-sky transparency and stargazing outlook combining the composite Dark Skies score with planetary geomagnetic Kp-index trends and aurora visibility potential."
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "widget_1792190868441_337",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "widget_1792190862787_301",
              "type": "bottom-nav",
              "title": "Navigation Bar",
              "colSpan": 12,
              "options": {
                "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
              },
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "golden_hour",
          "label": "Sunrise & Sunset",
          "product": "sunrise",
          "model": "gw_v2_blend_50",
          "icon": "\ud83c\udf05",
          "category": "sky_solar",
          "description": "Sunrise and Sunset color/quality probability forecast",
          "category_label": "Forecast Quality Scoring",
          "long_description": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
          "score_description": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "output_models": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toast_title": "Sunrise & Sunset 10-Day Forecast",
          "toast_subtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toast_description": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
          "nowcast_toast_title": "SkySkout Sunset & Sunrise NowCast",
          "nowcast_toast_subtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcast_toast_description": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions.",
          "longDescription": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
          "scoreDescription": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "outputModels": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toastTitle": "Sunrise & Sunset 10-Day Forecast",
          "toastSubtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toastDescription": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
          "nowcastToastTitle": "SkySkout Sunset & Sunrise NowCast",
          "nowcastToastSubtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcastToastDescription": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions."
        },
        {
          "id": "alpenglow_forecast",
          "label": "Golden Hour / Alpenglow",
          "product": "alpenglow",
          "model": "gw_v2_blend_50",
          "icon": "\ud83c\udfd4\ufe0f\ud83c\udf05",
          "category": "sky_solar",
          "description": "High-elevation alpine illumination quality/probability score",
          "basemap_override": {
            "mode": "dark"
          },
          "category_label": "Forecast Quality Scoring",
          "long_description": "Dual-mode alpine alpenglow (topographic prominence & solar aspect hillshading) and landscape golden hour forecast.",
          "score_description": "\u2022 80-100 (Vivid/Burn): Unobstructed low-angle solar beam illuminating prominent peaks or landscapes with intense warm golden and crimson light.\n\u2022 60-79 (Above Average): Strong direct golden hour illumination with favorable atmospheric clarity and minimal horizon blockage.\n\u2022 40-59 (Average/Clear): Clean standard golden hour light on exposed terrain slopes and ridges.\n\u2022 31-39 (Below Average): Filtered or partially attenuated low-angle sunlight due to cloud bands or haze.\n\u2022 21-30 (Muted): Weak, diffused twilight illumination with heavy cloud filtering along the solar path.\n\u2022 0-20 (Poor/Occluded): Direct solar beam blocked by terrain shadow, dense low cloud decks, or precipitation.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "output_models": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toast_title": "Golden Hour & Alpenglow 10-Day Forecast",
          "toast_subtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toast_description": "Models low-angle direct solar beam transmission and topographic mountain peak illumination up to 10 days out using multi-model NWP cloud and moisture forecasts.",
          "nowcast_toast_title": "Golden Hour & Alpenglow Live NowCast",
          "nowcast_toast_subtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcast_toast_description": "Uses live GOES satellite imagery and radar optical flow (T+2h/4h/6h) to score low-angle golden hour light transmission and peak alpenglow for the next upcoming twilight event.",
          "basemapOverride": {
            "mode": "dark"
          },
          "longDescription": "Dual-mode alpine alpenglow (topographic prominence & solar aspect hillshading) and landscape golden hour forecast.",
          "scoreDescription": "\u2022 80-100 (Vivid/Burn): Unobstructed low-angle solar beam illuminating prominent peaks or landscapes with intense warm golden and crimson light.\n\u2022 60-79 (Above Average): Strong direct golden hour illumination with favorable atmospheric clarity and minimal horizon blockage.\n\u2022 40-59 (Average/Clear): Clean standard golden hour light on exposed terrain slopes and ridges.\n\u2022 31-39 (Below Average): Filtered or partially attenuated low-angle sunlight due to cloud bands or haze.\n\u2022 21-30 (Muted): Weak, diffused twilight illumination with heavy cloud filtering along the solar path.\n\u2022 0-20 (Poor/Occluded): Direct solar beam blocked by terrain shadow, dense low cloud decks, or precipitation.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "outputModels": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toastTitle": "Golden Hour & Alpenglow 10-Day Forecast",
          "toastSubtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toastDescription": "Models low-angle direct solar beam transmission and topographic mountain peak illumination up to 10 days out using multi-model NWP cloud and moisture forecasts.",
          "nowcastToastTitle": "Golden Hour & Alpenglow Live NowCast",
          "nowcastToastSubtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcastToastDescription": "Uses live GOES satellite imagery and radar optical flow (T+2h/4h/6h) to score low-angle golden hour light transmission and peak alpenglow for the next upcoming twilight event."
        },
        {
          "id": "darkskies_bortle",
          "label": "Dark Sky Forecast",
          "product": "darkskies",
          "model": "blend",
          "icon": "\u2728",
          "category": "sky_solar",
          "description": "Hourly forecast of clear sky conditions incorporating Bortle score, numerous atmospheric conditions, lunar phase/position, and more.",
          "basemap_override": {
            "mode": "dark",
            "terrain_3d": false
          },
          "category_label": "Forecast Quality Scoring",
          "long_description": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
          "score_description": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "World Atlas Light Pollution"
          ],
          "output_models": [
            "blend",
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "toast_title": "Dark Skies Stargazing Forecast",
          "toast_subtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
          "toast_description": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score.",
          "basemapOverride": {
            "mode": "dark",
            "terrain3d": false
          },
          "longDescription": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
          "scoreDescription": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "World Atlas Light Pollution"
          ],
          "outputModels": [
            "blend",
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "toastTitle": "Dark Skies Stargazing Forecast",
          "toastSubtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
          "toastDescription": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score."
        },
        {
          "id": "aurora_viewline",
          "label": "Aurora Borealis",
          "product": "aurora",
          "icon": "\ud83c\udf0c",
          "category": "sky_solar",
          "description": "Auroral oval extent & Northern Lights visibility horizon forecast.",
          "category_label": "Space Weather & Astronomical",
          "long_description": "Auroral oval Extent & Kp Index Northern Lights visibility forecast.",
          "score_description": "\u2022 Overhead Auroral Oval (Green to Red Probability): Direct geomagnetic storm auroral precipitation probability.\n\u2022 Southern Viewline Horizon: The southernmost latitude where the Northern Lights can be seen low on the northern horizon under clear, dark skies.\n\u2022 Kp 0\u20133 (Quiet): Confined to far northern polar latitudes.\n\u2022 Kp 4\u20135 (Active to G1 Minor Storm): Visible across Canada and northern tier US states.\n\u2022 Kp 6\u20139 (G2 Moderate to G5 Extreme Storm): Mid-latitude aurora borealis expansion.",
          "source_models": [
            "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index (Kp) Forecast"
          ],
          "output_models": [
            "aurora_YYYY-MM-DD.pmtiles",
            "aurora_viewline_YYYY-MM-DD.json",
            "noaa_kp_forecast.json"
          ],
          "toast_title": "Aurora Borealis Viewline & Kp Forecast",
          "toast_subtitle": "NOAA SWPC GEOMAGNETIC STORM OUTLOOK",
          "toast_description": "Maps the southern aurora visibility horizon and geomagnetic Kp-index probabilities driven by real-time solar wind telemetry.",
          "longDescription": "Auroral oval Extent & Kp Index Northern Lights visibility forecast.",
          "scoreDescription": "\u2022 Overhead Auroral Oval (Green to Red Probability): Direct geomagnetic storm auroral precipitation probability.\n\u2022 Southern Viewline Horizon: The southernmost latitude where the Northern Lights can be seen low on the northern horizon under clear, dark skies.\n\u2022 Kp 0\u20133 (Quiet): Confined to far northern polar latitudes.\n\u2022 Kp 4\u20135 (Active to G1 Minor Storm): Visible across Canada and northern tier US states.\n\u2022 Kp 6\u20139 (G2 Moderate to G5 Extreme Storm): Mid-latitude aurora borealis expansion.",
          "categoryLabel": "Space Weather & Astronomical",
          "sourceModels": [
            "NOAA Space Weather Prediction Center (SWPC) 3-Day Planetary K-index (Kp) Forecast"
          ],
          "outputModels": [
            "aurora_YYYY-MM-DD.pmtiles",
            "aurora_viewline_YYYY-MM-DD.json",
            "noaa_kp_forecast.json"
          ],
          "toastTitle": "Aurora Borealis Viewline & Kp Forecast",
          "toastSubtitle": "NOAA SWPC GEOMAGNETIC STORM OUTLOOK",
          "toastDescription": "Maps the southern aurora visibility horizon and geomagnetic Kp-index probabilities driven by real-time solar wind telemetry."
        },
        {
          "id": "seeing",
          "label": "Astronomical Seeing",
          "product": "seeing",
          "model": "rdps",
          "icon": "\ud83d\udd2d",
          "category": "sky_solar",
          "description": "Atmospheric optical stability and wavefront steadiness modeling turbulent optical distortion across night hours (0-100 score).",
          "category_label": "Specialized Forecast Index",
          "long_description": "Atmospheric optical stability predicting wavefront steadiness, jet stream shear, boundary layer turbulence, and telescope resolution.",
          "score_description": "\u2022 80\u2013100 (Excellent / Sub-Arcsecond Stability): Calm upper-level winds and minimal thermal gradients; crisp planetary detail and pinpoint stars.\n\u2022 60\u201379 (Good Seeing): Slight atmospheric shimmer; well-suited for deep-sky imaging and medium-to-high magnification.\n\u2022 40\u201359 (Average / Moderate Turbulence): Noticeable star twinkling (scintillation) and softening of fine lunar/planetary features.\n\u2022 0\u201339 (Poor / Turbulent Jet Stream Shear): Strong vertical wind shear or boundary-layer mixing causing rapid wavefront distortion.",
          "source_models": [
            "rdps",
            "hrrr",
            "rrfs",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "rdps & hrrr .pmtiles"
          ],
          "toast_title": "Astronomical Seeing & Jet Stream Stability",
          "toast_subtitle": "OPTICAL TURBULENCE & THERMAL SHEAR",
          "toast_description": "Evaluates atmospheric optical stability for planetary imaging and high-magnification stargazing based on vertical wind shear and thermal gradients.",
          "longDescription": "Atmospheric optical stability predicting wavefront steadiness, jet stream shear, boundary layer turbulence, and telescope resolution.",
          "scoreDescription": "\u2022 80\u2013100 (Excellent / Sub-Arcsecond Stability): Calm upper-level winds and minimal thermal gradients; crisp planetary detail and pinpoint stars.\n\u2022 60\u201379 (Good Seeing): Slight atmospheric shimmer; well-suited for deep-sky imaging and medium-to-high magnification.\n\u2022 40\u201359 (Average / Moderate Turbulence): Noticeable star twinkling (scintillation) and softening of fine lunar/planetary features.\n\u2022 0\u201339 (Poor / Turbulent Jet Stream Shear): Strong vertical wind shear or boundary-layer mixing causing rapid wavefront distortion.",
          "categoryLabel": "Specialized Forecast Index",
          "sourceModels": [
            "rdps",
            "hrrr",
            "rrfs",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "rdps & hrrr .pmtiles"
          ],
          "toastTitle": "Astronomical Seeing & Jet Stream Stability",
          "toastSubtitle": "OPTICAL TURBULENCE & THERMAL SHEAR",
          "toastDescription": "Evaluates atmospheric optical stability for planetary imaging and high-magnification stargazing based on vertical wind shear and thermal gradients."
        },
        {
          "id": "precip_forecast",
          "label": "Precipitation Forecast",
          "product": "precip",
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Hourly and daily rain and snow forecasts.",
          "category_label": "Core Meteorological",
          "long_description": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "score_description": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "source_models": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "output_models": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toast_title": "Precipitation Rate, Probability & Snow",
          "toast_subtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toast_description": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models.",
          "longDescription": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "scoreDescription": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "outputModels": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toastTitle": "Precipitation Rate, Probability & Snow",
          "toastSubtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toastDescription": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models."
        },
        {
          "id": "thunderstorm",
          "label": "Thunderstorm Probability",
          "product": "thunderstorm",
          "model": "blend",
          "icon": "\u26a1",
          "category": "precipitation",
          "description": "Thunderstorm probability (0-100%) combining atmospheric instability (CAPE), cap strength (CIN), and convective triggers.",
          "category_label": "Core Meteorological",
          "long_description": "Convective storm lightning probability & flash density forecast. Shows area where conditions will be favorable for lightning.",
          "score_description": "\u2022 Slight / Isolated Risk (10\u201330% - Cool Teal/Green): Weak convective instability; isolated rumbles or brief mountain afternoon showers possible.\n\u2022 Moderate Thunderstorm Risk (35\u201365% - Yellow to Orange): Elevated CAPE and lifting; scattered thunderstorms and cloud-to-ground lightning likely.\n\u2022 High / Severe Convective Risk (70\u2013100% - Red to Magenta): Strong atmospheric instability and updraft helicity; widespread thunderstorms and frequent lightning.",
          "source_models": [
            "hrrr",
            "rrfs",
            "ecmwf",
            "gfs",
            "MRMS NLDN (Obs)"
          ],
          "output_models": [
            "Lightning risk .pmtiles per model",
            "Real-time MRMS flash density"
          ],
          "toast_title": "Lightning & Convective Hazard",
          "toast_subtitle": "CONVECTIVE CAPE & FLASH DENSITY POTENTIAL",
          "toast_description": "Quantifies thunderstorm instability and lightning strike hazard using convective available potential energy (CAPE) and updraft helicity.",
          "longDescription": "Convective storm lightning probability & flash density forecast. Shows area where conditions will be favorable for lightning.",
          "scoreDescription": "\u2022 Slight / Isolated Risk (10\u201330% - Cool Teal/Green): Weak convective instability; isolated rumbles or brief mountain afternoon showers possible.\n\u2022 Moderate Thunderstorm Risk (35\u201365% - Yellow to Orange): Elevated CAPE and lifting; scattered thunderstorms and cloud-to-ground lightning likely.\n\u2022 High / Severe Convective Risk (70\u2013100% - Red to Magenta): Strong atmospheric instability and updraft helicity; widespread thunderstorms and frequent lightning.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "ecmwf",
            "gfs",
            "MRMS NLDN (Obs)"
          ],
          "outputModels": [
            "Lightning risk .pmtiles per model",
            "Real-time MRMS flash density"
          ],
          "toastTitle": "Lightning & Convective Hazard",
          "toastSubtitle": "CONVECTIVE CAPE & FLASH DENSITY POTENTIAL",
          "toastDescription": "Quantifies thunderstorm instability and lightning strike hazard using convective available potential energy (CAPE) and updraft helicity."
        },
        {
          "id": "precip_radar",
          "label": "Doppler Radar",
          "product": "live_weather",
          "model": "mrms",
          "icon": "\ud83d\udce1",
          "category": "precipitation",
          "description": "Near real time doppler radar",
          "basemap_override": {
            "terrain_3d": false
          },
          "category_label": "Real-Time Observation",
          "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "source_models": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "output_models": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toast_title": "Live NOAA MRMS Doppler Radar",
          "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
          "basemapOverride": {
            "terrain3d": false
          },
          "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "outputModels": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toastTitle": "Live NOAA MRMS Doppler Radar",
          "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
        },
        {
          "id": "lightning_live",
          "label": "Lightning Activity (Observed)",
          "product": "live_weather",
          "model": "mrms_lightning",
          "icon": "\u26a1",
          "category": "precipitation",
          "description": "Rolling 8-hour 5-minute lightning strikes scaled by flash density and age (yellow to gray).",
          "long_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "category_label": "Real-Time Observation",
          "score_description": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "source_models": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "output_models": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toast_title": "Live Lightning Strikes (8-Hour Trail)",
          "toast_subtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toast_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.",
          "longDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "scoreDescription": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "outputModels": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toastTitle": "Live Lightning Strikes (8-Hour Trail)",
          "toastSubtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toastDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes."
        },
        {
          "id": "precip_accum",
          "label": "Precipitation Accumulation (Past 1-7 Days)",
          "product": "precip_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP precipitation accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "long_description": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "source_models": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toast_title": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toast_subtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toast_description": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation.",
          "longDescription": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toastSubtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toastDescription": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation."
        },
        {
          "id": "snow_accum",
          "label": "Snowfall Accumulation (Past 1-7 Days)",
          "product": "snow_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf28\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP snowfall accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "long_description": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "source_models": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toast_title": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toast_subtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toast_description": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows.",
          "longDescription": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toastSubtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toastDescription": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows."
        },
        {
          "id": "clouds",
          "label": "Cloud Forecast",
          "product": "clouds",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud forecasts.",
          "long_description": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "category_label": "Core Meteorological",
          "score_description": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "source_models": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "output_models": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toast_title": "Cloud Cover Forecast",
          "toast_subtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toast_description": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures.",
          "longDescription": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "scoreDescription": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "outputModels": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toastTitle": "Cloud Cover Forecast",
          "toastSubtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toastDescription": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures."
        },
        {
          "id": "cloud_base",
          "label": "Cloud Base Elevation",
          "product": "cloud_base",
          "model": "nbm",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud base elevation (MSL) critical for climbing, hiking, and photography",
          "long_description": "Cloud Base Elevation maps the absolute Mean Sea Level (MSL) altitude of the lowest cloud deck across the landscape.\n\nKnowing the exact cloud base altitude is critical for backcountry hikers, mountaineers, climbers, and landscape photographers. It indicates the exact elevation where trails enter fog, rain, and whiteout conditions, and reveals when summits, ridgelines, and alpine passes are clear of cloud cover.\n\nThe layer uses high-resolution National Blend of Models (NOAA NBM) aviation ceiling and lowest cloud base fields combined with high-resolution digital elevation modeling. Clear skies with absent or high cirrus clouds are rendered transparent so the underlying terrain remains visible, while active cloud decks are rendered with a continuous elevation gradient from sea level up to 16,000 ft MSL.",
          "score_description": "\u2022 Purple/Violet (0 - 3,000 ft MSL): Very low cloud base or sea-level marine stratus and coastal fog.\n\u2022 Blue to Cyan (3,000 - 6,000 ft MSL): Low-to-mid mountain cloud deck covering foothills and lower trailheads.\n\u2022 Teal to Emerald Green (6,000 - 9,000 ft MSL): Subalpine cloud ceiling; peaks above 9,000 ft extend above the clouds.\n\u2022 Yellow to Amber (9,000 - 12,000 ft MSL): High-altitude mountain cloud deck; alpine terrain below 9,000 ft remains in clear air.\n\u2022 Orange to Red/Magenta (12,000 - 16,000+ ft MSL): High cloud bases; only the highest continental summits are obscured.\n\u2022 Transparent: Clear skies (no low cloud deck or ceiling detected).",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Cloud Base Elevation (.pmtiles)"
          ],
          "toast_title": "Cloud Base Altitude (MSL)",
          "toast_subtitle": "LOWEST CLOUD CEILING ELEVATION",
          "toast_description": "Maps the Mean Sea Level (MSL) elevation of the lowest cloud ceiling so hikers and photographers know whether summits are clear or in the clouds.",
          "longDescription": "Cloud Base Elevation maps the absolute Mean Sea Level (MSL) altitude of the lowest cloud deck across the landscape.\n\nKnowing the exact cloud base altitude is critical for backcountry hikers, mountaineers, climbers, and landscape photographers. It indicates the exact elevation where trails enter fog, rain, and whiteout conditions, and reveals when summits, ridgelines, and alpine passes are clear of cloud cover.\n\nThe layer uses high-resolution National Blend of Models (NOAA NBM) aviation ceiling and lowest cloud base fields combined with high-resolution digital elevation modeling. Clear skies with absent or high cirrus clouds are rendered transparent so the underlying terrain remains visible, while active cloud decks are rendered with a continuous elevation gradient from sea level up to 16,000 ft MSL.",
          "scoreDescription": "\u2022 Purple/Violet (0 - 3,000 ft MSL): Very low cloud base or sea-level marine stratus and coastal fog.\n\u2022 Blue to Cyan (3,000 - 6,000 ft MSL): Low-to-mid mountain cloud deck covering foothills and lower trailheads.\n\u2022 Teal to Emerald Green (6,000 - 9,000 ft MSL): Subalpine cloud ceiling; peaks above 9,000 ft extend above the clouds.\n\u2022 Yellow to Amber (9,000 - 12,000 ft MSL): High-altitude mountain cloud deck; alpine terrain below 9,000 ft remains in clear air.\n\u2022 Orange to Red/Magenta (12,000 - 16,000+ ft MSL): High cloud bases; only the highest continental summits are obscured.\n\u2022 Transparent: Clear skies (no low cloud deck or ceiling detected).",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Cloud Base Elevation (.pmtiles)"
          ],
          "toastTitle": "Cloud Base Altitude (MSL)",
          "toastSubtitle": "LOWEST CLOUD CEILING ELEVATION",
          "toastDescription": "Maps the Mean Sea Level (MSL) elevation of the lowest cloud ceiling so hikers and photographers know whether summits are clear or in the clouds."
        },
        {
          "id": "cloud_inversion",
          "label": "Valley Clouds / Sea of Clouds",
          "product": "cloud_inversion",
          "model": "nbm",
          "icon": "\ud83c\udfd4\ufe0f",
          "category": "clouds_wind",
          "description": "Reveals low cloud decks/deep fog below mountainous terrain.",
          "long_description": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
          "score_description": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Cloud Inversion / Sea of Clouds (.pmtiles)"
          ],
          "toast_title": "Sea of Clouds (Cloud Inversion)",
          "toast_subtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
          "toast_description": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas.",
          "longDescription": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
          "scoreDescription": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Cloud Inversion / Sea of Clouds (.pmtiles)"
          ],
          "toastTitle": "Sea of Clouds (Cloud Inversion)",
          "toastSubtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
          "toastDescription": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas."
        },
        {
          "id": "winds_surface",
          "label": "Surface Winds Forecast",
          "product": "winds",
          "model": "blend",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Forecasted Surface Winds (10m)",
          "category_label": "Core Meteorological",
          "long_description": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "score_description": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toast_title": "Surface Winds & Gusts",
          "toast_subtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toast_description": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models.",
          "longDescription": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "scoreDescription": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toastTitle": "Surface Winds & Gusts",
          "toastSubtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toastDescription": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models."
        },
        {
          "id": "lenticular_clouds",
          "label": "Lenticular Cloud Probability",
          "product": "lenticular",
          "model": "ensemble",
          "icon": "\ud83d\udef8",
          "category": "clouds_wind",
          "description": "Identifies favorable conditions for lenticular cloud formation indicating turbulent conditions near mountain peaks.",
          "long_description": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
          "category_label": "Forecast Quality Scoring",
          "score_description": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
          "source_models": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "output_models": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "toast_title": "Lenticular Wave Cloud Forecast",
          "toast_subtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
          "toast_description": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks.",
          "longDescription": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
          "scoreDescription": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "outputModels": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "toastTitle": "Lenticular Wave Cloud Forecast",
          "toastSubtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
          "toastDescription": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks."
        },
        {
          "id": "valley_fog",
          "label": "Surface Fog",
          "product": "valley_fog",
          "model": "hrrr",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "clouds_wind",
          "description": "Ground level radiation fog.",
          "category_label": "Core Meteorological",
          "long_description": "Radiation & inversion valley fog formation risk. Forecasts likelihood of low lying fog development.",
          "score_description": "\u2022 20\u201340% (Patchy Mist / Shallow Ground Fog): Localized fog forming in low meadows, river bottoms, and marshlands near dawn.\n\u2022 45\u201370% (Moderate Valley Fog): Cohesive radiation or advection fog bank pooling in sheltered valleys.\n\u2022 75\u2013100% (Dense Radiation / Inversion Fog): High probability of thick boundary-layer fog filling valley floors under a stable nocturnal inversion.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "nbm",
            "gdps"
          ],
          "output_models": [
            "Fog probability .pmtiles per model"
          ],
          "toast_title": "Valley Fog & Radiation Fog Probability",
          "toast_subtitle": "TERRAIN-TRAPPED BOUNDARY LAYER FOG",
          "toast_description": "Identifies nocturnal temperature inversions, boundary-layer saturation, and topographic cold-air drainage to forecast low-lying valley fog and sea-of-clouds events.",
          "longDescription": "Radiation & inversion valley fog formation risk. Forecasts likelihood of low lying fog development.",
          "scoreDescription": "\u2022 20\u201340% (Patchy Mist / Shallow Ground Fog): Localized fog forming in low meadows, river bottoms, and marshlands near dawn.\n\u2022 45\u201370% (Moderate Valley Fog): Cohesive radiation or advection fog bank pooling in sheltered valleys.\n\u2022 75\u2013100% (Dense Radiation / Inversion Fog): High probability of thick boundary-layer fog filling valley floors under a stable nocturnal inversion.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "nbm",
            "gdps"
          ],
          "outputModels": [
            "Fog probability .pmtiles per model"
          ],
          "toastTitle": "Valley Fog & Radiation Fog Probability",
          "toastSubtitle": "TERRAIN-TRAPPED BOUNDARY LAYER FOG",
          "toastDescription": "Identifies nocturnal temperature inversions, boundary-layer saturation, and topographic cold-air drainage to forecast low-lying valley fog and sea-of-clouds events."
        },
        {
          "id": "satellite_imagery",
          "label": "Satellite Imagery (Vis & IR)",
          "product": "live_weather",
          "model": "goes",
          "icon": "\ud83d\udef0\ufe0f",
          "category": "clouds_wind",
          "description": "High-frequency visible and infrared geostationary satellite cloud loops.",
          "category_label": "Real-Time Observation",
          "long_description": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "score_description": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "source_models": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "output_models": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toast_title": "Live Geostationary Satellite Imagery",
          "toast_subtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toast_description": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems.",
          "longDescription": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "scoreDescription": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "outputModels": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toastTitle": "Live Geostationary Satellite Imagery",
          "toastSubtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toastDescription": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems."
        },
        {
          "id": "winds_surface_current",
          "label": "Surface Winds (Current)",
          "product": "live_weather",
          "model": "rtma_winds",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Current and recently observed surface winds.",
          "category_label": "Real-Time Observation",
          "long_description": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "score_description": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "source_models": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "output_models": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toast_title": "Current Surface Winds (Live RTMA)",
          "toast_subtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toast_description": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines.",
          "longDescription": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "scoreDescription": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "outputModels": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toastTitle": "Current Surface Winds (Live RTMA)",
          "toastSubtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toastDescription": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines."
        },
        {
          "id": "hrtemp_current",
          "label": "Current Temperature (RTMA)",
          "product": "hrtemp_current",
          "model": "rtma",
          "icon": "\ud83c\udf21\ufe0f",
          "category": "temperature",
          "description": "Real-time NOAA RTMA 2.5km surface temperature observations.",
          "category_label": "Real-Time Observation",
          "long_description": "Real-time surface temperature observations derived from NOAA Real-Time Mesoscale Analysis (RTMA 2.5km).",
          "score_description": "\u2022 High-Resolution 2.5km Grid: Blends surface weather station observations with topographic elevation modeling to map current temperatures across peaks and valleys.\n\u2022 Isotherm Contours: Optional 5\u00b0F contour lines highlighting sharp thermal fronts and freezing boundaries.",
          "source_models": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "output_models": [
            "Real-time 2.5km surface temperature .pmtiles"
          ],
          "toast_title": "Current Surface Temperature (Live RTMA)",
          "toast_subtitle": "2.5KM TERRAIN-ANALYZED OBSERVATIONS",
          "toast_description": "Maps current real-time 2-meter air temperatures at 2.5km resolution using NOAA Real-Time Mesoscale Analysis.",
          "longDescription": "Real-time surface temperature observations derived from NOAA Real-Time Mesoscale Analysis (RTMA 2.5km).",
          "scoreDescription": "\u2022 High-Resolution 2.5km Grid: Blends surface weather station observations with topographic elevation modeling to map current temperatures across peaks and valleys.\n\u2022 Isotherm Contours: Optional 5\u00b0F contour lines highlighting sharp thermal fronts and freezing boundaries.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "outputModels": [
            "Real-time 2.5km surface temperature .pmtiles"
          ],
          "toastTitle": "Current Surface Temperature (Live RTMA)",
          "toastSubtitle": "2.5KM TERRAIN-ANALYZED OBSERVATIONS",
          "toastDescription": "Maps current real-time 2-meter air temperatures at 2.5km resolution using NOAA Real-Time Mesoscale Analysis."
        },
        {
          "id": "wx_stations",
          "label": "Weather Station Observations",
          "product": "wx_stations",
          "model": "metar",
          "icon": "\ud83d\udce1",
          "category": "temperature",
          "description": "Real-time 5-min NOAA METAR/ASOS surface weather station observations & 14-day history charts.",
          "category_label": "Surface Weather Observations",
          "long_description": "Real-time surface weather observations (5-minute cadence) from ~7,300+ global NOAA Aviation Weather Center (METAR / ASOS / AWOS) and backcountry US Interagency RAWS mountain/wilderness weather stations with interactive Today, 7-Day, and 14-Day telemetry charts.",
          "score_description": "\u2022 Selectable Telemetry Badges: Switch station badges between Temperature, Wind Speed, Wind Gusts, Dew Point, Relative Humidity, Pressure, and Visibility.\n\u2022 Historical Trend Charts: Click any station to inspect 24-Hour, 7-Day, and 14-Day observed temperature, wind, and precipitation history.",
          "source_models": [
            "NOAA Aviation Weather Center (AWC) METAR / ASOS / AWOS Feed",
            "NIFC Interagency Remote Automatic Weather Stations (PublicView_RAWS)",
            "NOAA HADS / NWS & Iowa Environmental Mesonet Historical Archives"
          ],
          "output_models": [
            "Progressive-zoom WebGL station markers & readout badges",
            "Interactive 24H / 7-Day / 14-Day surface observation trend charts"
          ],
          "toast_title": "Live Weather Stations (METAR & RAWS)",
          "toast_subtitle": "REAL-TIME 5-MIN SURFACE TELEMETRY",
          "toast_description": "Displays live observations from 7,300+ airport METAR and backcountry mountain RAWS weather stations with 14-day historical charts.",
          "longDescription": "Real-time surface weather observations (5-minute cadence) from ~7,300+ global NOAA Aviation Weather Center (METAR / ASOS / AWOS) and backcountry US Interagency RAWS mountain/wilderness weather stations with interactive Today, 7-Day, and 14-Day telemetry charts.",
          "scoreDescription": "\u2022 Selectable Telemetry Badges: Switch station badges between Temperature, Wind Speed, Wind Gusts, Dew Point, Relative Humidity, Pressure, and Visibility.\n\u2022 Historical Trend Charts: Click any station to inspect 24-Hour, 7-Day, and 14-Day observed temperature, wind, and precipitation history.",
          "categoryLabel": "Surface Weather Observations",
          "sourceModels": [
            "NOAA Aviation Weather Center (AWC) METAR / ASOS / AWOS Feed",
            "NIFC Interagency Remote Automatic Weather Stations (PublicView_RAWS)",
            "NOAA HADS / NWS & Iowa Environmental Mesonet Historical Archives"
          ],
          "outputModels": [
            "Progressive-zoom WebGL station markers & readout badges",
            "Interactive 24H / 7-Day / 14-Day surface observation trend charts"
          ],
          "toastTitle": "Live Weather Stations (METAR & RAWS)",
          "toastSubtitle": "REAL-TIME 5-MIN SURFACE TELEMETRY",
          "toastDescription": "Displays live observations from 7,300+ airport METAR and backcountry mountain RAWS weather stations with 14-day historical charts."
        },
        {
          "id": "hrtemp",
          "label": "Temperature Forecast",
          "product": "hrtemp",
          "model": "nbm",
          "icon": "\ud83c\udf21\ufe0f",
          "category": "temperature",
          "description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "category_label": "Core Meteorological",
          "long_description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "score_description": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Surface temperature .pmtiles per model"
          ],
          "toast_title": "Terrain-Corrected Surface Temperature",
          "toast_subtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toast_description": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures.",
          "longDescription": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "scoreDescription": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Surface temperature .pmtiles per model"
          ],
          "toastTitle": "Terrain-Corrected Surface Temperature",
          "toastSubtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toastDescription": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures."
        },
        {
          "id": "windchill",
          "label": "Wind Chill Index",
          "product": "windchill",
          "icon": "\ud83e\udd76",
          "category": "temperature",
          "description": "Wind chill forecast.",
          "category_label": "Core Meteorological",
          "long_description": "Apparent temperature / wind chill index.",
          "score_description": "\u2022 32\u00b0F to 15\u00b0F (Chilly - Light Blue): Dress in warm windproof layers.\n\u2022 15\u00b0F to -15\u00b0F (Bitter Cold - Deep Blue/Violet): Frostbite risk on exposed skin within 30 minutes under strong winds.\n\u2022 Below -20\u00b0F (Extreme Cold Hazard - Magenta/Purple): Life-threatening wind chill; frostbite can occur on exposed skin in under 10\u201315 minutes.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Wind chill .pmtiles per model"
          ],
          "toast_title": "Wind Chill & Apparent Temperature",
          "toast_subtitle": "FEELS-LIKE COLD EXPOSURE INDEX",
          "toast_description": "Combines air temperature and 10-meter wind speed to calculate feels-like wind chill temperatures and alpine frostbite risk.",
          "longDescription": "Apparent temperature / wind chill index.",
          "scoreDescription": "\u2022 32\u00b0F to 15\u00b0F (Chilly - Light Blue): Dress in warm windproof layers.\n\u2022 15\u00b0F to -15\u00b0F (Bitter Cold - Deep Blue/Violet): Frostbite risk on exposed skin within 30 minutes under strong winds.\n\u2022 Below -20\u00b0F (Extreme Cold Hazard - Magenta/Purple): Life-threatening wind chill; frostbite can occur on exposed skin in under 10\u201315 minutes.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Wind chill .pmtiles per model"
          ],
          "toastTitle": "Wind Chill & Apparent Temperature",
          "toastSubtitle": "FEELS-LIKE COLD EXPOSURE INDEX",
          "toastDescription": "Combines air temperature and 10-meter wind speed to calculate feels-like wind chill temperatures and alpine frostbite risk."
        },
        {
          "id": "relative_humidity",
          "label": "Relative Humidity",
          "product": "relative_humidity",
          "icon": "\ud83d\udca7",
          "category": "temperature",
          "description": "Relative Humidity forecast.",
          "category_label": "Core Meteorological",
          "long_description": "2m Surface Relative Humidity percentage.",
          "score_description": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Surface RH .pmtiles per model"
          ],
          "toast_title": "Surface Relative Humidity (RH%)",
          "toast_subtitle": "2-METER ATMOSPHERIC SATURATION",
          "toast_description": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions.",
          "longDescription": "2m Surface Relative Humidity percentage.",
          "scoreDescription": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Surface RH .pmtiles per model"
          ],
          "toastTitle": "Surface Relative Humidity (RH%)",
          "toastSubtitle": "2-METER ATMOSPHERIC SATURATION",
          "toastDescription": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions."
        },
        {
          "id": "freezing_level",
          "label": "Freezing Level",
          "product": "freezing_level",
          "model": "hrrr",
          "icon": "\ud83e\uddca",
          "category": "temperature",
          "description": "Freezing level forecast.",
          "category_label": "Core Meteorological",
          "long_description": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
          "score_description": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Altitude (Meters MSL) .pmtiles per model"
          ],
          "toast_title": "Freezing Level Altitude (0\u00b0C Isotherm)",
          "toast_subtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
          "toast_description": "Displays the forecasted elevation where air temperature reaches freezing.",
          "longDescription": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
          "scoreDescription": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Altitude (Meters MSL) .pmtiles per model"
          ],
          "toastTitle": "Freezing Level Altitude (0\u00b0C Isotherm)",
          "toastSubtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
          "toastDescription": "Displays the forecasted elevation where air temperature reaches freezing."
        },
        {
          "id": "sun_intensity_forecast",
          "label": "Solar Intensity Forecast",
          "product": "sun_intensity",
          "icon": "\u2600\ufe0f",
          "category": "temperature",
          "description": "Surface downwelling solar irradiance forecast (W/m\u00b2) across numerical weather models.",
          "category_label": "Core Meteorological",
          "long_description": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "score_description": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "source_models": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "output_models": [
            "Solar Intensity .pmtiles per model"
          ],
          "toast_title": "Solar Intensity & Surface Irradiance",
          "toast_subtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toast_description": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation.",
          "longDescription": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "scoreDescription": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "outputModels": [
            "Solar Intensity .pmtiles per model"
          ],
          "toastTitle": "Solar Intensity & Surface Irradiance",
          "toastSubtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toastDescription": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation."
        },
        {
          "id": "optics_dew_risk",
          "label": "Optics Fogging Potential",
          "product": "optics_dew_risk",
          "icon": "\ud83d\udcf7",
          "category": "temperature",
          "description": "Likelihood of optics (Camera lenses and Telescopes) fogging.",
          "category_label": "Specialized Forecast Index",
          "long_description": "Dew point depression & lens/telescope fogging risk index. Indicates where fogging on lenses is likely for telescope and camera users.",
          "score_description": "\u2022 Low Risk (0\u201325%): Large spread between air temperature and dew point or sufficient breeze to prevent radiative surface cooling.\n\u2022 Moderate Risk (25\u201360%): Narrowing dewpoint depression under clear skies; lens hoods recommended for long timelapses.\n\u2022 High / Severe Condensation Risk (60\u2013100%): Exposed glass and metal surfaces cool below the ambient dew point via clear-sky infrared radiation; active dew heaters required.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "blend & hrrr .pmtiles"
          ],
          "toast_title": "Camera & Telescope Optics Dew Risk",
          "toast_subtitle": "RADIATIVE COOLING CONDENSATION HAZARD",
          "toast_description": "Predicts the likelihood of condensation forming on exposed camera lenses and telescope optics based on dewpoint depression, wind speed, and clear-sky radiative cooling.",
          "longDescription": "Dew point depression & lens/telescope fogging risk index. Indicates where fogging on lenses is likely for telescope and camera users.",
          "scoreDescription": "\u2022 Low Risk (0\u201325%): Large spread between air temperature and dew point or sufficient breeze to prevent radiative surface cooling.\n\u2022 Moderate Risk (25\u201360%): Narrowing dewpoint depression under clear skies; lens hoods recommended for long timelapses.\n\u2022 High / Severe Condensation Risk (60\u2013100%): Exposed glass and metal surfaces cool below the ambient dew point via clear-sky infrared radiation; active dew heaters required.",
          "categoryLabel": "Specialized Forecast Index",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "blend & hrrr .pmtiles"
          ],
          "toastTitle": "Camera & Telescope Optics Dew Risk",
          "toastSubtitle": "RADIATIVE COOLING CONDENSATION HAZARD",
          "toastDescription": "Predicts the likelihood of condensation forming on exposed camera lenses and telescope optics based on dewpoint depression, wind speed, and clear-sky radiative cooling."
        },
        {
          "id": "smoke_forecast",
          "label": "Wildfire Smoke",
          "product": "smoke",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "air_quality_fires",
          "description": "Wildfire smoke forecasts for North America.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "score_description": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "source_models": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "output_models": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toast_title": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toast_subtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toast_description": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation.",
          "longDescription": "Shows forecasted Surface Smoke Concentration & Vertically Integrated Smoke.",
          "scoreDescription": "\u2022 Surface Smoke (PM2.5 \u00b5g/m\u00b3): Near-ground breathable smoke concentration affecting hiking health, ground visibility, and local air quality.\n\u2022 Vertically Integrated Smoke (Column mg/m\u00b2): Total smoke mass suspended from the ground to the top of the troposphere, responsible for hazy skies, red suns, and muted twilight colors even when surface air is clean.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "raqdps (Canadian AQ)",
            "rrfs (Smoke)",
            "hrrr (3km Smoke)"
          ],
          "outputModels": [
            "Smoke density .pmtiles per model (Surface & Column levels)"
          ],
          "toastTitle": "Wildfire Smoke & Vertically Integrated PM2.5",
          "toastSubtitle": "NEAR-SURFACE & COLUMN SMOKE PLUMES",
          "toastDescription": "Tracks wildfire smoke dispersion at the surface and aloft to assess air quality impacts, hazy golden hours, and visibility degradation."
        },
        {
          "id": "aqi_index",
          "label": "AQI Forecast",
          "product": "aqi",
          "icon": "\ud83e\udec1",
          "category": "air_quality_fires",
          "description": "Air quality forecast.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "score_description": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "source_models": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "output_models": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toast_title": "Air Quality Index (AQI) Forecast",
          "toast_subtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toast_description": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone.",
          "longDescription": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "scoreDescription": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "outputModels": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toastTitle": "Air Quality Index (AQI) Forecast",
          "toastSubtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toastDescription": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone."
        },
        {
          "id": "aqi_stations",
          "label": "AQI Station Data",
          "product": "live_weather",
          "model": "aqi_stations",
          "icon": "\ud83e\udec1",
          "category": "air_quality_fires",
          "description": "Near real time AQI station data.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Near-real-time hourly Air Quality Index (AQI) and PM2.5/Ozone pollutant observations from official US EPA AirNow, USFS permanent and temporary smoke monitors, and Canadian AQHI monitoring stations.",
          "score_description": "\u2022 0\u201350 (Good - Green): Clean breathable air.\n\u2022 51\u2013100 (Moderate - Yellow): Slight particulate or ozone elevation.\n\u2022 101\u2013150 (USG - Orange): Unhealthy for sensitive groups.\n\u2022 151\u2013200 (Unhealthy - Red): Widespread smoke or pollution impact.\n\u2022 201+ (Very Unhealthy / Hazardous - Purple/Maroon): Severe smoke plume impact at surface sensors.",
          "source_models": [
            "US EPA AirNow Real-Time Telemetry",
            "USFS AirFire Smoke Monitors",
            "ECCC Canadian AQHI Network"
          ],
          "output_models": [
            "Real-time AQI observation station markers & telemetry"
          ],
          "toast_title": "Live Air Quality Monitoring Stations",
          "toast_subtitle": "REAL-TIME EPA AIRNOW & SMOKE SENSORS",
          "toast_description": "Displays live hourly AQI readings from ground-level EPA AirNow and USFS air quality monitoring stations.",
          "longDescription": "Near-real-time hourly Air Quality Index (AQI) and PM2.5/Ozone pollutant observations from official US EPA AirNow, USFS permanent and temporary smoke monitors, and Canadian AQHI monitoring stations.",
          "scoreDescription": "\u2022 0\u201350 (Good - Green): Clean breathable air.\n\u2022 51\u2013100 (Moderate - Yellow): Slight particulate or ozone elevation.\n\u2022 101\u2013150 (USG - Orange): Unhealthy for sensitive groups.\n\u2022 151\u2013200 (Unhealthy - Red): Widespread smoke or pollution impact.\n\u2022 201+ (Very Unhealthy / Hazardous - Purple/Maroon): Severe smoke plume impact at surface sensors.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "US EPA AirNow Real-Time Telemetry",
            "USFS AirFire Smoke Monitors",
            "ECCC Canadian AQHI Network"
          ],
          "outputModels": [
            "Real-time AQI observation station markers & telemetry"
          ],
          "toastTitle": "Live Air Quality Monitoring Stations",
          "toastSubtitle": "REAL-TIME EPA AIRNOW & SMOKE SENSORS",
          "toastDescription": "Displays live hourly AQI readings from ground-level EPA AirNow and USFS air quality monitoring stations."
        },
        {
          "id": "wildfires",
          "label": "Wildfire Perimeters & Info",
          "product": "wildfires",
          "icon": "\ud83d\udd25",
          "category": "air_quality_fires",
          "description": "Active US (NIFC) and Canadian (CWFIS) wildfire perimeters & incident info.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Displays active wildfire perimeters across the United States (NIFC) and Canada (CWFIS), alongside near-real-time satellite thermal anomaly hotspots detected by NASA VIIRS instruments (375m resolution). Includes acreage, containment progress, and incident reporting.",
          "score_description": "\u2022 Active Fire Perimeters (Red/Orange Polygons): Official mapped incident burn boundaries from NIFC WFIGS and Canadian CWFIS with acreage and % containment.\n\u2022 VIIRS Thermal Hotspots (Glowing Dots): Satellite-detected 375m infrared heat signatures indicating active fire fronts and flare-ups.",
          "source_models": [
            "NIFC WFIGS (National Interagency Fire Center)",
            "CWFIS (Canadian Wildland Fire Information System)",
            "NASA FIRMS VIIRS (375m Active Fire Detections)"
          ],
          "output_models": [
            "Vector Perimeters & Point Hotspots GeoJSON"
          ],
          "toast_title": "Active Wildfire Perimeters & Incidents",
          "toast_subtitle": "NIFC, CWFIS & NASA VIIRS DETECTIONS",
          "toast_description": "Maps active US and Canadian wildfire burn perimeters, containment percentages, incident details, and satellite thermal hotspots.",
          "longDescription": "Displays active wildfire perimeters across the United States (NIFC) and Canada (CWFIS), alongside near-real-time satellite thermal anomaly hotspots detected by NASA VIIRS instruments (375m resolution). Includes acreage, containment progress, and incident reporting.",
          "scoreDescription": "\u2022 Active Fire Perimeters (Red/Orange Polygons): Official mapped incident burn boundaries from NIFC WFIGS and Canadian CWFIS with acreage and % containment.\n\u2022 VIIRS Thermal Hotspots (Glowing Dots): Satellite-detected 375m infrared heat signatures indicating active fire fronts and flare-ups.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "NIFC WFIGS (National Interagency Fire Center)",
            "CWFIS (Canadian Wildland Fire Information System)",
            "NASA FIRMS VIIRS (375m Active Fire Detections)"
          ],
          "outputModels": [
            "Vector Perimeters & Point Hotspots GeoJSON"
          ],
          "toastTitle": "Active Wildfire Perimeters & Incidents",
          "toastSubtitle": "NIFC, CWFIS & NASA VIIRS DETECTIONS",
          "toastDescription": "Maps active US and Canadian wildfire burn perimeters, containment percentages, incident details, and satellite thermal hotspots."
        },
        {
          "id": "wildfire_hotspots",
          "label": "Satellite Hotspots",
          "product": "wildfires",
          "model": "firms_hotspots",
          "icon": "\ud83d\udce1",
          "category": "air_quality_fires",
          "description": "Hot spots detected by satellite.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Near-real-time satellite thermal anomaly hotspots detected by NASA/NOAA Suomi-NPP and NOAA-20/21 VIIRS (375m) and MODIS (1km) instruments, highlighting active wildfire fronts, spot fires, and radiative heat intensity (FRP).",
          "score_description": "\u2022 Recent Detections (<6h - Bright Red/Yellow): Fresh satellite overpass thermal detections indicating active flaming fronts.\n\u2022 6\u201324h Detections (Orange): Active burning detected within the past day.\n\u2022 Fire Radiative Power (FRP): Measured in Megawatts (MW), indicating thermal intensity of the sub-pixel heat source.",
          "source_models": [
            "NASA FIRMS VIIRS (375m Active Fire Detections)",
            "NOAA NESDIS HMS Fire & Smoke Product"
          ],
          "output_models": [
            "Satellite Thermal Anomaly Hotspots GeoJSON"
          ],
          "toast_title": "Satellite Wildfire Thermal Hotspots",
          "toast_subtitle": "375M NASA VIIRS INFRARED DETECTIONS",
          "toast_description": "Pinpoints near-real-time 375-meter satellite infrared heat detections to track active wildfire expansion before perimeters are mapped.",
          "longDescription": "Near-real-time satellite thermal anomaly hotspots detected by NASA/NOAA Suomi-NPP and NOAA-20/21 VIIRS (375m) and MODIS (1km) instruments, highlighting active wildfire fronts, spot fires, and radiative heat intensity (FRP).",
          "scoreDescription": "\u2022 Recent Detections (<6h - Bright Red/Yellow): Fresh satellite overpass thermal detections indicating active flaming fronts.\n\u2022 6\u201324h Detections (Orange): Active burning detected within the past day.\n\u2022 Fire Radiative Power (FRP): Measured in Megawatts (MW), indicating thermal intensity of the sub-pixel heat source.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "NASA FIRMS VIIRS (375m Active Fire Detections)",
            "NOAA NESDIS HMS Fire & Smoke Product"
          ],
          "outputModels": [
            "Satellite Thermal Anomaly Hotspots GeoJSON"
          ],
          "toastTitle": "Satellite Wildfire Thermal Hotspots",
          "toastSubtitle": "375M NASA VIIRS INFRARED DETECTIONS",
          "toastDescription": "Pinpoints near-real-time 375-meter satellite infrared heat detections to track active wildfire expansion before perimeters are mapped."
        },
        {
          "id": "fire_restrictions",
          "label": "Fire Restrictions (USFS/BLM/NPS)",
          "product": "fire_restrictions",
          "icon": "\ud83d\udd25\ud83d\udeab",
          "category": "air_quality_fires",
          "description": "Camp Fire restrictions.",
          "long_description": "Provides data from land management agencies around what fire restrictions, if any, are currently in place.\n\nAggregates active campfire bans, Stage 1 and Stage 2 fire restrictions, industrial fire precaution levels, and area closures across US Forest Service (USFS), Bureau of Land Management (BLM), National Park Service (NPS), BIA, USFWS, and state forestry jurisdictions.",
          "category_label": "Public Lands & Wildfire Safety",
          "score_description": "\u2022 Stage 1 Fire Restrictions (Yellow/Amber): Campfires restricted to developed agency-approved fire rings; smoking and spark-emitting equipment restricted.\n\u2022 Stage 2 Fire Restrictions (Orange/Red): All wood and charcoal campfires prohibited (including developed campgrounds); pressurized liquid/gas stoves with shutoff valves typically permitted.\n\u2022 Stage 3 / Area Closure (Magenta/Dark Red): Extreme fire danger closure or complete prohibition of all ignition sources.",
          "source_models": [
            "NIFC / Interagency Fire Restrictions Feeds (USFS, BLM, NPS, BIA, State)"
          ],
          "output_models": [
            "Jurisdictional Fire Restriction Polygons & Order Summaries GeoJSON"
          ],
          "toast_title": "Public Land Fire Restrictions",
          "toast_subtitle": "USFS, BLM, NPS & STATE CAMPFIRE ORDERS",
          "toast_description": "Maps active Stage 1 and Stage 2 campfire bans and agency fire restriction orders across federal and state public lands.",
          "longDescription": "Provides data from land management agencies around what fire restrictions, if any, are currently in place.\n\nAggregates active campfire bans, Stage 1 and Stage 2 fire restrictions, industrial fire precaution levels, and area closures across US Forest Service (USFS), Bureau of Land Management (BLM), National Park Service (NPS), BIA, USFWS, and state forestry jurisdictions.",
          "scoreDescription": "\u2022 Stage 1 Fire Restrictions (Yellow/Amber): Campfires restricted to developed agency-approved fire rings; smoking and spark-emitting equipment restricted.\n\u2022 Stage 2 Fire Restrictions (Orange/Red): All wood and charcoal campfires prohibited (including developed campgrounds); pressurized liquid/gas stoves with shutoff valves typically permitted.\n\u2022 Stage 3 / Area Closure (Magenta/Dark Red): Extreme fire danger closure or complete prohibition of all ignition sources.",
          "categoryLabel": "Public Lands & Wildfire Safety",
          "sourceModels": [
            "NIFC / Interagency Fire Restrictions Feeds (USFS, BLM, NPS, BIA, State)"
          ],
          "outputModels": [
            "Jurisdictional Fire Restriction Polygons & Order Summaries GeoJSON"
          ],
          "toastTitle": "Public Land Fire Restrictions",
          "toastSubtitle": "USFS, BLM, NPS & STATE CAMPFIRE ORDERS",
          "toastDescription": "Maps active Stage 1 and Stage 2 campfire bans and agency fire restriction orders across federal and state public lands."
        },
        {
          "id": "snow_depth",
          "label": "Snow Depth & SNOTEL",
          "product": "snow_depth",
          "icon": "\u2744\ufe0f",
          "category": "hydrology",
          "description": "Observed snowpack depth & SNOTEL telemetry",
          "category_label": "Hydrology & Mountain Weather",
          "long_description": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
          "score_description": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
          "source_models": [
            "NOAA SNODAS 1km Snow Analysis",
            "USDA NRCS SNOTEL Telemetry",
            "ECCC & BC Snow Pillow Network"
          ],
          "output_models": [
            "Continuous mountain snowpack gradient",
            "Live SNOTEL observation stations"
          ],
          "toast_title": "Snow Depth & Live SNOTEL Stations",
          "toast_subtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
          "toast_description": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements.",
          "longDescription": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
          "scoreDescription": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
          "categoryLabel": "Hydrology & Mountain Weather",
          "sourceModels": [
            "NOAA SNODAS 1km Snow Analysis",
            "USDA NRCS SNOTEL Telemetry",
            "ECCC & BC Snow Pillow Network"
          ],
          "outputModels": [
            "Continuous mountain snowpack gradient",
            "Live SNOTEL observation stations"
          ],
          "toastTitle": "Snow Depth & Live SNOTEL Stations",
          "toastSubtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
          "toastDescription": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements."
        },
        {
          "id": "avalanche_danger",
          "label": "Avalanche Danger (USFS NAC)",
          "product": "avalanche",
          "icon": "\ud83c\udfd4\ufe0f\u26a0\ufe0f",
          "category": "hydrology",
          "description": "Live avalanche danger ratings & official bulletins",
          "basemap_override": {
            "theme": "usgs-topo"
          },
          "category_label": "Backcountry & Alpine Safety",
          "long_description": "Official daily backcountry avalanche danger ratings, avalanche problem types, elevation rose diagrams, and forecaster bulletins aggregated from the USFS National Avalanche Center (NAC) and regional avalanche centers across North America.",
          "score_description": "\u2022 1 - Low (Green): Generally safe avalanche conditions; watch for unstable snow on isolated terrain features.\n\u2022 2 - Moderate (Yellow): Heightened avalanche conditions on specific terrain features; evaluate snow and terrain carefully.\n\u2022 3 - Considerable (Orange): Dangerous avalanche conditions; careful snowpack evaluation, conservative decision-making, and cautious route-finding essential.\n\u2022 4 - High (Red): Very dangerous avalanche conditions; travel in avalanche terrain not recommended.\n\u2022 5 - Extreme (Black/Maroon): Avoid all avalanche terrain; natural and human-triggered avalanches certain.",
          "source_models": [
            "USFS National Avalanche Center (NAC) API",
            "Regional Backcountry Avalanche Forecast Centers"
          ],
          "output_models": [
            "Interactive Avalanche Forecast Zone Polygons & Official Bulletins"
          ],
          "toast_title": "Backcountry Avalanche Danger (NAC)",
          "toast_subtitle": "OFFICIAL NORTH AMERICAN AVALANCHE RATINGS",
          "toast_description": "Displays live official avalanche danger ratings (1-Low to 5-Extreme) and backcountry forecast bulletins by mountain zone.",
          "basemapOverride": {
            "theme": "usgs-topo"
          },
          "longDescription": "Official daily backcountry avalanche danger ratings, avalanche problem types, elevation rose diagrams, and forecaster bulletins aggregated from the USFS National Avalanche Center (NAC) and regional avalanche centers across North America.",
          "scoreDescription": "\u2022 1 - Low (Green): Generally safe avalanche conditions; watch for unstable snow on isolated terrain features.\n\u2022 2 - Moderate (Yellow): Heightened avalanche conditions on specific terrain features; evaluate snow and terrain carefully.\n\u2022 3 - Considerable (Orange): Dangerous avalanche conditions; careful snowpack evaluation, conservative decision-making, and cautious route-finding essential.\n\u2022 4 - High (Red): Very dangerous avalanche conditions; travel in avalanche terrain not recommended.\n\u2022 5 - Extreme (Black/Maroon): Avoid all avalanche terrain; natural and human-triggered avalanches certain.",
          "categoryLabel": "Backcountry & Alpine Safety",
          "sourceModels": [
            "USFS National Avalanche Center (NAC) API",
            "Regional Backcountry Avalanche Forecast Centers"
          ],
          "outputModels": [
            "Interactive Avalanche Forecast Zone Polygons & Official Bulletins"
          ],
          "toastTitle": "Backcountry Avalanche Danger (NAC)",
          "toastSubtitle": "OFFICIAL NORTH AMERICAN AVALANCHE RATINGS",
          "toastDescription": "Displays live official avalanche danger ratings (1-Low to 5-Extreme) and backcountry forecast bulletins by mountain zone."
        },
        {
          "id": "streamflow_gauges",
          "label": "Stream & Reservoir Flows",
          "product": "streamflow",
          "icon": "\ud83c\udf0a",
          "category": "hydrology",
          "description": "Stream and reservoir levels, flow rates, temperature.",
          "category_label": "Hydrology & Inland Waters",
          "long_description": "Real-time USGS river and stream telemetry monitoring flow discharge rates (cfs), gauge height, and water temperatures.",
          "score_description": "\u2022 Percentile Color Mode (% of Historical Normal): Colors gauges from extreme low flow (Red/Orange) through normal flow (Green) to high/flood flow (Blue/Purple).\n\u2022 Flow & Storage Mode: Displays absolute river discharge (cfs) and reservoir storage capacity.\n\u2022 Water Temperature Mode: Displays live river and lake water temperatures (\u00b0F/\u00b0C) for anglers and paddlers.",
          "source_models": [
            "USGS National Water Information System (NWIS) Telemetry"
          ],
          "output_models": [
            "Streamflow station telemetry markers",
            "Inland water temperature raster"
          ],
          "toast_title": "Live Streamflow, Reservoirs & Water Temp",
          "toast_subtitle": "REAL-TIME USGS NWIS HYDROLOGY GAUGES",
          "toast_description": "Monitors real-time river discharge (cfs), historical flow percentiles, reservoir levels, and water temperatures across thousands of gauges.",
          "longDescription": "Real-time USGS river and stream telemetry monitoring flow discharge rates (cfs), gauge height, and water temperatures.",
          "scoreDescription": "\u2022 Percentile Color Mode (% of Historical Normal): Colors gauges from extreme low flow (Red/Orange) through normal flow (Green) to high/flood flow (Blue/Purple).\n\u2022 Flow & Storage Mode: Displays absolute river discharge (cfs) and reservoir storage capacity.\n\u2022 Water Temperature Mode: Displays live river and lake water temperatures (\u00b0F/\u00b0C) for anglers and paddlers.",
          "categoryLabel": "Hydrology & Inland Waters",
          "sourceModels": [
            "USGS National Water Information System (NWIS) Telemetry"
          ],
          "outputModels": [
            "Streamflow station telemetry markers",
            "Inland water temperature raster"
          ],
          "toastTitle": "Live Streamflow, Reservoirs & Water Temp",
          "toastSubtitle": "REAL-TIME USGS NWIS HYDROLOGY GAUGES",
          "toastDescription": "Monitors real-time river discharge (cfs), historical flow percentiles, reservoir levels, and water temperatures across thousands of gauges."
        },
        {
          "id": "sst",
          "label": "Sea Surface Temperature",
          "product": "sst",
          "icon": "\ud83c\udf0a",
          "category": "hydrology",
          "description": "Observed sea surface temperature.",
          "category_label": "Marine & Oceanographic",
          "long_description": "High-resolution sea surface water temperatures coupled with NOAA NDBC real-time buoy observations.",
          "score_description": "\u2022 5km SST Raster: Daily satellite-blended ocean and Great Lakes surface water temperatures.\n\u2022 Live NDBC Marine Buoys: Click any offshore or coastal buoy to view real-time water temperature, wave height, dominant swell period, and marine winds.",
          "source_models": [
            "NOAA Coral Reef Watch (CRW) 5km SST",
            "NOAA NDBC Marine Buoy Stations"
          ],
          "output_models": [
            "SST temperature .pmtiles",
            "Live marine buoy observation telemetry"
          ],
          "toast_title": "Sea Surface Temperature & Marine Buoys",
          "toast_subtitle": "5KM SATELLITE SST & LIVE NDBC BUOYS",
          "toast_description": "Combines high-resolution satellite sea surface water temperatures with live coastal and offshore NOAA marine buoy telemetry.",
          "longDescription": "High-resolution sea surface water temperatures coupled with NOAA NDBC real-time buoy observations.",
          "scoreDescription": "\u2022 5km SST Raster: Daily satellite-blended ocean and Great Lakes surface water temperatures.\n\u2022 Live NDBC Marine Buoys: Click any offshore or coastal buoy to view real-time water temperature, wave height, dominant swell period, and marine winds.",
          "categoryLabel": "Marine & Oceanographic",
          "sourceModels": [
            "NOAA Coral Reef Watch (CRW) 5km SST",
            "NOAA NDBC Marine Buoy Stations"
          ],
          "outputModels": [
            "SST temperature .pmtiles",
            "Live marine buoy observation telemetry"
          ],
          "toastTitle": "Sea Surface Temperature & Marine Buoys",
          "toastSubtitle": "5KM SATELLITE SST & LIVE NDBC BUOYS",
          "toastDescription": "Combines high-resolution satellite sea surface water temperatures with live coastal and offshore NOAA marine buoy telemetry."
        },
        {
          "id": "foliage",
          "label": "Fall Foliage Forecast",
          "product": "foliage",
          "icon": "\ud83c\udf41",
          "category": "phenology",
          "description": "Daily refreshed forecast for fall foliage timing and intensity.",
          "category_label": "Seasonal Phenology",
          "long_description": "The Fall Foliage forecast provides a comprehensive set of visual tools to help autumn travelers, hikers, and photographers plan their trips:\n\n\u2022 PEAK DATE - Displays a continental map of the projected calendar date when peak autumn color first arrives at each location. Colors transition chronologically from early September 15 peaks (green), through yellow, gold, orange, red, and brown, to mid-November (grey). Toggle between Full Landscape and Treed Regions Only, or click any location to see its exact projected peak date.\n\n\u2022 DETAILED TIMING / CALENDAR - Shows an interactive calendar providing an at-a-glance seasonal color progression for any selected location, alongside daily continental maps showing color evolution from green canopy to peak foliage. Toggle between Full Landscape and Treed Regions Only to inspect regional forests.\n\n\u2022 VIBRANCY THIS SEASON - Displays anticipated differences in peak color brilliance and saturation compared to an average season. Evaluates cool crisp nights (which trap anthocyanin red pigments), bright sunny days (which power sugar production), summer drought scorch, and wind penalties.\n\n\u2022 CANOPY COVER - Displays satellite-measured tree canopy density (USGS NLCD & NALCMS) to show where broadleaf deciduous and mixed hardwood forests are concentrated across North America.\n\n\u2022 TREE SPECIES - Maps native forest distributions for key autumn tree families, including Scarlet Red Maples, Canary Gold Aspens & Birches, Bronze Oaks & Beeches, and Golden Larches/Tamaracks.\n\n\u2022 HEAT ANOMALY - Shows summer mean temperature departures compared to 30-year climate normals. Excessive summer heat stress damages leaf chlorophyll and can cause early scorching or dull browning.\n\n\u2022 MOISTURE - Shows summer root-zone soil moisture anomalies compared to normal (from NOAA CPC). Soil moisture plays a critical role in tree health: severe drought causes premature leaf drop and muted colors, whereas healthy summer moisture supports vibrant displays.\n\nHow the Forecast Works & Data Timeline:\nOur biophysical phenology model continuously integrates seasonal growing conditions, real-time weather observations, and short-term numerical forecasts:\n\u2022 Antecedent Inputs: Summer soil moisture and heat stress define baseline tree vitality and drought resilience.\n\u2022 Observed Weather: Ground-truth daily minimum temperatures from NOAA URMA lock in chilling accumulation through September and October.\n\u2022 5-to-7 Day Forecasts: Short-term weather predictions from NOAA NDFD drive active chilling and color onset. Note that forecasts 5 to 7 days out are dynamic and subject to update as weather systems shift.\n\u2022 Long-Range Horizon: Dates beyond the short-term forecast window are guided by 30-year PRISM climatological normals for long-range trip planning.",
          "score_description": "\u2022 Above Normal / Enhanced Vibrancy: Plentiful sunny afternoons, crisp above-freezing nights (34\u00b0F to 45\u00b0F), and calm winds promote intense anthocyanin pigment production, rich saturation, and extended peak retention with minimal early leaf drop.\n\u2022 Average / Typical Vibrancy: Expected baseline autumn coloration aligned with 30-year historical climate norms for the region and species mix.\n\u2022 Below Normal / Reduced Vibrancy: Unseasonably warm nights (preventing sugar trapping), severe summer drought scorch, persistent cloudy rain, or premature killing freezes produce muted, dull, or brown-tinted foliage.",
          "source_models": [
            "NOAA URMA (Observed Daily Tmin)",
            "NOAA NDFD (5-7 Day Weather Forecast)",
            "PRISM (30-Yr Daily Climatology Normals)",
            "NOAA CPC (Soil Moisture Anomalies)",
            "NASA Daymet (Solar Irradiance Normals)",
            "USGS NLCD & Tree Species Atlas"
          ],
          "output_models": [
            "Peak Color Arrival by Date (foliage_peak_date.pmtiles)",
            "Peak Color Arrival - Treed Only (foliage_peak_date_treed.pmtiles)",
            "Daily Color Progression (foliage_{date}.pmtiles)",
            "Seasonal Vibrancy Departure (foliage_vibrancy.pmtiles)",
            "Deciduous Tree Canopy Density (foliage_canopy.pmtiles)",
            "Native Tree Species Distribution (foliage_species.pmtiles)",
            "Summer Temperature Anomaly (foliage_summer_temp_anomaly.pmtiles)",
            "Summer Soil Moisture Anomaly (foliage_soil_moisture_anomaly.pmtiles)"
          ],
          "toast_title": "Fall Foliage Timing & Vibrancy Forecast",
          "toast_subtitle": "BIOPHYSICAL AUTUMN PHENOLOGY MODEL",
          "toast_description": "Tracks projected peak autumn foliage dates, daily color progression, tree species habitats, and seasonal color vibrancy across North America.",
          "longDescription": "The Fall Foliage forecast provides a comprehensive set of visual tools to help autumn travelers, hikers, and photographers plan their trips:\n\n\u2022 PEAK DATE - Displays a continental map of the projected calendar date when peak autumn color first arrives at each location. Colors transition chronologically from early September 15 peaks (green), through yellow, gold, orange, red, and brown, to mid-November (grey). Toggle between Full Landscape and Treed Regions Only, or click any location to see its exact projected peak date.\n\n\u2022 DETAILED TIMING / CALENDAR - Shows an interactive calendar providing an at-a-glance seasonal color progression for any selected location, alongside daily continental maps showing color evolution from green canopy to peak foliage. Toggle between Full Landscape and Treed Regions Only to inspect regional forests.\n\n\u2022 VIBRANCY THIS SEASON - Displays anticipated differences in peak color brilliance and saturation compared to an average season. Evaluates cool crisp nights (which trap anthocyanin red pigments), bright sunny days (which power sugar production), summer drought scorch, and wind penalties.\n\n\u2022 CANOPY COVER - Displays satellite-measured tree canopy density (USGS NLCD & NALCMS) to show where broadleaf deciduous and mixed hardwood forests are concentrated across North America.\n\n\u2022 TREE SPECIES - Maps native forest distributions for key autumn tree families, including Scarlet Red Maples, Canary Gold Aspens & Birches, Bronze Oaks & Beeches, and Golden Larches/Tamaracks.\n\n\u2022 HEAT ANOMALY - Shows summer mean temperature departures compared to 30-year climate normals. Excessive summer heat stress damages leaf chlorophyll and can cause early scorching or dull browning.\n\n\u2022 MOISTURE - Shows summer root-zone soil moisture anomalies compared to normal (from NOAA CPC). Soil moisture plays a critical role in tree health: severe drought causes premature leaf drop and muted colors, whereas healthy summer moisture supports vibrant displays.\n\nHow the Forecast Works & Data Timeline:\nOur biophysical phenology model continuously integrates seasonal growing conditions, real-time weather observations, and short-term numerical forecasts:\n\u2022 Antecedent Inputs: Summer soil moisture and heat stress define baseline tree vitality and drought resilience.\n\u2022 Observed Weather: Ground-truth daily minimum temperatures from NOAA URMA lock in chilling accumulation through September and October.\n\u2022 5-to-7 Day Forecasts: Short-term weather predictions from NOAA NDFD drive active chilling and color onset. Note that forecasts 5 to 7 days out are dynamic and subject to update as weather systems shift.\n\u2022 Long-Range Horizon: Dates beyond the short-term forecast window are guided by 30-year PRISM climatological normals for long-range trip planning.",
          "scoreDescription": "\u2022 Above Normal / Enhanced Vibrancy: Plentiful sunny afternoons, crisp above-freezing nights (34\u00b0F to 45\u00b0F), and calm winds promote intense anthocyanin pigment production, rich saturation, and extended peak retention with minimal early leaf drop.\n\u2022 Average / Typical Vibrancy: Expected baseline autumn coloration aligned with 30-year historical climate norms for the region and species mix.\n\u2022 Below Normal / Reduced Vibrancy: Unseasonably warm nights (preventing sugar trapping), severe summer drought scorch, persistent cloudy rain, or premature killing freezes produce muted, dull, or brown-tinted foliage.",
          "categoryLabel": "Seasonal Phenology",
          "sourceModels": [
            "NOAA URMA (Observed Daily Tmin)",
            "NOAA NDFD (5-7 Day Weather Forecast)",
            "PRISM (30-Yr Daily Climatology Normals)",
            "NOAA CPC (Soil Moisture Anomalies)",
            "NASA Daymet (Solar Irradiance Normals)",
            "USGS NLCD & Tree Species Atlas"
          ],
          "outputModels": [
            "Peak Color Arrival by Date (foliage_peak_date.pmtiles)",
            "Peak Color Arrival - Treed Only (foliage_peak_date_treed.pmtiles)",
            "Daily Color Progression (foliage_{date}.pmtiles)",
            "Seasonal Vibrancy Departure (foliage_vibrancy.pmtiles)",
            "Deciduous Tree Canopy Density (foliage_canopy.pmtiles)",
            "Native Tree Species Distribution (foliage_species.pmtiles)",
            "Summer Temperature Anomaly (foliage_summer_temp_anomaly.pmtiles)",
            "Summer Soil Moisture Anomaly (foliage_soil_moisture_anomaly.pmtiles)"
          ],
          "toastTitle": "Fall Foliage Timing & Vibrancy Forecast",
          "toastSubtitle": "BIOPHYSICAL AUTUMN PHENOLOGY MODEL",
          "toastDescription": "Tracks projected peak autumn foliage dates, daily color progression, tree species habitats, and seasonal color vibrancy across North America."
        },
        {
          "id": "mushrooms",
          "label": "Wild Mushroom Foraging",
          "product": "mushrooms",
          "icon": "\ud83c\udf44",
          "category": "phenology",
          "description": "Active fruiting flushes and 7-day outlook updated daily.",
          "category_label": "Seasonal Phenology",
          "long_description": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
          "score_description": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
          "source_models": [
            "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
            "NOAA NBM / HRRR Soil & Surface Temperature",
            "USGS NLCD & Forest Host Species Habitat Maps"
          ],
          "output_models": [
            "Species-Specific Fruiting Probability Tiles (.pmtiles)",
            "7-Day Foraging Flush Outlook"
          ],
          "toast_title": "Wild Mushroom Foraging Forecast",
          "toast_subtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
          "toast_description": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats.",
          "longDescription": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
          "scoreDescription": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
          "categoryLabel": "Seasonal Phenology",
          "sourceModels": [
            "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
            "NOAA NBM / HRRR Soil & Surface Temperature",
            "USGS NLCD & Forest Host Species Habitat Maps"
          ],
          "outputModels": [
            "Species-Specific Fruiting Probability Tiles (.pmtiles)",
            "7-Day Foraging Flush Outlook"
          ],
          "toastTitle": "Wild Mushroom Foraging Forecast",
          "toastSubtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
          "toastDescription": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats."
        },
        {
          "id": "alpine_wildflowers",
          "label": "Wildflowers (Mountain/Alpine)",
          "product": "alpine_wildflowers",
          "icon": "\ud83c\udf38",
          "category": "phenology",
          "description": "Peak bloom timing & intensity",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts bloom onset, peak floral concurrency, bloom duration, and display intensity (Mountain Bloom Intensity Index, MBII) for alpine and subalpine herbaceous perennials.\n\nDriven by winter snowpack insulation, dynamic snowmelt biofix (SWE <= 0), and post-melt growing degree days (GDD) with elevation lapse-rate corrections.\n\nIncludes multi-species coverage (Arrowleaf Balsamroot, Subalpine Lupine, Indian Paintbrush, Avalanche Lily), dual domain support (North America 2.5km and Global Alpine 13km), and interactive summer calendar and multi-species concurrency curves.",
          "score_description": "\u2022 Snowbound / Pre-Melt (Icy Cyan): Terrain still insulated under winter snowpack.\n\u2022 Emerging / Vegetative (Fresh Green): Post-melt vegetative green-up and bud initiation.\n\u2022 Early Bloom (Lime Yellow): Initial floral bud opening (15-30% open).\n\u2022 Peak Concurrency (Magenta / Rose): Broadfield meadow bloom display (60-100% open).\n\u2022 Past Peak (Amber / Orange): Seed maturation and petal drop.\n\u2022 MBII Intensity (Gold to Hot Pink): Mountain Bloom Intensity factoring floral synchrony, insulation, frost risk, and snowmelt sub-irrigation.",
          "source_models": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "output_models": [
            "Alpine Wildflowers (.pmtiles)"
          ],
          "toast_title": "Alpine & Mountain Wildflowers Forecast",
          "toast_subtitle": "SNOWMELT BIOFIX & GDD PHENOLOGY",
          "toast_description": "Predicts alpine meadow bloom timing, peak multi-species concurrency, and Mountain Bloom Intensity (MBII) following winter snowmelt.",
          "longDescription": "Predicts bloom onset, peak floral concurrency, bloom duration, and display intensity (Mountain Bloom Intensity Index, MBII) for alpine and subalpine herbaceous perennials.\n\nDriven by winter snowpack insulation, dynamic snowmelt biofix (SWE <= 0), and post-melt growing degree days (GDD) with elevation lapse-rate corrections.\n\nIncludes multi-species coverage (Arrowleaf Balsamroot, Subalpine Lupine, Indian Paintbrush, Avalanche Lily), dual domain support (North America 2.5km and Global Alpine 13km), and interactive summer calendar and multi-species concurrency curves.",
          "scoreDescription": "\u2022 Snowbound / Pre-Melt (Icy Cyan): Terrain still insulated under winter snowpack.\n\u2022 Emerging / Vegetative (Fresh Green): Post-melt vegetative green-up and bud initiation.\n\u2022 Early Bloom (Lime Yellow): Initial floral bud opening (15-30% open).\n\u2022 Peak Concurrency (Magenta / Rose): Broadfield meadow bloom display (60-100% open).\n\u2022 Past Peak (Amber / Orange): Seed maturation and petal drop.\n\u2022 MBII Intensity (Gold to Hot Pink): Mountain Bloom Intensity factoring floral synchrony, insulation, frost risk, and snowmelt sub-irrigation.",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "outputModels": [
            "Alpine Wildflowers (.pmtiles)"
          ],
          "toastTitle": "Alpine & Mountain Wildflowers Forecast",
          "toastSubtitle": "SNOWMELT BIOFIX & GDD PHENOLOGY",
          "toastDescription": "Predicts alpine meadow bloom timing, peak multi-species concurrency, and Mountain Bloom Intensity (MBII) following winter snowmelt."
        },
        {
          "id": "desert_wildflowers",
          "label": "Desert Superbloom & Annuals",
          "product": "desert_wildflowers",
          "icon": "\ud83c\udfdc\ufe0f",
          "category": "phenology",
          "description": "Spring Desert wildflower timing and outlook updated daily.",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts episodic germination probability, storm cadence viability, seasonal precipitation anomalies, and flowering intensity (Bloom Intensity Index, BII) across arid basins and alluvial fans.\n\nModels the 4-phase environmental cascade: autumn seed-leaching storm trigger (>= 20mm), mid-winter storm spacing (<= 18 days), spring thermal maturation, and desert heat scorch resistance.",
          "score_description": "\u2022 Germination / Rosette (Meadow Green): Early basal leaves emerging following soaking rainfall.\n\u2022 Early Blooms (Lime Yellow): Initial desert wash and alluvial fan flowering.\n\u2022 Peak Floral Carpet (Vibrant Rose / Crimson): Peak carpet concurrency across desert valley floors.\n\u2022 Past Peak (Warm Gold): Seed setting and rapid thermal desiccation.\n\u2022 BII Score (0-100): Desert Bloom Intensity measuring superbloom probability and display density.",
          "source_models": [
            "nbm",
            "icon13"
          ],
          "output_models": [
            "Desert Superbloom (.pmtiles)"
          ],
          "toast_title": "Desert Superbloom & Annuals Outlook",
          "toast_subtitle": "ARID GERMINATION & BLOOM INTENSITY",
          "toast_description": "Tracks winter rain germination triggers, storm cadence survival, and spring superbloom intensity across desert basins and washes.",
          "longDescription": "Predicts episodic germination probability, storm cadence viability, seasonal precipitation anomalies, and flowering intensity (Bloom Intensity Index, BII) across arid basins and alluvial fans.\n\nModels the 4-phase environmental cascade: autumn seed-leaching storm trigger (>= 20mm), mid-winter storm spacing (<= 18 days), spring thermal maturation, and desert heat scorch resistance.",
          "scoreDescription": "\u2022 Germination / Rosette (Meadow Green): Early basal leaves emerging following soaking rainfall.\n\u2022 Early Blooms (Lime Yellow): Initial desert wash and alluvial fan flowering.\n\u2022 Peak Floral Carpet (Vibrant Rose / Crimson): Peak carpet concurrency across desert valley floors.\n\u2022 Past Peak (Warm Gold): Seed setting and rapid thermal desiccation.\n\u2022 BII Score (0-100): Desert Bloom Intensity measuring superbloom probability and display density.",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13"
          ],
          "outputModels": [
            "Desert Superbloom (.pmtiles)"
          ],
          "toastTitle": "Desert Superbloom & Annuals Outlook",
          "toastSubtitle": "ARID GERMINATION & BLOOM INTENSITY",
          "toastDescription": "Tracks winter rain germination triggers, storm cadence survival, and spring superbloom intensity across desert basins and washes."
        },
        {
          "id": "wild_berries",
          "label": "Wild Berry Ripening & Foraging",
          "product": "wild_berries",
          "icon": "\ud83e\uded0",
          "category": "phenology",
          "description": "Ripening waves, harvest windows & berry quality updated daily.",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
          "score_description": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
          "source_models": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "output_models": [
            "Wild Berries (.pmtiles)"
          ],
          "toast_title": "Wild Berry Ripening & Foraging",
          "toast_subtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
          "toast_description": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality.",
          "longDescription": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
          "scoreDescription": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "outputModels": [
            "Wild Berries (.pmtiles)"
          ],
          "toastTitle": "Wild Berry Ripening & Foraging",
          "toastSubtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
          "toastDescription": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality."
        },
        {
          "id": "climate_data",
          "label": "Historical Climatology (30-year)",
          "product": "climate",
          "icon": "\ud83d\udcca",
          "category": "extended_climate",
          "is_tool_mode": true,
          "description": "30-year climatological normals & microclimate elevation profiles",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "score_description": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "source_models": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "output_models": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toast_title": "Historical Climatology (30-Year Normals)",
          "toast_subtitle": "1991\u20132020 CLIMATE BASELINE",
          "toast_description": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips.",
          "longDescription": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "scoreDescription": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "outputModels": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toastTitle": "Historical Climatology (30-Year Normals)",
          "toastSubtitle": "1991\u20132020 CLIMATE BASELINE",
          "toastDescription": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips."
        },
        {
          "id": "recent_climate",
          "label": "Recent Climate Data",
          "product": "recent_climate",
          "icon": "\ud83d\uddd3\ufe0f",
          "category": "extended_climate",
          "is_tool_mode": true,
          "description": "Monthly & Year-to-Date observed temperature, precipitation, snowfall, and departures from 1991-2020 normals (2021-present)",
          "long_description": "Recent Climate Data is an interactive multi-year observed climate almanac (2021-present) tracking monthly and Year-to-Date (or Annual) temperature, precipitation, snowfall, and departures from 1991-2020 climatological normals.\n\nPowered by a seamless hybrid stitch of high-resolution NOAA NCEI nClimGrid-Daily (~4.6 km across CONUS) and NOAA PSL/CPC Global Unified Daily observations (0.5 deg across Alaska, Canada, and global land), paired with NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS). Hover anywhere over the map for instant telemetry showing High/Low, Mean Temp, Temp Departure, Total Precip, Normal Precip, % of Normal, Snowfall, and Elevation.",
          "score_description": "\u2022 7 Selectable Layers: Average High, Average Low, Mean Temp, Temp Departure (\u00b1\u00b0F), Total Precip, Precip Departure (\u00b1in & % of normal), and Snowfall (CONUS).\n\u2022 Time Modes: Clickable Jan-Dec monthly views plus Year-to-Date (active year) or Full Annual Summary (completed years 2021-2025+).\n\u2022 Daily Incremental Updates: Automatically refreshes the active calendar month and YTD totals daily as new NOAA observations publish.",
          "category_label": "Extended Climate & Outlooks",
          "source_models": [
            "NOAA NCEI nClimGrid-Daily (~4.6 km CONUS)",
            "NOAA PSL/CPC Global Unified Daily (0.5\u00b0 Global)",
            "NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS)"
          ],
          "output_models": [
            "Monthly & YTD Temperature, Precip, Snow & Departure Rasters (.pmtiles)"
          ],
          "toast_title": "Recent Climate Almanac (2021\u2013Present)",
          "toast_subtitle": "OBSERVED MONTHLY & YTD DEPARTURES",
          "toast_description": "Compare actual monthly and year-to-date temperatures, rainfall, and snowfall from 2021 to the present against 30-year climatological normals.",
          "longDescription": "Recent Climate Data is an interactive multi-year observed climate almanac (2021-present) tracking monthly and Year-to-Date (or Annual) temperature, precipitation, snowfall, and departures from 1991-2020 climatological normals.\n\nPowered by a seamless hybrid stitch of high-resolution NOAA NCEI nClimGrid-Daily (~4.6 km across CONUS) and NOAA PSL/CPC Global Unified Daily observations (0.5 deg across Alaska, Canada, and global land), paired with NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS). Hover anywhere over the map for instant telemetry showing High/Low, Mean Temp, Temp Departure, Total Precip, Normal Precip, % of Normal, Snowfall, and Elevation.",
          "scoreDescription": "\u2022 7 Selectable Layers: Average High, Average Low, Mean Temp, Temp Departure (\u00b1\u00b0F), Total Precip, Precip Departure (\u00b1in & % of normal), and Snowfall (CONUS).\n\u2022 Time Modes: Clickable Jan-Dec monthly views plus Year-to-Date (active year) or Full Annual Summary (completed years 2021-2025+).\n\u2022 Daily Incremental Updates: Automatically refreshes the active calendar month and YTD totals daily as new NOAA observations publish.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "NOAA NCEI nClimGrid-Daily (~4.6 km CONUS)",
            "NOAA PSL/CPC Global Unified Daily (0.5\u00b0 Global)",
            "NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS)"
          ],
          "outputModels": [
            "Monthly & YTD Temperature, Precip, Snow & Departure Rasters (.pmtiles)"
          ],
          "toastTitle": "Recent Climate Almanac (2021\u2013Present)",
          "toastSubtitle": "OBSERVED MONTHLY & YTD DEPARTURES",
          "toastDescription": "Compare actual monthly and year-to-date temperatures, rainfall, and snowfall from 2021 to the present against 30-year climatological normals."
        },
        {
          "id": "tropical_cyclones",
          "label": "Tropical Cyclones & Hazards",
          "product": "tropical",
          "icon": "\ud83c\udf00",
          "category": "extended_climate",
          "description": "NOAA National Hurricane Center (NHC) active tropical cyclone forecast tracks, cones of uncertainty, wind radii swaths, coastal warnings, and GTWO disturbance outlooks",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
          "score_description": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
          "source_models": [
            "NOAA National Hurricane Center (NHC)",
            "Central Pacific Hurricane Center (CPHC)",
            "Automated Tropical Cyclone Forecasting (ATCF) System"
          ],
          "output_models": [
            "NHC Active Tropical Advisory GIS GeoJSON"
          ],
          "toast_title": "Tropical Cyclones & NHC Outlooks",
          "toast_subtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
          "toast_description": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities.",
          "longDescription": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
          "scoreDescription": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "NOAA National Hurricane Center (NHC)",
            "Central Pacific Hurricane Center (CPHC)",
            "Automated Tropical Cyclone Forecasting (ATCF) System"
          ],
          "outputModels": [
            "NHC Active Tropical Advisory GIS GeoJSON"
          ],
          "toastTitle": "Tropical Cyclones & NHC Outlooks",
          "toastSubtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
          "toastDescription": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities."
        }
      ],
      "secondaryLayers": []
    },
    "foraging": {
      "id": "foraging",
      "title": "Mushroom & Berry Foraging",
      "icon": "\ud83c\udf44",
      "description": "14-day rainfall triggers, flush outlook, soil moisture & canopy",
      "defaultBasemap": "terrain-mapterhorn",
      "basemapConfig": {
        "theme": "terrain-mapterhorn",
        "mode": "light",
        "terrain3d": false,
        "shading": "color_tint"
      },
      "isDefault": false,
      "isCustom": false,
      "forecastLayoutRef": "",
      "forecastLayout": {
        "id": "foraging",
        "name": "Mushroom & Berry Foraging",
        "description": "Phenology timing, precipitation accumulation, ground moisture, humidity, and temperature trends",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "widget_1791671289486_518",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "horizon_selector",
              "type": "horizon-selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "3-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "foraging_kpi",
              "type": "kpi-grid",
              "title": "Phenology & Moisture Conditions",
              "col_span": 6,
              "options": {
                "checks": [
                  "obs_precip_24h_in",
                  "relative_humidity_pct",
                  "temps_f",
                  "wind_speed_mph"
                ],
                "description": "At-a-glance environmental threshold indicators evaluating recent rainfall, relative humidity, surface temperature, and wind speed against optimal field activity criteria."
              },
              "description": "At-a-glance environmental threshold indicators evaluating recent rainfall, relative humidity, surface temperature, and wind speed against optimal field activity criteria."
            },
            {
              "id": "foraging_stats",
              "type": "stat-grid",
              "title": "Ground & Forest Indicators",
              "col_span": 6,
              "options": {
                "columns": 2,
                "tiles": [
                  {
                    "key": "obs_precip_24h_in",
                    "label": "24h Rainfall",
                    "sub": "Soil Saturation",
                    "icon": "\ud83c\udf27\ufe0f",
                    "color": "#38bdf8"
                  },
                  {
                    "key": "relative_humidity_pct",
                    "label": "Humidity",
                    "sub": "Spore Germination",
                    "icon": "\ud83d\udca7",
                    "color": "#10b981"
                  },
                  {
                    "key": "temps_f",
                    "label": "Ground Temp",
                    "sub": "Mycelium Active",
                    "icon": "\ud83c\udf21\ufe0f",
                    "color": "#f59e0b"
                  },
                  {
                    "key": "obs_mrms_radar_dbz",
                    "label": "Radar Reflectivity",
                    "sub": "Live Ground Truth",
                    "icon": "\ud83d\udce1",
                    "color": "#a855f7"
                  }
                ],
                "description": "Compact metric tile grid highlighting key environmental variables and real-time ground/canopy indicators for rapid field assessment."
              },
              "description": "Compact metric tile grid highlighting key environmental variables and real-time ground/canopy indicators for rapid field assessment."
            },
            {
              "id": "foraging_meteo",
              "type": "meteogram-card",
              "title": "Precipitation Accumulation vs Temp & Humidity",
              "col_span": 12,
              "options": {
                "height": 380,
                "showNow": true,
                "horizonDays": "3",
                "series": [
                  {
                    "key": "precip_rate_in_h",
                    "type": "bar",
                    "yAxis": "right",
                    "color": "#38bdf8"
                  },
                  {
                    "key": "temps_f",
                    "type": "line",
                    "yAxis": "left",
                    "color": "#10b981"
                  },
                  {
                    "key": "relative_humidity_pct",
                    "type": "line",
                    "dashed": true,
                    "yAxis": "right",
                    "color": "#3b82f6"
                  }
                ],
                "description": "Foraging microclimate meteogram tracking hourly rainfall rate (in/hr, cyan bars), surface air temperature (\u00b0F, green curve on left axis), and relative humidity (%, blue dashed curve on right axis). Sustained high humidity (>75%) following soaking rain events with mild temperatures (45\u201368\u00b0F) triggers prime mycelial pinning and mushroom flushes."
              },
              "description": "Foraging microclimate meteogram tracking hourly rainfall rate (in/hr, cyan bars), surface air temperature (\u00b0F, green curve on left axis), and relative humidity (%, blue dashed curve on right axis). Sustained high humidity (>75%) following soaking rain events with mild temperatures (45\u201368\u00b0F) triggers prime mycelial pinning and mushroom flushes."
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "w_appbar",
              "type": "app-bar",
              "title": "Foraging Location Header",
              "col_span": 12,
              "options": {
                "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
              },
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            {
              "id": "w_horizon",
              "type": "horizon-selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "default": "3-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "w_glance",
              "type": "glance-2x2",
              "title": "Current Conditions",
              "col_span": 4,
              "options": {
                "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
              },
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            {
              "id": "w_foraging_kpi",
              "type": "kpi-grid",
              "title": "Phenology & Moisture Indicators",
              "col_span": 12,
              "options": {
                "checks": [
                  "obs_precip_24h_in",
                  "relative_humidity_pct",
                  "temps_f",
                  "wind_speed_mph"
                ],
                "description": "At-a-glance environmental threshold indicators evaluating recent rainfall, relative humidity, surface temperature, and wind speed against optimal field activity criteria."
              },
              "description": "At-a-glance environmental threshold indicators evaluating recent rainfall, relative humidity, surface temperature, and wind speed against optimal field activity criteria."
            },
            {
              "id": "w_foraging_stats",
              "type": "stat-grid",
              "title": "Soil & Canopy Conditions",
              "col_span": 12,
              "options": {
                "columns": 2,
                "tiles": [
                  {
                    "key": "obs_precip_24h_in",
                    "label": "24h Rainfall",
                    "sub": "Soil Saturation",
                    "icon": "\ud83c\udf27\ufe0f",
                    "color": "#38bdf8"
                  },
                  {
                    "key": "relative_humidity_pct",
                    "label": "Humidity",
                    "sub": "Spore Trigger",
                    "icon": "\ud83d\udca7",
                    "color": "#10b981"
                  }
                ],
                "description": "Compact metric tile grid highlighting key environmental variables and real-time ground/canopy indicators for rapid field assessment."
              },
              "description": "Compact metric tile grid highlighting key environmental variables and real-time ground/canopy indicators for rapid field assessment."
            },
            {
              "id": "w_foraging_meteo",
              "type": "meteogram-card",
              "title": "Rain Rate vs Surface Temp & Humidity",
              "col_span": 12,
              "options": {
                "height": 380,
                "showNow": true,
                "horizonDays": "3",
                "series": [
                  {
                    "key": "precip_rate_in_h",
                    "type": "bar",
                    "yAxis": "right",
                    "color": "#38bdf8"
                  },
                  {
                    "key": "temps_f",
                    "type": "line",
                    "yAxis": "left",
                    "color": "#10b981"
                  },
                  {
                    "key": "relative_humidity_pct",
                    "type": "line",
                    "dashed": true,
                    "yAxis": "right",
                    "color": "#3b82f6"
                  }
                ],
                "description": "Foraging microclimate meteogram tracking hourly rainfall rate (in/hr, cyan bars), surface air temperature (\u00b0F, green curve on left axis), and relative humidity (%, blue dashed curve on right axis). Sustained high humidity (>75%) following soaking rain events with mild temperatures (45\u201368\u00b0F) triggers prime mycelial pinning and mushroom flushes."
              },
              "description": "Foraging microclimate meteogram tracking hourly rainfall rate (in/hr, cyan bars), surface air temperature (\u00b0F, green curve on left axis), and relative humidity (%, blue dashed curve on right axis). Sustained high humidity (>75%) following soaking rain events with mild temperatures (45\u201368\u00b0F) triggers prime mycelial pinning and mushroom flushes."
            },
            {
              "id": "w_bottom_nav",
              "type": "bottom-nav",
              "title": "Navigation Bar",
              "col_span": 12,
              "options": {
                "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
              },
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "mushrooms",
          "label": "Wild Mushroom Foraging",
          "product": "mushrooms",
          "icon": "\ud83c\udf44",
          "category": "phenology",
          "description": "Active fruiting flushes and 7-day outlook updated daily.",
          "category_label": "Seasonal Phenology",
          "long_description": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
          "score_description": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
          "source_models": [
            "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
            "NOAA NBM / HRRR Soil & Surface Temperature",
            "USGS NLCD & Forest Host Species Habitat Maps"
          ],
          "output_models": [
            "Species-Specific Fruiting Probability Tiles (.pmtiles)",
            "7-Day Foraging Flush Outlook"
          ],
          "toast_title": "Wild Mushroom Foraging Forecast",
          "toast_subtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
          "toast_description": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats.",
          "longDescription": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
          "scoreDescription": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
          "categoryLabel": "Seasonal Phenology",
          "sourceModels": [
            "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
            "NOAA NBM / HRRR Soil & Surface Temperature",
            "USGS NLCD & Forest Host Species Habitat Maps"
          ],
          "outputModels": [
            "Species-Specific Fruiting Probability Tiles (.pmtiles)",
            "7-Day Foraging Flush Outlook"
          ],
          "toastTitle": "Wild Mushroom Foraging Forecast",
          "toastSubtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
          "toastDescription": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats."
        },
        {
          "id": "wild_berries",
          "label": "Wild Berry Ripening & Foraging",
          "product": "wild_berries",
          "icon": "\ud83e\uded0",
          "category": "phenology",
          "description": "Ripening waves, harvest windows & berry quality updated daily.",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
          "score_description": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
          "source_models": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "output_models": [
            "Wild Berries (.pmtiles)"
          ],
          "toast_title": "Wild Berry Ripening & Foraging",
          "toast_subtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
          "toast_description": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality.",
          "longDescription": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
          "scoreDescription": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "outputModels": [
            "Wild Berries (.pmtiles)"
          ],
          "toastTitle": "Wild Berry Ripening & Foraging",
          "toastSubtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
          "toastDescription": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality."
        },
        {
          "id": "precip_accum",
          "label": "Precipitation Accumulation (Past 1-7 Days)",
          "product": "precip_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP precipitation accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "long_description": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "source_models": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toast_title": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toast_subtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toast_description": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation.",
          "longDescription": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toastSubtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toastDescription": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation."
        },
        {
          "id": "precip_radar",
          "label": "Doppler Radar",
          "product": "live_weather",
          "model": "mrms",
          "icon": "\ud83d\udce1",
          "category": "precipitation",
          "description": "Near real time doppler radar",
          "basemap_override": {
            "terrain_3d": false
          },
          "category_label": "Real-Time Observation",
          "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "source_models": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "output_models": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toast_title": "Live NOAA MRMS Doppler Radar",
          "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
          "basemapOverride": {
            "terrain3d": false
          },
          "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "outputModels": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toastTitle": "Live NOAA MRMS Doppler Radar",
          "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
        },
        {
          "id": "climate_data",
          "label": "Historical Climatology (30-year)",
          "product": "climate",
          "icon": "\ud83d\udcca",
          "category": "extended_climate",
          "is_tool_mode": true,
          "description": "30-year climatological normals & microclimate elevation profiles",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "score_description": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "source_models": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "output_models": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toast_title": "Historical Climatology (30-Year Normals)",
          "toast_subtitle": "1991\u20132020 CLIMATE BASELINE",
          "toast_description": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips.",
          "longDescription": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "scoreDescription": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "outputModels": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toastTitle": "Historical Climatology (30-Year Normals)",
          "toastSubtitle": "1991\u20132020 CLIMATE BASELINE",
          "toastDescription": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips."
        },
        {
          "id": "recent_climate",
          "label": "Recent Climate Data",
          "product": "recent_climate",
          "icon": "\ud83d\uddd3\ufe0f",
          "category": "extended_climate",
          "is_tool_mode": true,
          "description": "Monthly & Year-to-Date observed temperature, precipitation, snowfall, and departures from 1991-2020 normals (2021-present)",
          "long_description": "Recent Climate Data is an interactive multi-year observed climate almanac (2021-present) tracking monthly and Year-to-Date (or Annual) temperature, precipitation, snowfall, and departures from 1991-2020 climatological normals.\n\nPowered by a seamless hybrid stitch of high-resolution NOAA NCEI nClimGrid-Daily (~4.6 km across CONUS) and NOAA PSL/CPC Global Unified Daily observations (0.5 deg across Alaska, Canada, and global land), paired with NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS). Hover anywhere over the map for instant telemetry showing High/Low, Mean Temp, Temp Departure, Total Precip, Normal Precip, % of Normal, Snowfall, and Elevation.",
          "score_description": "\u2022 7 Selectable Layers: Average High, Average Low, Mean Temp, Temp Departure (\u00b1\u00b0F), Total Precip, Precip Departure (\u00b1in & % of normal), and Snowfall (CONUS).\n\u2022 Time Modes: Clickable Jan-Dec monthly views plus Year-to-Date (active year) or Full Annual Summary (completed years 2021-2025+).\n\u2022 Daily Incremental Updates: Automatically refreshes the active calendar month and YTD totals daily as new NOAA observations publish.",
          "category_label": "Extended Climate & Outlooks",
          "source_models": [
            "NOAA NCEI nClimGrid-Daily (~4.6 km CONUS)",
            "NOAA PSL/CPC Global Unified Daily (0.5\u00b0 Global)",
            "NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS)"
          ],
          "output_models": [
            "Monthly & YTD Temperature, Precip, Snow & Departure Rasters (.pmtiles)"
          ],
          "toast_title": "Recent Climate Almanac (2021\u2013Present)",
          "toast_subtitle": "OBSERVED MONTHLY & YTD DEPARTURES",
          "toast_description": "Compare actual monthly and year-to-date temperatures, rainfall, and snowfall from 2021 to the present against 30-year climatological normals.",
          "longDescription": "Recent Climate Data is an interactive multi-year observed climate almanac (2021-present) tracking monthly and Year-to-Date (or Annual) temperature, precipitation, snowfall, and departures from 1991-2020 climatological normals.\n\nPowered by a seamless hybrid stitch of high-resolution NOAA NCEI nClimGrid-Daily (~4.6 km across CONUS) and NOAA PSL/CPC Global Unified Daily observations (0.5 deg across Alaska, Canada, and global land), paired with NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS). Hover anywhere over the map for instant telemetry showing High/Low, Mean Temp, Temp Departure, Total Precip, Normal Precip, % of Normal, Snowfall, and Elevation.",
          "scoreDescription": "\u2022 7 Selectable Layers: Average High, Average Low, Mean Temp, Temp Departure (\u00b1\u00b0F), Total Precip, Precip Departure (\u00b1in & % of normal), and Snowfall (CONUS).\n\u2022 Time Modes: Clickable Jan-Dec monthly views plus Year-to-Date (active year) or Full Annual Summary (completed years 2021-2025+).\n\u2022 Daily Incremental Updates: Automatically refreshes the active calendar month and YTD totals daily as new NOAA observations publish.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "NOAA NCEI nClimGrid-Daily (~4.6 km CONUS)",
            "NOAA PSL/CPC Global Unified Daily (0.5\u00b0 Global)",
            "NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS)"
          ],
          "outputModels": [
            "Monthly & YTD Temperature, Precip, Snow & Departure Rasters (.pmtiles)"
          ],
          "toastTitle": "Recent Climate Almanac (2021\u2013Present)",
          "toastSubtitle": "OBSERVED MONTHLY & YTD DEPARTURES",
          "toastDescription": "Compare actual monthly and year-to-date temperatures, rainfall, and snowfall from 2021 to the present against 30-year climatological normals."
        }
      ],
      "secondaryLayers": [
        {
          "id": "hrtemp",
          "label": "Temperature Forecast",
          "product": "hrtemp",
          "model": "nbm",
          "icon": "\ud83c\udf21\ufe0f",
          "category": "temperature",
          "description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "category_label": "Core Meteorological",
          "long_description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "score_description": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Surface temperature .pmtiles per model"
          ],
          "toast_title": "Terrain-Corrected Surface Temperature",
          "toast_subtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toast_description": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures.",
          "longDescription": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "scoreDescription": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Surface temperature .pmtiles per model"
          ],
          "toastTitle": "Terrain-Corrected Surface Temperature",
          "toastSubtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toastDescription": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures."
        },
        {
          "id": "relative_humidity",
          "label": "Relative Humidity",
          "product": "relative_humidity",
          "icon": "\ud83d\udca7",
          "category": "temperature",
          "description": "Relative Humidity forecast.",
          "category_label": "Core Meteorological",
          "long_description": "2m Surface Relative Humidity percentage.",
          "score_description": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Surface RH .pmtiles per model"
          ],
          "toast_title": "Surface Relative Humidity (RH%)",
          "toast_subtitle": "2-METER ATMOSPHERIC SATURATION",
          "toast_description": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions.",
          "longDescription": "2m Surface Relative Humidity percentage.",
          "scoreDescription": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Surface RH .pmtiles per model"
          ],
          "toastTitle": "Surface Relative Humidity (RH%)",
          "toastSubtitle": "2-METER ATMOSPHERIC SATURATION",
          "toastDescription": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions."
        },
        {
          "id": "sun_intensity_forecast",
          "label": "Solar Intensity Forecast",
          "product": "sun_intensity",
          "icon": "\u2600\ufe0f",
          "category": "temperature",
          "description": "Surface downwelling solar irradiance forecast (W/m\u00b2) across numerical weather models.",
          "category_label": "Core Meteorological",
          "long_description": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "score_description": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "source_models": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "output_models": [
            "Solar Intensity .pmtiles per model"
          ],
          "toast_title": "Solar Intensity & Surface Irradiance",
          "toast_subtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toast_description": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation.",
          "longDescription": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "scoreDescription": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "outputModels": [
            "Solar Intensity .pmtiles per model"
          ],
          "toastTitle": "Solar Intensity & Surface Irradiance",
          "toastSubtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toastDescription": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation."
        },
        {
          "id": "clouds",
          "label": "Cloud Forecast",
          "product": "clouds",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud forecasts.",
          "long_description": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "category_label": "Core Meteorological",
          "score_description": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "source_models": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "output_models": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toast_title": "Cloud Cover Forecast",
          "toast_subtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toast_description": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures.",
          "longDescription": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "scoreDescription": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "outputModels": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toastTitle": "Cloud Cover Forecast",
          "toastSubtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toastDescription": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures."
        }
      ]
    },
    "hunting": {
      "id": "hunting",
      "title": "Hunting & Wildlife",
      "icon": "\ud83c\udff9",
      "description": "Scent-carrying winds, thermals, freeze line, solar/lunar activity",
      "defaultBasemap": "usgs-topo",
      "basemapConfig": {
        "theme": "usgs-topo",
        "mode": "light",
        "terrain3d": false,
        "shading": "color_tint"
      },
      "isDefault": false,
      "isCustom": false,
      "forecastLayoutRef": "",
      "forecastLayout": {
        "id": "hunting",
        "name": "Hunting & Wildlife",
        "description": "Scent-carrying winds, thermals, freeze line, solar/lunar activity",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "widget_1791672969709_169",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "temp_precip_meteo",
              "type": "meteogram_card",
              "title": "Temperature & Precipitation",
              "col_span": 6,
              "options": {
                "height": 220,
                "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
              },
              "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
            },
            {
              "id": "lightning_hazard",
              "type": "lightning_map_card",
              "title": "Daily Lightning Hazard & Strike Timing",
              "col_span": 6,
              "options": {
                "show_diurnal_chart": true,
                "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
              },
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            {
              "id": "sounding_inversion",
              "type": "sounding_card",
              "title": "Atmospheric Sounding & Inversion Profile",
              "col_span": 6,
              "options": {
                "interactive": true,
                "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
              },
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            {
              "id": "sun_intensity",
              "type": "sun_intensity_card",
              "title": "Sun Intensity & Solar Flux",
              "col_span": 6,
              "options": {
                "height": 120,
                "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
              },
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            {
              "id": "air_sky_quality",
              "type": "air_quality_card",
              "title": "Air & Sky Quality",
              "col_span": 6,
              "options": {
                "height": 180,
                "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
              },
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            {
              "id": "solar_alpenglow",
              "type": "solar_alpenglow_card",
              "title": "Sunrise, Sunset and Golden Hour Outlooks",
              "col_span": 6,
              "options": {
                "show_blue_hour": true,
                "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
              },
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            {
              "id": "wind_profile",
              "type": "wind_card",
              "title": "Wind Speed & Direction",
              "col_span": 6,
              "options": {
                "height": 180,
                "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
              },
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            {
              "id": "astronomical_events",
              "type": "astronomical_card",
              "title": "Astronomical Events & Night Sky",
              "col_span": 6,
              "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows.",
              "options": {
                "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows."
              }
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "temp_precip_meteo",
              "type": "meteogram_card",
              "title": "Temperature & Precipitation",
              "col_span": 12,
              "options": {
                "height": 200,
                "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
              },
              "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
            },
            {
              "id": "lightning_hazard",
              "type": "lightning_map_card",
              "title": "Lightning Hazard & Timing",
              "col_span": 12,
              "options": {
                "show_diurnal_chart": true,
                "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
              },
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            {
              "id": "wind_profile",
              "type": "wind_card",
              "title": "Wind Speed & Direction",
              "col_span": 12,
              "options": {
                "height": 160,
                "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
              },
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            {
              "id": "solar_alpenglow",
              "type": "solar_alpenglow_card",
              "title": "Sun & Alpenglow Times",
              "col_span": 12,
              "options": {
                "show_blue_hour": true,
                "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
              },
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            {
              "id": "air_sky_quality",
              "type": "air_quality_card",
              "title": "Air & Sky Quality",
              "col_span": 12,
              "options": {
                "height": 160,
                "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
              },
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            {
              "id": "sun_intensity",
              "type": "sun_intensity_card",
              "title": "Sun Intensity & Solar Flux",
              "col_span": 12,
              "options": {
                "height": 120,
                "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
              },
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            {
              "id": "sounding_inversion",
              "type": "sounding_card",
              "title": "Atmospheric Sounding Profile",
              "col_span": 12,
              "options": {
                "interactive": true,
                "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
              },
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            {
              "id": "astronomical_events",
              "type": "astronomical_card",
              "title": "Night Sky & Lunar Events",
              "col_span": 12,
              "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows.",
              "options": {
                "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows."
              }
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "winds_surface",
          "label": "Surface Winds Forecast",
          "product": "winds",
          "model": "blend",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Forecasted Surface Winds (10m)",
          "category_label": "Core Meteorological",
          "long_description": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "score_description": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toast_title": "Surface Winds & Gusts",
          "toast_subtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toast_description": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models.",
          "longDescription": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "scoreDescription": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toastTitle": "Surface Winds & Gusts",
          "toastSubtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toastDescription": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models."
        },
        {
          "id": "hrtemp",
          "label": "Temperature Forecast",
          "product": "hrtemp",
          "model": "nbm",
          "icon": "\ud83c\udf21\ufe0f",
          "category": "temperature",
          "description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "category_label": "Core Meteorological",
          "long_description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "score_description": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Surface temperature .pmtiles per model"
          ],
          "toast_title": "Terrain-Corrected Surface Temperature",
          "toast_subtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toast_description": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures.",
          "longDescription": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "scoreDescription": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Surface temperature .pmtiles per model"
          ],
          "toastTitle": "Terrain-Corrected Surface Temperature",
          "toastSubtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toastDescription": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures."
        },
        {
          "id": "freezing_level",
          "label": "Freezing Level",
          "product": "freezing_level",
          "model": "hrrr",
          "icon": "\ud83e\uddca",
          "category": "temperature",
          "description": "Freezing level forecast.",
          "category_label": "Core Meteorological",
          "long_description": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
          "score_description": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Altitude (Meters MSL) .pmtiles per model"
          ],
          "toast_title": "Freezing Level Altitude (0\u00b0C Isotherm)",
          "toast_subtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
          "toast_description": "Displays the forecasted elevation where air temperature reaches freezing.",
          "longDescription": "Maps the Mean Sea Level (MSL) elevation of the 32\u00b0F (0\u00b0C) freezing isotherm to track rain-snow transitions and alpine freeze-thaw cycles.",
          "scoreDescription": "\u2022 Sea Level to 3,000 ft MSL (Purple/Blue): Sub-freezing air extending into low valleys and coastal foothills.\n\u2022 3,000 to 8,000 ft MSL (Cyan to Green/Yellow): Mid-mountain freezing level separating valley rain from alpine snow.\n\u2022 8,000 to 15,000+ ft MSL (Orange to Red): High summer freezing altitude affecting glacier melt and high-peak snow stability.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Altitude (Meters MSL) .pmtiles per model"
          ],
          "toastTitle": "Freezing Level Altitude (0\u00b0C Isotherm)",
          "toastSubtitle": "RAIN-SNOW LINE & ALPINE THAW ALTITUDE",
          "toastDescription": "Displays the forecasted elevation where air temperature reaches freezing."
        },
        {
          "id": "precip_radar",
          "label": "Doppler Radar",
          "product": "live_weather",
          "model": "mrms",
          "icon": "\ud83d\udce1",
          "category": "precipitation",
          "description": "Near real time doppler radar",
          "basemap_override": {
            "terrain_3d": false
          },
          "category_label": "Real-Time Observation",
          "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "source_models": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "output_models": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toast_title": "Live NOAA MRMS Doppler Radar",
          "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
          "basemapOverride": {
            "terrain3d": false
          },
          "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "outputModels": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toastTitle": "Live NOAA MRMS Doppler Radar",
          "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
        }
      ],
      "secondaryLayers": [
        {
          "id": "clouds",
          "label": "Cloud Forecast",
          "product": "clouds",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud forecasts.",
          "long_description": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "category_label": "Core Meteorological",
          "score_description": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "source_models": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "output_models": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toast_title": "Cloud Cover Forecast",
          "toast_subtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toast_description": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures.",
          "longDescription": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "scoreDescription": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "outputModels": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toastTitle": "Cloud Cover Forecast",
          "toastSubtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toastDescription": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures."
        },
        {
          "id": "snow_depth",
          "label": "Snow Depth & SNOTEL",
          "product": "snow_depth",
          "icon": "\u2744\ufe0f",
          "category": "hydrology",
          "description": "Observed snowpack depth & SNOTEL telemetry",
          "category_label": "Hydrology & Mountain Weather",
          "long_description": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
          "score_description": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
          "source_models": [
            "NOAA SNODAS 1km Snow Analysis",
            "USDA NRCS SNOTEL Telemetry",
            "ECCC & BC Snow Pillow Network"
          ],
          "output_models": [
            "Continuous mountain snowpack gradient",
            "Live SNOTEL observation stations"
          ],
          "toast_title": "Snow Depth & Live SNOTEL Stations",
          "toast_subtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
          "toast_description": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements.",
          "longDescription": "High-resolution NOAA SNODAS 1km snow depth and ECMWF IFS 0.25\u00b0 global snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.",
          "scoreDescription": "\u2022 Snowpack Depth Gradient: Continuous observed snow depth from trace dustings (1\u20134 in) to deep alpine snowpacks (100\u2013250+ in).\n\u2022 Live SNOTEL & Snow Pillow Stations: Click any station marker to inspect current snow depth, Snow Water Equivalent (SWE), and recent snowpack changes.",
          "categoryLabel": "Hydrology & Mountain Weather",
          "sourceModels": [
            "NOAA SNODAS 1km Snow Analysis",
            "USDA NRCS SNOTEL Telemetry",
            "ECCC & BC Snow Pillow Network"
          ],
          "outputModels": [
            "Continuous mountain snowpack gradient",
            "Live SNOTEL observation stations"
          ],
          "toastTitle": "Snow Depth & Live SNOTEL Stations",
          "toastSubtitle": "OBSERVED 1KM SNOWPACK & TELEMETRY",
          "toastDescription": "Displays high-resolution observed snowpack depth paired with live backcountry SNOTEL and snow pillow station measurements."
        },
        {
          "id": "fire_restrictions",
          "label": "Fire Restrictions (USFS/BLM/NPS)",
          "product": "fire_restrictions",
          "icon": "\ud83d\udd25\ud83d\udeab",
          "category": "air_quality_fires",
          "description": "Camp Fire restrictions.",
          "long_description": "Provides data from land management agencies around what fire restrictions, if any, are currently in place.\n\nAggregates active campfire bans, Stage 1 and Stage 2 fire restrictions, industrial fire precaution levels, and area closures across US Forest Service (USFS), Bureau of Land Management (BLM), National Park Service (NPS), BIA, USFWS, and state forestry jurisdictions.",
          "category_label": "Public Lands & Wildfire Safety",
          "score_description": "\u2022 Stage 1 Fire Restrictions (Yellow/Amber): Campfires restricted to developed agency-approved fire rings; smoking and spark-emitting equipment restricted.\n\u2022 Stage 2 Fire Restrictions (Orange/Red): All wood and charcoal campfires prohibited (including developed campgrounds); pressurized liquid/gas stoves with shutoff valves typically permitted.\n\u2022 Stage 3 / Area Closure (Magenta/Dark Red): Extreme fire danger closure or complete prohibition of all ignition sources.",
          "source_models": [
            "NIFC / Interagency Fire Restrictions Feeds (USFS, BLM, NPS, BIA, State)"
          ],
          "output_models": [
            "Jurisdictional Fire Restriction Polygons & Order Summaries GeoJSON"
          ],
          "toast_title": "Public Land Fire Restrictions",
          "toast_subtitle": "USFS, BLM, NPS & STATE CAMPFIRE ORDERS",
          "toast_description": "Maps active Stage 1 and Stage 2 campfire bans and agency fire restriction orders across federal and state public lands.",
          "longDescription": "Provides data from land management agencies around what fire restrictions, if any, are currently in place.\n\nAggregates active campfire bans, Stage 1 and Stage 2 fire restrictions, industrial fire precaution levels, and area closures across US Forest Service (USFS), Bureau of Land Management (BLM), National Park Service (NPS), BIA, USFWS, and state forestry jurisdictions.",
          "scoreDescription": "\u2022 Stage 1 Fire Restrictions (Yellow/Amber): Campfires restricted to developed agency-approved fire rings; smoking and spark-emitting equipment restricted.\n\u2022 Stage 2 Fire Restrictions (Orange/Red): All wood and charcoal campfires prohibited (including developed campgrounds); pressurized liquid/gas stoves with shutoff valves typically permitted.\n\u2022 Stage 3 / Area Closure (Magenta/Dark Red): Extreme fire danger closure or complete prohibition of all ignition sources.",
          "categoryLabel": "Public Lands & Wildfire Safety",
          "sourceModels": [
            "NIFC / Interagency Fire Restrictions Feeds (USFS, BLM, NPS, BIA, State)"
          ],
          "outputModels": [
            "Jurisdictional Fire Restriction Polygons & Order Summaries GeoJSON"
          ],
          "toastTitle": "Public Land Fire Restrictions",
          "toastSubtitle": "USFS, BLM, NPS & STATE CAMPFIRE ORDERS",
          "toastDescription": "Maps active Stage 1 and Stage 2 campfire bans and agency fire restriction orders across federal and state public lands."
        },
        {
          "id": "sun_intensity_forecast",
          "label": "Solar Intensity Forecast",
          "product": "sun_intensity",
          "icon": "\u2600\ufe0f",
          "category": "temperature",
          "description": "Surface downwelling solar irradiance forecast (W/m\u00b2) across numerical weather models.",
          "category_label": "Core Meteorological",
          "long_description": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "score_description": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "source_models": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "output_models": [
            "Solar Intensity .pmtiles per model"
          ],
          "toast_title": "Solar Intensity & Surface Irradiance",
          "toast_subtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toast_description": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation.",
          "longDescription": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "scoreDescription": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "outputModels": [
            "Solar Intensity .pmtiles per model"
          ],
          "toastTitle": "Solar Intensity & Surface Irradiance",
          "toastSubtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toastDescription": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation."
        }
      ]
    },
    "skyskout": {
      "id": "skyskout",
      "title": "SkySkout Unique Layers",
      "icon": "\ud83c\udfa3",
      "description": "Layers that are more than just the weather.",
      "defaultBasemap": "terrain-mapterhorn",
      "basemapConfig": {
        "theme": "terrain-mapterhorn",
        "mode": "light",
        "terrain3d": false,
        "shading": "color_tint"
      },
      "isDefault": false,
      "isCustom": false,
      "forecastLayoutRef": "",
      "forecastLayout": {
        "id": "default",
        "name": "Default Balanced Forecast",
        "description": "Comprehensive atmospheric overview with temperature, precipitation, wind, air quality, lightning, and solar ephemeris",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "temp_precip_meteo",
              "type": "meteogram_card",
              "title": "Temperature & Precipitation",
              "col_span": 6,
              "options": {
                "height": 220,
                "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
              },
              "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
            },
            {
              "id": "lightning_hazard",
              "type": "lightning_map_card",
              "title": "Daily Lightning Hazard & Strike Timing",
              "col_span": 6,
              "options": {
                "show_diurnal_chart": true,
                "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
              },
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            {
              "id": "sounding_inversion",
              "type": "sounding_card",
              "title": "Atmospheric Sounding & Inversion Profile",
              "col_span": 6,
              "options": {
                "interactive": true,
                "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
              },
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            {
              "id": "sun_intensity",
              "type": "sun_intensity_card",
              "title": "Sun Intensity & Solar Flux",
              "col_span": 6,
              "options": {
                "height": 120,
                "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
              },
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            {
              "id": "air_sky_quality",
              "type": "air_quality_card",
              "title": "Air & Sky Quality",
              "col_span": 6,
              "options": {
                "height": 180,
                "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
              },
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            {
              "id": "solar_alpenglow",
              "type": "solar_alpenglow_card",
              "title": "Sunrise, Sunset and Golden Hour Outlooks",
              "col_span": 6,
              "options": {
                "show_blue_hour": true,
                "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
              },
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            {
              "id": "wind_profile",
              "type": "wind_card",
              "title": "Wind Speed & Direction",
              "col_span": 6,
              "options": {
                "height": 180,
                "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
              },
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            {
              "id": "astronomical_events",
              "type": "astronomical_card",
              "title": "Astronomical Events & Night Sky",
              "col_span": 6,
              "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows.",
              "options": {
                "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows."
              }
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "temp_precip_meteo",
              "type": "meteogram_card",
              "title": "Temperature & Precipitation",
              "col_span": 12,
              "options": {
                "height": 200,
                "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
              },
              "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
            },
            {
              "id": "lightning_hazard",
              "type": "lightning_map_card",
              "title": "Lightning Hazard & Timing",
              "col_span": 12,
              "options": {
                "show_diurnal_chart": true,
                "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
              },
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            {
              "id": "wind_profile",
              "type": "wind_card",
              "title": "Wind Speed & Direction",
              "col_span": 12,
              "options": {
                "height": 160,
                "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
              },
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            {
              "id": "solar_alpenglow",
              "type": "solar_alpenglow_card",
              "title": "Sun & Alpenglow Times",
              "col_span": 12,
              "options": {
                "show_blue_hour": true,
                "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
              },
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            {
              "id": "air_sky_quality",
              "type": "air_quality_card",
              "title": "Air & Sky Quality",
              "col_span": 12,
              "options": {
                "height": 160,
                "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
              },
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            {
              "id": "sun_intensity",
              "type": "sun_intensity_card",
              "title": "Sun Intensity & Solar Flux",
              "col_span": 12,
              "options": {
                "height": 120,
                "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
              },
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            {
              "id": "sounding_inversion",
              "type": "sounding_card",
              "title": "Atmospheric Sounding Profile",
              "col_span": 12,
              "options": {
                "interactive": true,
                "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
              },
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            {
              "id": "astronomical_events",
              "type": "astronomical_card",
              "title": "Night Sky & Lunar Events",
              "col_span": 12,
              "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows.",
              "options": {
                "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows."
              }
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "golden_hour",
          "label": "Sunrise & Sunset",
          "product": "sunrise",
          "model": "gw_v2_blend_50",
          "icon": "\ud83c\udf05",
          "category": "sky_solar",
          "description": "Sunrise and Sunset color/quality probability forecast",
          "category_label": "Forecast Quality Scoring",
          "long_description": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
          "score_description": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "output_models": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toast_title": "Sunrise & Sunset 10-Day Forecast",
          "toast_subtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toast_description": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
          "nowcast_toast_title": "SkySkout Sunset & Sunrise NowCast",
          "nowcast_toast_subtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcast_toast_description": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions.",
          "longDescription": "Ray-tracing solar quality model assessing cloud alignment, horizon clearance, optical depth along with various other inputs to score sunrise/sunset color conditions.  Relies on data from forecast models to built predictions.  Due to variability in forecast model reliability forecasts will change over time.  The closer to the event the more reliable forecasts typically become.  Leverage the NowCast to get live satellite-advected scores 6, 4, and 2 hours before sunrise/sunset if you need critical accuracy.",
          "scoreDescription": "\u2022 80-100 (Vivid/Burn): High likelihood of optimal cloud geometry and horizon clearance leading to vibrant sky color.\n\u2022 60-79 (Above Average): Favorable cloud scattering and clear solar corridor for strong warm tones.\n\u2022 40-59 (Average/Clear): A mostly clear sky or moderate cloud cover with a clear horizon and conditions favorable to warm color on the horizon.\n\u2022 31-39 (Below Average): Partial horizon obstruction or limited cloud scattering.\n\u2022 21-30 (Muted): Subdued lighting from haze, high humidity, or unfavorable cloud heights.\n\u2022 0-20 (Poor/Occluded): Likely blocking of the horizon by dense low clouds or other extinguishing factors.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "outputModels": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toastTitle": "Sunrise & Sunset 10-Day Forecast",
          "toastSubtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toastDescription": "Predicts sunrise and sunset color vibrancy by leveraging data from numerical weather prediction (NWP) data.",
          "nowcastToastTitle": "SkySkout Sunset & Sunrise NowCast",
          "nowcastToastSubtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcastToastDescription": "Generates rolling forecasts 6, 4, and 2 hours before sunrise/sunset based on current observed atmospheric conditions."
        },
        {
          "id": "alpenglow_forecast",
          "label": "Golden Hour / Alpenglow",
          "product": "alpenglow",
          "model": "gw_v2_blend_50",
          "icon": "\ud83c\udfd4\ufe0f\ud83c\udf05",
          "category": "sky_solar",
          "description": "High-elevation alpine illumination quality/probability score",
          "basemap_override": {
            "mode": "dark"
          },
          "category_label": "Forecast Quality Scoring",
          "long_description": "Dual-mode alpine alpenglow (topographic prominence & solar aspect hillshading) and landscape golden hour forecast.",
          "score_description": "\u2022 80-100 (Vivid/Burn): Unobstructed low-angle solar beam illuminating prominent peaks or landscapes with intense warm golden and crimson light.\n\u2022 60-79 (Above Average): Strong direct golden hour illumination with favorable atmospheric clarity and minimal horizon blockage.\n\u2022 40-59 (Average/Clear): Clean standard golden hour light on exposed terrain slopes and ridges.\n\u2022 31-39 (Below Average): Filtered or partially attenuated low-angle sunlight due to cloud bands or haze.\n\u2022 21-30 (Muted): Weak, diffused twilight illumination with heavy cloud filtering along the solar path.\n\u2022 0-20 (Poor/Occluded): Direct solar beam blocked by terrain shadow, dense low cloud decks, or precipitation.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "output_models": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toast_title": "Golden Hour & Alpenglow 10-Day Forecast",
          "toast_subtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toast_description": "Models low-angle direct solar beam transmission and topographic mountain peak illumination up to 10 days out using multi-model NWP cloud and moisture forecasts.",
          "nowcast_toast_title": "Golden Hour & Alpenglow Live NowCast",
          "nowcast_toast_subtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcast_toast_description": "Uses live GOES satellite imagery and radar optical flow (T+2h/4h/6h) to score low-angle golden hour light transmission and peak alpenglow for the next upcoming twilight event.",
          "basemapOverride": {
            "mode": "dark"
          },
          "longDescription": "Dual-mode alpine alpenglow (topographic prominence & solar aspect hillshading) and landscape golden hour forecast.",
          "scoreDescription": "\u2022 80-100 (Vivid/Burn): Unobstructed low-angle solar beam illuminating prominent peaks or landscapes with intense warm golden and crimson light.\n\u2022 60-79 (Above Average): Strong direct golden hour illumination with favorable atmospheric clarity and minimal horizon blockage.\n\u2022 40-59 (Average/Clear): Clean standard golden hour light on exposed terrain slopes and ridges.\n\u2022 31-39 (Below Average): Filtered or partially attenuated low-angle sunlight due to cloud bands or haze.\n\u2022 21-30 (Muted): Weak, diffused twilight illumination with heavy cloud filtering along the solar path.\n\u2022 0-20 (Poor/Occluded): Direct solar beam blocked by terrain shadow, dense low cloud decks, or precipitation.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "outputModels": [
            "gw_v2_blend_50",
            "gw_v2_hrrr",
            "gw_v2_rrfs",
            "gw_v2_rdps",
            "gw_v2_gfs",
            "gw_v2_ecmwf",
            "gw_nowcast"
          ],
          "toastTitle": "Golden Hour & Alpenglow 10-Day Forecast",
          "toastSubtitle": "MULTI-MODEL NWP ATMOSPHERIC FORECAST",
          "toastDescription": "Models low-angle direct solar beam transmission and topographic mountain peak illumination up to 10 days out using multi-model NWP cloud and moisture forecasts.",
          "nowcastToastTitle": "Golden Hour & Alpenglow Live NowCast",
          "nowcastToastSubtitle": "LIVE SATELLITE & DOPPLER RADAR NOWCAST (T+2H / 4H / 6H)",
          "nowcastToastDescription": "Uses live GOES satellite imagery and radar optical flow (T+2h/4h/6h) to score low-angle golden hour light transmission and peak alpenglow for the next upcoming twilight event."
        },
        {
          "id": "darkskies_bortle",
          "label": "Dark Sky Forecast",
          "product": "darkskies",
          "model": "blend",
          "icon": "\u2728",
          "category": "sky_solar",
          "description": "Hourly forecast of clear sky conditions incorporating Bortle score, numerous atmospheric conditions, lunar phase/position, and more.",
          "basemap_override": {
            "mode": "dark",
            "terrain_3d": false
          },
          "category_label": "Forecast Quality Scoring",
          "long_description": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
          "score_description": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "World Atlas Light Pollution"
          ],
          "output_models": [
            "blend",
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "toast_title": "Dark Skies Stargazing Forecast",
          "toast_subtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
          "toast_description": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score.",
          "basemapOverride": {
            "mode": "dark",
            "terrain3d": false
          },
          "longDescription": "Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.",
          "scoreDescription": "\u2022 80-100 (Pristine / Exceptional): Cloud-free skies, minimal moon illumination, low aerosols, and dark Bortle 1\u20133 background ideal for Milky Way and deep-sky astrophotography.\n\u2022 60-79 (Good / Dark Sky): Clear skies with light natural skyglow or low lunar interference; very good stargazing visibility.\n\u2022 40-59 (Moderate / Fair): Partial thin clouds, moderate moonlight, or suburban light dome reducing faint star contrast.\n\u2022 20-39 (Poor / Bright or Hazy): Significant moonlight, smoke/aerosol haze, urban skyglow, or scattered cloud cover.\n\u2022 0-19 (Occluded / Overcast): Overcast cloud cover, bright daylight/twilight, or severe atmospheric obscuration.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "World Atlas Light Pollution"
          ],
          "outputModels": [
            "blend",
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf"
          ],
          "toastTitle": "Dark Skies Stargazing Forecast",
          "toastSubtitle": "NIGHT SKY TRANSPARENCY & BORTLE INDEX",
          "toastDescription": "Combines total cloud cover, lunar illumination, aerosol optical depth, and artificial light pollution into a unified 0\u2013100 stargazing and astrophotography quality score."
        },
        {
          "id": "foliage",
          "label": "Fall Foliage Forecast",
          "product": "foliage",
          "icon": "\ud83c\udf41",
          "category": "phenology",
          "description": "Daily refreshed forecast for fall foliage timing and intensity.",
          "category_label": "Seasonal Phenology",
          "long_description": "The Fall Foliage forecast provides a comprehensive set of visual tools to help autumn travelers, hikers, and photographers plan their trips:\n\n\u2022 PEAK DATE - Displays a continental map of the projected calendar date when peak autumn color first arrives at each location. Colors transition chronologically from early September 15 peaks (green), through yellow, gold, orange, red, and brown, to mid-November (grey). Toggle between Full Landscape and Treed Regions Only, or click any location to see its exact projected peak date.\n\n\u2022 DETAILED TIMING / CALENDAR - Shows an interactive calendar providing an at-a-glance seasonal color progression for any selected location, alongside daily continental maps showing color evolution from green canopy to peak foliage. Toggle between Full Landscape and Treed Regions Only to inspect regional forests.\n\n\u2022 VIBRANCY THIS SEASON - Displays anticipated differences in peak color brilliance and saturation compared to an average season. Evaluates cool crisp nights (which trap anthocyanin red pigments), bright sunny days (which power sugar production), summer drought scorch, and wind penalties.\n\n\u2022 CANOPY COVER - Displays satellite-measured tree canopy density (USGS NLCD & NALCMS) to show where broadleaf deciduous and mixed hardwood forests are concentrated across North America.\n\n\u2022 TREE SPECIES - Maps native forest distributions for key autumn tree families, including Scarlet Red Maples, Canary Gold Aspens & Birches, Bronze Oaks & Beeches, and Golden Larches/Tamaracks.\n\n\u2022 HEAT ANOMALY - Shows summer mean temperature departures compared to 30-year climate normals. Excessive summer heat stress damages leaf chlorophyll and can cause early scorching or dull browning.\n\n\u2022 MOISTURE - Shows summer root-zone soil moisture anomalies compared to normal (from NOAA CPC). Soil moisture plays a critical role in tree health: severe drought causes premature leaf drop and muted colors, whereas healthy summer moisture supports vibrant displays.\n\nHow the Forecast Works & Data Timeline:\nOur biophysical phenology model continuously integrates seasonal growing conditions, real-time weather observations, and short-term numerical forecasts:\n\u2022 Antecedent Inputs: Summer soil moisture and heat stress define baseline tree vitality and drought resilience.\n\u2022 Observed Weather: Ground-truth daily minimum temperatures from NOAA URMA lock in chilling accumulation through September and October.\n\u2022 5-to-7 Day Forecasts: Short-term weather predictions from NOAA NDFD drive active chilling and color onset. Note that forecasts 5 to 7 days out are dynamic and subject to update as weather systems shift.\n\u2022 Long-Range Horizon: Dates beyond the short-term forecast window are guided by 30-year PRISM climatological normals for long-range trip planning.",
          "score_description": "\u2022 Above Normal / Enhanced Vibrancy: Plentiful sunny afternoons, crisp above-freezing nights (34\u00b0F to 45\u00b0F), and calm winds promote intense anthocyanin pigment production, rich saturation, and extended peak retention with minimal early leaf drop.\n\u2022 Average / Typical Vibrancy: Expected baseline autumn coloration aligned with 30-year historical climate norms for the region and species mix.\n\u2022 Below Normal / Reduced Vibrancy: Unseasonably warm nights (preventing sugar trapping), severe summer drought scorch, persistent cloudy rain, or premature killing freezes produce muted, dull, or brown-tinted foliage.",
          "source_models": [
            "NOAA URMA (Observed Daily Tmin)",
            "NOAA NDFD (5-7 Day Weather Forecast)",
            "PRISM (30-Yr Daily Climatology Normals)",
            "NOAA CPC (Soil Moisture Anomalies)",
            "NASA Daymet (Solar Irradiance Normals)",
            "USGS NLCD & Tree Species Atlas"
          ],
          "output_models": [
            "Peak Color Arrival by Date (foliage_peak_date.pmtiles)",
            "Peak Color Arrival - Treed Only (foliage_peak_date_treed.pmtiles)",
            "Daily Color Progression (foliage_{date}.pmtiles)",
            "Seasonal Vibrancy Departure (foliage_vibrancy.pmtiles)",
            "Deciduous Tree Canopy Density (foliage_canopy.pmtiles)",
            "Native Tree Species Distribution (foliage_species.pmtiles)",
            "Summer Temperature Anomaly (foliage_summer_temp_anomaly.pmtiles)",
            "Summer Soil Moisture Anomaly (foliage_soil_moisture_anomaly.pmtiles)"
          ],
          "toast_title": "Fall Foliage Timing & Vibrancy Forecast",
          "toast_subtitle": "BIOPHYSICAL AUTUMN PHENOLOGY MODEL",
          "toast_description": "Tracks projected peak autumn foliage dates, daily color progression, tree species habitats, and seasonal color vibrancy across North America.",
          "longDescription": "The Fall Foliage forecast provides a comprehensive set of visual tools to help autumn travelers, hikers, and photographers plan their trips:\n\n\u2022 PEAK DATE - Displays a continental map of the projected calendar date when peak autumn color first arrives at each location. Colors transition chronologically from early September 15 peaks (green), through yellow, gold, orange, red, and brown, to mid-November (grey). Toggle between Full Landscape and Treed Regions Only, or click any location to see its exact projected peak date.\n\n\u2022 DETAILED TIMING / CALENDAR - Shows an interactive calendar providing an at-a-glance seasonal color progression for any selected location, alongside daily continental maps showing color evolution from green canopy to peak foliage. Toggle between Full Landscape and Treed Regions Only to inspect regional forests.\n\n\u2022 VIBRANCY THIS SEASON - Displays anticipated differences in peak color brilliance and saturation compared to an average season. Evaluates cool crisp nights (which trap anthocyanin red pigments), bright sunny days (which power sugar production), summer drought scorch, and wind penalties.\n\n\u2022 CANOPY COVER - Displays satellite-measured tree canopy density (USGS NLCD & NALCMS) to show where broadleaf deciduous and mixed hardwood forests are concentrated across North America.\n\n\u2022 TREE SPECIES - Maps native forest distributions for key autumn tree families, including Scarlet Red Maples, Canary Gold Aspens & Birches, Bronze Oaks & Beeches, and Golden Larches/Tamaracks.\n\n\u2022 HEAT ANOMALY - Shows summer mean temperature departures compared to 30-year climate normals. Excessive summer heat stress damages leaf chlorophyll and can cause early scorching or dull browning.\n\n\u2022 MOISTURE - Shows summer root-zone soil moisture anomalies compared to normal (from NOAA CPC). Soil moisture plays a critical role in tree health: severe drought causes premature leaf drop and muted colors, whereas healthy summer moisture supports vibrant displays.\n\nHow the Forecast Works & Data Timeline:\nOur biophysical phenology model continuously integrates seasonal growing conditions, real-time weather observations, and short-term numerical forecasts:\n\u2022 Antecedent Inputs: Summer soil moisture and heat stress define baseline tree vitality and drought resilience.\n\u2022 Observed Weather: Ground-truth daily minimum temperatures from NOAA URMA lock in chilling accumulation through September and October.\n\u2022 5-to-7 Day Forecasts: Short-term weather predictions from NOAA NDFD drive active chilling and color onset. Note that forecasts 5 to 7 days out are dynamic and subject to update as weather systems shift.\n\u2022 Long-Range Horizon: Dates beyond the short-term forecast window are guided by 30-year PRISM climatological normals for long-range trip planning.",
          "scoreDescription": "\u2022 Above Normal / Enhanced Vibrancy: Plentiful sunny afternoons, crisp above-freezing nights (34\u00b0F to 45\u00b0F), and calm winds promote intense anthocyanin pigment production, rich saturation, and extended peak retention with minimal early leaf drop.\n\u2022 Average / Typical Vibrancy: Expected baseline autumn coloration aligned with 30-year historical climate norms for the region and species mix.\n\u2022 Below Normal / Reduced Vibrancy: Unseasonably warm nights (preventing sugar trapping), severe summer drought scorch, persistent cloudy rain, or premature killing freezes produce muted, dull, or brown-tinted foliage.",
          "categoryLabel": "Seasonal Phenology",
          "sourceModels": [
            "NOAA URMA (Observed Daily Tmin)",
            "NOAA NDFD (5-7 Day Weather Forecast)",
            "PRISM (30-Yr Daily Climatology Normals)",
            "NOAA CPC (Soil Moisture Anomalies)",
            "NASA Daymet (Solar Irradiance Normals)",
            "USGS NLCD & Tree Species Atlas"
          ],
          "outputModels": [
            "Peak Color Arrival by Date (foliage_peak_date.pmtiles)",
            "Peak Color Arrival - Treed Only (foliage_peak_date_treed.pmtiles)",
            "Daily Color Progression (foliage_{date}.pmtiles)",
            "Seasonal Vibrancy Departure (foliage_vibrancy.pmtiles)",
            "Deciduous Tree Canopy Density (foliage_canopy.pmtiles)",
            "Native Tree Species Distribution (foliage_species.pmtiles)",
            "Summer Temperature Anomaly (foliage_summer_temp_anomaly.pmtiles)",
            "Summer Soil Moisture Anomaly (foliage_soil_moisture_anomaly.pmtiles)"
          ],
          "toastTitle": "Fall Foliage Timing & Vibrancy Forecast",
          "toastSubtitle": "BIOPHYSICAL AUTUMN PHENOLOGY MODEL",
          "toastDescription": "Tracks projected peak autumn foliage dates, daily color progression, tree species habitats, and seasonal color vibrancy across North America."
        },
        {
          "id": "alpine_wildflowers",
          "label": "Wildflowers (Mountain/Alpine)",
          "product": "alpine_wildflowers",
          "icon": "\ud83c\udf38",
          "category": "phenology",
          "description": "Peak bloom timing & intensity",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts bloom onset, peak floral concurrency, bloom duration, and display intensity (Mountain Bloom Intensity Index, MBII) for alpine and subalpine herbaceous perennials.\n\nDriven by winter snowpack insulation, dynamic snowmelt biofix (SWE <= 0), and post-melt growing degree days (GDD) with elevation lapse-rate corrections.\n\nIncludes multi-species coverage (Arrowleaf Balsamroot, Subalpine Lupine, Indian Paintbrush, Avalanche Lily), dual domain support (North America 2.5km and Global Alpine 13km), and interactive summer calendar and multi-species concurrency curves.",
          "score_description": "\u2022 Snowbound / Pre-Melt (Icy Cyan): Terrain still insulated under winter snowpack.\n\u2022 Emerging / Vegetative (Fresh Green): Post-melt vegetative green-up and bud initiation.\n\u2022 Early Bloom (Lime Yellow): Initial floral bud opening (15-30% open).\n\u2022 Peak Concurrency (Magenta / Rose): Broadfield meadow bloom display (60-100% open).\n\u2022 Past Peak (Amber / Orange): Seed maturation and petal drop.\n\u2022 MBII Intensity (Gold to Hot Pink): Mountain Bloom Intensity factoring floral synchrony, insulation, frost risk, and snowmelt sub-irrigation.",
          "source_models": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "output_models": [
            "Alpine Wildflowers (.pmtiles)"
          ],
          "toast_title": "Alpine & Mountain Wildflowers Forecast",
          "toast_subtitle": "SNOWMELT BIOFIX & GDD PHENOLOGY",
          "toast_description": "Predicts alpine meadow bloom timing, peak multi-species concurrency, and Mountain Bloom Intensity (MBII) following winter snowmelt.",
          "longDescription": "Predicts bloom onset, peak floral concurrency, bloom duration, and display intensity (Mountain Bloom Intensity Index, MBII) for alpine and subalpine herbaceous perennials.\n\nDriven by winter snowpack insulation, dynamic snowmelt biofix (SWE <= 0), and post-melt growing degree days (GDD) with elevation lapse-rate corrections.\n\nIncludes multi-species coverage (Arrowleaf Balsamroot, Subalpine Lupine, Indian Paintbrush, Avalanche Lily), dual domain support (North America 2.5km and Global Alpine 13km), and interactive summer calendar and multi-species concurrency curves.",
          "scoreDescription": "\u2022 Snowbound / Pre-Melt (Icy Cyan): Terrain still insulated under winter snowpack.\n\u2022 Emerging / Vegetative (Fresh Green): Post-melt vegetative green-up and bud initiation.\n\u2022 Early Bloom (Lime Yellow): Initial floral bud opening (15-30% open).\n\u2022 Peak Concurrency (Magenta / Rose): Broadfield meadow bloom display (60-100% open).\n\u2022 Past Peak (Amber / Orange): Seed maturation and petal drop.\n\u2022 MBII Intensity (Gold to Hot Pink): Mountain Bloom Intensity factoring floral synchrony, insulation, frost risk, and snowmelt sub-irrigation.",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "outputModels": [
            "Alpine Wildflowers (.pmtiles)"
          ],
          "toastTitle": "Alpine & Mountain Wildflowers Forecast",
          "toastSubtitle": "SNOWMELT BIOFIX & GDD PHENOLOGY",
          "toastDescription": "Predicts alpine meadow bloom timing, peak multi-species concurrency, and Mountain Bloom Intensity (MBII) following winter snowmelt."
        },
        {
          "id": "desert_wildflowers",
          "label": "Desert Superbloom & Annuals",
          "product": "desert_wildflowers",
          "icon": "\ud83c\udfdc\ufe0f",
          "category": "phenology",
          "description": "Spring Desert wildflower timing and outlook updated daily.",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts episodic germination probability, storm cadence viability, seasonal precipitation anomalies, and flowering intensity (Bloom Intensity Index, BII) across arid basins and alluvial fans.\n\nModels the 4-phase environmental cascade: autumn seed-leaching storm trigger (>= 20mm), mid-winter storm spacing (<= 18 days), spring thermal maturation, and desert heat scorch resistance.",
          "score_description": "\u2022 Germination / Rosette (Meadow Green): Early basal leaves emerging following soaking rainfall.\n\u2022 Early Blooms (Lime Yellow): Initial desert wash and alluvial fan flowering.\n\u2022 Peak Floral Carpet (Vibrant Rose / Crimson): Peak carpet concurrency across desert valley floors.\n\u2022 Past Peak (Warm Gold): Seed setting and rapid thermal desiccation.\n\u2022 BII Score (0-100): Desert Bloom Intensity measuring superbloom probability and display density.",
          "source_models": [
            "nbm",
            "icon13"
          ],
          "output_models": [
            "Desert Superbloom (.pmtiles)"
          ],
          "toast_title": "Desert Superbloom & Annuals Outlook",
          "toast_subtitle": "ARID GERMINATION & BLOOM INTENSITY",
          "toast_description": "Tracks winter rain germination triggers, storm cadence survival, and spring superbloom intensity across desert basins and washes.",
          "longDescription": "Predicts episodic germination probability, storm cadence viability, seasonal precipitation anomalies, and flowering intensity (Bloom Intensity Index, BII) across arid basins and alluvial fans.\n\nModels the 4-phase environmental cascade: autumn seed-leaching storm trigger (>= 20mm), mid-winter storm spacing (<= 18 days), spring thermal maturation, and desert heat scorch resistance.",
          "scoreDescription": "\u2022 Germination / Rosette (Meadow Green): Early basal leaves emerging following soaking rainfall.\n\u2022 Early Blooms (Lime Yellow): Initial desert wash and alluvial fan flowering.\n\u2022 Peak Floral Carpet (Vibrant Rose / Crimson): Peak carpet concurrency across desert valley floors.\n\u2022 Past Peak (Warm Gold): Seed setting and rapid thermal desiccation.\n\u2022 BII Score (0-100): Desert Bloom Intensity measuring superbloom probability and display density.",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13"
          ],
          "outputModels": [
            "Desert Superbloom (.pmtiles)"
          ],
          "toastTitle": "Desert Superbloom & Annuals Outlook",
          "toastSubtitle": "ARID GERMINATION & BLOOM INTENSITY",
          "toastDescription": "Tracks winter rain germination triggers, storm cadence survival, and spring superbloom intensity across desert basins and washes."
        },
        {
          "id": "mushrooms",
          "label": "Wild Mushroom Foraging",
          "product": "mushrooms",
          "icon": "\ud83c\udf44",
          "category": "phenology",
          "description": "Active fruiting flushes and 7-day outlook updated daily.",
          "category_label": "Seasonal Phenology",
          "long_description": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
          "score_description": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
          "source_models": [
            "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
            "NOAA NBM / HRRR Soil & Surface Temperature",
            "USGS NLCD & Forest Host Species Habitat Maps"
          ],
          "output_models": [
            "Species-Specific Fruiting Probability Tiles (.pmtiles)",
            "7-Day Foraging Flush Outlook"
          ],
          "toast_title": "Wild Mushroom Foraging Forecast",
          "toast_subtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
          "toast_description": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats.",
          "longDescription": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
          "scoreDescription": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
          "categoryLabel": "Seasonal Phenology",
          "sourceModels": [
            "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
            "NOAA NBM / HRRR Soil & Surface Temperature",
            "USGS NLCD & Forest Host Species Habitat Maps"
          ],
          "outputModels": [
            "Species-Specific Fruiting Probability Tiles (.pmtiles)",
            "7-Day Foraging Flush Outlook"
          ],
          "toastTitle": "Wild Mushroom Foraging Forecast",
          "toastSubtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
          "toastDescription": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats."
        },
        {
          "id": "wild_berries",
          "label": "Wild Berry Ripening & Foraging",
          "product": "wild_berries",
          "icon": "\ud83e\uded0",
          "category": "phenology",
          "description": "Ripening waves, harvest windows & berry quality updated daily.",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
          "score_description": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
          "source_models": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "output_models": [
            "Wild Berries (.pmtiles)"
          ],
          "toast_title": "Wild Berry Ripening & Foraging",
          "toast_subtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
          "toast_description": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality.",
          "longDescription": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
          "scoreDescription": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "outputModels": [
            "Wild Berries (.pmtiles)"
          ],
          "toastTitle": "Wild Berry Ripening & Foraging",
          "toastSubtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
          "toastDescription": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality."
        }
      ],
      "secondaryLayers": [
        {
          "id": "cloud_inversion",
          "label": "Valley Clouds / Sea of Clouds",
          "product": "cloud_inversion",
          "model": "nbm",
          "icon": "\ud83c\udfd4\ufe0f",
          "category": "clouds_wind",
          "description": "Reveals low cloud decks/deep fog below mountainous terrain.",
          "long_description": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
          "score_description": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Cloud Inversion / Sea of Clouds (.pmtiles)"
          ],
          "toast_title": "Sea of Clouds (Cloud Inversion)",
          "toast_subtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
          "toast_description": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas.",
          "longDescription": "A temperature inversion occurs when a layer of warm air traps cooler, denser air beneath it in valleys and lowlands, creating a dramatic \"Sea of Clouds\" where dense fog and low stratus clouds fill the valleys like an ocean while higher terrain remains clear and sunny.\n\nThis layer uses high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with boundary-layer cloud geometry to map the 3D surface of low cloud decks against actual topography. Mountain summits, high ridges, and elevated viewpoints extending above the cloud top altitude are cleanly unmasked and rendered transparent with smooth 50-meter shoreline feathering.\n\nLow clouds (stratus, stratocumulus, radiation fog, and marine layers) with bases below 12,000 ft MSL are rendered where they flood valleys and low-elevation basins. High cirrus and elevated cloud decks are filtered out to focus purely on boundary-layer inversions and low-altitude fog pools.\n\nDesigned specifically for hikers, mountaineers, landscape photographers, and pilots planning summit trips to witness spectacular 'sea of clouds' phenomena above submerged valleys.",
          "scoreDescription": "\u2022 Infilled Valleys & Lowlands (Solid to Translucent White/Blue): Low cloud decks and valley fog submerging low-elevation terrain beneath the temperature inversion.\n\u2022 Emergent Summits & Ridges (Transparent): Mountain topography rising above the cloud top elevation (Z_DEM > Z_top), revealing unobstructed clear skies and sunny terrain.\n\u2022 Shoreline Feathering (50m Gradient): Smooth elevation transition along mountainsides where the cloud deck laps against rising terrain slopes.\n\u2022 Low Deck Gate: Only cloud decks with cloud bases below 12,000 ft MSL are displayed to filter out high-altitude overcast and cirrus.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Cloud Inversion / Sea of Clouds (.pmtiles)"
          ],
          "toastTitle": "Sea of Clouds (Cloud Inversion)",
          "toastSubtitle": "UNDERCAST TOPOGRAPHIC CLOUD TOPS",
          "toastDescription": "Highlights high-elevation viewpoints and mountain ridges that rise above a trapped stratus cloud deck for dramatic above-the-clouds vistas."
        },
        {
          "id": "mountain_visibility",
          "label": "Mountain Visibility",
          "product": "mountain_visibility",
          "model": "nbm",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "clouds_wind",
          "description": "Terrain based visibility forecast indicating mountainous areas with no or limited visibility.",
          "long_description": "Mountain Visibility identifies the exact vertical zone where mountain slopes, passes, and ridgelines are submerged within active cloud decks, enveloped in dense fog, rain, or whiteout conditions.\n\nUsing high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with National Blend of Models (NBM) cloud base and cloud top boundary surfaces, this layer maps the physical 3D cloud deck sandwich against real terrain:\n\u2022 Below Cloud Base: Valleys and lowlands under the cloud deck remain 100% transparent in clear air beneath the ceiling.\n\u2022 In-Cloud Deck: Mountain terrain between cloud base and cloud top is rendered in an atmospheric slate-blue cloud shroud.\n\u2022 Above Cloud Tops: Mountain summits and high alpine ridges piercing above the cloud deck remain 100% transparent in clear sunshine.\n\nThis gives backcountry hikers, mountaineers, trail runners, and alpine photographers immediate clarity on whether a trail enters the clouds, where whiteout conditions begin, and which mountain peaks rise into clear sky above.",
          "score_description": "\u2022 Slate-Blue Shroud: Terrain submerged inside the cloud deck (Cloud Base <= Elevation <= Cloud Top), indicating fog, cloud obscuration, or whiteout.\n\u2022 Transparent Valleys: Terrain below the cloud base with clear air and open ground-level visibility underneath the ceiling.\n\u2022 Transparent Summits: High alpine peaks and ridges extending above the cloud top into clear blue sky and sunshine.\n\u2022 Shoreline Feathering: Smooth 50-meter elevation transition along lower and upper cloud boundaries.",
          "category_label": "Core Meteorological",
          "source_models": [
            "nbm"
          ],
          "output_models": [
            "Mountain Visibility (.pmtiles)"
          ],
          "toast_title": "Mountain Cloud Shroud & Whiteout Zones",
          "toast_subtitle": "3D TERRAIN CLOUD INTERSECTION",
          "toast_description": "Map plots areas where there is no visibility based on elevation in grey.  Areas shrouded in grey on the map indicates low or no visibility at the given elevation.",
          "longDescription": "Mountain Visibility identifies the exact vertical zone where mountain slopes, passes, and ridgelines are submerged within active cloud decks, enveloped in dense fog, rain, or whiteout conditions.\n\nUsing high-resolution digital elevation modeling (USGS 3DEP 1km DEM) coupled with National Blend of Models (NBM) cloud base and cloud top boundary surfaces, this layer maps the physical 3D cloud deck sandwich against real terrain:\n\u2022 Below Cloud Base: Valleys and lowlands under the cloud deck remain 100% transparent in clear air beneath the ceiling.\n\u2022 In-Cloud Deck: Mountain terrain between cloud base and cloud top is rendered in an atmospheric slate-blue cloud shroud.\n\u2022 Above Cloud Tops: Mountain summits and high alpine ridges piercing above the cloud deck remain 100% transparent in clear sunshine.\n\nThis gives backcountry hikers, mountaineers, trail runners, and alpine photographers immediate clarity on whether a trail enters the clouds, where whiteout conditions begin, and which mountain peaks rise into clear sky above.",
          "scoreDescription": "\u2022 Slate-Blue Shroud: Terrain submerged inside the cloud deck (Cloud Base <= Elevation <= Cloud Top), indicating fog, cloud obscuration, or whiteout.\n\u2022 Transparent Valleys: Terrain below the cloud base with clear air and open ground-level visibility underneath the ceiling.\n\u2022 Transparent Summits: High alpine peaks and ridges extending above the cloud top into clear blue sky and sunshine.\n\u2022 Shoreline Feathering: Smooth 50-meter elevation transition along lower and upper cloud boundaries.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm"
          ],
          "outputModels": [
            "Mountain Visibility (.pmtiles)"
          ],
          "toastTitle": "Mountain Cloud Shroud & Whiteout Zones",
          "toastSubtitle": "3D TERRAIN CLOUD INTERSECTION",
          "toastDescription": "Map plots areas where there is no visibility based on elevation in grey.  Areas shrouded in grey on the map indicates low or no visibility at the given elevation."
        },
        {
          "id": "streamflow_gauges",
          "label": "Stream & Reservoir Flows",
          "product": "streamflow",
          "icon": "\ud83c\udf0a",
          "category": "hydrology",
          "description": "Stream and reservoir levels, flow rates, temperature.",
          "category_label": "Hydrology & Inland Waters",
          "long_description": "Real-time USGS river and stream telemetry monitoring flow discharge rates (cfs), gauge height, and water temperatures.",
          "score_description": "\u2022 Percentile Color Mode (% of Historical Normal): Colors gauges from extreme low flow (Red/Orange) through normal flow (Green) to high/flood flow (Blue/Purple).\n\u2022 Flow & Storage Mode: Displays absolute river discharge (cfs) and reservoir storage capacity.\n\u2022 Water Temperature Mode: Displays live river and lake water temperatures (\u00b0F/\u00b0C) for anglers and paddlers.",
          "source_models": [
            "USGS National Water Information System (NWIS) Telemetry"
          ],
          "output_models": [
            "Streamflow station telemetry markers",
            "Inland water temperature raster"
          ],
          "toast_title": "Live Streamflow, Reservoirs & Water Temp",
          "toast_subtitle": "REAL-TIME USGS NWIS HYDROLOGY GAUGES",
          "toast_description": "Monitors real-time river discharge (cfs), historical flow percentiles, reservoir levels, and water temperatures across thousands of gauges.",
          "longDescription": "Real-time USGS river and stream telemetry monitoring flow discharge rates (cfs), gauge height, and water temperatures.",
          "scoreDescription": "\u2022 Percentile Color Mode (% of Historical Normal): Colors gauges from extreme low flow (Red/Orange) through normal flow (Green) to high/flood flow (Blue/Purple).\n\u2022 Flow & Storage Mode: Displays absolute river discharge (cfs) and reservoir storage capacity.\n\u2022 Water Temperature Mode: Displays live river and lake water temperatures (\u00b0F/\u00b0C) for anglers and paddlers.",
          "categoryLabel": "Hydrology & Inland Waters",
          "sourceModels": [
            "USGS National Water Information System (NWIS) Telemetry"
          ],
          "outputModels": [
            "Streamflow station telemetry markers",
            "Inland water temperature raster"
          ],
          "toastTitle": "Live Streamflow, Reservoirs & Water Temp",
          "toastSubtitle": "REAL-TIME USGS NWIS HYDROLOGY GAUGES",
          "toastDescription": "Monitors real-time river discharge (cfs), historical flow percentiles, reservoir levels, and water temperatures across thousands of gauges."
        },
        {
          "id": "lenticular_clouds",
          "label": "Lenticular Cloud Probability",
          "product": "lenticular",
          "model": "ensemble",
          "icon": "\ud83d\udef8",
          "category": "clouds_wind",
          "description": "Identifies favorable conditions for lenticular cloud formation indicating turbulent conditions near mountain peaks.",
          "long_description": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
          "category_label": "Forecast Quality Scoring",
          "score_description": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
          "source_models": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "output_models": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "toast_title": "Lenticular Wave Cloud Forecast",
          "toast_subtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
          "toast_description": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks.",
          "longDescription": "Mountain wave cloud formation model indicates where conditions are favorable for Lenticular cloud formation. Colored area does not represent the likely extent of a Lenticular, but only where conditions are favorable.",
          "scoreDescription": "\u2022 Cap / Standing Wave Mode (Cyan): Favorable upper-ridge moisture, static stability, and strong cross-barrier wind shear for clean standing lenticular clouds.\n\u2022 Trapped Lee Wave Mode (Amber): Downstream resonance waves favorable for stacked or repeating lee-wave cloud bands.\n\u2022 Shrouded / Socked-In Penalty (Red): High low-level cloud cover or precipitation that obscures mountain peaks from view.",
          "categoryLabel": "Forecast Quality Scoring",
          "sourceModels": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "outputModels": [
            "ecmwf",
            "rrfs",
            "rdps",
            "gdps"
          ],
          "toastTitle": "Lenticular Wave Cloud Forecast",
          "toastSubtitle": "OROGRAPHIC STANDING MOUNTAIN WAVES",
          "toastDescription": "Detects strong cross-barrier ridge winds combined with stable, moist mid-tropospheric layers capable of forming standing lenticular wave clouds downwind of peaks."
        },
        {
          "id": "mushrooms",
          "label": "Wild Mushroom Foraging",
          "product": "mushrooms",
          "icon": "\ud83c\udf44",
          "category": "phenology",
          "description": "Active fruiting flushes and 7-day outlook updated daily.",
          "category_label": "Seasonal Phenology",
          "long_description": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
          "score_description": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
          "source_models": [
            "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
            "NOAA NBM / HRRR Soil & Surface Temperature",
            "USGS NLCD & Forest Host Species Habitat Maps"
          ],
          "output_models": [
            "Species-Specific Fruiting Probability Tiles (.pmtiles)",
            "7-Day Foraging Flush Outlook"
          ],
          "toast_title": "Wild Mushroom Foraging Forecast",
          "toast_subtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
          "toast_description": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats.",
          "longDescription": "Biophysical wild mushroom fruiting probability and 7-day foraging outlook updated daily across North America.\n\nIntegrates antecedent soaking rainfall (14-day QPE accumulation), top-10cm soil temperature regimes, forest canopy host associations, vapor pressure deficit (VPD), and elevation thermal triggers to identify active and upcoming fungal flushes for Morels, Chanterelles, Porcini (King Boletes), Matsutake, Maitake, Oyster, and Black Trumpet mushrooms.",
          "scoreDescription": "\u2022 Prime Flush (80\u2013100): Optimal soil temperature, soaking antecedent rainfall, high forest floor humidity, and compatible host tree canopy.\n\u2022 Active / Emerging (50\u201379): Favorable moisture and thermal conditions initiating primordia and localized fruiting.\n\u2022 Marginal / Dormant (20\u201349): Partial moisture deficit or temperatures slightly outside peak fruiting window.\n\u2022 Unfavorable / Dry (<20): Frozen soil, severe heat, or insufficient rainfall for fungal fruiting.",
          "categoryLabel": "Seasonal Phenology",
          "sourceModels": [
            "NOAA MRMS & URMA 14-Day Precipitation & Soil Moisture",
            "NOAA NBM / HRRR Soil & Surface Temperature",
            "USGS NLCD & Forest Host Species Habitat Maps"
          ],
          "outputModels": [
            "Species-Specific Fruiting Probability Tiles (.pmtiles)",
            "7-Day Foraging Flush Outlook"
          ],
          "toastTitle": "Wild Mushroom Foraging Forecast",
          "toastSubtitle": "SOIL MOISTURE, TEMP & HOST HABITAT MODEL",
          "toastDescription": "Models active fungal fruiting flushes and 7-day foraging outlooks using antecedent rainfall, soil temperatures, and forest host habitats."
        },
        {
          "id": "wild_berries",
          "label": "Wild Berry Ripening & Foraging",
          "product": "wild_berries",
          "icon": "\ud83e\uded0",
          "category": "phenology",
          "description": "Ripening waves, harvest windows & berry quality updated daily.",
          "category_label": "Seasonal & Phenology",
          "long_description": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
          "score_description": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
          "source_models": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "output_models": [
            "Wild Berries (.pmtiles)"
          ],
          "toast_title": "Wild Berry Ripening & Foraging",
          "toast_subtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
          "toast_description": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality.",
          "longDescription": "Predicts two-phase developmental progression (anthesis and fruit maturation), harvest windows, ascending mountain elevation-wave timing, and crop stress badges for native edible species without exposing sensitive GPS locations.\n\nTarget species include Mountain Huckleberry (Vaccinium membranaceum), Salmonberry (Rubus spectabilis), and Wild Blackberries. Evaluates crop quality badges (Prime/Plump, Moderate/Fair, Drought-Stressed/Seedy, Frost Aborted).",
          "scoreDescription": "\u2022 Green / Immature (Meadow Green): Developing unripe green fruit.\n\u2022 Early Ripe Window (Magenta Violet): Appearance of first ripe berries for early foragers.\n\u2022 Peak Sugar Harvest (Deep Royal Purple): Prime sweet flavor, high brix concurrency.\n\u2022 Overripe (Russet Brown): Fruit drop, shriveling, and post-season senescence.\n\u2022 Crop Quality Badges: Emerald (Prime / Plump), Amber (Moderate), Orange (Drought-Stressed), Ruby (Frost Aborted).",
          "categoryLabel": "Seasonal & Phenology",
          "sourceModels": [
            "nbm",
            "icon13",
            "gdps"
          ],
          "outputModels": [
            "Wild Berries (.pmtiles)"
          ],
          "toastTitle": "Wild Berry Ripening & Foraging",
          "toastSubtitle": "ELEVATION RIPENING WAVE & CROP QUALITY",
          "toastDescription": "Predicts wild huckleberry, salmonberry, and blackberry ripening waves across elevation bands along with seasonal berry quality."
        },
        {
          "id": "seeing",
          "label": "Astronomical Seeing",
          "product": "seeing",
          "model": "rdps",
          "icon": "\ud83d\udd2d",
          "category": "sky_solar",
          "description": "Atmospheric optical stability and wavefront steadiness modeling turbulent optical distortion across night hours (0-100 score).",
          "category_label": "Specialized Forecast Index",
          "long_description": "Atmospheric optical stability predicting wavefront steadiness, jet stream shear, boundary layer turbulence, and telescope resolution.",
          "score_description": "\u2022 80\u2013100 (Excellent / Sub-Arcsecond Stability): Calm upper-level winds and minimal thermal gradients; crisp planetary detail and pinpoint stars.\n\u2022 60\u201379 (Good Seeing): Slight atmospheric shimmer; well-suited for deep-sky imaging and medium-to-high magnification.\n\u2022 40\u201359 (Average / Moderate Turbulence): Noticeable star twinkling (scintillation) and softening of fine lunar/planetary features.\n\u2022 0\u201339 (Poor / Turbulent Jet Stream Shear): Strong vertical wind shear or boundary-layer mixing causing rapid wavefront distortion.",
          "source_models": [
            "rdps",
            "hrrr",
            "rrfs",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "rdps & hrrr .pmtiles"
          ],
          "toast_title": "Astronomical Seeing & Jet Stream Stability",
          "toast_subtitle": "OPTICAL TURBULENCE & THERMAL SHEAR",
          "toast_description": "Evaluates atmospheric optical stability for planetary imaging and high-magnification stargazing based on vertical wind shear and thermal gradients.",
          "longDescription": "Atmospheric optical stability predicting wavefront steadiness, jet stream shear, boundary layer turbulence, and telescope resolution.",
          "scoreDescription": "\u2022 80\u2013100 (Excellent / Sub-Arcsecond Stability): Calm upper-level winds and minimal thermal gradients; crisp planetary detail and pinpoint stars.\n\u2022 60\u201379 (Good Seeing): Slight atmospheric shimmer; well-suited for deep-sky imaging and medium-to-high magnification.\n\u2022 40\u201359 (Average / Moderate Turbulence): Noticeable star twinkling (scintillation) and softening of fine lunar/planetary features.\n\u2022 0\u201339 (Poor / Turbulent Jet Stream Shear): Strong vertical wind shear or boundary-layer mixing causing rapid wavefront distortion.",
          "categoryLabel": "Specialized Forecast Index",
          "sourceModels": [
            "rdps",
            "hrrr",
            "rrfs",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "rdps & hrrr .pmtiles"
          ],
          "toastTitle": "Astronomical Seeing & Jet Stream Stability",
          "toastSubtitle": "OPTICAL TURBULENCE & THERMAL SHEAR",
          "toastDescription": "Evaluates atmospheric optical stability for planetary imaging and high-magnification stargazing based on vertical wind shear and thermal gradients."
        }
      ]
    },
    "standard_forecast": {
      "id": "standard_forecast",
      "title": "Standard Forecast",
      "icon": "\u26c5",
      "description": "Layers for general weather forecast.",
      "defaultBasemap": "road",
      "basemapConfig": {
        "theme": "road",
        "mode": "light",
        "terrain3d": false,
        "shading": "color_tint"
      },
      "isDefault": true,
      "isCustom": false,
      "forecastLayoutRef": "config/forecast_layouts/standard_forecast.yaml",
      "forecastLayout": {
        "id": "standard_forecast",
        "name": "Standard Forecast",
        "description": "Layers for general weather forecast.",
        "web": {
          "columns": 12,
          "widgets": [
            {
              "id": "widget_1792255571140_673",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "horizon_selector",
              "type": "horizon_selector",
              "title": "Forecast Horizon",
              "col_span": 12,
              "options": {
                "options": [
                  "1-Day",
                  "3-Day",
                  "5-Day",
                  "Max"
                ],
                "default": "1-Day",
                "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
              },
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            {
              "id": "widget_1791778478494_174",
              "type": "glance-2x2",
              "title": "Current Weather",
              "colSpan": 6,
              "options": {
                "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
              },
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            {
              "id": "widget_1791778466710_156",
              "type": "recent-weather-2x3",
              "title": "Recent Rain and Snow Totals",
              "colSpan": 6,
              "options": {
                "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
              },
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            {
              "id": "widget_1791778362110_245",
              "type": "daily-forecast-list",
              "title": "Daily and Hourly Weather Forecast",
              "colSpan": 12,
              "options": {
                "period": "auto",
                "dataSource": "auto",
                "showRainChance": true,
                "showWind": true,
                "showTempBar": true,
                "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
              },
              "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
            },
            {
              "id": "widget_1792250342667_626",
              "type": "meteogram-card",
              "title": "Temperature and Precipitation Probability",
              "colSpan": 12,
              "options": {
                "height": 200,
                "showNow": true,
                "staticYAxis": true,
                "horizonDays": "auto",
                "showMountainSilhouette": false,
                "declutterElevations": true,
                "showMinMaxLines": false,
                "minMaxSeriesKey": "auto",
                "series": [
                  {
                    "key": "temps_f",
                    "label": "Temperature at Forecast Point (\u00b0F)",
                    "type": "line",
                    "yAxis": "left",
                    "color": "#f43f5e",
                    "tension": 0.3
                  },
                  {
                    "key": "precip_prob_pct",
                    "label": "Precipitation Probability (%)",
                    "type": "bar",
                    "yAxis": "right",
                    "color": "#3b82f6",
                    "tension": 0.3,
                    "model": "auto"
                  }
                ],
                "description": "Hourly multi-series meteogram plotting forecast air temperature (\u00b0F, red curve on left axis) alongside hourly precipitation probability (%, blue bars on right axis). Use the model selector to compare official agency blends (NWS/ECCC) against individual global and mesoscale models."
              },
              "description": "Hourly multi-series meteogram plotting forecast air temperature (\u00b0F, red curve on left axis) alongside hourly precipitation probability (%, blue bars on right axis). Use the model selector to compare official agency blends (NWS/ECCC) against individual global and mesoscale models."
            },
            {
              "id": "tropical_hazards",
              "type": "tropical-cyclones-card",
              "title": "Hurricanes & Tropical Storms",
              "col_span": 6,
              "options": {
                "description": "Active NHC and JTWC tropical cyclone tracker displaying nearby tropical depressions, storms, and hurricanes with forecast intensity, track distance, arrival timing, and wind radii."
              },
              "description": "Active NHC and JTWC tropical cyclone tracker displaying nearby tropical depressions, storms, and hurricanes with forecast intensity, track distance, arrival timing, and wind radii."
            },
            {
              "id": "nearby_wildfires",
              "type": "nearby-wildfires-card",
              "title": "Nearby Wildfires",
              "col_span": 6,
              "options": {
                "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
              },
              "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
            }
          ]
        },
        "mobile": {
          "columns": 12,
          "widgets": [
            {
              "id": "widget_1791745202229_500",
              "type": "app-bar",
              "title": "Location Header",
              "colSpan": 12,
              "options": {
                "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
              },
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            {
              "id": "widget_1791745184446_706",
              "type": "persona-chips",
              "title": "Activity Selector",
              "colSpan": 12,
              "options": {
                "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
              },
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            {
              "id": "widget_1791745147981_703",
              "type": "glance-2x2",
              "title": "Current Weather",
              "colSpan": 4,
              "options": {
                "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
              },
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            {
              "id": "widget_1791745166205_538",
              "type": "daily-forecast-list",
              "title": "Daily Weather Forecast",
              "colSpan": 12,
              "options": {
                "period": "auto",
                "dataSource": "auto",
                "showRainChance": true,
                "showWind": true,
                "showTempBar": true,
                "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
              },
              "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
            },
            {
              "id": "widget_1791745149325_775",
              "type": "recent-weather-2x3",
              "title": "Recent Rain and Snow Totals",
              "colSpan": 6,
              "options": {
                "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
              },
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            {
              "id": "mobile_nearby_wildfires",
              "type": "nearby-wildfires-card",
              "title": "Nearby Wildfires",
              "colSpan": 12,
              "options": {
                "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
              },
              "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
            },
            {
              "id": "mobile_tropical_hazards",
              "type": "tropical-cyclones-card",
              "title": "Hurricanes & Tropical Storms",
              "colSpan": 12,
              "options": {
                "description": "Active NHC and JTWC tropical cyclone tracker displaying nearby tropical depressions, storms, and hurricanes with forecast intensity, track distance, arrival timing, and wind radii."
              },
              "description": "Active NHC and JTWC tropical cyclone tracker displaying nearby tropical depressions, storms, and hurricanes with forecast intensity, track distance, arrival timing, and wind radii."
            },
            {
              "id": "widget_1791745191798_3",
              "type": "bottom-nav",
              "title": "Navigation Bar",
              "colSpan": 12,
              "options": {
                "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
              },
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            }
          ]
        }
      },
      "primaryLayers": [
        {
          "id": "wx_stations",
          "label": "Weather Station Observations",
          "product": "wx_stations",
          "model": "metar",
          "icon": "\ud83d\udce1",
          "category": "temperature",
          "description": "Real-time 5-min NOAA METAR/ASOS surface weather station observations & 14-day history charts.",
          "category_label": "Surface Weather Observations",
          "long_description": "Real-time surface weather observations (5-minute cadence) from ~7,300+ global NOAA Aviation Weather Center (METAR / ASOS / AWOS) and backcountry US Interagency RAWS mountain/wilderness weather stations with interactive Today, 7-Day, and 14-Day telemetry charts.",
          "score_description": "\u2022 Selectable Telemetry Badges: Switch station badges between Temperature, Wind Speed, Wind Gusts, Dew Point, Relative Humidity, Pressure, and Visibility.\n\u2022 Historical Trend Charts: Click any station to inspect 24-Hour, 7-Day, and 14-Day observed temperature, wind, and precipitation history.",
          "source_models": [
            "NOAA Aviation Weather Center (AWC) METAR / ASOS / AWOS Feed",
            "NIFC Interagency Remote Automatic Weather Stations (PublicView_RAWS)",
            "NOAA HADS / NWS & Iowa Environmental Mesonet Historical Archives"
          ],
          "output_models": [
            "Progressive-zoom WebGL station markers & readout badges",
            "Interactive 24H / 7-Day / 14-Day surface observation trend charts"
          ],
          "toast_title": "Live Weather Stations (METAR & RAWS)",
          "toast_subtitle": "REAL-TIME 5-MIN SURFACE TELEMETRY",
          "toast_description": "Displays live observations from 7,300+ airport METAR and backcountry mountain RAWS weather stations with 14-day historical charts.",
          "longDescription": "Real-time surface weather observations (5-minute cadence) from ~7,300+ global NOAA Aviation Weather Center (METAR / ASOS / AWOS) and backcountry US Interagency RAWS mountain/wilderness weather stations with interactive Today, 7-Day, and 14-Day telemetry charts.",
          "scoreDescription": "\u2022 Selectable Telemetry Badges: Switch station badges between Temperature, Wind Speed, Wind Gusts, Dew Point, Relative Humidity, Pressure, and Visibility.\n\u2022 Historical Trend Charts: Click any station to inspect 24-Hour, 7-Day, and 14-Day observed temperature, wind, and precipitation history.",
          "categoryLabel": "Surface Weather Observations",
          "sourceModels": [
            "NOAA Aviation Weather Center (AWC) METAR / ASOS / AWOS Feed",
            "NIFC Interagency Remote Automatic Weather Stations (PublicView_RAWS)",
            "NOAA HADS / NWS & Iowa Environmental Mesonet Historical Archives"
          ],
          "outputModels": [
            "Progressive-zoom WebGL station markers & readout badges",
            "Interactive 24H / 7-Day / 14-Day surface observation trend charts"
          ],
          "toastTitle": "Live Weather Stations (METAR & RAWS)",
          "toastSubtitle": "REAL-TIME 5-MIN SURFACE TELEMETRY",
          "toastDescription": "Displays live observations from 7,300+ airport METAR and backcountry mountain RAWS weather stations with 14-day historical charts."
        },
        {
          "id": "hrtemp_current",
          "label": "Current Temperature (RTMA)",
          "product": "hrtemp_current",
          "model": "rtma",
          "icon": "\ud83c\udf21\ufe0f",
          "category": "temperature",
          "description": "Real-time NOAA RTMA 2.5km surface temperature observations.",
          "category_label": "Real-Time Observation",
          "long_description": "Real-time surface temperature observations derived from NOAA Real-Time Mesoscale Analysis (RTMA 2.5km).",
          "score_description": "\u2022 High-Resolution 2.5km Grid: Blends surface weather station observations with topographic elevation modeling to map current temperatures across peaks and valleys.\n\u2022 Isotherm Contours: Optional 5\u00b0F contour lines highlighting sharp thermal fronts and freezing boundaries.",
          "source_models": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "output_models": [
            "Real-time 2.5km surface temperature .pmtiles"
          ],
          "toast_title": "Current Surface Temperature (Live RTMA)",
          "toast_subtitle": "2.5KM TERRAIN-ANALYZED OBSERVATIONS",
          "toast_description": "Maps current real-time 2-meter air temperatures at 2.5km resolution using NOAA Real-Time Mesoscale Analysis.",
          "longDescription": "Real-time surface temperature observations derived from NOAA Real-Time Mesoscale Analysis (RTMA 2.5km).",
          "scoreDescription": "\u2022 High-Resolution 2.5km Grid: Blends surface weather station observations with topographic elevation modeling to map current temperatures across peaks and valleys.\n\u2022 Isotherm Contours: Optional 5\u00b0F contour lines highlighting sharp thermal fronts and freezing boundaries.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "outputModels": [
            "Real-time 2.5km surface temperature .pmtiles"
          ],
          "toastTitle": "Current Surface Temperature (Live RTMA)",
          "toastSubtitle": "2.5KM TERRAIN-ANALYZED OBSERVATIONS",
          "toastDescription": "Maps current real-time 2-meter air temperatures at 2.5km resolution using NOAA Real-Time Mesoscale Analysis."
        },
        {
          "id": "precip_radar",
          "label": "Doppler Radar",
          "product": "live_weather",
          "model": "mrms",
          "icon": "\ud83d\udce1",
          "category": "precipitation",
          "description": "Near real time doppler radar",
          "basemap_override": {
            "terrain_3d": false
          },
          "category_label": "Real-Time Observation",
          "long_description": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "score_description": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "source_models": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "output_models": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toast_title": "Live NOAA MRMS Doppler Radar",
          "toast_subtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toast_description": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops.",
          "basemapOverride": {
            "terrain3d": false
          },
          "longDescription": "High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.",
          "scoreDescription": "\u2022 Light Virga / Drizzle (10\u201320 dBZ - Light Blue/Green): Mist, light rain, or light snow flurries.\n\u2022 Moderate Precipitation (25\u201335 dBZ - Emerald to Yellow): Steady rain or moderate snowfall.\n\u2022 Heavy Downpour (40\u201350 dBZ - Orange to Red): Heavy convective rain, graupel, or intense squalls.\n\u2022 Severe Storm Core / Hail (55+ dBZ - Magenta/Purple/White): Torrential rain, large hail, and severe thunderstorm cores.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity"
          ],
          "outputModels": [
            "Real-time seamless WebGL tile loops (1h, 2h, 4h history)"
          ],
          "toastTitle": "Live NOAA MRMS Doppler Radar",
          "toastSubtitle": "REAL-TIME 2\u20135 MIN COMPOSITE REFLECTIVITY",
          "toastDescription": "Displays live high-resolution NOAA Multi-Radar Multi-Sensor (MRMS) Doppler radar reflectivity with animated historical playback loops."
        },
        {
          "id": "lightning_live",
          "label": "Lightning Activity (Observed)",
          "product": "live_weather",
          "model": "mrms_lightning",
          "icon": "\u26a1",
          "category": "precipitation",
          "description": "Rolling 8-hour 5-minute lightning strikes scaled by flash density and age (yellow to gray).",
          "long_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "category_label": "Real-Time Observation",
          "score_description": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "source_models": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "output_models": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toast_title": "Live Lightning Strikes (8-Hour Trail)",
          "toast_subtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toast_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.",
          "longDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "scoreDescription": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "outputModels": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toastTitle": "Live Lightning Strikes (8-Hour Trail)",
          "toastSubtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toastDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes."
        },
        {
          "id": "satellite_imagery",
          "label": "Satellite Imagery (Vis & IR)",
          "product": "live_weather",
          "model": "goes",
          "icon": "\ud83d\udef0\ufe0f",
          "category": "clouds_wind",
          "description": "High-frequency visible and infrared geostationary satellite cloud loops.",
          "category_label": "Real-Time Observation",
          "long_description": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "score_description": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "source_models": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "output_models": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toast_title": "Live Geostationary Satellite Imagery",
          "toast_subtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toast_description": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems.",
          "longDescription": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "scoreDescription": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "outputModels": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toastTitle": "Live Geostationary Satellite Imagery",
          "toastSubtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toastDescription": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems."
        },
        {
          "id": "winds_surface_current",
          "label": "Surface Winds (Current)",
          "product": "live_weather",
          "model": "rtma_winds",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Current and recently observed surface winds.",
          "category_label": "Real-Time Observation",
          "long_description": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "score_description": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "source_models": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "output_models": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toast_title": "Current Surface Winds (Live RTMA)",
          "toast_subtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toast_description": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines.",
          "longDescription": "Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).",
          "scoreDescription": "\u2022 Sustained 10m Winds: Real-time analyzed surface wind speed and animated directional streamlines.\n\u2022 Wind Gusts Mode: Toggle between sustained winds and peak 10-meter wind gusts across complex terrain.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)"
          ],
          "outputModels": [
            "Real-time wind vector streamlines and velocity tiles"
          ],
          "toastTitle": "Current Surface Winds (Live RTMA)",
          "toastSubtitle": "2.5KM REAL-TIME MESOSCALE ANALYSIS",
          "toastDescription": "Displays live 2.5km terrain-analyzed 10-meter sustained wind speeds, gusts, and animated directional streamlines."
        },
        {
          "id": "hrtemp",
          "label": "Temperature Forecast",
          "product": "hrtemp",
          "model": "nbm",
          "icon": "\ud83c\udf21\ufe0f",
          "category": "temperature",
          "description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "category_label": "Core Meteorological",
          "long_description": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "score_description": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Surface temperature .pmtiles per model"
          ],
          "toast_title": "Terrain-Corrected Surface Temperature",
          "toast_subtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toast_description": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures.",
          "longDescription": "2M Surface temperature forecast with high-resolution topographic corrections.",
          "scoreDescription": "\u2022 Terrain Lapse-Rate Downscaling: Adjusts numerical weather model temperatures onto high-resolution digital elevation models so mountain summits and deep canyons reflect true altitude temperatures.\n\u2022 5\u00b0F Isotherm Contours: Optional vector temperature contours for pinpointing freezing lines (32\u00b0F) and thermal inversions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Surface temperature .pmtiles per model"
          ],
          "toastTitle": "Terrain-Corrected Surface Temperature",
          "toastSubtitle": "HIGH-RESOLUTION LAPSE-RATE ADJUSTED TEMPS",
          "toastDescription": "Downscales numerical weather model temperatures onto high-resolution terrain elevation so mountain peaks and valley floors reflect true altitude-adjusted temperatures."
        },
        {
          "id": "precip_forecast",
          "label": "Precipitation Forecast",
          "product": "precip",
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Hourly and daily rain and snow forecasts.",
          "category_label": "Core Meteorological",
          "long_description": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "score_description": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "source_models": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "output_models": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toast_title": "Precipitation Rate, Probability & Snow",
          "toast_subtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toast_description": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models.",
          "longDescription": "Hourly precipitation rates & 24h/48h rain & snow accumulation forecasts.",
          "scoreDescription": "\u2022 Hourly Precip Rate: Instantaneous rain and snow intensity (mm/hr or in/hr) at each forecast hour.\n\u2022 Precip Probability (PoP %): Likelihood (0\u2013100%) of measurable precipitation occurring at a given point.\n\u2022 24h Rain & Snow Accumulation: Rolling 24-hour liquid precipitation and snowfall totals.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "nbm",
            "rdps",
            "ecmwf",
            "gfs",
            "hrrr",
            "icon13",
            "blend",
            "MRMS (Obs)"
          ],
          "outputModels": [
            "Precip rate & 24h Rain/Snow accumulation .pmtiles per model"
          ],
          "toastTitle": "Precipitation Rate, Probability & Snow",
          "toastSubtitle": "HOURLY RATE, POP% & 24H ACCUMULATION",
          "toastDescription": "Tracks forecasted rain and snow intensity, precipitation probability (PoP%), and 24-hour liquid or snowfall totals across NWP models."
        },
        {
          "id": "aqi_stations",
          "label": "AQI Station Data",
          "product": "live_weather",
          "model": "aqi_stations",
          "icon": "\ud83e\udec1",
          "category": "air_quality_fires",
          "description": "Near real time AQI station data.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Near-real-time hourly Air Quality Index (AQI) and PM2.5/Ozone pollutant observations from official US EPA AirNow, USFS permanent and temporary smoke monitors, and Canadian AQHI monitoring stations.",
          "score_description": "\u2022 0\u201350 (Good - Green): Clean breathable air.\n\u2022 51\u2013100 (Moderate - Yellow): Slight particulate or ozone elevation.\n\u2022 101\u2013150 (USG - Orange): Unhealthy for sensitive groups.\n\u2022 151\u2013200 (Unhealthy - Red): Widespread smoke or pollution impact.\n\u2022 201+ (Very Unhealthy / Hazardous - Purple/Maroon): Severe smoke plume impact at surface sensors.",
          "source_models": [
            "US EPA AirNow Real-Time Telemetry",
            "USFS AirFire Smoke Monitors",
            "ECCC Canadian AQHI Network"
          ],
          "output_models": [
            "Real-time AQI observation station markers & telemetry"
          ],
          "toast_title": "Live Air Quality Monitoring Stations",
          "toast_subtitle": "REAL-TIME EPA AIRNOW & SMOKE SENSORS",
          "toast_description": "Displays live hourly AQI readings from ground-level EPA AirNow and USFS air quality monitoring stations.",
          "longDescription": "Near-real-time hourly Air Quality Index (AQI) and PM2.5/Ozone pollutant observations from official US EPA AirNow, USFS permanent and temporary smoke monitors, and Canadian AQHI monitoring stations.",
          "scoreDescription": "\u2022 0\u201350 (Good - Green): Clean breathable air.\n\u2022 51\u2013100 (Moderate - Yellow): Slight particulate or ozone elevation.\n\u2022 101\u2013150 (USG - Orange): Unhealthy for sensitive groups.\n\u2022 151\u2013200 (Unhealthy - Red): Widespread smoke or pollution impact.\n\u2022 201+ (Very Unhealthy / Hazardous - Purple/Maroon): Severe smoke plume impact at surface sensors.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "US EPA AirNow Real-Time Telemetry",
            "USFS AirFire Smoke Monitors",
            "ECCC Canadian AQHI Network"
          ],
          "outputModels": [
            "Real-time AQI observation station markers & telemetry"
          ],
          "toastTitle": "Live Air Quality Monitoring Stations",
          "toastSubtitle": "REAL-TIME EPA AIRNOW & SMOKE SENSORS",
          "toastDescription": "Displays live hourly AQI readings from ground-level EPA AirNow and USFS air quality monitoring stations."
        },
        {
          "id": "thunderstorm",
          "label": "Thunderstorm Probability",
          "product": "thunderstorm",
          "model": "blend",
          "icon": "\u26a1",
          "category": "precipitation",
          "description": "Thunderstorm probability (0-100%) combining atmospheric instability (CAPE), cap strength (CIN), and convective triggers.",
          "category_label": "Core Meteorological",
          "long_description": "Convective storm lightning probability & flash density forecast. Shows area where conditions will be favorable for lightning.",
          "score_description": "\u2022 Slight / Isolated Risk (10\u201330% - Cool Teal/Green): Weak convective instability; isolated rumbles or brief mountain afternoon showers possible.\n\u2022 Moderate Thunderstorm Risk (35\u201365% - Yellow to Orange): Elevated CAPE and lifting; scattered thunderstorms and cloud-to-ground lightning likely.\n\u2022 High / Severe Convective Risk (70\u2013100% - Red to Magenta): Strong atmospheric instability and updraft helicity; widespread thunderstorms and frequent lightning.",
          "source_models": [
            "hrrr",
            "rrfs",
            "ecmwf",
            "gfs",
            "MRMS NLDN (Obs)"
          ],
          "output_models": [
            "Lightning risk .pmtiles per model",
            "Real-time MRMS flash density"
          ],
          "toast_title": "Lightning & Convective Hazard",
          "toast_subtitle": "CONVECTIVE CAPE & FLASH DENSITY POTENTIAL",
          "toast_description": "Quantifies thunderstorm instability and lightning strike hazard using convective available potential energy (CAPE) and updraft helicity.",
          "longDescription": "Convective storm lightning probability & flash density forecast. Shows area where conditions will be favorable for lightning.",
          "scoreDescription": "\u2022 Slight / Isolated Risk (10\u201330% - Cool Teal/Green): Weak convective instability; isolated rumbles or brief mountain afternoon showers possible.\n\u2022 Moderate Thunderstorm Risk (35\u201365% - Yellow to Orange): Elevated CAPE and lifting; scattered thunderstorms and cloud-to-ground lightning likely.\n\u2022 High / Severe Convective Risk (70\u2013100% - Red to Magenta): Strong atmospheric instability and updraft helicity; widespread thunderstorms and frequent lightning.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "ecmwf",
            "gfs",
            "MRMS NLDN (Obs)"
          ],
          "outputModels": [
            "Lightning risk .pmtiles per model",
            "Real-time MRMS flash density"
          ],
          "toastTitle": "Lightning & Convective Hazard",
          "toastSubtitle": "CONVECTIVE CAPE & FLASH DENSITY POTENTIAL",
          "toastDescription": "Quantifies thunderstorm instability and lightning strike hazard using convective available potential energy (CAPE) and updraft helicity."
        },
        {
          "id": "clouds",
          "label": "Cloud Forecast",
          "product": "clouds",
          "icon": "\u2601\ufe0f",
          "category": "clouds_wind",
          "description": "Cloud forecasts.",
          "long_description": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "category_label": "Core Meteorological",
          "score_description": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "source_models": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "output_models": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toast_title": "Cloud Cover Forecast",
          "toast_subtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toast_description": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures.",
          "longDescription": "High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.",
          "scoreDescription": "\u2022 Total Cloud Cover (0\u2013100%): Combined cloud fraction across the entire atmospheric column.\n\u2022 Low Clouds (Surface to ~6,500 ft / 800 hPa): Stratus, cumulus, and fog decks that obscure mountain peaks and block low horizon rays.\n\u2022 Mid Clouds (~6,500 to 20,000 ft / 800\u2013450 hPa): Altocumulus and altostratus decks ideal for dramatic golden hour texture.\n\u2022 High Clouds (>20,000 ft / <450 hPa): Ice-crystal cirrus and cirrostratus canopies that catch vivid pre-dawn and post-sunset color.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "ecmwf",
            "gfs",
            "hrrr",
            "rdps",
            "rrfs",
            "icon13"
          ],
          "outputModels": [
            "Multi-layer .pmtiles grids per model (Low, Mid, High, Total)"
          ],
          "toastTitle": "Cloud Cover Forecast",
          "toastSubtitle": "HIGH, MID, LOW & TOTAL CLOUD DECKS",
          "toastDescription": "Visualizes forecasted high, mid, and low altitude cloud fractions across multiple atmospheric models to pinpoint clear windows and dramatic sky textures."
        },
        {
          "id": "winds_surface",
          "label": "Surface Winds Forecast",
          "product": "winds",
          "model": "blend",
          "icon": "\ud83d\udca8",
          "category": "clouds_wind",
          "description": "Forecasted Surface Winds (10m)",
          "category_label": "Core Meteorological",
          "long_description": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "score_description": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "source_models": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "output_models": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toast_title": "Surface Winds & Gusts",
          "toast_subtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toast_description": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models.",
          "longDescription": "10m Wind Speed, Direction, and Wind Gusts forecast across all major meteorological models.",
          "scoreDescription": "\u2022 Calm to Light Breeze (0\u201310 mph - Cool Blue/Teal): Calm waters and stable tripod conditions.\n\u2022 Moderate Wind (10\u201325 mph - Green to Yellow): Whitecaps on lakes and noticeable ridge breeze.\n\u2022 Strong / Gale Wind (25\u201345 mph - Orange to Red): Difficult hiking on exposed ridges and hazardous boating conditions.\n\u2022 Severe / Hurricane Force (50+ mph - Magenta/Purple): Extreme alpine ridge gusts and dangerous travel conditions.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "gfs",
            "rdps",
            "ecmwf",
            "icon13",
            "RTMA (Obs)"
          ],
          "outputModels": [
            "Vector directional JSON (wind_grid.json)",
            "Magnitude .pmtiles per model"
          ],
          "toastTitle": "Surface Winds & Gusts",
          "toastSubtitle": "10-METER SUSTAINED WINDS & GUST VECTORS",
          "toastDescription": "Displays animated 10-meter wind streamlines and speed/gust magnitudes across high-resolution regional and global forecast models."
        },
        {
          "id": "dewpoint",
          "label": "Dew Point",
          "product": "dewpoint",
          "icon": "\ud83c\udf2b\ufe0f",
          "category": "temperature",
          "description": "2m Surface Dew Point forecast.",
          "category_label": "Core Meteorological",
          "long_description": "2m Surface Dew Point temperature and atmospheric moisture comfort levels.",
          "score_description": "\u2022 <30\u00b0F (Crisp / Arid): Very dry continental or alpine air mass.\n\u2022 35\u201355\u00b0F (Comfortable): Pleasant outdoor humidity levels.\n\u2022 60\u201369\u00b0F (Muggy / Humid): Noticeable low-level moisture and fuel for convective storms.\n\u2022 70\u00b0F+ (Oppressive / Tropical): High latent heat and oppressive humidity.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "gdps",
            "icon13",
            "nbm"
          ],
          "output_models": [
            "Surface Dew Point .pmtiles per model"
          ],
          "toast_title": "Surface Dew Point Temperature",
          "toast_subtitle": "ABSOLUTE MOISTURE & HUMIDITY COMFORT",
          "toast_description": "Maps 2-meter dew point temperatures to measure absolute atmospheric moisture, mugginess, and overnight condensation thresholds.",
          "longDescription": "2m Surface Dew Point temperature and atmospheric moisture comfort levels.",
          "scoreDescription": "\u2022 <30\u00b0F (Crisp / Arid): Very dry continental or alpine air mass.\n\u2022 35\u201355\u00b0F (Comfortable): Pleasant outdoor humidity levels.\n\u2022 60\u201369\u00b0F (Muggy / Humid): Noticeable low-level moisture and fuel for convective storms.\n\u2022 70\u00b0F+ (Oppressive / Tropical): High latent heat and oppressive humidity.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "gdps",
            "icon13",
            "nbm"
          ],
          "outputModels": [
            "Surface Dew Point .pmtiles per model"
          ],
          "toastTitle": "Surface Dew Point Temperature",
          "toastSubtitle": "ABSOLUTE MOISTURE & HUMIDITY COMFORT",
          "toastDescription": "Maps 2-meter dew point temperatures to measure absolute atmospheric moisture, mugginess, and overnight condensation thresholds."
        },
        {
          "id": "windchill",
          "label": "Wind Chill Index",
          "product": "windchill",
          "icon": "\ud83e\udd76",
          "category": "temperature",
          "description": "Wind chill forecast.",
          "category_label": "Core Meteorological",
          "long_description": "Apparent temperature / wind chill index.",
          "score_description": "\u2022 32\u00b0F to 15\u00b0F (Chilly - Light Blue): Dress in warm windproof layers.\n\u2022 15\u00b0F to -15\u00b0F (Bitter Cold - Deep Blue/Violet): Frostbite risk on exposed skin within 30 minutes under strong winds.\n\u2022 Below -20\u00b0F (Extreme Cold Hazard - Magenta/Purple): Life-threatening wind chill; frostbite can occur on exposed skin in under 10\u201315 minutes.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Wind chill .pmtiles per model"
          ],
          "toast_title": "Wind Chill & Apparent Temperature",
          "toast_subtitle": "FEELS-LIKE COLD EXPOSURE INDEX",
          "toast_description": "Combines air temperature and 10-meter wind speed to calculate feels-like wind chill temperatures and alpine frostbite risk.",
          "longDescription": "Apparent temperature / wind chill index.",
          "scoreDescription": "\u2022 32\u00b0F to 15\u00b0F (Chilly - Light Blue): Dress in warm windproof layers.\n\u2022 15\u00b0F to -15\u00b0F (Bitter Cold - Deep Blue/Violet): Frostbite risk on exposed skin within 30 minutes under strong winds.\n\u2022 Below -20\u00b0F (Extreme Cold Hazard - Magenta/Purple): Life-threatening wind chill; frostbite can occur on exposed skin in under 10\u201315 minutes.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Wind chill .pmtiles per model"
          ],
          "toastTitle": "Wind Chill & Apparent Temperature",
          "toastSubtitle": "FEELS-LIKE COLD EXPOSURE INDEX",
          "toastDescription": "Combines air temperature and 10-meter wind speed to calculate feels-like wind chill temperatures and alpine frostbite risk."
        },
        {
          "id": "tropical_cyclones",
          "label": "Tropical Cyclones & Hazards",
          "product": "tropical",
          "icon": "\ud83c\udf00",
          "category": "extended_climate",
          "description": "NOAA National Hurricane Center (NHC) active tropical cyclone forecast tracks, cones of uncertainty, wind radii swaths, coastal warnings, and GTWO disturbance outlooks",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
          "score_description": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
          "source_models": [
            "NOAA National Hurricane Center (NHC)",
            "Central Pacific Hurricane Center (CPHC)",
            "Automated Tropical Cyclone Forecasting (ATCF) System"
          ],
          "output_models": [
            "NHC Active Tropical Advisory GIS GeoJSON"
          ],
          "toast_title": "Tropical Cyclones & NHC Outlooks",
          "toast_subtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
          "toast_description": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities.",
          "longDescription": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
          "scoreDescription": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "NOAA National Hurricane Center (NHC)",
            "Central Pacific Hurricane Center (CPHC)",
            "Automated Tropical Cyclone Forecasting (ATCF) System"
          ],
          "outputModels": [
            "NHC Active Tropical Advisory GIS GeoJSON"
          ],
          "toastTitle": "Tropical Cyclones & NHC Outlooks",
          "toastSubtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
          "toastDescription": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities."
        },
        {
          "id": "aqi_index",
          "label": "AQI Forecast",
          "product": "aqi",
          "icon": "\ud83e\udec1",
          "category": "air_quality_fires",
          "description": "Air quality forecast.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "score_description": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "source_models": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "output_models": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toast_title": "Air Quality Index (AQI) Forecast",
          "toast_subtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toast_description": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone.",
          "longDescription": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "scoreDescription": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "outputModels": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toastTitle": "Air Quality Index (AQI) Forecast",
          "toastSubtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toastDescription": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone."
        },
        {
          "id": "recent_climate",
          "label": "Recent Climate Data",
          "product": "recent_climate",
          "icon": "\ud83d\uddd3\ufe0f",
          "category": "extended_climate",
          "is_tool_mode": true,
          "description": "Monthly & Year-to-Date observed temperature, precipitation, snowfall, and departures from 1991-2020 normals (2021-present)",
          "long_description": "Recent Climate Data is an interactive multi-year observed climate almanac (2021-present) tracking monthly and Year-to-Date (or Annual) temperature, precipitation, snowfall, and departures from 1991-2020 climatological normals.\n\nPowered by a seamless hybrid stitch of high-resolution NOAA NCEI nClimGrid-Daily (~4.6 km across CONUS) and NOAA PSL/CPC Global Unified Daily observations (0.5 deg across Alaska, Canada, and global land), paired with NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS). Hover anywhere over the map for instant telemetry showing High/Low, Mean Temp, Temp Departure, Total Precip, Normal Precip, % of Normal, Snowfall, and Elevation.",
          "score_description": "\u2022 7 Selectable Layers: Average High, Average Low, Mean Temp, Temp Departure (\u00b1\u00b0F), Total Precip, Precip Departure (\u00b1in & % of normal), and Snowfall (CONUS).\n\u2022 Time Modes: Clickable Jan-Dec monthly views plus Year-to-Date (active year) or Full Annual Summary (completed years 2021-2025+).\n\u2022 Daily Incremental Updates: Automatically refreshes the active calendar month and YTD totals daily as new NOAA observations publish.",
          "category_label": "Extended Climate & Outlooks",
          "source_models": [
            "NOAA NCEI nClimGrid-Daily (~4.6 km CONUS)",
            "NOAA PSL/CPC Global Unified Daily (0.5\u00b0 Global)",
            "NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS)"
          ],
          "output_models": [
            "Monthly & YTD Temperature, Precip, Snow & Departure Rasters (.pmtiles)"
          ],
          "toast_title": "Recent Climate Almanac (2021\u2013Present)",
          "toast_subtitle": "OBSERVED MONTHLY & YTD DEPARTURES",
          "toast_description": "Compare actual monthly and year-to-date temperatures, rainfall, and snowfall from 2021 to the present against 30-year climatological normals.",
          "longDescription": "Recent Climate Data is an interactive multi-year observed climate almanac (2021-present) tracking monthly and Year-to-Date (or Annual) temperature, precipitation, snowfall, and departures from 1991-2020 climatological normals.\n\nPowered by a seamless hybrid stitch of high-resolution NOAA NCEI nClimGrid-Daily (~4.6 km across CONUS) and NOAA PSL/CPC Global Unified Daily observations (0.5 deg across Alaska, Canada, and global land), paired with NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS). Hover anywhere over the map for instant telemetry showing High/Low, Mean Temp, Temp Departure, Total Precip, Normal Precip, % of Normal, Snowfall, and Elevation.",
          "scoreDescription": "\u2022 7 Selectable Layers: Average High, Average Low, Mean Temp, Temp Departure (\u00b1\u00b0F), Total Precip, Precip Departure (\u00b1in & % of normal), and Snowfall (CONUS).\n\u2022 Time Modes: Clickable Jan-Dec monthly views plus Year-to-Date (active year) or Full Annual Summary (completed years 2021-2025+).\n\u2022 Daily Incremental Updates: Automatically refreshes the active calendar month and YTD totals daily as new NOAA observations publish.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "NOAA NCEI nClimGrid-Daily (~4.6 km CONUS)",
            "NOAA PSL/CPC Global Unified Daily (0.5\u00b0 Global)",
            "NOAA NOHRSC Gridded Snowfall v2 (~4 km CONUS)"
          ],
          "outputModels": [
            "Monthly & YTD Temperature, Precip, Snow & Departure Rasters (.pmtiles)"
          ],
          "toastTitle": "Recent Climate Almanac (2021\u2013Present)",
          "toastSubtitle": "OBSERVED MONTHLY & YTD DEPARTURES",
          "toastDescription": "Compare actual monthly and year-to-date temperatures, rainfall, and snowfall from 2021 to the present against 30-year climatological normals."
        },
        {
          "id": "climate_data",
          "label": "Historical Climatology (30-year)",
          "product": "climate",
          "icon": "\ud83d\udcca",
          "category": "extended_climate",
          "is_tool_mode": true,
          "description": "30-year climatological normals & microclimate elevation profiles",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "score_description": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "source_models": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "output_models": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toast_title": "Historical Climatology (30-Year Normals)",
          "toast_subtitle": "1991\u20132020 CLIMATE BASELINE",
          "toast_description": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips.",
          "longDescription": "Interactive 30-year climatological normals (1991\u20132020) and topographic microclimate elevation profiles across North America and global regions.\n\nExplore historical daily and monthly temperature ranges, precipitation probabilities, snowfall normals, cloud cover, and wind patterns to plan long-range backcountry and travel itineraries.",
          "scoreDescription": "\u2022 Temperature Normals: Daily and monthly 30-year average highs, lows, and mean temperatures.\n\u2022 Precipitation & Snowfall: Historical wet-day frequency and average accumulation totals.\n\u2022 Elevation Profiles: Lapse-rate adjusted microclimate comparisons across valleys, trailheads, and summits.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "PRISM 30-Year Normals (800m CONUS)",
            "ERA5 / WorldClim Global Climatology",
            "NOAA NCEI 1991-2020 Climate Normals"
          ],
          "outputModels": [
            "30-Year Daily & Monthly Climatology Tiles (.pmtiles)",
            "Point Microclimate Elevation Profiles"
          ],
          "toastTitle": "Historical Climatology (30-Year Normals)",
          "toastSubtitle": "1991\u20132020 CLIMATE BASELINE",
          "toastDescription": "Explore 30-year historical temperature, precipitation, snowfall, and cloud cover normals for any day of the year to plan future trips."
        },
        {
          "id": "drought_usdm",
          "label": "U.S. Drought Monitor",
          "product": "drought",
          "icon": "\ud83c\udfdc\ufe0f",
          "category": "extended_climate",
          "description": "Authoritative weekly U.S. Drought Monitor classification (D0 Abnormally Dry to D4 Exceptional Drought)",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Authoritative weekly U.S. Drought Monitor classifications (D0 Abnormally Dry to D4 Exceptional Drought) from NDMC/USDA/NOAA, coupled with NOAA Climate Prediction Center (CPC) Monthly and Seasonal drought tendency outlooks.",
          "score_description": "\u2022 D0 (Abnormally Dry - Yellow): Going into drought or recovering from drought; short-term dryness slowing planting or growth.\n\u2022 D1 (Moderate Drought - Tan): Some damage to crops and pastures; streams, reservoirs, or wells low.\n\u2022 D2 (Severe Drought - Orange): Crop or pasture losses likely; water shortages common and water restrictions imposed.\n\u2022 D3 (Extreme Drought - Red): Major crop/pasture losses and widespread water shortages or restrictions.\n\u2022 D4 (Exceptional Drought - Dark Brown/Maroon): Exceptional and widespread crop/pasture losses; emergencies in water supply and wildfire fuel aridity.",
          "source_models": [
            "National Drought Mitigation Center (NDMC / UNL)",
            "NOAA National Integrated Drought Information System (NIDIS)",
            "USDA World Agricultural Outlook Board",
            "NOAA Climate Prediction Center (CPC)"
          ],
          "output_models": [
            "Vector Classifications & Tendency Polygons GeoJSON"
          ],
          "toast_title": "U.S. Drought Monitor & Outlook",
          "toast_subtitle": "WEEKLY NDMC / NOAA CLASSIFICATION",
          "toast_description": "Maps official weekly U.S. Drought Monitor intensity tiers (D0 Abnormally Dry to D4 Exceptional Drought) and seasonal drought tendency outlooks.",
          "longDescription": "Authoritative weekly U.S. Drought Monitor classifications (D0 Abnormally Dry to D4 Exceptional Drought) from NDMC/USDA/NOAA, coupled with NOAA Climate Prediction Center (CPC) Monthly and Seasonal drought tendency outlooks.",
          "scoreDescription": "\u2022 D0 (Abnormally Dry - Yellow): Going into drought or recovering from drought; short-term dryness slowing planting or growth.\n\u2022 D1 (Moderate Drought - Tan): Some damage to crops and pastures; streams, reservoirs, or wells low.\n\u2022 D2 (Severe Drought - Orange): Crop or pasture losses likely; water shortages common and water restrictions imposed.\n\u2022 D3 (Extreme Drought - Red): Major crop/pasture losses and widespread water shortages or restrictions.\n\u2022 D4 (Exceptional Drought - Dark Brown/Maroon): Exceptional and widespread crop/pasture losses; emergencies in water supply and wildfire fuel aridity.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "National Drought Mitigation Center (NDMC / UNL)",
            "NOAA National Integrated Drought Information System (NIDIS)",
            "USDA World Agricultural Outlook Board",
            "NOAA Climate Prediction Center (CPC)"
          ],
          "outputModels": [
            "Vector Classifications & Tendency Polygons GeoJSON"
          ],
          "toastTitle": "U.S. Drought Monitor & Outlook",
          "toastSubtitle": "WEEKLY NDMC / NOAA CLASSIFICATION",
          "toastDescription": "Maps official weekly U.S. Drought Monitor intensity tiers (D0 Abnormally Dry to D4 Exceptional Drought) and seasonal drought tendency outlooks."
        },
        {
          "id": "cpc_outlook",
          "label": "Extended Outlooks (Climate Prediction Center)",
          "product": "cpc_outlooks",
          "icon": "\ud83d\udcc8",
          "category": "extended_climate",
          "description": "NOAA Climate Prediction Center 6-10 Day, 8-14 Day, and Monthly temperature and precipitation probability outlooks",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Authoritative NOAA Climate Prediction Center (CPC) probabilistic outlooks for temperature and precipitation anomalies covering 6-10 Day, 8-14 Day (Week 2), and Monthly planning horizons.",
          "score_description": "\u2022 Warm / Above-Normal Temperature (Orange to Red): Elevated probability (33% to 90%+) of temperatures averaging above the 30-year seasonal normal.\n\u2022 Cool / Below-Normal Temperature (Light Blue to Deep Blue): Elevated probability of temperatures averaging below the 30-year seasonal normal.\n\u2022 Wet / Above-Normal Precipitation (Teal to Emerald Green): Elevated probability of cumulative precipitation exceeding seasonal norms.\n\u2022 Dry / Below-Normal Precipitation (Tan to Brown): Elevated probability of drier-than-normal conditions.\n\u2022 Near Normal / Equal Chances (Gray/Clear): Climatological probabilities apply with no dominant anomaly signal.",
          "source_models": [
            "NOAA Climate Prediction Center (CPC)",
            "Global Ensemble Forecast System (GEFS)",
            "ECMWF Integrated Forecasting System Ensemble (EPS)",
            "Canadian Meteorological Centre Ensemble (CMCE)"
          ],
          "output_models": [
            "CPC Anomaly Probability Contours GeoJSON"
          ],
          "toast_title": "CPC Extended Temperature & Precip Outlooks",
          "toast_subtitle": "6\u201310 DAY, 8\u201314 DAY & MONTHLY OUTLOOKS",
          "toast_description": "Shows NOAA Climate Prediction Center probabilistic outlooks for above- or below-normal temperatures and precipitation 1 to 4 weeks ahead.",
          "longDescription": "Authoritative NOAA Climate Prediction Center (CPC) probabilistic outlooks for temperature and precipitation anomalies covering 6-10 Day, 8-14 Day (Week 2), and Monthly planning horizons.",
          "scoreDescription": "\u2022 Warm / Above-Normal Temperature (Orange to Red): Elevated probability (33% to 90%+) of temperatures averaging above the 30-year seasonal normal.\n\u2022 Cool / Below-Normal Temperature (Light Blue to Deep Blue): Elevated probability of temperatures averaging below the 30-year seasonal normal.\n\u2022 Wet / Above-Normal Precipitation (Teal to Emerald Green): Elevated probability of cumulative precipitation exceeding seasonal norms.\n\u2022 Dry / Below-Normal Precipitation (Tan to Brown): Elevated probability of drier-than-normal conditions.\n\u2022 Near Normal / Equal Chances (Gray/Clear): Climatological probabilities apply with no dominant anomaly signal.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "NOAA Climate Prediction Center (CPC)",
            "Global Ensemble Forecast System (GEFS)",
            "ECMWF Integrated Forecasting System Ensemble (EPS)",
            "Canadian Meteorological Centre Ensemble (CMCE)"
          ],
          "outputModels": [
            "CPC Anomaly Probability Contours GeoJSON"
          ],
          "toastTitle": "CPC Extended Temperature & Precip Outlooks",
          "toastSubtitle": "6\u201310 DAY, 8\u201314 DAY & MONTHLY OUTLOOKS",
          "toastDescription": "Shows NOAA Climate Prediction Center probabilistic outlooks for above- or below-normal temperatures and precipitation 1 to 4 weeks ahead."
        }
      ],
      "secondaryLayers": [
        {
          "id": "lightning_live",
          "label": "Lightning Activity (Observed)",
          "product": "live_weather",
          "model": "mrms_lightning",
          "icon": "\u26a1",
          "category": "precipitation",
          "description": "Rolling 8-hour 5-minute lightning strikes scaled by flash density and age (yellow to gray).",
          "long_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "category_label": "Real-Time Observation",
          "score_description": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "source_models": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "output_models": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toast_title": "Live Lightning Strikes (8-Hour Trail)",
          "toast_subtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toast_description": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.",
          "longDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes.  Data is plotted as 5-minute interval densities with strike size indicating the density/number of strikes in the area.",
          "scoreDescription": "\u2022 0\u201315 Minutes (Electric Yellow): Active, immediate cloud-to-ground lightning hazard.\n\u2022 15\u201360 Minutes (Warm Gold to Orange): Recent thunderstorm electrical activity.\n\u2022 1\u20133 Hours (Red to Deep Crimson): Departing storm track history.\n\u2022 3\u20138 Hours (Purple to Slate Gray): Historical 8-hour storm motion trail.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)"
          ],
          "outputModels": [
            "Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)"
          ],
          "toastTitle": "Live Lightning Strikes (8-Hour Trail)",
          "toastSubtitle": "REAL-TIME 5-MIN NLDN / MRMS FLASH DENSITY",
          "toastDescription": "Plots lightning data sourced from the National Weather Service up to an 8 hour rolling window updated every 5 minutes."
        },
        {
          "id": "precip_accum",
          "label": "Precipitation Accumulation (Past 1-7 Days)",
          "product": "precip_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf27\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP precipitation accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "long_description": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "source_models": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toast_title": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toast_subtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toast_description": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation.",
          "longDescription": "Multi-model global and regional precipitation accumulation combining NOAA CMORPH2 satellite QPE, ECMWF IFS NWP analysis, and NOAA MRMS radar observations across 24h to 168h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h, 96h, 120h, 144h, 168h): Total liquid precipitation accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily rainfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar QPE, NOAA CMORPH2 global satellite QPE, and ECMWF IFS analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA CMORPH2 Global Satellite QPE",
            "ECMWF IFS 0.25\u00b0 Global Precipitation Analysis",
            "NOAA MRMS Multi-Sensor Gauge-Adjusted QPE"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Precipitation Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Precipitation Accumulation (1\u20137 Days)",
          "toastSubtitle": "MRMS RADAR, CMORPH2 SATELLITE & ECMWF",
          "toastDescription": "Shows actual accumulated rainfall over the past 1 to 7 days to evaluate trail mud, river runoff, and soil saturation."
        },
        {
          "id": "snow_accum",
          "label": "Snowfall Accumulation (Past 1-7 Days)",
          "product": "snow_accum",
          "model": "cmorph2",
          "sources": [
            "cmorph2",
            "ecmwf",
            "mrms"
          ],
          "icon": "\ud83c\udf28\ufe0f",
          "category": "precipitation",
          "description": "Global observed and NWP snowfall accumulation (NOAA CMORPH2, ECMWF IFS, MRMS) for cumulative 24h, 48h, 72h totals or daily increments.",
          "long_description": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "category_label": "Real-Time & Multi-Model Accumulation",
          "score_description": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "source_models": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "output_models": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toast_title": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toast_subtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toast_description": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows.",
          "longDescription": "Multi-model global snowfall accumulation combining NOAA CMORPH2 satellite QPE and ECMWF IFS NWP snow analysis across 24h, 48h, 72h cumulative and daily breakdown time horizons.",
          "scoreDescription": "\u2022 Cumulative Mode (Past 24h, 48h, 72h to 168h): Total fresh snowfall accumulated up to the present hour.\n\u2022 Daily Breakdown Mode (Day 1 to Day 7): Individual 24-hour daily snowfall totals over the past week.\n\u2022 Selectable Sources: Compare NOAA MRMS radar snowfall, NOAA CMORPH2 cold-sector snow, and ECMWF IFS snow analysis.",
          "categoryLabel": "Real-Time & Multi-Model Accumulation",
          "sourceModels": [
            "NOAA MRMS Snowfall Accumulation Product",
            "NOAA CMORPH2 Global Satellite Snow Estimation",
            "ECMWF IFS 0.25\u00b0 Global Snowfall Analysis"
          ],
          "outputModels": [
            "24h to 168h Cumulative & Daily Snowfall Grids (.pmtiles)"
          ],
          "toastTitle": "Observed Snowfall Accumulation (1\u20137 Days)",
          "toastSubtitle": "RECENT FRESH POWDER & STORM TOTALS",
          "toastDescription": "Tracks actual snowfall accumulated over the past 1 to 7 days across cumulative and daily storm windows."
        },
        {
          "id": "satellite_imagery",
          "label": "Satellite Imagery (Vis & IR)",
          "product": "live_weather",
          "model": "goes",
          "icon": "\ud83d\udef0\ufe0f",
          "category": "clouds_wind",
          "description": "High-frequency visible and infrared geostationary satellite cloud loops.",
          "category_label": "Real-Time Observation",
          "long_description": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "score_description": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "source_models": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "output_models": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toast_title": "Live Geostationary Satellite Imagery",
          "toast_subtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toast_description": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems.",
          "longDescription": "High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.",
          "scoreDescription": "\u2022 Visible Band: High-resolution daytime solar reflectance showing fine boundary-layer fog, cumulus streets, and smoke plumes.\n\u2022 Infrared (Clean IR 10.3 \u00b5m): 24/7 thermal cloud-top temperature imagery tracking cloud deck heights day and night.\n\u2022 Cloud Deck Overlays: Optional high, mid, and low/fog satellite cloud phase classification overlays.",
          "categoryLabel": "Real-Time Observation",
          "sourceModels": [
            "NOAA GOES-East (GOES-16/19)",
            "NOAA GOES-West (GOES-18)",
            "JMA Himawari-9",
            "EUMETSAT Meteosat-9/10"
          ],
          "outputModels": [
            "Georeferenced visual & infrared tile loops"
          ],
          "toastTitle": "Live Geostationary Satellite Imagery",
          "toastSubtitle": "GOES, HIMAWARI & METEOSAT LOOPS",
          "toastDescription": "Streams real-time visible and infrared satellite imagery loops to track live cloud clearing, marine stratus, and storm systems."
        },
        {
          "id": "aqi_index",
          "label": "AQI Forecast",
          "product": "aqi",
          "icon": "\ud83e\udec1",
          "category": "air_quality_fires",
          "description": "Air quality forecast.",
          "category_label": "Environmental & Air Quality",
          "long_description": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "score_description": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "source_models": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "output_models": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toast_title": "Air Quality Index (AQI) Forecast",
          "toast_subtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toast_description": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone.",
          "longDescription": "Ground-level AQI (PM2.5, PM10, Ozone) forecast and real-time monitoring station feeds.",
          "scoreDescription": "\u2022 0\u201350 (Good - Green): Air quality is satisfactory and air pollution poses little or no risk.\n\u2022 51\u2013100 (Moderate - Yellow): Acceptable air quality; unusually sensitive individuals should consider limiting prolonged outdoor exertion.\n\u2022 101\u2013150 (Unhealthy for Sensitive Groups - Orange): Sensitive groups may experience health effects during outdoor exertion.\n\u2022 151\u2013200 (Unhealthy - Red): Everyone may begin to experience health effects; avoid prolonged heavy outdoor exertion.\n\u2022 201\u2013300 (Very Unhealthy - Purple): Health alert; everyone should avoid prolonged outdoor exertion.\n\u2022 301+ (Hazardous - Maroon): Health warning of emergency conditions.",
          "categoryLabel": "Environmental & Air Quality",
          "sourceModels": [
            "gefs",
            "raqdps",
            "hrrr",
            "rrfs",
            "AirNow / EPA Station Telemetry"
          ],
          "outputModels": [
            "AQI scale .pmtiles per model",
            "Real-time observation markers"
          ],
          "toastTitle": "Air Quality Index (AQI) Forecast",
          "toastSubtitle": "PM2.5, PM10 & SURFACE OZONE AQI",
          "toastDescription": "Forecasts ground-level EPA Air Quality Index (0\u2013500 scale) driven by wildfire smoke, fine particulates (PM2.5), and ozone."
        },
        {
          "id": "sun_intensity_forecast",
          "label": "Solar Intensity Forecast",
          "product": "sun_intensity",
          "icon": "\u2600\ufe0f",
          "category": "temperature",
          "description": "Surface downwelling solar irradiance forecast (W/m\u00b2) across numerical weather models.",
          "category_label": "Core Meteorological",
          "long_description": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "score_description": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "source_models": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "output_models": [
            "Solar Intensity .pmtiles per model"
          ],
          "toast_title": "Solar Intensity & Surface Irradiance",
          "toast_subtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toast_description": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation.",
          "longDescription": "Direct surface downwelling solar irradiance (W/m\u00b2) from numerical weather prediction model radiative transfer schemes.",
          "scoreDescription": "\u2022 0\u2013150 W/m\u00b2 (Overcast / Twilight - Cool Blue/Slate): Heavily diffused light under thick cloud cover or low sun angles.\n\u2022 200\u2013550 W/m\u00b2 (Filtered Sunshine - Teal to Yellow): Filtered solar beam through high/mid clouds or mid-morning/afternoon sun.\n\u2022 600\u20131000+ W/m\u00b2 (Intense Direct Sun - Orange to Red/Magenta): Strong, unobstructed solar radiation driving rapid snowpack warming and high UV exposure.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "rrfs",
            "rdps",
            "gfs",
            "gdps",
            "icon13"
          ],
          "outputModels": [
            "Solar Intensity .pmtiles per model"
          ],
          "toastTitle": "Solar Intensity & Surface Irradiance",
          "toastSubtitle": "DOWNWELLING SHORTWAVE RADIATION (W/M\u00b2)",
          "toastDescription": "Forecasts direct solar energy (W/m\u00b2) reaching the ground to evaluate sun warmth, solar charging, and snowpack sun-crust formation."
        },
        {
          "id": "relative_humidity",
          "label": "Relative Humidity",
          "product": "relative_humidity",
          "icon": "\ud83d\udca7",
          "category": "temperature",
          "description": "Relative Humidity forecast.",
          "category_label": "Core Meteorological",
          "long_description": "2m Surface Relative Humidity percentage.",
          "score_description": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
          "source_models": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "output_models": [
            "Surface RH .pmtiles per model"
          ],
          "toast_title": "Surface Relative Humidity (RH%)",
          "toast_subtitle": "2-METER ATMOSPHERIC SATURATION",
          "toast_description": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions.",
          "longDescription": "2m Surface Relative Humidity percentage.",
          "scoreDescription": "\u2022 0\u201325% (Bone Dry / Critical Fire Weather - Brown/Amber): Rapid fuel drying and high evaporative demand.\n\u2022 30\u201365% (Comfortable / Moderate - Green to Cyan): Standard daytime atmospheric moisture.\n\u2022 70\u2013100% (Humid to Saturated - Blue to Deep Indigo): Near-saturated boundary layer prone to dew, frost, or fog formation.",
          "categoryLabel": "Core Meteorological",
          "sourceModels": [
            "hrrr",
            "rrfs",
            "rdps",
            "gfs",
            "ecmwf",
            "icon13"
          ],
          "outputModels": [
            "Surface RH .pmtiles per model"
          ],
          "toastTitle": "Surface Relative Humidity (RH%)",
          "toastSubtitle": "2-METER ATMOSPHERIC SATURATION",
          "toastDescription": "Displays forecasted 2-meter relative humidity (0\u2013100%) to monitor dry wildfire air masses or near-saturated fog and dew conditions."
        },
        {
          "id": "tropical_cyclones",
          "label": "Tropical Cyclones & Hazards",
          "product": "tropical",
          "icon": "\ud83c\udf00",
          "category": "extended_climate",
          "description": "NOAA National Hurricane Center (NHC) active tropical cyclone forecast tracks, cones of uncertainty, wind radii swaths, coastal warnings, and GTWO disturbance outlooks",
          "category_label": "Extended Climate & Outlooks",
          "long_description": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
          "score_description": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
          "source_models": [
            "NOAA National Hurricane Center (NHC)",
            "Central Pacific Hurricane Center (CPHC)",
            "Automated Tropical Cyclone Forecasting (ATCF) System"
          ],
          "output_models": [
            "NHC Active Tropical Advisory GIS GeoJSON"
          ],
          "toast_title": "Tropical Cyclones & NHC Outlooks",
          "toast_subtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
          "toast_description": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities.",
          "longDescription": "Authoritative NOAA National Hurricane Center (NHC) active tropical cyclone intelligence: 5-day forecast tracks, cones of uncertainty, 34/50/64-knot wind radii swaths, coastal watches/warnings, and 2-day/7-day disturbance formation outlooks.",
          "scoreDescription": "\u2022 7-Day Formation Risk (Yellow <40%, Orange 40-60%, Red >60%): NHC Graphical Tropical Weather Outlook (GTWO) cyclone genesis probability.\n\u2022 Forecast Track & Cone: Official 5-day projected center path and historical 67% track error boundary.\n\u2022 Wind Radii Swaths: Extent of Tropical Storm (34 kt), Storm (50 kt), and Hurricane-force (64 kt) sustained surface winds.\n\u2022 Coastal Advisories: Active Hurricane and Tropical Storm Warnings and Watches.",
          "categoryLabel": "Extended Climate & Outlooks",
          "sourceModels": [
            "NOAA National Hurricane Center (NHC)",
            "Central Pacific Hurricane Center (CPHC)",
            "Automated Tropical Cyclone Forecasting (ATCF) System"
          ],
          "outputModels": [
            "NHC Active Tropical Advisory GIS GeoJSON"
          ],
          "toastTitle": "Tropical Cyclones & NHC Outlooks",
          "toastSubtitle": "ACTIVE TRACKS, CONES & FORMATION RISK",
          "toastDescription": "Displays live NOAA National Hurricane Center cyclone forecast tracks, cones of uncertainty, wind swaths, and 7-day tropical formation probabilities."
        }
      ]
    }
  },
  "forecastLayouts": {
    "advanced": {
      "id": "advanced",
      "name": "Advanced Meteorology",
      "description": "Atmospheric lapse rates, thermal inversions, Skew-T soundings, diurnal lightning hazard, and multi-model consensus",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "sounding_inversion",
            "type": "sounding_card",
            "title": "Thermodynamic Sounding & Inversion Profile",
            "col_span": 6,
            "options": {
              "interactive": true,
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
          },
          {
            "id": "temp_precip_meteo",
            "type": "meteogram_card",
            "title": "Mesoanalysis Temperature & Precipitation Rate",
            "col_span": 6,
            "options": {
              "height": 230,
              "description": "High-resolution mesoanalysis meteogram tracking hourly surface temperature, dew point depression, and precipitation rate across the active forecast horizon."
            },
            "description": "High-resolution mesoanalysis meteogram tracking hourly surface temperature, dew point depression, and precipitation rate across the active forecast horizon."
          },
          {
            "id": "lightning_hazard",
            "type": "lightning_map_card",
            "title": "Diurnal Convective Initiation & Strike Timing",
            "col_span": 6,
            "options": {
              "show_diurnal_chart": true,
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
          },
          {
            "id": "wind_profile",
            "type": "wind_card",
            "title": "Boundary Layer Wind Vectors",
            "col_span": 6,
            "options": {
              "height": 180,
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
          },
          {
            "id": "air_quality",
            "type": "air_quality_card",
            "title": "Boundary Layer Smoke & Aerosol Optical Depth",
            "col_span": 6,
            "options": {
              "height": 180,
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
          },
          {
            "id": "darkskies_aurora",
            "type": "darkskies_aurora_card",
            "title": "Atmospheric Optical Transparency & Night Sky",
            "col_span": 6,
            "options": {
              "show_kp_chart": true,
              "show_aurora_map": true,
              "description": "Night-sky transparency and stargazing outlook combining the composite Dark Skies score with planetary geomagnetic Kp-index trends and aurora visibility potential."
            },
            "description": "Night-sky transparency and stargazing outlook combining the composite Dark Skies score with planetary geomagnetic Kp-index trends and aurora visibility potential."
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "widget_1792190868441_337",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "widget_1792190862787_301",
            "type": "bottom-nav",
            "title": "Navigation Bar",
            "colSpan": 12,
            "options": {
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            },
            "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
          }
        ]
      }
    },
    "default": {
      "id": "default",
      "name": "Default Balanced Forecast",
      "description": "Comprehensive atmospheric overview with temperature, precipitation, wind, air quality, lightning, and solar ephemeris",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "temp_precip_meteo",
            "type": "meteogram_card",
            "title": "Temperature & Precipitation",
            "col_span": 6,
            "options": {
              "height": 220,
              "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
            },
            "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
          },
          {
            "id": "lightning_hazard",
            "type": "lightning_map_card",
            "title": "Daily Lightning Hazard & Strike Timing",
            "col_span": 6,
            "options": {
              "show_diurnal_chart": true,
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
          },
          {
            "id": "sounding_inversion",
            "type": "sounding_card",
            "title": "Atmospheric Sounding & Inversion Profile",
            "col_span": 6,
            "options": {
              "interactive": true,
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
          },
          {
            "id": "sun_intensity",
            "type": "sun_intensity_card",
            "title": "Sun Intensity & Solar Flux",
            "col_span": 6,
            "options": {
              "height": 120,
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
          },
          {
            "id": "air_sky_quality",
            "type": "air_quality_card",
            "title": "Air & Sky Quality",
            "col_span": 6,
            "options": {
              "height": 180,
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
          },
          {
            "id": "solar_alpenglow",
            "type": "solar_alpenglow_card",
            "title": "Sunrise, Sunset and Golden Hour Outlooks",
            "col_span": 6,
            "options": {
              "show_blue_hour": true,
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
          },
          {
            "id": "wind_profile",
            "type": "wind_card",
            "title": "Wind Speed & Direction",
            "col_span": 6,
            "options": {
              "height": 180,
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
          },
          {
            "id": "astronomical_events",
            "type": "astronomical_card",
            "title": "Astronomical Events & Night Sky",
            "col_span": 6,
            "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows.",
            "options": {
              "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows."
            }
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "temp_precip_meteo",
            "type": "meteogram_card",
            "title": "Temperature & Precipitation",
            "col_span": 12,
            "options": {
              "height": 200,
              "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
            },
            "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
          },
          {
            "id": "lightning_hazard",
            "type": "lightning_map_card",
            "title": "Lightning Hazard & Timing",
            "col_span": 12,
            "options": {
              "show_diurnal_chart": true,
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
          },
          {
            "id": "wind_profile",
            "type": "wind_card",
            "title": "Wind Speed & Direction",
            "col_span": 12,
            "options": {
              "height": 160,
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
          },
          {
            "id": "solar_alpenglow",
            "type": "solar_alpenglow_card",
            "title": "Sun & Alpenglow Times",
            "col_span": 12,
            "options": {
              "show_blue_hour": true,
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
          },
          {
            "id": "air_sky_quality",
            "type": "air_quality_card",
            "title": "Air & Sky Quality",
            "col_span": 12,
            "options": {
              "height": 160,
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
          },
          {
            "id": "sun_intensity",
            "type": "sun_intensity_card",
            "title": "Sun Intensity & Solar Flux",
            "col_span": 12,
            "options": {
              "height": 120,
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
          },
          {
            "id": "sounding_inversion",
            "type": "sounding_card",
            "title": "Atmospheric Sounding Profile",
            "col_span": 12,
            "options": {
              "interactive": true,
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
          },
          {
            "id": "astronomical_events",
            "type": "astronomical_card",
            "title": "Night Sky & Lunar Events",
            "col_span": 12,
            "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows.",
            "options": {
              "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows."
            }
          }
        ]
      }
    },
    "foraging": {
      "id": "foraging",
      "name": "Mushroom & Berry Foraging",
      "description": "Phenology timing, precipitation accumulation, ground moisture, humidity, and temperature trends",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "widget_1791671289486_518",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "horizon_selector",
            "type": "horizon-selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "3-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "foraging_kpi",
            "type": "kpi-grid",
            "title": "Phenology & Moisture Conditions",
            "col_span": 6,
            "options": {
              "checks": [
                "obs_precip_24h_in",
                "relative_humidity_pct",
                "temps_f",
                "wind_speed_mph"
              ],
              "description": "At-a-glance environmental threshold indicators evaluating recent rainfall, relative humidity, surface temperature, and wind speed against optimal field activity criteria."
            },
            "description": "At-a-glance environmental threshold indicators evaluating recent rainfall, relative humidity, surface temperature, and wind speed against optimal field activity criteria."
          },
          {
            "id": "foraging_stats",
            "type": "stat-grid",
            "title": "Ground & Forest Indicators",
            "col_span": 6,
            "options": {
              "columns": 2,
              "tiles": [
                {
                  "key": "obs_precip_24h_in",
                  "label": "24h Rainfall",
                  "sub": "Soil Saturation",
                  "icon": "\ud83c\udf27\ufe0f",
                  "color": "#38bdf8"
                },
                {
                  "key": "relative_humidity_pct",
                  "label": "Humidity",
                  "sub": "Spore Germination",
                  "icon": "\ud83d\udca7",
                  "color": "#10b981"
                },
                {
                  "key": "temps_f",
                  "label": "Ground Temp",
                  "sub": "Mycelium Active",
                  "icon": "\ud83c\udf21\ufe0f",
                  "color": "#f59e0b"
                },
                {
                  "key": "obs_mrms_radar_dbz",
                  "label": "Radar Reflectivity",
                  "sub": "Live Ground Truth",
                  "icon": "\ud83d\udce1",
                  "color": "#a855f7"
                }
              ],
              "description": "Compact metric tile grid highlighting key environmental variables and real-time ground/canopy indicators for rapid field assessment."
            },
            "description": "Compact metric tile grid highlighting key environmental variables and real-time ground/canopy indicators for rapid field assessment."
          },
          {
            "id": "foraging_meteo",
            "type": "meteogram-card",
            "title": "Precipitation Accumulation vs Temp & Humidity",
            "col_span": 12,
            "options": {
              "height": 380,
              "showNow": true,
              "horizonDays": "3",
              "series": [
                {
                  "key": "precip_rate_in_h",
                  "type": "bar",
                  "yAxis": "right",
                  "color": "#38bdf8"
                },
                {
                  "key": "temps_f",
                  "type": "line",
                  "yAxis": "left",
                  "color": "#10b981"
                },
                {
                  "key": "relative_humidity_pct",
                  "type": "line",
                  "dashed": true,
                  "yAxis": "right",
                  "color": "#3b82f6"
                }
              ],
              "description": "Foraging microclimate meteogram tracking hourly rainfall rate (in/hr, cyan bars), surface air temperature (\u00b0F, green curve on left axis), and relative humidity (%, blue dashed curve on right axis). Sustained high humidity (>75%) following soaking rain events with mild temperatures (45\u201368\u00b0F) triggers prime mycelial pinning and mushroom flushes."
            },
            "description": "Foraging microclimate meteogram tracking hourly rainfall rate (in/hr, cyan bars), surface air temperature (\u00b0F, green curve on left axis), and relative humidity (%, blue dashed curve on right axis). Sustained high humidity (>75%) following soaking rain events with mild temperatures (45\u201368\u00b0F) triggers prime mycelial pinning and mushroom flushes."
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "w_appbar",
            "type": "app-bar",
            "title": "Foraging Location Header",
            "col_span": 12,
            "options": {
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
          },
          {
            "id": "w_horizon",
            "type": "horizon-selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "default": "3-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "w_glance",
            "type": "glance-2x2",
            "title": "Current Conditions",
            "col_span": 4,
            "options": {
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
          },
          {
            "id": "w_foraging_kpi",
            "type": "kpi-grid",
            "title": "Phenology & Moisture Indicators",
            "col_span": 12,
            "options": {
              "checks": [
                "obs_precip_24h_in",
                "relative_humidity_pct",
                "temps_f",
                "wind_speed_mph"
              ],
              "description": "At-a-glance environmental threshold indicators evaluating recent rainfall, relative humidity, surface temperature, and wind speed against optimal field activity criteria."
            },
            "description": "At-a-glance environmental threshold indicators evaluating recent rainfall, relative humidity, surface temperature, and wind speed against optimal field activity criteria."
          },
          {
            "id": "w_foraging_stats",
            "type": "stat-grid",
            "title": "Soil & Canopy Conditions",
            "col_span": 12,
            "options": {
              "columns": 2,
              "tiles": [
                {
                  "key": "obs_precip_24h_in",
                  "label": "24h Rainfall",
                  "sub": "Soil Saturation",
                  "icon": "\ud83c\udf27\ufe0f",
                  "color": "#38bdf8"
                },
                {
                  "key": "relative_humidity_pct",
                  "label": "Humidity",
                  "sub": "Spore Trigger",
                  "icon": "\ud83d\udca7",
                  "color": "#10b981"
                }
              ],
              "description": "Compact metric tile grid highlighting key environmental variables and real-time ground/canopy indicators for rapid field assessment."
            },
            "description": "Compact metric tile grid highlighting key environmental variables and real-time ground/canopy indicators for rapid field assessment."
          },
          {
            "id": "w_foraging_meteo",
            "type": "meteogram-card",
            "title": "Rain Rate vs Surface Temp & Humidity",
            "col_span": 12,
            "options": {
              "height": 380,
              "showNow": true,
              "horizonDays": "3",
              "series": [
                {
                  "key": "precip_rate_in_h",
                  "type": "bar",
                  "yAxis": "right",
                  "color": "#38bdf8"
                },
                {
                  "key": "temps_f",
                  "type": "line",
                  "yAxis": "left",
                  "color": "#10b981"
                },
                {
                  "key": "relative_humidity_pct",
                  "type": "line",
                  "dashed": true,
                  "yAxis": "right",
                  "color": "#3b82f6"
                }
              ],
              "description": "Foraging microclimate meteogram tracking hourly rainfall rate (in/hr, cyan bars), surface air temperature (\u00b0F, green curve on left axis), and relative humidity (%, blue dashed curve on right axis). Sustained high humidity (>75%) following soaking rain events with mild temperatures (45\u201368\u00b0F) triggers prime mycelial pinning and mushroom flushes."
            },
            "description": "Foraging microclimate meteogram tracking hourly rainfall rate (in/hr, cyan bars), surface air temperature (\u00b0F, green curve on left axis), and relative humidity (%, blue dashed curve on right axis). Sustained high humidity (>75%) following soaking rain events with mild temperatures (45\u201368\u00b0F) triggers prime mycelial pinning and mushroom flushes."
          },
          {
            "id": "w_bottom_nav",
            "type": "bottom-nav",
            "title": "Navigation Bar",
            "col_span": 12,
            "options": {
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            },
            "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
          }
        ]
      }
    },
    "hiking": {
      "id": "hiking",
      "name": "Hiking & Climbing",
      "description": "Altitude hazards, mountain lapse rates, lightning timing, wind, and precipitation",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "widget_1791652625511_437",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "widget_1791656609430_2",
            "type": "daily-forecast-list",
            "title": "Daily Weather Forecast",
            "colSpan": 6,
            "options": {
              "period": "auto",
              "dataSource": "auto",
              "showRainChance": true,
              "showWind": true,
              "showTempBar": true,
              "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
            },
            "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
          },
          {
            "id": "widget_1791655092340_480",
            "type": "recent-weather-2x3",
            "title": "Recent Observations",
            "colSpan": 6,
            "options": {
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
          },
          {
            "id": "widget_1791606537622_893",
            "type": "elevation-temp-card",
            "title": "Elevation Temperatures & Lapse Trend",
            "colSpan": 12,
            "options": {
              "showFreezingLine": true,
              "chartHeight": 160,
              "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
            },
            "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
          },
          {
            "id": "widget_1791606564694_787",
            "type": "cloud-ceiling-card",
            "title": "Clouds & Tops Elevation Trend",
            "colSpan": 12,
            "options": {
              "displayMode": "chart",
              "showFreezingLine": false,
              "showCloudCover": true,
              "chartHeight": 250,
              "topColor": "#93c5fd",
              "baseColor": "#0284c7",
              "fillColor": "#daf3fe",
              "fillOpacity": 22,
              "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
            },
            "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
          },
          {
            "id": "widget_1791606612397_565",
            "type": "meteogram-card",
            "title": "Precipitation Rate and Freezing LEvel",
            "colSpan": 12,
            "options": {
              "height": 200,
              "showNow": true,
              "horizonDays": "auto",
              "showMountainSilhouette": false,
              "declutterElevations": true,
              "showMinMaxLines": false,
              "minMaxSeriesKey": "auto",
              "series": [
                {
                  "key": "freezing_level_ft",
                  "type": "line",
                  "yAxis": "left",
                  "color": "#38bdf8",
                  "tension": 0.3
                },
                {
                  "key": "precip_rate_in_h",
                  "type": "bar",
                  "yAxis": "right",
                  "color": "#3b82f6",
                  "tension": 0.3
                }
              ],
              "description": "Hourly mountain hazard meteogram comparing the freezing level altitude (ft MSL, cyan curve on left axis) against hourly liquid-equivalent precipitation intensity (in/hr, blue bars on right axis). When the freezing level drops below your trail or summit elevation during active precipitation, expect rain to transition to snow, sleet, or verglas."
            },
            "description": "Hourly mountain hazard meteogram comparing the freezing level altitude (ft MSL, cyan curve on left axis) against hourly liquid-equivalent precipitation intensity (in/hr, blue bars on right axis). When the freezing level drops below your trail or summit elevation during active precipitation, expect rain to transition to snow, sleet, or verglas."
          },
          {
            "id": "widget_1791655030071_613",
            "type": "golden-window-card",
            "title": "Sunrise, Sunset and Golden Hour Outlooks",
            "colSpan": 12,
            "options": {
              "displayMode": "cards",
              "daysCount": "auto",
              "showLunarTimeline": true,
              "showScores": true,
              "showTimes": false,
              "showAlpenglow": false,
              "chartHeight": 140,
              "showGoldenHour": true,
              "layoutStyle": "web",
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "w_appbar",
            "type": "app-bar",
            "title": "Mountain Location Bar",
            "col_span": 12,
            "options": {
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
          },
          {
            "id": "w_horizon",
            "type": "horizon-selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "default": "5-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "widget_1791576661895_925",
            "type": "glance-2x2",
            "title": "Current Conditions",
            "col_span": 4,
            "options": {
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
          },
          {
            "id": "widget_1791606446037_292",
            "type": "elevation-temp-card",
            "title": "Elevation Temperatures & Lapse Trend",
            "colSpan": 6,
            "options": {
              "showFreezingLine": true,
              "chartHeight": 160,
              "labelFontSize": 9,
              "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
            },
            "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
          },
          {
            "id": "widget_1791561906679_640",
            "type": "cloud-ceiling-card",
            "title": "Clouds & Tops Elevation Trend",
            "col_span": 6,
            "options": {
              "displayMode": "chart",
              "showFreezingLine": false,
              "showCloudCover": true,
              "chartHeight": 220,
              "baseColor": "#cfebea",
              "fillColor": "#d6e0e0",
              "labelFontSize": 9,
              "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
            },
            "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
          },
          {
            "id": "widget_1791574438751_161",
            "type": "meteogram-card",
            "title": "Thunderstorm and Precipitation Probability",
            "col_span": 12,
            "options": {
              "height": 180,
              "showNow": true,
              "horizonDays": "5",
              "showMountainSilhouette": false,
              "declutterElevations": true,
              "showMinMaxLines": false,
              "minMaxSeriesKey": "precip_rate_in_h",
              "series": [
                {
                  "key": "precip_prob_pct",
                  "type": "line",
                  "yAxis": "left",
                  "color": "#3b82f6",
                  "tension": 0.3
                },
                {
                  "key": "thunderstorm_prob",
                  "type": "bar",
                  "yAxis": "left",
                  "color": "#eab308",
                  "tension": 0.3
                },
                {
                  "key": "precip_rate_in_h",
                  "label": "Precipitation Rate (in/hr)",
                  "type": "bar",
                  "yAxis": "right",
                  "color": "#38bdf8",
                  "tension": 0.3
                }
              ],
              "labelFontSize": 9,
              "description": "Hourly alpine convective threat meteogram combining precipitation probability (%, blue curve), thunderstorm probability (%, gold bars), and hourly precipitation rate (in/hr, cyan bars on right axis). Ideal for timing early-morning summit pushes before afternoon convective storms build over exposed ridges."
            },
            "description": "Hourly alpine convective threat meteogram combining precipitation probability (%, blue curve), thunderstorm probability (%, gold bars), and hourly precipitation rate (in/hr, cyan bars on right axis). Ideal for timing early-morning summit pushes before afternoon convective storms build over exposed ridges."
          },
          {
            "id": "widget_1792980764902_513",
            "type": "recent-weather-2x3",
            "title": "Recent Rainfall",
            "colSpan": 6,
            "options": {
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
          },
          {
            "id": "widget_1793035208082_674",
            "type": "sounding-card",
            "title": "Vertical Atmospheric Sounding",
            "colSpan": 6,
            "options": {
              "chartHeight": 280,
              "showInversions": true,
              "showFreezingLine": true,
              "showWindsAloft": true,
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
          },
          {
            "id": "widget_1793034976723_41",
            "type": "wildfires-card",
            "title": "Nearby Wildfires",
            "colSpan": 6,
            "options": {
              "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
            },
            "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
          },
          {
            "id": "widget_1791574434399_102",
            "type": "bottom-nav",
            "title": "Navigation Bar",
            "col_span": 12,
            "options": {
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            },
            "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
          }
        ]
      }
    },
    "hunting": {
      "id": "hunting",
      "name": "Hunting & Wildlife",
      "description": "Scent-carrying winds, thermals, freeze line, solar/lunar activity",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "widget_1791672969709_169",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "temp_precip_meteo",
            "type": "meteogram_card",
            "title": "Temperature & Precipitation",
            "col_span": 6,
            "options": {
              "height": 220,
              "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
            },
            "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
          },
          {
            "id": "lightning_hazard",
            "type": "lightning_map_card",
            "title": "Daily Lightning Hazard & Strike Timing",
            "col_span": 6,
            "options": {
              "show_diurnal_chart": true,
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
          },
          {
            "id": "sounding_inversion",
            "type": "sounding_card",
            "title": "Atmospheric Sounding & Inversion Profile",
            "col_span": 6,
            "options": {
              "interactive": true,
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
          },
          {
            "id": "sun_intensity",
            "type": "sun_intensity_card",
            "title": "Sun Intensity & Solar Flux",
            "col_span": 6,
            "options": {
              "height": 120,
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
          },
          {
            "id": "air_sky_quality",
            "type": "air_quality_card",
            "title": "Air & Sky Quality",
            "col_span": 6,
            "options": {
              "height": 180,
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
          },
          {
            "id": "solar_alpenglow",
            "type": "solar_alpenglow_card",
            "title": "Sunrise, Sunset and Golden Hour Outlooks",
            "col_span": 6,
            "options": {
              "show_blue_hour": true,
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
          },
          {
            "id": "wind_profile",
            "type": "wind_card",
            "title": "Wind Speed & Direction",
            "col_span": 6,
            "options": {
              "height": 180,
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
          },
          {
            "id": "astronomical_events",
            "type": "astronomical_card",
            "title": "Astronomical Events & Night Sky",
            "col_span": 6,
            "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows.",
            "options": {
              "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows."
            }
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "temp_precip_meteo",
            "type": "meteogram_card",
            "title": "Temperature & Precipitation",
            "col_span": 12,
            "options": {
              "height": 200,
              "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
            },
            "description": "Hourly temperature and precipitation meteogram tracking air temperature trends alongside precipitation probability and intensity across the active forecast horizon."
          },
          {
            "id": "lightning_hazard",
            "type": "lightning_map_card",
            "title": "Lightning Hazard & Timing",
            "col_span": 12,
            "options": {
              "show_diurnal_chart": true,
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
          },
          {
            "id": "wind_profile",
            "type": "wind_card",
            "title": "Wind Speed & Direction",
            "col_span": 12,
            "options": {
              "height": 160,
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
          },
          {
            "id": "solar_alpenglow",
            "type": "solar_alpenglow_card",
            "title": "Sun & Alpenglow Times",
            "col_span": 12,
            "options": {
              "show_blue_hour": true,
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
          },
          {
            "id": "air_sky_quality",
            "type": "air_quality_card",
            "title": "Air & Sky Quality",
            "col_span": 12,
            "options": {
              "height": 160,
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
          },
          {
            "id": "sun_intensity",
            "type": "sun_intensity_card",
            "title": "Sun Intensity & Solar Flux",
            "col_span": 12,
            "options": {
              "height": 120,
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
          },
          {
            "id": "sounding_inversion",
            "type": "sounding_card",
            "title": "Atmospheric Sounding Profile",
            "col_span": 12,
            "options": {
              "interactive": true,
              "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
            },
            "description": "Vertical thermodynamic profile of temperature, dew point, freezing level, thermal inversions, and winds aloft from the surface up through the troposphere."
          },
          {
            "id": "astronomical_events",
            "type": "astronomical_card",
            "title": "Night Sky & Lunar Events",
            "col_span": 12,
            "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows.",
            "options": {
              "description": "Nighttime astronomical summary highlighting twilight phases, moonrise/moonset timing, lunar illumination percentage, and dark-sky observing windows."
            }
          }
        ]
      }
    },
    "photography": {
      "id": "photography",
      "name": "Outdoor Photography",
      "description": "Golden hour timing, alpenglow quality, optical condensation risk, cloud tiers, and clarity",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "widget_1791671255326_575",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "solar_alpenglow",
            "type": "solar_alpenglow_card",
            "title": "Sunrise, Sunset and Golden Hour Outlooks",
            "col_span": 6,
            "options": {
              "show_blue_hour": true,
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
          },
          {
            "id": "widget_1791831610606_85",
            "type": "darkskies-card",
            "title": "Dark Skies Stargazing & Trend",
            "colSpan": 12,
            "options": {
              "showTrend": true,
              "showSolarLunarPhase": true,
              "showKpis": true,
              "chartHeight": 120,
              "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
            },
            "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
          },
          {
            "id": "widget_1791831619161_990",
            "type": "meteogram-card",
            "title": "Cloud Coverage",
            "colSpan": 12,
            "options": {
              "height": 200,
              "showNow": true,
              "horizonDays": "auto",
              "showMountainSilhouette": false,
              "declutterElevations": true,
              "showMinMaxLines": false,
              "minMaxSeriesKey": "auto",
              "series": [
                {
                  "key": "cloud_cover_mid",
                  "type": "stacked_area",
                  "yAxis": "right",
                  "color": "#0284c7",
                  "tension": 0.3
                },
                {
                  "key": "cloud_cover_low",
                  "type": "stacked_area",
                  "yAxis": "right",
                  "color": "#a855f7",
                  "tension": 0.3
                },
                {
                  "key": "cloud_cover_high",
                  "type": "stacked_area",
                  "yAxis": "right",
                  "color": "#3b82f6",
                  "tension": 0.3
                },
                {
                  "key": "cloud_cover_total",
                  "type": "area",
                  "yAxis": "right",
                  "color": "#94a3b8",
                  "tension": 0.3
                }
              ],
              "staticYAxis": true,
              "description": "Multi-tier hourly cloud fraction meteogram separating high-altitude cirrus (blue), mid-level altocumulus (cyan), low-level stratus (purple), and total sky cover (slate). For dramatic sunrise and sunset color, look for 30\u201370% high or mid clouds to catch sub-horizon light while low cloud cover remains minimal (<20%) so the horizon stays unobstructed."
            },
            "description": "Multi-tier hourly cloud fraction meteogram separating high-altitude cirrus (blue), mid-level altocumulus (cyan), low-level stratus (purple), and total sky cover (slate). For dramatic sunrise and sunset color, look for 30\u201370% high or mid clouds to catch sub-horizon light while low cloud cover remains minimal (<20%) so the horizon stays unobstructed."
          },
          {
            "id": "widget_1793384573308_147",
            "type": "solar-lunar-calendar",
            "title": "Solar & Lunar Calendar & Ephemeris",
            "colSpan": 12,
            "options": {
              "componentMode": "combined",
              "displayMode": "calendar",
              "daysToShow": 10,
              "showIllumination": true,
              "showMoonTimes": true,
              "showSunTimes": true,
              "showLunarTimeline": true,
              "showGoldenHour": true,
              "showBlueHour": true,
              "showMoonPhase": true,
              "description": "10-day astronomical ephemeris table and visual timeline detailing exact Sunrise, Sunset, Golden Hour, Blue Hour, Moonrise, Moonset, Lunar Phase, and % Lunar Illumination."
            },
            "description": "10-day astronomical ephemeris table and visual timeline detailing exact Sunrise, Sunset, Golden Hour, Blue Hour, Moonrise, Moonset, Lunar Phase, and % Lunar Illumination."
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "w_appbar",
            "type": "app-bar",
            "title": "Location Header",
            "col_span": 12,
            "options": {
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
          },
          {
            "id": "w_horizon",
            "type": "horizon-selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "default": "3-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "w_golden_window",
            "type": "golden-window-card",
            "title": "Sunrise, Sunset and Golden Hour Outlooks",
            "col_span": 12,
            "options": {
              "showLunarTimeline": true,
              "showScores": true,
              "displayMode": "both",
              "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
            },
            "description": "Photographic light-quality forecast grading upcoming Sunrise, Sunset, Golden Hour, and Alpine Alpenglow sessions (0\u2013100%) by analyzing multi-tier cloud geometry, sub-horizon ray paths, atmospheric aerosols, and local horizon terrain."
          },
          {
            "id": "w_ephemeris",
            "type": "solar-lunar-calendar",
            "title": "Solar & Lunar Calendar & Ephemeris",
            "col_span": 12,
            "options": {
              "componentMode": "combined",
              "displayMode": "calendar",
              "showTimeline": true,
              "showGoldenHour": true,
              "showMoonPhase": true,
              "showIllumination": true,
              "showMoonTimes": true,
              "showSunTimes": true,
              "description": "10-day astronomical ephemeris table and visual timeline detailing exact Sunrise, Sunset, Golden Hour, Blue Hour, Moonrise, Moonset, Lunar Phase, and % Lunar Illumination."
            },
            "description": "10-day astronomical ephemeris table and visual timeline detailing exact Sunrise, Sunset, Golden Hour, Blue Hour, Moonrise, Moonset, Lunar Phase, and % Lunar Illumination."
          },
          {
            "id": "widget_1793035233770_738",
            "type": "aurora-card",
            "title": "Aurora & Space Weather",
            "colSpan": 6,
            "options": {
              "showKpTrend": true,
              "kpChartScope": "all",
              "chartHeight": 130,
              "showProbabilities": true,
              "showMetrics": true,
              "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
            },
            "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
          },
          {
            "id": "w_bottom_nav",
            "type": "bottom-nav",
            "title": "Navigation Bar",
            "col_span": 12,
            "options": {
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            },
            "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
          }
        ]
      }
    },
    "standard_forecast": {
      "id": "standard_forecast",
      "name": "Standard Forecast",
      "description": "Layers for general weather forecast.",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "widget_1792255571140_673",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "widget_1791778478494_174",
            "type": "glance-2x2",
            "title": "Current Weather",
            "colSpan": 6,
            "options": {
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
          },
          {
            "id": "widget_1791778466710_156",
            "type": "recent-weather-2x3",
            "title": "Recent Rain and Snow Totals",
            "colSpan": 6,
            "options": {
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
          },
          {
            "id": "widget_1791778362110_245",
            "type": "daily-forecast-list",
            "title": "Daily and Hourly Weather Forecast",
            "colSpan": 12,
            "options": {
              "period": "auto",
              "dataSource": "auto",
              "showRainChance": true,
              "showWind": true,
              "showTempBar": true,
              "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
            },
            "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
          },
          {
            "id": "widget_1792250342667_626",
            "type": "meteogram-card",
            "title": "Temperature and Precipitation Probability",
            "colSpan": 12,
            "options": {
              "height": 200,
              "showNow": true,
              "staticYAxis": true,
              "horizonDays": "auto",
              "showMountainSilhouette": false,
              "declutterElevations": true,
              "showMinMaxLines": false,
              "minMaxSeriesKey": "auto",
              "series": [
                {
                  "key": "temps_f",
                  "label": "Temperature at Forecast Point (\u00b0F)",
                  "type": "line",
                  "yAxis": "left",
                  "color": "#f43f5e",
                  "tension": 0.3
                },
                {
                  "key": "precip_prob_pct",
                  "label": "Precipitation Probability (%)",
                  "type": "bar",
                  "yAxis": "right",
                  "color": "#3b82f6",
                  "tension": 0.3,
                  "model": "auto"
                }
              ],
              "description": "Hourly multi-series meteogram plotting forecast air temperature (\u00b0F, red curve on left axis) alongside hourly precipitation probability (%, blue bars on right axis). Use the model selector to compare official agency blends (NWS/ECCC) against individual global and mesoscale models."
            },
            "description": "Hourly multi-series meteogram plotting forecast air temperature (\u00b0F, red curve on left axis) alongside hourly precipitation probability (%, blue bars on right axis). Use the model selector to compare official agency blends (NWS/ECCC) against individual global and mesoscale models."
          },
          {
            "id": "tropical_hazards",
            "type": "tropical-cyclones-card",
            "title": "Hurricanes & Tropical Storms",
            "col_span": 6,
            "options": {
              "description": "Active NHC and JTWC tropical cyclone tracker displaying nearby tropical depressions, storms, and hurricanes with forecast intensity, track distance, arrival timing, and wind radii."
            },
            "description": "Active NHC and JTWC tropical cyclone tracker displaying nearby tropical depressions, storms, and hurricanes with forecast intensity, track distance, arrival timing, and wind radii."
          },
          {
            "id": "nearby_wildfires",
            "type": "nearby-wildfires-card",
            "title": "Nearby Wildfires",
            "col_span": 6,
            "options": {
              "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
            },
            "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "widget_1791745202229_500",
            "type": "app-bar",
            "title": "Location Header",
            "colSpan": 12,
            "options": {
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
          },
          {
            "id": "widget_1791745184446_706",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "widget_1791745147981_703",
            "type": "glance-2x2",
            "title": "Current Weather",
            "colSpan": 4,
            "options": {
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
          },
          {
            "id": "widget_1791745166205_538",
            "type": "daily-forecast-list",
            "title": "Daily Weather Forecast",
            "colSpan": 12,
            "options": {
              "period": "auto",
              "dataSource": "auto",
              "showRainChance": true,
              "showWind": true,
              "showTempBar": true,
              "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
            },
            "description": "Multi-day daily weather outlook displaying daily high/low temperature spans, sky condition icons, precipitation probability, and peak wind vectors. Tap or click any day row to expand 3-hour interval breakdowns."
          },
          {
            "id": "widget_1791745149325_775",
            "type": "recent-weather-2x3",
            "title": "Recent Rain and Snow Totals",
            "colSpan": 6,
            "options": {
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
          },
          {
            "id": "mobile_nearby_wildfires",
            "type": "nearby-wildfires-card",
            "title": "Nearby Wildfires",
            "colSpan": 12,
            "options": {
              "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
            },
            "description": "Live proximity monitor scanning NIFC, CWFIS, and satellite thermal detections for active wildfires within range, showing distance, compass bearing, burn acreage, and containment status."
          },
          {
            "id": "mobile_tropical_hazards",
            "type": "tropical-cyclones-card",
            "title": "Hurricanes & Tropical Storms",
            "colSpan": 12,
            "options": {
              "description": "Active NHC and JTWC tropical cyclone tracker displaying nearby tropical depressions, storms, and hurricanes with forecast intensity, track distance, arrival timing, and wind radii."
            },
            "description": "Active NHC and JTWC tropical cyclone tracker displaying nearby tropical depressions, storms, and hurricanes with forecast intensity, track distance, arrival timing, and wind radii."
          },
          {
            "id": "widget_1791745191798_3",
            "type": "bottom-nav",
            "title": "Navigation Bar",
            "colSpan": 12,
            "options": {
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            },
            "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
          }
        ]
      }
    },
    "stargazing": {
      "id": "stargazing",
      "name": "Stargazing & Astronomy",
      "description": "Dark sky quality, lunar illumination, aurora oval forecast, optics dew risk, and atmospheric transparency",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "widget_1791671263127_680",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "widget_1791820176917_527",
            "type": "darkskies-card",
            "title": "Dark Skies Stargazing & Trend",
            "colSpan": 12,
            "options": {
              "showTrend": true,
              "showSolarLunarPhase": true,
              "showKpis": true,
              "chartHeight": 120,
              "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
            },
            "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
          },
          {
            "id": "widget_1791813712754_635",
            "type": "aurora-card",
            "title": "Aurora & Space Weather",
            "colSpan": 6,
            "options": {
              "showKpTrend": true,
              "kpChartScope": "all",
              "chartHeight": 130,
              "showProbabilities": true,
              "showMetrics": true,
              "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
            },
            "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
          },
          {
            "id": "widget_1791813723827_322",
            "type": "meteogram-card",
            "title": "Dark Skies vs Optical Dew Risk",
            "colSpan": 6,
            "options": {
              "height": 240,
              "showNow": true,
              "horizonDays": "auto",
              "showMountainSilhouette": false,
              "declutterElevations": true,
              "showMinMaxLines": false,
              "minMaxSeriesKey": "auto",
              "series": [
                {
                  "key": "seeing_arcsec",
                  "type": "line",
                  "yAxis": "left",
                  "color": "#f97316",
                  "tension": 0.3
                },
                {
                  "key": "darkskies_score",
                  "type": "area",
                  "yAxis": "right",
                  "color": "#a855f7",
                  "tension": 0.3
                },
                {
                  "key": "optics_dew_risk_score",
                  "type": "line",
                  "yAxis": "right",
                  "color": "#fbbf24",
                  "tension": 0.3
                }
              ],
              "staticYAxis": true,
              "description": "Astrophotography & deep-sky planning meteogram comparing the composite Dark Skies Score (purple shaded area), Astronomical Seeing FWHM in arcseconds (orange curve on left axis \u2014 lower arcsec means steadier air and sharper planetary/lunar detail), and Optics Dew Risk (0\u2013100 gold curve \u2014 activate lens/telescope dew heaters when risk exceeds 50)."
            },
            "description": "Astrophotography & deep-sky planning meteogram comparing the composite Dark Skies Score (purple shaded area), Astronomical Seeing FWHM in arcseconds (orange curve on left axis \u2014 lower arcsec means steadier air and sharper planetary/lunar detail), and Optics Dew Risk (0\u2013100 gold curve \u2014 activate lens/telescope dew heaters when risk exceeds 50)."
          },
          {
            "id": "darksky_calendar",
            "type": "darksky-calendar",
            "title": "Dark Sky & Ephemeris Calendar",
            "col_span": 12,
            "options": {
              "showDiurnalCurve": true,
              "showDarkScores": true,
              "showDarkHours": true,
              "showEphemerisDetails": true,
              "bortleOverride": "auto",
              "description": "Multi-night stargazing planning calendar showing each night's peak Dark Skies score, total cloud-free dark hours, astronomical twilight window, and lunar interference curve."
            },
            "description": "Multi-night stargazing planning calendar showing each night's peak Dark Skies score, total cloud-free dark hours, astronomical twilight window, and lunar interference curve."
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "w_appbar",
            "type": "app-bar",
            "title": "Location Header",
            "col_span": 12,
            "options": {
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
          },
          {
            "id": "w_horizon",
            "type": "horizon-selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "default": "3-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "w_glance",
            "type": "glance-2x2",
            "title": "Current Conditions",
            "col_span": 4,
            "options": {
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
          },
          {
            "id": "widget_1791819245399_381",
            "type": "darkskies-card",
            "title": "Dark Skies Stargazing & Trend",
            "colSpan": 12,
            "options": {
              "showTrend": true,
              "showSolarLunarPhase": true,
              "showKpis": true,
              "chartHeight": 120,
              "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
            },
            "description": "Hourly nighttime stargazing quality forecast (0\u2013100%) combining the site's baseline Bortle light-pollution class with cloud cover, lunar illumination, wildfire smoke, humidity, and atmospheric seeing."
          },
          {
            "id": "w_darksky_cal",
            "type": "darksky-calendar",
            "title": "Dark Sky & Ephemeris Calendar",
            "col_span": 12,
            "options": {
              "showDiurnalCurve": true,
              "showDarkScores": true,
              "showDarkHours": true,
              "showEphemerisDetails": true,
              "bortleOverride": "auto",
              "description": "Multi-night stargazing planning calendar showing each night's peak Dark Skies score, total cloud-free dark hours, astronomical twilight window, and lunar interference curve."
            },
            "description": "Multi-night stargazing planning calendar showing each night's peak Dark Skies score, total cloud-free dark hours, astronomical twilight window, and lunar interference curve."
          },
          {
            "id": "w_aurora",
            "type": "aurora-card",
            "title": "Aurora Borealis & Space Weather",
            "col_span": 12,
            "options": {
              "showKpTrend": true,
              "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
            },
            "description": "Space weather and geomagnetic storm dashboard tracking the planetary Kp-index forecast, solar wind speed and Bz magnetic orientation, and localized probability of Aurora Borealis visibility."
          },
          {
            "id": "w_astro_meteo",
            "type": "meteogram-card",
            "title": "Dark Sky Score vs Cloud Cover & Dew Risk",
            "col_span": 12,
            "options": {
              "height": 380,
              "showNow": false,
              "horizonDays": "3",
              "series": [
                {
                  "key": "darkskies_score",
                  "type": "line",
                  "yAxis": "left",
                  "color": "#a855f7"
                },
                {
                  "key": "cloud_cover_total",
                  "type": "area",
                  "yAxis": "right",
                  "color": "#94a3b8"
                },
                {
                  "key": "optics_dew_risk_score",
                  "type": "line",
                  "dashed": true,
                  "yAxis": "left",
                  "color": "#fbbf24"
                }
              ],
              "declutterElevations": false,
              "staticYAxis": true,
              "description": "Night-sky observing meteogram overlaying the composite Dark Skies Score (purple line), Total Cloud Cover percentage (grey shaded area on right axis), and Optics Dew Risk index (gold dashed line). Target windows where Dark Skies Score peaks, cloud cover drops near 0%, and optical dew risk remains manageable."
            },
            "description": "Night-sky observing meteogram overlaying the composite Dark Skies Score (purple line), Total Cloud Cover percentage (grey shaded area on right axis), and Optics Dew Risk index (gold dashed line). Target windows where Dark Skies Score peaks, cloud cover drops near 0%, and optical dew risk remains manageable."
          },
          {
            "id": "w_bottom_nav",
            "type": "bottom-nav",
            "title": "Navigation Bar",
            "col_span": 12,
            "options": {
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            },
            "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
          }
        ]
      }
    },
    "water_sports": {
      "id": "water_sports",
      "name": "Water Sports",
      "description": "Surface wind vectors, gust progression, convective thunderstorms, and sun exposure",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "widget_1791671281638_187",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "wind_profile",
            "type": "wind_card",
            "title": "Surface Wind & Water Chop",
            "col_span": 6,
            "options": {
              "height": 180,
              "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
            },
            "description": "Hourly 10-meter sustained wind speed, peak wind gusts, and compass wind direction trend for assessing exposure, water chop, and boundary-layer turbulence."
          },
          {
            "id": "lightning_hazard",
            "type": "lightning_map_card",
            "title": "Lake Convective Storm & Lightning Timing",
            "col_span": 6,
            "options": {
              "show_diurnal_chart": true,
              "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
            },
            "description": "Hourly convective thunderstorm and cloud-to-ground lightning hazard timeline showing peak diurnal strike probability windows."
          },
          {
            "id": "temp_precip_meteo",
            "type": "meteogram_card",
            "title": "Air Temperature & Precipitation",
            "col_span": 6,
            "options": {
              "height": 220,
              "description": "Hourly air temperature and precipitation trend over the selected water body, helping paddlers and boaters anticipate cold-front passages, squalls, and thermal comfort shifts."
            },
            "description": "Hourly air temperature and precipitation trend over the selected water body, helping paddlers and boaters anticipate cold-front passages, squalls, and thermal comfort shifts."
          },
          {
            "id": "sun_intensity",
            "type": "sun_intensity_card",
            "title": "Direct Solar Exposure & UV Index",
            "col_span": 6,
            "options": {
              "height": 120,
              "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
            },
            "description": "Hourly downwelling shortwave solar irradiance (W/m\u00b2) and UV exposure curve accounting for solar elevation angle and cloud attenuation."
          },
          {
            "id": "air_quality",
            "type": "air_quality_card",
            "title": "Air Quality & Smoke",
            "col_span": 6,
            "options": {
              "height": 180,
              "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
            },
            "description": "Hourly Air Quality Index (AQI) and surface PM2.5 wildfire smoke concentration forecast for assessing respiratory health and atmospheric haze."
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "w_appbar",
            "type": "app-bar",
            "title": "River & Lake Location Header",
            "col_span": 12,
            "options": {
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
          },
          {
            "id": "w_horizon",
            "type": "horizon-selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "default": "3-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "w_glance",
            "type": "glance-2x2",
            "title": "Current Conditions",
            "col_span": 4,
            "options": {
              "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
            },
            "description": "Real-time and near-real-time surface weather summary combining the nearest reporting observation station with point-specific temperature, dew point, relative humidity, daily high/low range, and directional wind compass."
          },
          {
            "id": "w_recent_weather",
            "type": "recent-weather-2x3",
            "title": "Recent Rainfall",
            "col_span": 12,
            "options": {
              "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
            },
            "description": "Observed 24-hour, 48-hour, and 72-hour liquid precipitation and snowfall accumulation totals derived from multi-sensor radar and gauge-corrected analysis (MRMS, CMORPH2, and ECMWF)."
          },
          {
            "id": "widget_1792980395767_168",
            "type": "daily-precip-card",
            "title": "Daily Precipitation Forecast",
            "colSpan": 12,
            "options": {
              "period": "auto",
              "dataSource": "auto",
              "showProbability": true,
              "showSummaryBanner": true,
              "description": "Day-by-day liquid precipitation accumulation forecast (inches/mm) and daily probability of measurable rain, including a storm-total summary banner and peak wettest day highlight."
            },
            "description": "Day-by-day liquid precipitation accumulation forecast (inches/mm) and daily probability of measurable rain, including a storm-total summary banner and peak wettest day highlight."
          },
          {
            "id": "w_water_meteo",
            "type": "meteogram-card",
            "title": "Rain Rate vs Surface Winds & Gusts",
            "col_span": 12,
            "options": {
              "height": 380,
              "showNow": true,
              "horizonDays": "3",
              "series": [
                {
                  "key": "precip_rate_in_h",
                  "type": "bar",
                  "yAxis": "right",
                  "color": "#38bdf8"
                },
                {
                  "key": "wind_speed_mph",
                  "type": "line",
                  "yAxis": "left",
                  "color": "#10b981"
                },
                {
                  "key": "wind_gust_mph",
                  "type": "line",
                  "dashed": true,
                  "yAxis": "left",
                  "color": "#f43f5e"
                }
              ],
              "description": "On-water wind & squall meteogram plotting sustained 10-meter surface wind speed (mph, green curve), peak wind gusts (mph, red dashed curve), and hourly rainfall rate (in/hr, cyan bars on right axis). Critical for identifying afternoon thermal wind ramps and sudden convective gust fronts on open lakes, reservoirs, and bays."
            },
            "description": "On-water wind & squall meteogram plotting sustained 10-meter surface wind speed (mph, green curve), peak wind gusts (mph, red dashed curve), and hourly rainfall rate (in/hr, cyan bars on right axis). Critical for identifying afternoon thermal wind ramps and sudden convective gust fronts on open lakes, reservoirs, and bays."
          },
          {
            "id": "w_bottom_nav",
            "type": "bottom-nav",
            "title": "Navigation Bar",
            "col_span": 12,
            "options": {
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            },
            "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
          }
        ]
      }
    },
    "winter_sports": {
      "id": "winter_sports",
      "name": "Winter Sports",
      "description": "Freezing level, snowfall accumulation, mountain ridge winds, and temperature inversions",
      "web": {
        "columns": 12,
        "widgets": [
          {
            "id": "widget_1791671275142_901",
            "type": "persona-chips",
            "title": "Activity Selector",
            "colSpan": 12,
            "options": {
              "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
            },
            "description": "Switches between specialized activity forecast layouts (Standard Forecast, Hiking, Photography, Stargazing, Winter Sports, Water Sports, and Foraging)."
          },
          {
            "id": "horizon_selector",
            "type": "horizon_selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "options": [
                "1-Day",
                "3-Day",
                "5-Day",
                "Max"
              ],
              "default": "1-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "widget_1793073747833_714",
            "type": "daily-snow-card",
            "title": "Daily Snowfall Forecast",
            "colSpan": 12,
            "options": {
              "period": "auto",
              "dataSource": "auto",
              "showProbability": true,
              "showSummaryBanner": true,
              "description": "Day-by-day snowfall accumulation forecast (inches/cm) and daily snow probability, highlighting total storm snowfall and the deepest powder day across the forecast horizon."
            },
            "description": "Day-by-day snowfall accumulation forecast (inches/cm) and daily snow probability, highlighting total storm snowfall and the deepest powder day across the forecast horizon."
          },
          {
            "id": "widget_1793073795807_264",
            "type": "meteogram-card",
            "title": "Multi-Product Meteogram",
            "colSpan": 12,
            "options": {
              "height": 200,
              "showNow": true,
              "staticYAxis": false,
              "horizonDays": "auto",
              "showMountainSilhouette": false,
              "declutterElevations": true,
              "showMinMaxLines": false,
              "minMaxSeriesKey": "auto",
              "series": [
                {
                  "key": "cloud_cover_total",
                  "type": "area",
                  "yAxis": "right",
                  "color": "#94a3b8",
                  "tension": 0.3,
                  "label": "Total Cloud Cover (%)",
                  "model": "auto"
                },
                {
                  "key": "sun_intensity_wm2",
                  "type": "area",
                  "yAxis": "left",
                  "color": "#fbbf24",
                  "tension": 0.3,
                  "label": "Downwelling Solar Irradiance (W/m\u00b2)"
                }
              ],
              "description": "Alpine solar radiation & flat-light meteogram comparing downwelling solar irradiance (W/m\u00b2, gold area on left axis) against total cloud cover (%, grey area on right axis). High solar irradiance under low cloud cover indicates bright visibility and potential south-aspect solar snow crusting, whereas 100% cloud cover with low irradiance warns of flat-light conditions."
            },
            "description": "Alpine solar radiation & flat-light meteogram comparing downwelling solar irradiance (W/m\u00b2, gold area on left axis) against total cloud cover (%, grey area on right axis). High solar irradiance under low cloud cover indicates bright visibility and potential south-aspect solar snow crusting, whereas 100% cloud cover with low irradiance warns of flat-light conditions."
          }
        ]
      },
      "mobile": {
        "columns": 12,
        "widgets": [
          {
            "id": "w_appbar",
            "type": "app-bar",
            "title": "Mountain Location Header",
            "col_span": 12,
            "options": {
              "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
            },
            "description": "Displays the active forecast location name, coordinates, elevation, and quick navigation controls."
          },
          {
            "id": "w_horizon",
            "type": "horizon-selector",
            "title": "Forecast Horizon",
            "col_span": 12,
            "options": {
              "default": "5-Day",
              "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
            },
            "description": "Switches the active forecast time horizon across all charts and tables on this page (1-Day, 3-Day, 5-Day, or Max model extent)."
          },
          {
            "id": "w_elevation_temps",
            "type": "elevation-temp-card",
            "title": "Mountain Temperatures & Lapse Rates",
            "col_span": 12,
            "options": {
              "showFreezingLine": true,
              "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
            },
            "description": "Hourly vertical temperature profile plotting simultaneous temperature curves at Summit/Peak, Mid-Mountain, and Valley/Base elevations alongside the 32\u00b0F (0\u00b0C) freezing level line to reveal thermal inversions and alpine lapse rates."
          },
          {
            "id": "widget_1792980324958_278",
            "type": "daily-snow-card",
            "title": "Daily Snowfall Forecast",
            "colSpan": 12,
            "options": {
              "period": "auto",
              "dataSource": "auto",
              "showProbability": true,
              "showSummaryBanner": true,
              "description": "Day-by-day snowfall accumulation forecast (inches/cm) and daily snow probability, highlighting total storm snowfall and the deepest powder day across the forecast horizon."
            },
            "description": "Day-by-day snowfall accumulation forecast (inches/cm) and daily snow probability, highlighting total storm snowfall and the deepest powder day across the forecast horizon."
          },
          {
            "id": "w_snow",
            "type": "observed-snow-card",
            "title": "SNOTEL Snowpack & 24h New Snow",
            "col_span": 12,
            "options": {
              "expandedStations": {
                "0": true
              },
              "description": "Live telemetry from the nearest high-elevation SNOTEL and snow-pillow stations showing total snow depth, Snow Water Equivalent (SWE), 24h/72h new snowfall, and multi-day snowpack trends."
            },
            "description": "Live telemetry from the nearest high-elevation SNOTEL and snow-pillow stations showing total snow depth, Snow Water Equivalent (SWE), 24h/72h new snowfall, and multi-day snowpack trends."
          },
          {
            "id": "w_cloud_ceiling",
            "type": "cloud-ceiling-card",
            "title": "Snow Level & Cloud Tops",
            "col_span": 12,
            "options": {
              "displayMode": "chart",
              "showFreezingLine": true,
              "showCloudCover": true,
              "chartHeight": 340,
              "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
            },
            "description": "Vertical cross-section of cloud base (ceiling) and cloud top altitudes (ft MSL) relative to local mountain terrain elevation. Shows when summits will be socked-in inside the cloud deck versus above a valley cloud inversion ('sea of clouds')."
          },
          {
            "id": "w_winter_meteo",
            "type": "meteogram-card",
            "title": "Snow Accumulation vs Freezing Line & Ridge Winds",
            "col_span": 12,
            "options": {
              "height": 380,
              "showNow": true,
              "horizonDays": "5",
              "series": [
                {
                  "key": "snow_rate_in_h",
                  "type": "bar",
                  "yAxis": "right",
                  "color": "#38bdf8"
                },
                {
                  "key": "freezing_level_ft",
                  "type": "line",
                  "yAxis": "left",
                  "color": "#3b82f6"
                },
                {
                  "key": "wind_gust_mph",
                  "type": "line",
                  "dashed": true,
                  "yAxis": "right",
                  "color": "#f43f5e"
                }
              ],
              "description": "Backcountry & resort storm meteogram tracking hourly snowfall rate (in/hr, cyan bars), freezing level elevation (ft MSL, blue curve on left axis), and peak ridge wind gusts (mph, red dashed curve). Watch for high snowfall rates paired with strong gusts, which rapidly build reactive wind slabs on leeward alpine slopes."
            },
            "description": "Backcountry & resort storm meteogram tracking hourly snowfall rate (in/hr, cyan bars), freezing level elevation (ft MSL, blue curve on left axis), and peak ridge wind gusts (mph, red dashed curve). Watch for high snowfall rates paired with strong gusts, which rapidly build reactive wind slabs on leeward alpine slopes."
          },
          {
            "id": "w_bottom_nav",
            "type": "bottom-nav",
            "title": "Navigation Bar",
            "col_span": 12,
            "options": {
              "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
            },
            "description": "Mobile navigation bar for switching between Forecast, Live Map, Saved Spots, and Settings."
          }
        ]
      }
    }
  },
  "categories": [
    {
      "id": "sky_solar",
      "title": "Sky & Solar",
      "icon": "\u2600\ufe0f \u2728"
    },
    {
      "id": "precipitation",
      "title": "Precipitation",
      "icon": "\ud83c\udf27\ufe0f \u26a1"
    },
    {
      "id": "clouds_wind",
      "title": "Clouds & Wind",
      "icon": "\u2601\ufe0f \ud83d\udca8"
    },
    {
      "id": "temperature",
      "title": "Temperature",
      "icon": "\ud83c\udf21\ufe0f \ud83e\udd76"
    },
    {
      "id": "air_quality_fires",
      "title": "Air Quality & Wildfires",
      "icon": "\ud83e\udec1 \ud83d\udd25"
    },
    {
      "id": "hydrology",
      "title": "Hydrology & Cryosphere",
      "icon": "\ud83c\udf0a \u2744\ufe0f"
    },
    {
      "id": "phenology",
      "title": "Seasonal & Phenology",
      "icon": "\ud83c\udf41 \ud83c\udf38"
    },
    {
      "id": "extended_climate",
      "title": "Extended Climate & Outlooks",
      "icon": "\ud83d\udcca \ud83c\udf10"
    }
  ]
}